import { href } from "react-router-dom";
import api from "../../plugin/api";
import { initAuth, MainSession, BasicInfoSession, loginauthservice, logoutauthservice, clearCookieUser } from "../../plugin/authService";
import html2canvas from "html2canvas";
import QRCode from 'qrcode';
import lottie from 'lottie-web';

window.MinimalPasswordCharacter = 8;

window.PanelChoiceOpen = null;
window.DropDownInsideContainer = null;
window.AnimateBlockerDuration = 150;
window.AnimateLeftPanelDuration = 500;
window.PhoneFeatureIsUnavailable = true;

window.SearchInfo = null;
window.SearchFilterType = "Rooms"; // Room or Experience
window.SlugInfo = null;
window.CheckInInfo = null;
window.CheckOutInfo = null;
window.RoomNumberInfo = null;

 // Fixed Data For On Type Change  ----------------------
window.FixedSlugInfo = null;
window.FixedCheckInInfo = null;
window.FixedCheckOutInfo = null;
window.FixedRoomQuota = 1;
window.PastReloadTypeChangeData = null; // For Type Change Not Multiple Call ----------------------

window.WhichIndexImage = null;
window.FullPhotoListForIndex = null;

window.CurrentUserToken = null;
window.CurrentUserID = null;

window.HotelID = null;
window.HotelSlug = null;
window.CurrentSelectedRoomID = null;
window.CurrentSelectedRoomExpBookType = null; // Per Night or Day
window.CurrentSelectedAccFacilitiesType = null; // Room or Experience
window.ThisRoomData = null; // The Room or Experience Data Current Selected
window.ThisExperienceAddOnList = null; // Choice Add On Experience
window.AllChoicesBasedOnCurrentSelectedRoomAccType = []; // Choices for Drop Down

window.RoomQuotaNonTop = null;
window.CheckInDateNonTop = null;
window.CheckOutDateNonTop = null;
window.DifferenceBetweenDays = null;

window.IsPanelAnimating = false;

window.ThisCurrentQuotaInput = null;

window.CheckInNonTopInput = null;
window.CheckInNonTopInputText = null;
window.CheckOutNonTopInput = null;
window.CheckOutNonTopInputText = null;

// Limit Panel and Photo Instantiated --------------

window.limitPanelPerPage = 7;
window.MaximumPhotoEachRoom = 2;

window.DefaultSearchLocation = "Bali";
window.CurrentCountryID = "en";

window.ColorPaletteBasedOnStatus =
[
    {
        "status":["Booking Confirmed", "Booking Completed"],
        "backgroundcolor":"#D3EAF7",
        "textcolor":"#3A9FDD",
    },
    {
        "status":["Booking Fee Paid"],
        "backgroundcolor":"#ECFDF3",
        "textcolor":"#027A48",
    },
    {
        "status":["Check-in"],
        "backgroundcolor":"#E9F4FB",
        "textcolor":"#065986",
    },
    {
        "status":["Booking Payment Canceled", "Booking Canceled"],
        "backgroundcolor":"#FEF3F2",
        "textcolor":"#B42318",
    },
    {
        "status":["Booking Payment on Progress", "No Booking Payment", "Waiting for Confirmation", "Waiting Payment Confirmation", "Waiting Payment"],
        "backgroundcolor":"#FEF0C7",
        "textcolor":"#93370D",
    },
    {
        "status":["Booking Payment Timeout", "Booking Timeout"],
        "backgroundcolor":"#FFF6ED",
        "textcolor":"#F19668",
    },
];


window.provincePromise = null;
window.experiencePromise = null;

// Small Hotel Panel -------------------------------

window.CurrentNearbyPropertyIndex = 1;
window.CurrentPopularIDIndex = 1;
window.CurrentUnder300Index = 1;
window.CurrentTrendingAccIndex = 1;

// ---------------------------------- GET PROVINCE --------------------------------------


window.GetProvinceLoad = async function(thisfunction)
{
    if(window.provincePromise)
    {
        return window.provincePromise; // already loading or loaded
    }

    let URLSearchProvince = "/v2/hotels/province";

    window.provincePromise = window.CallApiAxios({
        method: "GET",
        url: URLSearchProvince,
    }).then(res =>
    {
        let ProvinceDataGet = res.data.data;
        ProvinceDataGet = window.sortByPriority(ProvinceDataGet, window.SortAreaHomePriority, "province");
        ProvinceDataGet.forEach(thisdata =>
        {
            thisdata.type = "province";
        });

        console.log(URLSearchProvince);
        console.log(ProvinceDataGet);

        if(thisfunction != null)
            thisfunction();

        return ProvinceDataGet;
    })
    .catch(err =>
    {
        //console.error(err);
        window.provincePromise = null; // allow retry if failed
        throw err;
    });


    return window.provincePromise;
}


// ---------------------------------- GET EXPERIENCE --------------------------------------


window.GetExperienceLoad = async function(thisfunction)
{
    if(window.experiencePromise)
    {
        return window.experiencePromise; // already loading or loaded
    }

    let URLSearchProvince = "/v2/hotels/province";

    window.experiencePromise = window.CallApiAxios({
        method: "GET",
        url: URLSearchProvince,
    }).then(res =>
    {
        let ExperienceDataGet = res.data.data;
        ExperienceDataGet = window.sortByPriority(ExperienceDataGet, window.SortAreaHomePriority, "province");
        ExperienceDataGet.forEach(thisdata =>
        {
            thisdata.type = "experience";
        });

        console.log(URLSearchProvince);
        console.log(ExperienceDataGet);

        if(thisfunction != null)
            thisfunction();

        return ExperienceDataGet;
    })
    .catch(err =>
    {
        //console.error(err);
        window.experiencePromise = null; // allow retry if failed
        throw err;
    });


    return window.experiencePromise;
}


// ================================== SEARCH RELATED =============================================

window.CurrentExistingSearchList = [];
window.MainSearchInputField = null;

window.SetSearchInputFunction = function(whichsection)
{
    window.MainSearchInputField = document.getElementById("MainSearchInputField");
    let WhereToInstantiate = document.getElementById("InputFieldSearchContainer");

    if(window.MainSearchInputField != null)
    {
        window.MainSearchInputField.addEventListener("click", function(e)
        {
            e.stopPropagation();
        });
        window.MainSearchInputField.addEventListener("focusin", (event) =>
        {
            event.preventDefault();
            event.stopPropagation();

            if(window.MainSearchInputField.getAttribute("current-inputed") != null && window.MainSearchInputField.getAttribute("current-inputed") != '')
                window.MainSearchInputField.value = window.MainSearchInputField.getAttribute("current-inputed");

            window.MainSearchInputField.style.color = "";
            window.SearchButtonOnInput(window.MainSearchInputField, WhereToInstantiate, event);
        });
        window.MainSearchInputField.onkeyup = function(event)
        {
            event.preventDefault();
            event.stopPropagation();

            window.MainSearchInputField.setAttribute("province-slug", '');
            window.MainSearchInputField.setAttribute("current-inputed", window.MainSearchInputField.value);
            window.MainSearchInputField.style.color = "";

            window.SearchButtonOnInput(window.MainSearchInputField, WhereToInstantiate, event);
        }
        window.MainSearchInputField.addEventListener("focusout", (event) =>
        {
            window.MainSearchInputField.setAttribute("current-inputed", window.MainSearchInputField.value);
            window.MainSearchInputField.style.color = "";
        });
    }

    // Set Check In Date Input Click Function -----------------------------
    let CheckInDateInput = document.getElementById("CheckInDateInput");
    if(CheckInDateInput != null)
    {
        CheckInDateInput.onclick = function()
        {
            window.OpenDateChoiceContainer('CheckInDateInput', 'CheckOutDateInput', '', 'Start', 'HowManyNightText', 1, false, false, true, true, false, false, null);
        }
    }

    // Set Check Out Date Input Click Function -----------------------------
    let CheckOutDateInput = document.getElementById("CheckOutDateInput");
    if(CheckOutDateInput != null)
    {
        CheckOutDateInput.onclick = function()
        {
            window.OpenDateChoiceContainer('CheckOutDateInput', 'CheckInDateInput', '', 'End', 'HowManyNightText', 1, false, false, true, false, false, false, null);
        }
    }

    // Set Check Out Date Input Click Function -----------------------------

    

    let InstantiateRoomQuotaFunction = function(roomquotacontainer, roomquotadisplayid, instantiateatleft, allowskip, whichtype, functiontocall, functiontocallclose)
    {
        let quotatextdisplayer = document.getElementById(roomquotadisplayid);
        
        if(window.ResponsivePanelMediaQuery2.matches == false)
        {
            window.OpenRoomQuotaChangePanel(roomquotacontainer, roomquotadisplayid, instantiateatleft, ()=>
            {
                if(whichtype == "Rooms")
                {
                    quotatextdisplayer.innerHTML = window.ThisCurrentQuotaInput + " " + window["RoomTxt" + window.CurrentCountryID];

                    if(window.ThisCurrentQuotaInput > 1)
                        quotatextdisplayer.innerHTML = window.ThisCurrentQuotaInput + " " + window["RoomTxtex" + window.CurrentCountryID];
                }
                else
                {
                    quotatextdisplayer.innerHTML = window.ThisCurrentQuotaInput + " " + window["GuestTxt" + window.CurrentCountryID];
                        
                    if(window.ThisCurrentQuotaInput > 1)
                        quotatextdisplayer.innerHTML = window.ThisCurrentQuotaInput + " " + window["GuestTxtex" + window.CurrentCountryID];
                }

                if(functiontocall != null)
                    functiontocall();
            });
        }
        else
        {
            window.RoomQuotaNonTop = parseInt(roomquotacontainer.getAttribute("room-quota"));

            window.InstantiateEditGuestandRoomQuotaMobilePanel(()=>
            {
                if(whichtype == "Rooms")
                {
                    quotatextdisplayer.innerHTML = window.ThisCurrentQuotaInput + " " + window["RoomTxt" + window.CurrentCountryID];

                    if(window.ThisCurrentQuotaInput > 1)
                        quotatextdisplayer.innerHTML = window.ThisCurrentQuotaInput + " " + window["RoomTxtex" + window.CurrentCountryID];
                }
                else
                {
                    quotatextdisplayer.innerHTML = window.ThisCurrentQuotaInput + " " + window["GuestTxt" + window.CurrentCountryID];
                        
                    if(window.ThisCurrentQuotaInput > 1)
                        quotatextdisplayer.innerHTML = window.ThisCurrentQuotaInput + " " + window["GuestTxtex" + window.CurrentCountryID];
                }

                roomquotacontainer.setAttribute("room-quota", window.ThisCurrentQuotaInput);
                
                if(functiontocall != null)
                    functiontocall();
                },
            ()=>
            {
                if(functiontocallclose != null)
                    functiontocallclose();

            }, allowskip, true, whichtype);
        }
    }

    
    let RoomQuotaInput = document.getElementById("RoomQuotaInput");
    if(RoomQuotaInput != null)
    {
        RoomQuotaInput.onclick = function()
        {
            let PrevData = window.CreateHotelDetailsSnapshot();
            
            InstantiateRoomQuotaFunction(RoomQuotaInput, "RoomQuotaTextDisplay", false, true, window.SearchFilterType,
            ()=>
            {
                window.RestoreHotelDetailsSnapshot(PrevData);
            },
            ()=>
            {
                window.RestoreHotelDetailsSnapshot(PrevData);
            });
        }
    }

    let RoomQuotaHotelDetailsInput = document.getElementById("RoomQuotaHotelDetailsInput");
    if(RoomQuotaHotelDetailsInput != null)
    {
        RoomQuotaHotelDetailsInput.onclick = function()
        {
            let PrevData = window.CreateHotelDetailsSnapshot();
            
            InstantiateRoomQuotaFunction(RoomQuotaHotelDetailsInput, "RoomQuotaHotelDetailsDisplayText", true, false, window.CurrentSelectedAccFacilitiesType,
            ()=>
            {
                window.CalculateTotalHotelDetails(false);
            },
            ()=>
            {
                window.RestoreHotelDetailsSnapshot(PrevData);
            });
        }
    }

    // Set Default Search Type (Accommodation or Experience) ------------------------------------

    const urlParams = new URLSearchParams(window.location.search);

    if(urlParams.has('type'))
    {
        let GetTypeEarly = urlParams.get('type');
        if(GetTypeEarly != "Rooms" && GetTypeEarly != "Experiences")
            GetTypeEarly = "Rooms";

        window.SearchFilterType = GetTypeEarly;
        window.SelectedHotelDetailsFilter = GetTypeEarly;

        if(whichsection == "PaymentForm")
        {
            window.CurrentSelectedAccFacilitiesType = GetTypeEarly;
        }
        else if(whichsection == "HotelDetails")
        {
            window.CurrentSelectedAccFacilitiesType = GetTypeEarly;
        }
    }

    console.log("whichsection", whichsection);

}

window.OnChangeFilterMainSearch = function(MainSession, loggedin, WhichPageisNow)
{
    let MauNginepDimanaHeaderInputText = document.getElementById("MauNginepDimanaHeaderInputText"); // Mau Nginep Dimana -------------------------------
    if(MauNginepDimanaHeaderInputText != null)
    {
        if(window.SearchFilterType == "Rooms")
        {
            MauNginepDimanaHeaderInputText.innerHTML = window["MauNginapDimanaTxt" + window.CurrentCountryID];
        }
        else
        {
            MauNginepDimanaHeaderInputText.innerHTML = window["MauNginapExploreTxt" + window.CurrentCountryID];
        }
    }

    let CheckInDateInputDayNameText = document.getElementById("CheckInInputHeaderSearchText"); // Check In -------------------------------
    if(CheckInDateInputDayNameText != null)
        CheckInDateInputDayNameText.innerHTML = window["CheckInTxt" + window.CurrentCountryID];

    let DateOfVisitSearchHeaderText = document.getElementById("DateOfVisitSearchHeaderText"); // Check In -------------------------------
    if(DateOfVisitSearchHeaderText != null)
        DateOfVisitSearchHeaderText.innerHTML = window["DateOfVisitTxt" + window.CurrentCountryID];
    
    let CheckOutInputHeaderSearchText = document.getElementById("CheckOutInputHeaderSearchText"); // Check Out -------------------------------
    if(CheckOutInputHeaderSearchText != null)
        CheckOutInputHeaderSearchText.innerHTML = window["CheckOutTxt" + window.CurrentCountryID];
    
    let JumlahTamuHeaderSearch = document.getElementById("JumlahTamuHeaderSearch"); // Check Out -------------------------------
    if(JumlahTamuHeaderSearch != null)
        JumlahTamuHeaderSearch.innerHTML = window["JumlahTamuTxt2" + window.CurrentCountryID];

    let ExperienceUIDisplay = document.querySelectorAll(".ExperienceUIDisplay"); // Remove or Display EXPERIENCE Type UI
    ExperienceUIDisplay.forEach(element =>
    {
        if(window.SearchFilterType == "Rooms")
        {
            element.style.display = "none";
        }
        else
        {
            element.style.display = "";
        }
    });

    let RoomUIDisplay = document.querySelectorAll(".RoomUIDisplay"); // Remove or Display ROOM Type UI
    RoomUIDisplay.forEach(element =>
    {
        if(window.SearchFilterType == "Rooms")
        {
            element.style.display = "";
        }
        else
        {
            element.style.display = "none";
        }
    });

    let CheckInOutQuotaWrapper = document.getElementById("CheckInOutQuotaWrapper"); // Make UI Search Two or Three Wrapper
    if(CheckInOutQuotaWrapper != null)
    {
        if(window.SearchFilterType == "Rooms")
        {
            CheckInOutQuotaWrapper.style.gridTemplateColumns = 'repeat(3, 1fr)';
        }
        else
        {
            CheckInOutQuotaWrapper.style.gridTemplateColumns = 'repeat(2, 1fr)';
        }
    }

    let RoomQuotaInput = document.getElementById("RoomQuotaInput"); // Update Room Quota Search
    if(RoomQuotaInput != null)
    {
        let RoomQuotaTextDisplay = document.getElementById("RoomQuotaTextDisplay");
        let CurrentQuota = parseInt(RoomQuotaInput.getAttribute("room-quota"));

        if(window.SearchFilterType == "Rooms")
        {
            RoomQuotaTextDisplay.innerHTML = CurrentQuota + " " + window["RoomTxt" + window.CurrentCountryID];

            if(CurrentQuota > 1)
                RoomQuotaTextDisplay.innerHTML = CurrentQuota + " " + window["RoomTxtex" + window.CurrentCountryID];
        }
        else
        {
            RoomQuotaTextDisplay.innerHTML = CurrentQuota + " " + window["GuestTxt" + window.CurrentCountryID];
                        
            if(CurrentQuota > 1)
                RoomQuotaTextDisplay.innerHTML = CurrentQuota + " " + window["GuestTxtex" + window.CurrentCountryID];
        }
    }

    let SearchButtonText = document.querySelectorAll('.SearchButtonText');
    SearchButtonText.forEach(ThisText =>
    {
        ThisText.innerHTML = window["Search" + window.SearchFilterType +"Txt" + window.CurrentCountryID];
    });

    if(WhichPageisNow == "Index")
    {
        let WhereToInstantiateAll = document.getElementById("MainContentIndex");
        WhereToInstantiateAll.innerHTML = "";

        // Login Sekarang ------------------------------------

        if(loggedin == false)
        {
            window.createLoginSekarangWarningSection(WhereToInstantiateAll);
        }

        // Prepare Popular Area ---------------------------------
        
        let PopularLoadingContainer = window.LoadingContentPanel(WhereToInstantiateAll, 1, 8);

        let PopularAreaMainContainer = document.createElement("div");
        PopularAreaMainContainer.className = "SectionSeparatorContainer";
        PopularAreaMainContainer.style.display = "none";
        WhereToInstantiateAll.append(PopularAreaMainContainer);
        
        // Slide Pop Up ---------------------------------

        let SlidePopUpContainer = document.createElement("div");
        SlidePopUpContainer.className = "SectionSeparatorContainer";
        SlidePopUpContainer.id = "SlidePopUpContainer";
        SlidePopUpContainer.style.display = "none";
        SlidePopUpContainer.style.padding = 0;
        WhereToInstantiateAll.append(SlidePopUpContainer);


        //LoadPopularArea(TempPopularData, PopularAreaMainContainer, PopularLoadingContainer)

        // Featured Hotel ---------------------------------
        
        let FeaturedHotelContainers = window.LoadingContentPanel(WhereToInstantiateAll, 3, 5);

        FeaturedHotelContainers[2].style.display = "";
        FeaturedHotelContainers[3].style.display = "none";
        FeaturedHotelContainers[4].style.display = "none";

        // Load Ads Panel ---------------------------------

        (async () =>
        {
            // Load Province --------------------------------

            // window.CurrentExistingSearchList = await window.GetProvinceLoad(null);

            // Load Popular Area ---------------------------------

            await window.LoadPopularAreaData(PopularAreaMainContainer, PopularLoadingContainer, 1);

            // Load Slide Pop Up --------------------------------

            await window.LoadSlidePopUpInfo(SlidePopUpContainer);

            // Prepare Featured Hotel ---------------------------------

            await window.PrepareFeaturedHotel(FeaturedHotelContainers);

            // Trending Hotels ---------------------------------
            
            window.ReadyToLoadBasicHotelPanelData(WhereToInstantiateAll, "/hotels/home/popular-id", "PopularID", window["TrendingAccForYouTxt" + window.CurrentCountryID]);

            // Under 300K ---------------------------------
            
            window.ReadyToLoadBasicHotelPanelData(WhereToInstantiateAll, "/hotels/home/under-300", "Under300", window["AccUnder300KTxt" + window.CurrentCountryID]);

            //Gabung Sekarang ---------------------------------
            
            window.CreateGabungSekarangIndex(WhereToInstantiateAll)

            window.PreparePopUpInfo();
        })();
    }
    else if(WhichPageisNow == "SearchResult")
    {
        // =========================== LOAD TRENDING ACCOMMODATION ON BOTTOM ==================================================

        if(window.FixedSlugInfo != null && window.PastReloadTypeChangeData != window.SearchFilterType)
        {
            window.PastReloadTypeChangeData = window.SearchFilterType;

            let OtherExtraPanelSearchPage = document.getElementById("OtherExtraPanelSearchPage");
            if(OtherExtraPanelSearchPage != null)
                OtherExtraPanelSearchPage.innerHTML = "";

            let TrendingAccommodationBottomURL = "/hotels/search/" + window.FixedSlugInfo + "/rooms/popular?checkin=" + window.FixedCheckInInfo + "&checkout=" + window.FixedCheckOutInfo + "&rooms=" + window.FixedRoomQuota + "&min_price=" + window.SliderMin.value + "&max_price=" + window.SliderMax.value + "&type=" + window.SearchFilterType;
            let TrendinHeaderText = "TrendingAccOnTxt";
            if(window.SearchFilterType == "Experiences")
            {
                TrendingAccommodationBottomURL = "/hotels/search/" + window.FixedSlugInfo + "/experiences/popular?date_visit=" + window.FixedCheckInInfo + "&date_until=" + window.FixedCheckOutInfo + "&rooms=" + window.FixedRoomQuota + "&min_price=" + window.SliderMin.value + "&max_price=" + window.SliderMax.value + "&type=" + window.SearchFilterType;
                TrendinHeaderText = "TrendingExpOnTxt";
            }

            let TrendingAccHeaderText = window[TrendinHeaderText + window.CurrentCountryID] + " " + window.CapitalizeEveryLetter(window.SearchInfo);

            window.ReadyToLoadBasicHotelPanelData(OtherExtraPanelSearchPage, TrendingAccommodationBottomURL, "TrendingAcc", TrendingAccHeaderText);
        }
        
        // Apply Changes -----------------------
        window.SortButtonClicked(window.CurrentSort); // Change Sort Button --------------
    }
    else if(WhichPageisNow == "HotelDetails")
    {
        // Nearby Property --------------------------------------------------------------------------------

        if(window.HotelDetails != null && window.CurrentSelectedAccFacilitiesType != null && window.PastReloadTypeChangeData != window.CurrentSelectedAccFacilitiesType)
        {
            window.PastReloadTypeChangeData = window.CurrentSelectedAccFacilitiesType;

            let WhereToInstantiateAll = document.getElementById("OtherExtraPanelHotelDetailsPage");
            WhereToInstantiateAll.innerHTML = "";

            let NearbyPropertyURL = "/hotels/search/" + window.HotelDetails.province_slug + "/rooms/popular?checkin=" + window.FixedCheckInInfo + "&checkout=" + window.FixedCheckOutInfo + "&rooms=" + window.FixedRoomQuota + "&min_price=" + 0 + "&max_price=" + 1000000000 + "&type=" + window.SearchFilterType;
            let TrendinHeaderText = "TrendingAccOnTxt";
            if(window.CurrentSelectedAccFacilitiesType == "Experiences")
            {
                NearbyPropertyURL = "/hotels/search/" + window.HotelDetails.province_slug + "/experiences/popular?date_visit=" + window.FixedCheckInInfo + "&date_until=" + window.FixedCheckOutInfo + "&rooms=" + window.FixedRoomQuota + "&min_price=" + 0 + "&max_price=" + 1000000000 + "&type=" + window.SearchFilterType;
                TrendinHeaderText = "TrendingExpOnTxt";
            }

            let NearbyHeaderText = window[TrendinHeaderText + window.CurrentCountryID] + " " + window.HotelDetails.province;
            window.ReadyToLoadBasicHotelPanelData(WhereToInstantiateAll, NearbyPropertyURL, "NearbyProperty", NearbyHeaderText);
        }
    }
}

window.SearchButtonOnInput = async function(thisinputfield, wheretoinstantiate, event)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    if(window.CurrentExistingSearchList.length == 0)
    {
        let ThisLoadingDropDown = window.InstantiateLoadingDropDown(wheretoinstantiate)

        let ProvinceData = await window.GetProvinceLoad(null);

        window.CurrentExistingSearchList = ProvinceData;
        // let ExperienceData = await window.GetExperienceLoad(null);

        window.InstantiateTheSearchResult(thisinputfield, wheretoinstantiate, event);

        ThisLoadingDropDown.remove();
    }
    else
    {
        window.InstantiateTheSearchResult(thisinputfield, wheretoinstantiate, event);
    }
}


window.InstantiateLoadingDropDown  = function(WhereToInstantiate)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    let ThisLoadingDropDown = document.createElement("div");
    ThisLoadingDropDown.className = "ContainerFlex";
    ThisLoadingDropDown.style.bottom = 0;
    WhereToInstantiate.append(ThisLoadingDropDown);

    let DropDownContainer = document.createElement("div");
    DropDownContainer.className = "DropDownContainer HideScrollBar";
    ThisLoadingDropDown.append(DropDownContainer);

    let WidthList = ["25%", "20%", "30%"];

    for(let i = 0; i < WidthList.length; i++)
    {
        let ThisDataButton = document.createElement("div");
        ThisDataButton.className = "DropDownSelectionContainer DropDownWithStatus";
        ThisDataButton.style.pointerEvents = "none";
        DropDownContainer.append(ThisDataButton);

        let ThisDataButtonLoading = document.createElement("div");
        ThisDataButtonLoading.className = "loading_grey NameofHotelPopularAreaLoadGrey";
        ThisDataButtonLoading.style.margin = "auto 0";
        ThisDataButtonLoading.style.width = WidthList[i];
        ThisDataButton.append(ThisDataButtonLoading);
    }

    return ThisLoadingDropDown
}

window.InstantiateTheSearchResult = function(ThisInputField, WhereToInstantiate, event)
{
    event.preventDefault();
    event.stopPropagation();
    

    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown("SearchDropDownMenu", WhereToInstantiate);

    if(ThisDropDownContainer == null)
        return

    ThisDropDownContainer.style.bottom = 0;
    ThisDropDownContainer.className = "ContainerFlex";
    ThisDropDownContainer.innerHTML = "";

    
    // ========================= FILTER BASED ON PROVINCE =============================

    let FilteredCity = [];

    if(ThisInputField.value != "")
    {
        for(let i = 0; i< window.CurrentExistingSearchList.length; i++)
        {
            if(window.CurrentExistingSearchList[i].province.toLowerCase().includes(ThisInputField.value.toLowerCase()))
            {
                FilteredCity.push(window.CurrentExistingSearchList[i]);
            }
        }
    }
    else
    {
        FilteredCity = window.CurrentExistingSearchList;
    }

    // ======================== START INSTANTIATING =========================================


    let DropDownContainer = document.createElement("div");
    DropDownContainer.className = "DropDownContainer HideScrollBar";
    ThisDropDownContainer.append(DropDownContainer);

    for(let i = 0; i < FilteredCity.length; i++)
    {
        let ThisDataButton = document.createElement("div");
        ThisDataButton.className = "DropDownSelectionContainer DropDownWithStatus";
        ThisDataButton.onclick = function(event)
        {
            event.preventDefault();
            event.stopPropagation();

            ThisInputField.value = FilteredCity[i].province;
            ThisInputField.setAttribute("province-slug", FilteredCity[i].province_slug);
            ThisInputField.setAttribute("current-inputed", FilteredCity[i].province);

            ThisDropDownContainer.remove();
        }
        DropDownContainer.append(ThisDataButton);

        let ThisDataButtonIcon = document.createElement("img");
        ThisDataButtonIcon.className = "LocationIconInsidePanel BasicMarginLR";
        ThisDataButtonIcon.src = "/Assets/images/ButtonIcon/location-icon.svg";
        ThisDataButtonIcon.style = "margin-left: 0; margin-top: auto; margin-bottom: auto;";
        ThisDataButton.append(ThisDataButtonIcon);

        let ThisDataButtonText = document.createElement("p");
        ThisDataButtonText.className = "DropDownSelectionText";
        ThisDataButtonText.innerHTML = FilteredCity[i].province + " ";
        ThisDataButton.append(ThisDataButtonText);

        // let TypeSearchAddOn = document.createElement("span");
        // TypeSearchAddOn.className = "LabelGreyHeaderSmallerTextB";
        // TypeSearchAddOn.style.width = "fit-content";
        // TypeSearchAddOn.style.color = "#344054";
        // TypeSearchAddOn.innerHTML = "(" + FilteredCity[i].type + ")";
        // ThisDataButtonText.append(TypeSearchAddOn);
    }
}


// ================================== DEFAULT FUNCTION THAT WILL BE CALLED ==================================

window.WhichPageisNow = null;
window.AlreadyCalled = false;

window.CallDefaultFunction = function(whichsection)
{
    if(window.AlreadyCalled == true)
        return

    window.AlreadyCalled = true;

    // Set Early Function ----------------------------------

    window.GetAndSetCountryID();
    window.SetSearchInputFunction(whichsection);

    window.WhichPageisNow = whichsection;

    if(whichsection == "Index")
    {
        window.SetIndexScrollFunction();
    }
    else if(whichsection == "SearchResult")
    {
        window.PrepareUISearchInfoText();
    }
    else if(whichsection == "HotelDetails")
    {
        window.PrepareUIHotelDetails();
    }
    else if(whichsection == "PaymentForm")
    {
        window.PreparePaymentForm();
    }
    else if(whichsection == "MyPing")
    {
        window.PrepareMyPingElement();
    }
    else if(whichsection == "BookingDetails")
    {
        window.PrepareBookingDetailsUI();
    }
    else if(whichsection == "AboutUs")
    {
        window.PrepareAboutUsUI();
    }
    else if(whichsection == "ContactUs")
    {
        window.PrepareContactUsUI();
    }
    else if(whichsection == "FAQ")
    {
        window.PrepareFAQUI();
    }
    else if(whichsection == "MyProfile")
    {
        window.PrepareUIMyProfile();
    }
    else if(whichsection == "Privacy")
    {
        window.PreparePrivacyUI();
    }
    else if(whichsection == "ReferralMenu")
    {
        window.PrepareVarforAllUI();
    }
    else if(whichsection == "TermsNCondition")
    {
        window.PrepareTermsConditionUI();
    }
    else if(whichsection == "VoucherMenu")
    {
        window.PrepareRewardMenuElements();
    }
    else if(whichsection == "VoucherDetails")
    {
        window.PrepareVoucherDetails();
    }
    else if(whichsection == "NotFound")
    {
        window.SetNotFoundUI();
    }

    window.CutURLToParts();
    window.AutoAnimateBackground();
    window.CheckUserInfoExist(false);
    window.LoadSomeUIImages();
    window.SetUIBasedOnLanguage();


    if(document.getElementById("HeadScriptToRemove") != null)
        document.getElementById("HeadScriptToRemove").remove();
}

// Set Some UI Image Early -----------------------------------------

window.LoadSomeUIImages = function()
{
    let FooterMainImageContainer = document.getElementById("FooterMainImageContainer");
    if(FooterMainImageContainer != null)
    {
        let FooterMainBackgroundImage = document.getElementById("FooterMainBackgroundImage");
        let LoadingBottomBackground = document.getElementById("LoadingBottomBackground");
        window.checkImageUrlValid("/Assets/images/AnimateBG/FooterNew.jpg", "/Assets/images/NoHotelImage.jpg", FooterMainBackgroundImage, () =>
        {
            window.CheckIfImageLoadedAndCallAFunction(FooterMainImageContainer, ()=>
            {
                if(LoadingBottomBackground != null)
                    LoadingBottomBackground.remove();
                FooterMainBackgroundImage.style.opacity = 1;
            });
        }, {});
    }
};


// Set Some Buttons Early -------------------------------------------

window.SetUIBasedOnLanguage = function()
{
    let ListYourAccBtnTxt = document.getElementById("ListYourAccBtnTxt");
    if(ListYourAccBtnTxt != null)
        ListYourAccBtnTxt.innerHTML = window["ListingYourAccBtnText" + window.CurrentCountryID];

    let ListYourAccBtnTxtShort = document.getElementById("ListYourAccBtnTxtShort");
    if(ListYourAccBtnTxtShort != null)
        ListYourAccBtnTxtShort.innerHTML = window["ListingYourAccBtnTextSrt" + window.CurrentCountryID];

    let LoginInButtonTop = document.getElementById("LoginInButtonTop");
    if(LoginInButtonTop != null)
        LoginInButtonTop.innerHTML = window["LoginBtnText" + window.CurrentCountryID];

    let SignInButtonTop = document.getElementById("SignInButtonTop");
    if(SignInButtonTop != null)
        SignInButtonTop.innerHTML = window["RegisterBtnText" + window.CurrentCountryID];

    let HeroBannerText = document.getElementById("HeroBannerText");
    if(HeroBannerText != null)
        HeroBannerText.innerHTML = window["HeroBannerText" + window.CurrentCountryID];

    let FooterBannerText = document.getElementById("FooterBannerText");
    if(FooterBannerText != null)
        FooterBannerText.innerHTML = window["FooterBannerText" + window.CurrentCountryID];

    let ForeMostFooterBelowText = document.getElementById("ForeMostFooterBelowText");
    if(ForeMostFooterBelowText != null)
        ForeMostFooterBelowText.innerHTML = window["ForeMostFooterBelowText" + window.CurrentCountryID];

    let FooterWhatsAppHeaderText = document.getElementById("FooterWhatsAppHeaderText");
    if(FooterWhatsAppHeaderText != null)
        FooterWhatsAppHeaderText.innerHTML = window["WhatsAppTxt" + window.CurrentCountryID];

    let FooterEmailHeaderText = document.getElementById("FooterEmailHeaderText");
    if(FooterEmailHeaderText != null)
        FooterEmailHeaderText.innerHTML = window["EmailTxt" + window.CurrentCountryID];

    let FooterAlamatHeaderText = document.getElementById("FooterAlamatHeaderText");
    if(FooterAlamatHeaderText != null)
        FooterAlamatHeaderText.innerHTML = window["AlamatTxt" + window.CurrentCountryID];

    let CompanyHeaderTextFooter = document.getElementById("CompanyHeaderTextFooter"); // Company Section ---------------
    if(CompanyHeaderTextFooter != null)
        CompanyHeaderTextFooter.innerHTML = window["CompanyTxt" + window.CurrentCountryID];

    document.getElementById("FooterTentangKamiHREF").href = "/about/" + window.CurrentCountryID;
    let FooterTentangKamiText = document.getElementById("FooterTentangKamiText");
    if(FooterTentangKamiText != null)
        FooterTentangKamiText.innerHTML = window["AboutUsTxt" + window.CurrentCountryID];

    document.getElementById("FooterContactUsHREF").href = "/contactus/" + window.CurrentCountryID;
    let FooterContactUsText = document.getElementById("FooterContactUsText");
    if(FooterContactUsText != null)
        FooterContactUsText.innerHTML = window["ContactUsTxt" + window.CurrentCountryID];

    document.getElementById("FooterTermsandConditionHREF").href = "/termsandcondition/" + window.CurrentCountryID;
    let FooterTermsandConditionText = document.getElementById("FooterTermsandConditionText");
    if(FooterTermsandConditionText != null)
        FooterTermsandConditionText.innerHTML = window["TermsNConditionTxt" + window.CurrentCountryID];

    document.getElementById("FooterPrivacyHREF").href = "/privacy/" + window.CurrentCountryID;
    let FooterPrivacyText = document.getElementById("FooterPrivacyText");
    if(FooterPrivacyText != null)
        FooterPrivacyText.innerHTML = window["PrivacyTxt" + window.CurrentCountryID];

    document.getElementById("FooterFAQHREF").href = "/frequentaskquestion/" + window.CurrentCountryID;
    let FooterFAQText = document.getElementById("FooterFAQText");
    if(FooterFAQText != null)
        FooterFAQText.innerHTML = window["FAQ2Txt" + window.CurrentCountryID];


    let InfoHeaderTextFooter = document.getElementById("InfoHeaderTextFooter"); // Info Section ---------------------
    if(InfoHeaderTextFooter != null)
        InfoHeaderTextFooter.innerHTML = window["InfoTxt" + window.CurrentCountryID];

    let FooterHowToBookText = document.getElementById("FooterHowToBookText");
    if(FooterHowToBookText != null)
        FooterHowToBookText.innerHTML = window["HowToBookTxt" + window.CurrentCountryID];

    let FooterDaftarkanAkAndaText = document.getElementById("FooterDaftarkanAkAndaText");
    if(FooterDaftarkanAkAndaText != null)
        FooterDaftarkanAkAndaText.innerHTML = window["ListingYourAccTxt" + window.CurrentCountryID];

    let FooterBlogPingingoText = document.getElementById("FooterBlogPingingoText");
    if(FooterBlogPingingoText != null)
        FooterBlogPingingoText.innerHTML = window["BlogPinginGoTxt" + window.CurrentCountryID];


    let FollowUsTextFooter = document.getElementById("FollowUsTextFooter"); // Info Section ---------------------
    if(FollowUsTextFooter != null)
        FollowUsTextFooter.innerHTML = window["FollowUsTxt" + window.CurrentCountryID];

    let FooterInstagramText = document.getElementById("FooterInstagramText");
    if(FooterInstagramText != null)
        FooterInstagramText.innerHTML = window["InstagramTxt" + window.CurrentCountryID];

    let FooterTikTokText = document.getElementById("FooterTikTokText");
    if(FooterTikTokText != null)
        FooterTikTokText.innerHTML = window["TikTokTxt" + window.CurrentCountryID];

    let FooterFacebookText = document.getElementById("FooterFacebookText");
    if(FooterFacebookText != null)
        FooterFacebookText.innerHTML = window["FacebookTxt" + window.CurrentCountryID];

    // View More Experiences And Accommodation Share -------------------------------

    let ShareAccommodationButtonText = document.getElementById("ShareAccommodationButtonText");
    if(ShareAccommodationButtonText != null)
        ShareAccommodationButtonText.innerHTML = window["ShareAccommodationTxt" + window.CurrentCountryID];

    let ShareAccommodationButtonTextMobile = document.getElementById("ShareAccommodationButtonTextMobile");
    if(ShareAccommodationButtonTextMobile != null)
        ShareAccommodationButtonTextMobile.innerHTML = window["ShareTxt" + window.CurrentCountryID];

    // Basic Check In Out ------------------------------

    let CheckInHeaderText = document.getElementById("CheckInHeaderText");
    if(CheckInHeaderText != null)
        CheckInHeaderText.innerHTML = window["CheckInTxt" + window.CurrentCountryID];

    let CheckOutHeaderText = document.getElementById("CheckOutHeaderText");
    if(CheckOutHeaderText != null)
        CheckOutHeaderText.innerHTML = window["CheckOutTxt" + window.CurrentCountryID];
    
    // Penginapan / Experience ------------------------------

    let PenginapanText = document.querySelectorAll(".PenginapanText");
    PenginapanText.forEach(thistext =>
    {
        thistext.innerHTML = window["AccommodationTxt" + window.CurrentCountryID];
    });
       
    let ExperienceText = document.querySelectorAll(".ExperienceText");
    ExperienceText.forEach(thistext =>
    {
        thistext.innerHTML = window["ExperienceTxt" + window.CurrentCountryID];
    });
         

    // Room Type ------------------------------

    let RoomTypeHeaderText = document.getElementById("RoomTypeHeaderText");
    if(RoomTypeHeaderText != null)
        RoomTypeHeaderText.innerHTML = window["RoomTypeTxt" + window.CurrentCountryID];

    // Pricing Related Text ------------------------------

    let OriginalPriceHeaderText = document.querySelectorAll('.OriginalPriceHeaderText');
    OriginalPriceHeaderText.forEach(ThisText =>
    {
        ThisText.innerHTML = window["OriginalPriceTxt" + window.CurrentCountryID];
    });

    let HideHyperlinkButtonText = document.querySelectorAll('.HideHyperlinkButtonText');
    HideHyperlinkButtonText.forEach(ThisText =>
    {
        ThisText.innerHTML = window["HideButtonTxt" + window.CurrentCountryID];
    });

    let YouSavedHeaderText = document.querySelectorAll('.YouSavedHeaderText');
    YouSavedHeaderText.forEach(ThisText =>
    {
        ThisText.innerHTML = window["YouSavedTxt2" + window.CurrentCountryID];
    });

    let SeeDetailsHyperlinkText = document.querySelectorAll('.SeeDetailsHyperlinkText');
    SeeDetailsHyperlinkText.forEach(ThisText =>
    {
        ThisText.innerHTML = window["SeeDetailsBtnTxt" + window.CurrentCountryID];
    });

    let PayAtHotelTextPaymentSection = document.querySelectorAll('.PayAtHotelTextPaymentSection');
    PayAtHotelTextPaymentSection.forEach(ThisText =>
    {
        ThisText.innerHTML = window["PayatHotelTxt" + window.CurrentCountryID];
    });

    let GuestPaymentHeaderText = document.getElementById("GuestPaymentHeaderText");
    if(GuestPaymentHeaderText != null)
        GuestPaymentHeaderText.innerHTML = window["GuestTxt" + window.CurrentCountryID];

    // Pricing Related Text ------------------------------

    let ListingMitraButtons = document.querySelectorAll('.ListingMitraButtons');
    ListingMitraButtons.forEach(ThisText =>
    {
        ThisText.href = "https://listing.pingingo.com/" + window.CurrentCountryID;
        ThisText.target = '_blank';
        ThisText.rel = 'noopener noreferrer';
    });

    // Footer -----------------------------------------------

    let FooterCopyrightText = document.querySelectorAll('.FooterCopyrightText');
    FooterCopyrightText.forEach(ThisText =>
    {
        let ThisCurrenYear = new Date().getFullYear();
        ThisText.innerHTML = "2023 - " + ThisCurrenYear +" PinginGo© All rights reserved";
    });


    
    // Right Panel Section ------------------------------

    let DaftarMitraButtonRightText = document.getElementById("DaftarMitraButtonRightText");
    if(DaftarMitraButtonRightText != null)
        DaftarMitraButtonRightText.innerHTML = window["ListingYourAccTxt" + window.CurrentCountryID];

    let MyPingButtonRightText = document.getElementById("MyPingButtonRightText");
    if(MyPingButtonRightText != null)
        MyPingButtonRightText.innerHTML = window["MyPingTxt" + window.CurrentCountryID];
    
    let ProfileButtonRightText = document.getElementById("ProfileButtonRightText");
    if(ProfileButtonRightText != null)
        ProfileButtonRightText.innerHTML = window["ProfileTxt" + window.CurrentCountryID];
    
    let ReferralButtonRightText = document.getElementById("ReferralButtonRightText");
    if(ReferralButtonRightText != null)
        ReferralButtonRightText.innerHTML = window["ReferralTxt" + window.CurrentCountryID];
    
    let MyVoucherButtonRightText = document.getElementById("MyVoucherButtonRightText");
    if(MyVoucherButtonRightText != null)
        MyVoucherButtonRightText.innerHTML = window["MyVoucherTxt" + window.CurrentCountryID];
    

    let SignOutButtonRightText = document.getElementById("SignOutButtonRightText");
    if(SignOutButtonRightText != null)
        SignOutButtonRightText.innerHTML = window["SignOutTxt" + window.CurrentCountryID];
    

    let LoginRightButton = document.getElementById("LoginRightButton");
    if(LoginRightButton != null)
    {
        LoginRightButton.onclick = function()
        {
            window.InstantiateLoginPanel('');
        }
    }
    let LoginButtonRightText = document.getElementById("LoginButtonRightText");
    if(LoginButtonRightText != null)
        LoginButtonRightText.innerHTML = window["LoginBtnText" + window.CurrentCountryID];

    
    let CollapsibleLanguageDropDownRight = document.getElementById("CollapsibleLanguageDropDownRight");
    CollapsibleLanguageDropDownRight.innerHTML = "";
    for(let i = 0; i < window.CurrentAvailableLang.length; i++)
    {
        if(window.CurrentAvailableLang[i].code == window.CurrentCountryID)
        {
            let LanguageNowRightPanelIcon = document.getElementById("LanguageNowRightPanelIcon");
            LanguageNowRightPanelIcon.src = window.CurrentAvailableLang[i].FlagIcon;

            let LanguageNowRightPanelText = document.getElementById("LanguageNowRightPanelText");
            LanguageNowRightPanelText.innerHTML = window.CurrentAvailableLang[i].LanguageName;
        }

        let LanguageButton = document.createElement("button");
        LanguageButton.className = "DropDownSelectionContainer BasicPaddingBalanced ColumnGapBasic";
        LanguageButton.style.backgroundColor = "#f5f5f5";
        LanguageButton.style.height = "fit-content";
        LanguageButton.onclick = function(event)
        {
            event.preventDefault();
            event.stopPropagation();
            
            let WaitingRefreshBlocker = window.InstantiateLoadingBlocker("WaitingRefreshBlocker");
            localStorage.setItem("current-cid", window.CurrentAvailableLang[i].code);
            window.location.reload();
        }
        CollapsibleLanguageDropDownRight.append(LanguageButton);

        let LanguageFlagIcon = document.createElement("img");
        LanguageFlagIcon.className = "BasicIconInsideInput2";
        LanguageFlagIcon.style.objectFit = "contain";
        LanguageFlagIcon.style.objectPosition = "center";
        LanguageFlagIcon.src = window.CurrentAvailableLang[i].FlagIcon;
        LanguageButton.append(LanguageFlagIcon);

        let LanguageFlagText = document.createElement("p");
        LanguageFlagText.className = "SignInTopDropDownText";
        LanguageFlagText.style.color = "#353535";
        LanguageFlagText.style.height = "fit-content";
        LanguageFlagText.innerHTML = window.CurrentAvailableLang[i].LanguageName;
        LanguageButton.append(LanguageFlagText);
    }


    

    
    // let Test = document.getElementById("Test");
    // if(Test != null)
    //     Test.innerHTML = window["Test" + window.CurrentCountryID];
}

window.BackArrowNonPayment = null;
window.BackArrowNonPaymentA = null;

window.SetSomeButtons = function()
{
    window.BackArrowNonPayment = document.getElementById("BackArrowNonPayment");
    window.BackArrowNonPaymentA = document.getElementById("BackArrowNonPaymentA");

    if(window.BackArrowNonPaymentA != null)
    {
        if(document.referrer)
        {
            window.BackArrowNonPaymentA.href = document.referrer;
        }
        else
        {
            window.BackArrowNonPayment.href = "/";
        }

    }
    if(window.BackArrowNonPayment != null)
    {
        window.BackArrowNonPayment.onclick = function()
        {
            window.event.preventDefault();
            window.event.stopPropagation();
            if(document.referrer)
            {
                window.history.back();
            }
            else
            {
                window.BackArrowNonPayment.href = "/";
            }
        }
    }
}

// ================================== GET AND SET COUNTRY ID ===========================================

window.GetAndSetCountryID = function()
{
    if(localStorage.getItem("current-cid") == null)
    {
        localStorage.setItem("current-cid", window.CurrentCountryID);
    }
    else
    {
        window.CurrentCountryID = localStorage.getItem("current-cid");
    }

    // Reinstantiate The Top Panel --------------------------------------

    let LanguageChangeTopMenu = document.getElementById("LanguageChangeTopMenu");
    LanguageChangeTopMenu.innerHTML = "";

    let LangProfileIconDiv = document.createElement("div");
    LangProfileIconDiv.className = "UserTopProfileIcon BasicThinGreyBorder Selectable2";
    LangProfileIconDiv.onclick = function()
    {
        window.ChangeLangDropDown(LanguageChangeTopMenu);
    }
    LanguageChangeTopMenu.append(LangProfileIconDiv);

    let LangProfileIconImg = document.createElement("img");
    LangProfileIconImg.className = "ImageFullCover";
    LangProfileIconDiv.append(LangProfileIconImg);

    for(let i = 0; i < window.CurrentAvailableLang.length; i++)
    {
        if(window.CurrentAvailableLang[i].code == window.CurrentCountryID)
        {
            LangProfileIconImg.src = window.CurrentAvailableLang[i].FlagIcon;
        }
    }
}

// ================================== SPLIT URL TO PARTS ==================================================

window.URLCutArray = null;
window.TempSlugFromHTML = null;

window.CutURLToParts = function()
{
    let path = window.location.pathname;

    // path = path.replace(/\.html$/, "");

    window.URLCutArray = path.split("/");

    window.URLCutArray.forEach(Array => {
        if(Array.includes(".html") == true)
        {
            window.TempSlugFromHTML = Array.replace(/\.html$/, "");
        }
    });
}

// ================================== SET BACKGROUND COLOR AND TEXT COLOR BASED ON STATUS ==================================

window.SetBackgroundAndTextColorBasedOnStatus = function(thisstatus, whichtextcontainer)
{
    let BackgroundColor = "#e9e9e9";
    let TextColor = "b0b0b0";

    for(let i = 0; i < window.ColorPaletteBasedOnStatus.length; i++)
    {
        for(let j = 0; j < window.ColorPaletteBasedOnStatus[i].status.length; j++)
        {
            if(window.ColorPaletteBasedOnStatus[i].status[j] == thisstatus)
            {
                BackgroundColor = window.ColorPaletteBasedOnStatus[i].backgroundcolor;
                TextColor = window.ColorPaletteBasedOnStatus[i].textcolor;
            }
        }
    }

    // Change The Background Color --------------------------------------
    whichtextcontainer.style.backgroundColor = BackgroundColor;

    // Prepare to Change status Based on Lang -----------------------------

    let StatusBasedOnLang = "";

    for(let i = 0; i < window.TranslatedRoomStatusTxt.length; i++)
    {
        if(window.TranslatedRoomStatusTxt[i].status == thisstatus)
        {
            StatusBasedOnLang = window.TranslatedRoomStatusTxt[i].text_lang[window.CurrentCountryID];
        }
    }

    // Change Text Color based on whether it has P element or not --------------------------------------

    const TextsInsideContainer = whichtextcontainer.querySelectorAll('p');
    if(TextsInsideContainer.length > 0)
    {
        TextsInsideContainer.forEach(p =>
        {
            p.style.color = TextColor;
            p.innerHTML = StatusBasedOnLang;
        });
    }
    else
    {
        whichtextcontainer.append(StatusBasedOnLang);
        whichtextcontainer.style.color = TextColor;
    }
}

// =================================== SET GOOGLE ANALYTICS ===================================

window.SetGoogleAnalytics = function()
{
    if(window.location.hostname != "beta.pingingo.com" && window.location.pathname.includes("/new_beta") == false && window.location.hostname != "test.pingingo.com")
    {
        let GoogleManagerScript = document.createElement("script");
        GoogleManagerScript.type = "text/javascript";
        GoogleManagerScript.async = true;
        GoogleManagerScript.src = "https://www.googletagmanager.com/gtag/js?id=G-DP4SX8KLFM";
        window.$("head").append(GoogleManagerScript);

        window.dataLayer = window.dataLayer || [];

        window.gtag = function()
        {
            window.dataLayer.push(arguments);
        }

        window.gtag('js', new Date());
        window.gtag('config', 'G-DP4SX8KLFM');

        (function(w,d,s,l,i)
        {
            w[l]=w[l]||[];

            w[l].push({
                'gtm.start': new Date().getTime(),
                event:'gtm.js'
            });

            window.f=d.getElementsByTagName(s)[0];
            window.j=d.createElement(s);
            window.dl=l!='dataLayer'?'&l='+l:'';

            window.j.async = true;
            window.j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + window.dl;

            window.f.parentNode.insertBefore(window.j, window.f);
        })(window,document,'script','dataLayer','GTM-56BS4FKZ');

        let GoogleTagManagerIframe = document.createElement("iframe");
        GoogleTagManagerIframe.style.height = "0";
        GoogleTagManagerIframe.style.width = "0";
        GoogleTagManagerIframe.style="display:none; visibility:hidden";
        GoogleTagManagerIframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-56BS4FKZ";
        window.$("head").append(GoogleTagManagerIframe);

    }
}

window.SetGoogleAnalytics();

window.SetIndexScrollFunction = function()
{
    if(window.location.pathname === "/" || window.location.pathname.toLowerCase().endsWith("index.php"))
    {
        window.addEventListener("scroll", function()
        {
            if(window.scrollY==0)
            {
                document.getElementById('TopCornerButtonContainer').className = "TopMenuPanel";
            }
            else
            {
                document.getElementById('TopCornerButtonContainer').className = "TopMenuPanel TopCornerButtonContainerScrolled";
            }
        });
    }
}

// =================================== CAPITALIZE LETTER =======================================

window.CapitalizeEveryLetter = function(whatword)
{
    let CapitalizeThis = true;
    let CapitalizedWord = "";
    for(let i = 0; i < whatword.length; i++)
    {
        if(CapitalizeThis == true)
        {
            CapitalizedWord = CapitalizedWord + whatword.charAt(i).toUpperCase();
            CapitalizeThis = false;
        }
        else
        {
            CapitalizedWord = CapitalizedWord + whatword.charAt(i);
            if(whatword.charAt(i) == " ")
            {
                CapitalizeThis = true;
            }
            else
            {
                CapitalizeThis = false;
            }
        }

    }
    return CapitalizedWord;
}

// ==================================== CONVERT EMPTY STRING TO NULL =============================

window.ConvertJSONEmptyToNull = function(obj)
{
    if (Array.isArray(obj))
    {
        return obj.map(window.ConvertJSONEmptyToNull);
    }
    else if (obj !== null && typeof obj === 'object')
    {
        return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, window.ConvertJSONEmptyToNull(value)]));
    }
    else
    {
        return obj === "" ? null : obj;
    }
}

// ==================================== CONVERT PRICE TO RP =======================================

window.ConvertTextToRP = function(whichvalue, whichtype, addlasttwoddigit, isreduce)
{
    let WhichRpToReturn = "----";

    if(whichvalue !== null && whichvalue !== "" && whichvalue !== undefined)
    {
        let ThisMoneyValue = whichvalue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        if(isreduce)
        {
            ThisMoneyValue = "-" + ThisMoneyValue;
        }

        if(whichtype == 1)
        {
            WhichRpToReturn = "Rp " + ThisMoneyValue;
        }
        else if(whichtype == 2)
        {
            WhichRpToReturn = "IDR " + ThisMoneyValue;
        }
        else if(whichtype == 3)
        {
            WhichRpToReturn = ThisMoneyValue;
        }

        if(addlasttwoddigit == true)
        {
            WhichRpToReturn = WhichRpToReturn + ",00";
        }
    }

    return WhichRpToReturn;
}

// =================================== CHECK URL VALIDITY ==============================================

window.CheckIsValidURL = function(urlinput, whattype)
{
   let pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
       '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
       '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
       '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
       '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
       '(\\#[-a-z\\d_]*)?$','i'); // fragment locator

    if(whattype == "TikTok")
    {
        pattern = /^https?:\/\/(www\.)?tiktok\.com\/(@[a-zA-Z0-9._]+|[^\/]+\/video\/\d+)/i;
    }
    else if(whattype == "Instagram")
    {
        pattern = /^https?:\/\/(www\.)?instagram\.com\/([a-zA-Z0-9._]+(\/)?|(?:p|reel|stories|tv)\/[a-zA-Z0-9_-]+)(\?.*)?$/i;
    }
    else if(whattype == "Google Maps")
    {
        pattern = /^https?:\/\/(?:(?:www\.)?google\.[a-z.]+\/maps(?:\/(?:place|dir|search|@|embed))?|(?:www\.)?google\.[a-z.]+\/maps(\?.+)?|goo\.gl\/maps|maps\.app\.goo\.gl)\/?.*$/i;
    }

   return !!pattern.test(urlinput);
}

// =================================== CHECK EMAIL VALIDITY / VALIDATE EMAIL & PASSWORD ===============================

window.CheckEmailValidity = function(email)
{
    let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}


window.CheckEmailValidityBackEnd = async function(email)
{
    let CheckEmailValidtyURL = "/v2/check/email/form";
    let formData = new FormData();
    formData.append("email", email);

    try
    {
        const response = await api.request(CheckEmailValidtyURL,
        {
            method: "POST",
            data: formData
        });

        const result = response.data;
        console.log(result);

        return result.valid;
    } 
    catch (error)
    {
        //console.error("Error checking email:", error);
        return false
    }
};

window.ConfirmTwoPasswordInputCorrect = function(NewPasswordInput, ConfirmPasswordInput, NewPasswordContainer, ConfirmPasswordContainer, NewPasswordWarning, ConfirmPasswordWarning, allowchange)
{
    let IsInputtedValid = true;

    if(NewPasswordInput == ""  || NewPasswordInput.replace(/ /g, "") == "") // If New Password Empty
    {
        IsInputtedValid = false;
        NewPasswordWarning.innerHTML = window["NewPasswordCannotBeEmpty" + window.CurrentCountryID];
    }
    else if(window.CheckPasswordInputted(NewPasswordInput, NewPasswordWarning) == false) // If Not Strong Enough
    {
        IsInputtedValid = false;
    }

    if(IsInputtedValid == false) // If New Password Not Acceptable
    {
        if(allowchange == true)
        {
            // ------------------------- Apply Change To Input Container -------------------------
            if(NewPasswordContainer.classList.contains("InputFieldWarningOutline") == false)
            {
                NewPasswordContainer.classList.add("InputFieldWarningOutline");
            }

            // ------------------------- Apply Change To Warning Text -------------------------
            if(NewPasswordWarning.classList.contains("RedWarningHidden") == true)
            {
                NewPasswordWarning.classList.remove("RedWarningHidden");
            }
        }
    }
    else // If New Password Acceptable
    {
        if(ConfirmPasswordInput == ""  || ConfirmPasswordInput.replace(/ /g, "") == "") // If Confirm Password Empty
        {
            IsInputtedValid = false;
            ConfirmPasswordWarning.innerHTML = window["ConfirmPasswordEmptyText" + window.CurrentCountryID];
        }
        else if(NewPasswordInput != ConfirmPasswordInput) // If Confirm Password Not Same
        {
            IsInputtedValid = false;
            ConfirmPasswordWarning.innerHTML = window["ConfirmPasswordNotSame" + window.CurrentCountryID];
        }

        if(IsInputtedValid == false)
        {
            if(allowchange == true)
            {
                // ------------------------- Apply Change To Input Container -------------------------
                if(ConfirmPasswordContainer.classList.contains("InputFieldWarningOutline") == false)
                {
                    ConfirmPasswordContainer.classList.add("InputFieldWarningOutline");
                }

                // ------------------------- Apply Change To Warning Text -------------------------
                if(ConfirmPasswordWarning.classList.contains("RedWarningHidden") == true)
                {
                    ConfirmPasswordWarning.classList.remove("RedWarningHidden");
                }
            }
        }
    }

    return IsInputtedValid;
}

window.CheckPasswordInputted = function(password, textwarningdisplayer)
{
    let strength = 0;
    let IsOkay = true;

    if (password.match(/[a-z]+/))
    {
      strength += 1;
    }
    if (password.match(/[A-Z]+/))
    {
      strength += 1;
    }
    if (password.match(/[0-9]+/))
    {
      strength += 1;
    }
    if (password.match(/[$@#&!]+/))
    {
      strength += 1;
    }


    if(password.length < window.MinimalPasswordCharacter)
    {
        textwarningdisplayer.innerHTML = window["MinPassWarning" + window.CurrentCountryID];
        IsOkay = false;
    }
    else if(strength < 3)
    {
        textwarningdisplayer.innerHTML = window["PassNotStrong" + window.CurrentCountryID];
        IsOkay = false;
    }
    else
    {
        IsOkay = true;
    }

    return IsOkay;

    // switch (strength)
    // {
    //   case 0:
    //     IsOkay = false;
    //     break;

    //   case 1:
    //     IsOkay = false;
    //     break;

    //   case 2:
    //     IsOkay = false;
    //     break;

    //   case 3:
    //     strengthbar.value = 75;
    //     break;

    //   case 4:
    //     strengthbar.value = 100;
    //     break;
    // }
}

// ==================================== CHECK REFERRAL & ID CARD =========================================

window.CheckReferralIDExist = function(ReferralInput, iduser, callback)
{
    let CheckRefIDBlocker = window.InstantiateLoadingBlocker("CheckRefIDBlocker");

    fetch("/function/check_referral_member.php?id_referral=" + encodeURIComponent(ReferralInput) + "&id_user=" + encodeURIComponent(iduser))
    .then(response => response.json())
    .then(data =>
    {
        let CheckReferralData = data[0];
        console.log(CheckReferralData);

        let ResultReturn = true;
        if(CheckReferralData.referral_available_to_use == "No")
        {
            ResultReturn = CheckReferralData.why;
        }
        CheckRefIDBlocker.remove();
        callback(ResultReturn);
    })
    .catch(error =>
    {
        callback('Error in A:', error);
        CheckRefIDBlocker.remove();
    });
}

window.CheckPhoneNumberAlreadyUsed = function(userid, countrycodeinput, phonenumberinput, isedit, callback)
{
    let CheckPhoneNumberBlocker = window.InstantiateLoadingBlocker("CheckPhoneNumberBlocker");
    let CheckPhoneNumberURL = "/v2/phone-number/check";

    let formData = new FormData();
    formData.append("country-code", countrycodeinput);
    formData.append("number", phonenumberinput);

    if(isedit == true)
        formData.append('id_user', userid);

    console.log(CheckPhoneNumberURL);
    console.log(window.ConvertFormDataToJSON(formData));

    window.CallApiAxios({
        method: "POST",
        url: CheckPhoneNumberURL,
        data: formData
    }).then(res =>
    {
        console.log(res);
        CheckPhoneNumberBlocker.remove();
        callback(true, res.data.message);
    })
    .catch(err =>
    {
        //console.error(err);
        CheckPhoneNumberBlocker.remove();
        callback(false, err.data.message);
    });
}

window.CheckIDCardUsed = function(userid, IDCardInput, isedit, callback)
{
    let CheckIDBlocker = window.InstantiateLoadingBlocker("CheckIDBlocker");
    let IDCardURL = "/v2/ktp/check";

    let formData = new FormData();
    formData.append("ktp", IDCardInput);

    if(isedit == true)
        formData.append('id_user', userid);

    console.log(IDCardURL);
    console.log(window.ConvertFormDataToJSON(formData));

    window.CallApiAxios({
        method: "POST",
        url: IDCardURL,
        data: formData
    }).then(res =>
    {
        console.log(res);
        CheckIDBlocker.remove();
        callback(true, res.data.message);
    })
    .catch(err =>
    {
        //console.error(err);
        CheckIDBlocker.remove();
        callback(false, err.data.message);
    });
}

// =================================== CHECK LOGIN AND LOG IN ===================================

window.CheckUserInfoExist = function(isonlyload)
{
    initAuth((loggedin) =>
    {
        //console.log("FULL AUTH DATA:", MainSession);
        //console.log("MAIN USER DATA:", BasicInfoSession);
        //console.log("USER LOGGED IN:", loggedin);

        let TopWhereToInstantiate = document.getElementById("UserTopInfoWrapper");

        if(loggedin == true) // Remove Function On The Right Based On Login Status
        {
            let RemoveIfLoggedin = document.querySelectorAll(".RemoveIfLoggedin");
            RemoveIfLoggedin.forEach(thiselement =>
            {
                thiselement.remove();    
            });
        }
        else
        {
            let RemoveIfNotLogin = document.querySelectorAll(".RemoveIfNotLogin");
            RemoveIfNotLogin.forEach(thiselement =>
            {
                thiselement.remove();    
            });
        }

        if(window.CheckAvailableToAccessMaintenance(BasicInfoSession, loggedin) == false)
        {
            window.DisplayMaintenance();
            return
        }
        else
        {
            window.SetSomeButtons();
        }

        if(isonlyload == true)
            return

        if(loggedin == true) // If Log In by Google or Normal Email -----------
        {
            window.InstantiateTopUserPanel(MainSession);
        }
        else // Not Logged In ----------------------------------------------------------------------------------
        {
            if(document.getElementById("UserInfoTopWrapper") != null)
            {
                document.getElementById("UserInfoTopWrapper").style.display = "none";
            }
            

            if(document.getElementById("LoginInButtonTop") == null)
            {
                let SignInButton = document.createElement("button");
                SignInButton.className = "BasicTextButton BasicBoxShadow OrangeButton2 SignInButtonTop Selectable";
                SignInButton.id = "LoginInButtonTop";
                SignInButton.innerHTML = window["LoginBtnText" + window.CurrentCountryID];
                SignInButton.onclick = function()
                {
                    window.InstantiateLoginPanel('');
                }
                TopWhereToInstantiate.append(SignInButton);
            }

            if(document.getElementById("SignInButtonTop") == null)
            {
                let SignInButton = document.createElement("button");
                SignInButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
                SignInButton.id = "SignInTopButton";
                SignInButton.innerHTML = window["RegisterBtnText" + window.CurrentCountryID];
                SignInButton.onclick = function()
                {
                    window.InstantiateLoginPanel('');
                }
                TopWhereToInstantiate.append(SignInButton);
            }

            if(sessionStorage.getItem("GoogleLoginPopUP") == null)
            {
                sessionStorage.setItem("GoogleLoginPopUP", true);
                window.InstantiateGoogleLoginNotif();
            }
        }

        // Set Filter Search Button Function --------------------------------

        let FunctionOnFilterSearchChange = function()
        {
            window.OnChangeFilterMainSearch(MainSession, loggedin, window.WhichPageisNow)
        }

        let TopHomeSearchFilterButton = document.querySelectorAll(".TopHomeSearchFilterButton");
        TopHomeSearchFilterButton.forEach(thisbutton =>
        {
            let ThisFilterType = thisbutton.getAttribute("this-value");

            thisbutton.onchange = function()
            {
                console.log("ThisFilterType", ThisFilterType);
                window.SearchFilterType = ThisFilterType;

                FunctionOnFilterSearchChange();
            }

            if(window.SearchFilterType == ThisFilterType)
            {
                thisbutton.checked = true;
            }
        });

        

        // Call Function Based On Current Page -------------------------------

        if(window.WhichPageisNow == "Index")
        {
            window.CheckIndexStatus(MainSession, loggedin, ()=>FunctionOnFilterSearchChange());
        }
        else if(window.WhichPageisNow == "SearchResult")
        {
            window.SearchSectionPrepareInfo(()=>FunctionOnFilterSearchChange());
        }
        else if(window.WhichPageisNow == "HotelDetails")
        {
            window.LoadAllHotelDetails(MainSession, loggedin, ()=>FunctionOnFilterSearchChange());
        }
        else if (window.WhichPageisNow == "PaymentForm")
        {
            window.SetFunctionPayment(MainSession, loggedin);
        }
        else if (window.WhichPageisNow == "MyProfile")
        {
            window.SetMyProfileInput(MainSession, loggedin);
        }
        else if (window.WhichPageisNow == "MyPing")
        {
            window.PrepareMyPingInfoAfterCheckUser(MainSession, loggedin);
        }
        else if (window.WhichPageisNow == "BookingDetails")
        {
            window.LoadBookingDetails(MainSession, BasicInfoSession, loggedin);
        }
        else if(window.WhichPageisNow == "ReferralMenu")
        {
            window.LoadAllRefData(MainSession, BasicInfoSession, loggedin);
        }
        else if(window.WhichPageisNow == "VoucherMenu")
        {
            window.AssignFunctionVariableRewardMenu(MainSession, loggedin);
        }
        else if(window.WhichPageisNow == "VoucherDetails")
        {
            window.AssignAllVariableVoucherDetails(MainSession, loggedin);
        }
    });
}


window.Orda = ["country_code", "email","first_name","ktp_passport","last_name","phone_number"];
window.OrdaNw = ["provider", "token","platform","expired_at"];

window.InstantiateTopUserPanel = function(thismaindata)
{
    let tokenget = thismaindata.usd_PING_tkn;

    let TopWhereToInstantiate = document.getElementById("UserTopInfoWrapper");

    if (document.getElementById("SignInButtonTop") != null)
    {
        document.getElementById("SignInButtonTop").remove();
    }

    if (document.getElementById("LoginInButtonTop") != null)
    {
        document.getElementById("LoginInButtonTop").remove();
    }


    if (document.getElementById("UserInfoTopWrapper") != null)
    {
        document.getElementById("UserInfoTopWrapper").style.display = "flex";
    }

    
    let SignOutRightButton = document.getElementById("SignOutRightButton");
    if(SignOutRightButton != null)
    {
        SignOutRightButton.onclick = function()
        {
            window.LogOutUserFunction(thismaindata, true);
        }
    }

    // if (document.getElementById("UserInfoTopWrapper") == null)
    // {
    //     let UserTopInfoWrapper = document.createElement("div");
    //     UserTopInfoWrapper.className = "UserTopInfoWrapper";
    //     UserTopInfoWrapper.id = "UserInfoTopWrapper";
    //     TopWhereToInstantiate.append(UserTopInfoWrapper);

    //     let UserTopProfileIcon = document.createElement("div");
    //     UserTopProfileIcon.className = "UserTopProfileIcon";
    //     UserTopProfileIcon.id = "UserTopProfileIcon";
    //     UserTopInfoWrapper.append(UserTopProfileIcon);

    //     // Check First & Last Name ----------------------

    //     let UserTopProfileName = document.createElement("p");
    //     UserTopProfileName.className = "UserTopProfileName InterBoldTextFont";
    //     UserTopProfileName.id = "UserTopProfileName";
    //     UserTopInfoWrapper.append(UserTopProfileName);

    //     // ---------------------------------------------------------

    //     let ToggleArrow = document.createElement("img");
    //     ToggleArrow.className = "BasicInputFieldChevronIconSearch ToggleArrow Selectable2";
    //     // ToggleArrow.src = "/Assets/images/ButtonIcon/chevron-blue.svg";
    //     ToggleArrow.id = "ToggleArrowTopUser";
    //     ToggleArrow.style.rotate = "0deg";
    //     UserTopInfoWrapper.append(ToggleArrow);
    // }
    

    // ------------------------------------------ Assign All Changes ------------------------------------------

    // Profile Picture -----------------------------------------------------------------------

    let UserTopProfileIcon = document.getElementById("UserTopProfileIcon");
    UserTopProfileIcon.innerHTML = "";

    let LoadingProfilePic = document.createElement("div");
    LoadingProfilePic.className = "loading_grey ImageFullCover";
    UserTopProfileIcon.append(LoadingProfilePic);

    let ImageFullCover = document.createElement("img");
    ImageFullCover.className = "ImageFullCover";
    ImageFullCover.style.opacity = 0;
    UserTopProfileIcon.append(ImageFullCover);

    window.checkImageUrlValid(BasicInfoSession.prof_pic, "/Assets/images/ProfilePicture.jpg", ImageFullCover, () =>
    {
        window.CheckIfImageLoadedAndCallAFunction(UserTopProfileIcon, () =>
        {
            LoadingProfilePic.remove();
            ImageFullCover.style.opacity = 1;
        });
    }, { quality: 70 });

    // User Name -----------------------------------------------------------------------

    let FirstName = BasicInfoSession.first_name;
    let LastName = BasicInfoSession.last_name;
    let NameToDisplay = "";
    let UserExist = true;

    if (FirstName != null && FirstName.replace(/ /g, "") != "" && FirstName != "-")
    {
        if (LastName != "")
        {
            NameToDisplay = FirstName + " " + LastName;
        }
        else
        {
            NameToDisplay = FirstName;
        }
    }
    else
    {
        NameToDisplay = "Newuser" + BasicInfoSession.no;
        UserExist = false;
        if(sessionStorage.getItem("NewUserGuideDisplayed") == null)
        {
            sessionStorage.setItem("NewUserGuideDisplayed", true);
            window.InstantiateEditInfoGuide(thismaindata, document.getElementById("UserInfoTopWrapper"), NameToDisplay, UserExist);
        }
    }
    document.getElementById("UserTopProfileName").innerHTML = NameToDisplay;

    // Toggle Arrow -----------------------------------------------------------------------
    document.getElementById("ToggleArrowTopUser").onclick = function ()
    {
        window.RotateToggle("ToggleArrowTopUser", true);
        window.TopUserDropDown(thismaindata, document.getElementById("UserInfoTopWrapper"), UserExist);
    };
}


// =================================== LOG OUT FUNCTION ===============================================

window.LogOutUserFunction = function(thismaindata, isallowrefresh)
{
    let LogoutBlocker = window.InstantiateLoadingBlocker("LogoutBlocker");

    (async () =>
    {
        let URLLogOut = "/v2/auth/logout";

        let formData = new FormData();
        formData.append('token', thismaindata.usd_PING_tkn);
        formData.append('lang', window.CurrentCountryID);
        await window.getBrowserData(formData);

        console.log(window.ConvertFormDataToJSON(formData));

        window.CallApiAxios({
            method: "POST",
            url: URLLogOut,
            data: formData,
        }).then(res =>
        {
            console.log(URLLogOut);
            console.log(res);

            if(res.status == 200)
            {
                let LogOutData = res.data;

                if(LogOutData.success == true && LogOutData.message == "Logout success")
                {
                    if(thismaindata.pvd_PING == "google") // If Logged In Using Google --------------------------
                    {
                        logoutauthservice((response) =>
                        {
                            if(!response.ok)
                            {
                                LogoutBlocker.remove();
                                window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["ErrorWhenLogOutTxt" + window.CurrentCountryID]);
                            }
                            else
                            {
                                if(sessionStorage.getItem("NewUserGuideDisplayed") != null)
                                    sessionStorage.removeItem("NewUserGuideDisplayed");

                                if(isallowrefresh == true)
                                {
                                    window.location.reload();
                                }
                                else
                                {
                                    LogoutBlocker.remove();
                                    window.CheckAndReinstantiateNoLoginPanel()
                                }
                            }
                        })
                    }
                    else // If Logged In Using Normal Method ------------------------------
                    {
                        clearCookieUser();

                        if(sessionStorage.getItem("NewUserGuideDisplayed") != null)
                            sessionStorage.removeItem("NewUserGuideDisplayed");
                        
                        if(isallowrefresh == true)
                        {
                            window.location.reload();
                        }
                        else
                        {
                            LogoutBlocker.remove();
                            window.CheckAndReinstantiateNoLoginPanel();
                        }
                    }
                }
                else
                {
                    LogoutBlocker.remove();
                    window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["ErrorWhenLogOutTxt" + window.CurrentCountryID]);
                }
            }
        })
        .catch(err =>
        {
            //console.error(err);
            LogoutBlocker.remove();
            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["ErrorWhenLogOutTxt" + window.CurrentCountryID]);
        });
    })();
}

// ================================== REINSTIATE TOP BUTTON WITHOUT LOGIN =====================================

window.CheckAndReinstantiateNoLoginPanel = function()
{
    if(document.getElementById("LoginInButtonTop") != null && document.getElementById("SignInButtonTop") != null)
    {
        if(document.getElementById("UserInfoTopWrapper") != null)
        {
            document.getElementById("UserInfoTopWrapper").remove();
        }

        let TopWhereToInstantiate = document.getElementById("UserTopInfoWrapper");

        let LoginInButtonTop = document.createElement("button"); // Login -----------------------------------------------------
        LoginInButtonTop.className = "BasicTextButton BasicBoxShadow OrangeButton2 SignInButtonTop Selectable";
        LoginInButtonTop.id = "LoginInButtonTop";
        LoginInButtonTop.onclick = function()
        {
            window.InstantiateLoginPanel('')
        }
        LoginInButtonTop.innerHTML = window["LoginBtnText" + window.CurrentCountryID];
        TopWhereToInstantiate.append(LoginInButtonTop);

        let SignInButtonTop = document.createElement("button"); // Register -----------------------------------------------------
        SignInButtonTop.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
        SignInButtonTop.id = "SignInButtonTop";
        SignInButtonTop.onclick = function()
        {
            window.InstantiateLoginPanel('')
        }
        SignInButtonTop.innerHTML = window["RegisterBtnText" + window.CurrentCountryID];
        TopWhereToInstantiate.append(SignInButtonTop);
    }

}

// ============================ DROP DOWN TOP ===================================

window.ChangeLangDropDown = function(langtopcontainer)
{
    window.event.preventDefault();
    window.event.stopPropagation();
    
    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown("TopLangDropDownContainer", langtopcontainer);
    
    if(ThisDropDownContainer == null)
        return

    ThisDropDownContainer.className = "ContainerFlex ContainerFlex2";
    ThisDropDownContainer.innerHTML = "";

    let DropDownContainer = document.createElement("div");
    DropDownContainer.className = "DropDownContainer SignInDropDownContainer HideScrollBar";
    ThisDropDownContainer.append(DropDownContainer);

    for(let i = 0; i < window.CurrentAvailableLang.length; i++)
    {
        let LangDropDownButton = document.createElement("button");
        LangDropDownButton.className = "DropDownSelectionContainer";
        if(window.CurrentCountryID == window.CurrentAvailableLang[i].code)
        {
            LangDropDownButton.className = "DropDownSelectionContainer DropDownSelectionContainerSelected";
            LangDropDownButton.onclick = function(event)
            {
                event.preventDefault();
                event.stopPropagation();

                ThisDropDownContainer.remove();
            }
        }
        else
        {
            LangDropDownButton.onclick = function(event)
            {
                event.preventDefault();
                event.stopPropagation();

                let WaitingRefreshBlocker = window.InstantiateLoadingBlocker("WaitingRefreshBlocker");

                localStorage.setItem("current-cid", window.CurrentAvailableLang[i].code);
                window.location.reload();
            }
        }
        DropDownContainer.append(LangDropDownButton);

        let LangDropDownIcon = document.createElement("img");
        LangDropDownIcon.className = "DropDownSelectionIMGIcon";
        LangDropDownIcon.src = window.CurrentAvailableLang[i].FlagIcon;
        LangDropDownButton.append(LangDropDownIcon);

        let LangDropDownText = document.createElement("p");
        LangDropDownText.className = "SignInTopDropDownText";
        LangDropDownText.innerHTML = window.CurrentAvailableLang[i].LanguageName;
        LangDropDownButton.append(LangDropDownText);
    }
}


window.TopUserDropDown = function(thismaindata, usertopcontainer, UserExist)
{
    window.event.preventDefault();
    window.event.stopPropagation();
        

    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown("TopUserDropDownContainer", usertopcontainer);

    if(ThisDropDownContainer == null)
        return

    ThisDropDownContainer.className = "ContainerFlex ContainerFlex2";
    ThisDropDownContainer.innerHTML = "";


    let DropDownContainer = document.createElement("div");
    DropDownContainer.className = "DropDownContainer SignInDropDownContainer HideScrollBar";
    DropDownContainer.style.maxHeight = "none";
    ThisDropDownContainer.append(DropDownContainer);

    // My Ping -------------------------------------

    let MyPingButton = document.createElement("button");
    MyPingButton.className = "DropDownSelectionContainer";
    DropDownContainer.append(MyPingButton);

    let MyPingButtonIcon = document.createElement("img");
    MyPingButtonIcon.className = "DropDownSelectionIMGIcon";
    window.GetOneImageCache("/Assets/images/ButtonIcon/pingicon.svg", MyPingButtonIcon);
    MyPingButton.append(MyPingButtonIcon);

    let MyPingButtonText = document.createElement("p");
    MyPingButtonText.className = "SignInTopDropDownText";
    MyPingButtonText.innerHTML = window["MyPingTxt" + window.CurrentCountryID];
    MyPingButton.append(MyPingButtonText);

    let MyPingButtonHREF = document.createElement("a");
    MyPingButtonHREF.className = "HREFInsideContainer";
    MyPingButtonHREF.href = "/myping/" + window.CurrentCountryID;
    MyPingButton.append(MyPingButtonHREF);

    // Profile -------------------------------------

    let ProfileButton = document.createElement("button");
    ProfileButton.className = "DropDownSelectionContainer";
    DropDownContainer.append(ProfileButton);

    let ProfileButtonIcon = document.createElement("img");
    ProfileButtonIcon.className = "DropDownSelectionIMGIcon";
    window.GetOneImageCache("/Assets/images/ButtonIcon/ProfileIcon.svg", ProfileButtonIcon);
    ProfileButton.append(ProfileButtonIcon);

    let ProfileButtonText = document.createElement("p");
    ProfileButtonText.className = "SignInTopDropDownText";
    ProfileButtonText.innerHTML = window["ProfileTxt" + window.CurrentCountryID];
    ProfileButton.append(ProfileButtonText);

    if(UserExist == false)
    {
        let UpdateProfileText = document.createElement("p");
        UpdateProfileText.className = "BasicCircularRectangleText InterRegularTextFont";
        UpdateProfileText.style="background-color: #ED7C42; white-space: nowrap;";
        UpdateProfileText.innerHTML = window["UpdateProfile" + window.CurrentCountryID];
        ProfileButton.append(UpdateProfileText);
    }

    let ProfileButtonHREF = document.createElement("a");
    ProfileButtonHREF.className = "HREFInsideContainer";
    ProfileButtonHREF.href = "/myprofile/" + window.CurrentCountryID;
    ProfileButton.append(ProfileButtonHREF);

    // Referral -------------------------------------

    let ReferralButton = document.createElement("button");
    ReferralButton.className = "DropDownSelectionContainer";
    DropDownContainer.append(ReferralButton);

    let ReferralButtonIcon = document.createElement("img");
    ReferralButtonIcon.className = "DropDownSelectionIMGIcon";
    window.GetOneImageCache("/Assets/images/ButtonIcon/referralicon.svg", ReferralButtonIcon);
    ReferralButton.append(ReferralButtonIcon);

    let ReferralButtonText = document.createElement("p");
    ReferralButtonText.className = "SignInTopDropDownText";
    ReferralButtonText.innerHTML = window["ReferralTxt" + window.CurrentCountryID];
    ReferralButton.append(ReferralButtonText);

    let ReferralButtonHREF = document.createElement("a");
    ReferralButtonHREF.className = "HREFInsideContainer";
    ReferralButtonHREF.href = "/referral/" + window.CurrentCountryID;
    ReferralButton.append(ReferralButtonHREF);

    // My Voucher -------------------------------------

    let MyVoucherButton = document.createElement("button");
    MyVoucherButton.className = "DropDownSelectionContainer";
    DropDownContainer.append(MyVoucherButton);

    let MyVoucherButtonIcon = document.createElement("img");
    MyVoucherButtonIcon.className = "DropDownSelectionIMGIcon";
    window.GetOneImageCache("/Assets/images/ButtonIcon/ticket-voucher.svg", MyVoucherButtonIcon);
    MyVoucherButton.append(MyVoucherButtonIcon);

    let MyVoucherButtonText = document.createElement("p");
    MyVoucherButtonText.className = "SignInTopDropDownText";
    MyVoucherButtonText.innerHTML = window["MyVoucherTxt" + window.CurrentCountryID];
    MyVoucherButton.append(MyVoucherButtonText);

    let MyVoucherButtonHREF = document.createElement("a");
    MyVoucherButtonHREF.className = "HREFInsideContainer";
    MyVoucherButtonHREF.href = "/vouchermenu/" + window.CurrentCountryID;
    MyVoucherButton.append(MyVoucherButtonHREF);

    // Sign Out -------------------------------------

    let SignOutButton = document.createElement("button");
    SignOutButton.className = "DropDownSelectionContainer";
    SignOutButton.onclick = function()
    {
        window.LogOutUserFunction(thismaindata, true);
    }
    DropDownContainer.append(SignOutButton);

    let SignOutButtonIcon = document.createElement("img");
    SignOutButtonIcon.className = "DropDownSelectionIMGIcon";
    window.GetOneImageCache("/Assets/images/ButtonIcon/signout.svg", SignOutButtonIcon);
    SignOutButton.append(SignOutButtonIcon);

    let SignOutButtonText = document.createElement("p");
    SignOutButtonText.className = "SignInTopDropDownText";
    SignOutButtonText.innerHTML = window["SignOutTxt" + window.CurrentCountryID];
    SignOutButton.append(SignOutButtonText);
}


// ====================================== INSTANTIATE POP UP GUIDE ============================================


window.InstantiateEditInfoGuide = function(thismaindata, UserTopInfoWrapper, ThisUserName, UserExist)
{
    let HintContentContainer = document.createElement("div");
    HintContentContainer.className = "HintContentContainer UserEditInfoMask";
    HintContentContainer.innerHTML = "<svg height=100% preserveAspectRatio=none viewBox='0 0 200 200'width=100%><defs><mask id=guide-mask-hole><rect fill=white height=100% width=100% /><rect fill=black class=Guide-Rect-Hole /></mask></defs><rect fill='rgba(0, 0, 0, 0.6)'height=100% width=100% mask=url(#guide-mask-hole) /></svg>";
    document.getElementsByTagName("body")[0].append(HintContentContainer);


    let TextBoxContainer = document.createElement("div");
    TextBoxContainer.className = "TextBoxContainer WelcomeToPinginGoGuide";
    HintContentContainer.append(TextBoxContainer);

    let TextBoxbubble = document.createElement("div");
    TextBoxbubble.className = "TextBoxbubble";
    TextBoxContainer.append(TextBoxbubble);

    let TextBoxHeaderContainer = document.createElement("div");
    TextBoxHeaderContainer.className = "TextBoxHeaderContainer";
    TextBoxbubble.append(TextBoxHeaderContainer);

    let TextBoxHeaderText = document.createElement("p");
    TextBoxHeaderText.className = "TextBoxHeaderText InterMediumTextFont";
    TextBoxHeaderText.innerHTML = window["WelcomeToPinginGoGuideTxt" + window.CurrentCountryID](ThisUserName);
    TextBoxHeaderContainer.append(TextBoxHeaderText);

    let CloseGuidePanel = document.createElement("button");
    CloseGuidePanel.className = "CloseGuidePanel Selectable";
    CloseGuidePanel.onclick = function()
    {
        window.ClosePanelAnimate(null, HintContentContainer, null);
    }
    TextBoxHeaderContainer.append(CloseGuidePanel);

    let TextBoxMessageSection = document.createElement("div");
    TextBoxMessageSection.className = "TextBoxMessageSection";
    TextBoxbubble.append(TextBoxMessageSection);

    let TextBoxMessageText = document.createElement("p");
    TextBoxMessageText.className = "InterRegularTextFont";
    TextBoxMessageText.innerHTML = window["EditGuideMessagTxt" + window.CurrentCountryID];
    TextBoxMessageSection.append(TextBoxMessageText);

    let BubblePointer = document.createElement("div");
    BubblePointer.className = "BubblePointer";
    TextBoxContainer.append(BubblePointer);


    let WhereToClickButtonGuide = document.createElement("div");
    WhereToClickButtonGuide.className = "WhereToClickButtonGuide";
    WhereToClickButtonGuide.onclick = function()
    {
        window.ClosePanelAnimate(null, HintContentContainer, null);
        window.TopUserDropDown(thismaindata, UserTopInfoWrapper, UserExist);
    }
    HintContentContainer.append(WhereToClickButtonGuide);

    // ANIMATE =====================================

    HintContentContainer.animate([{bottom: "-100%"},{bottom: 0}], {duration: window.AnimateBlockerDuration});
}


window.InstantiateGoogleLoginNotif = function()
{
    let HintContentContainer = document.createElement("div");
    HintContentContainer.className = "HintContentContainer UserEditInfoMask";
    HintContentContainer.innerHTML = "<svg height=100% preserveAspectRatio=none viewBox='0 0 200 200'width=100%><defs><mask id=guide-mask-hole><rect fill=white height=100% width=100% /><rect fill=black class=Guide-Rect-Hole id='WhereToClickGoogleLogin' /></mask></defs><rect fill='rgba(0, 0, 0, 0.6)'height=100% width=100% mask=url(#guide-mask-hole) /></svg>";
    document.getElementsByTagName("body")[0].append(HintContentContainer);

    let TextBoxContainer = document.createElement("div");
    TextBoxContainer.className = "TextBoxContainer WelcomeToPinginGoGuide";
    HintContentContainer.append(TextBoxContainer);

    let TextBoxbubble = document.createElement("div");
    TextBoxbubble.className = "TextBoxbubble";
    TextBoxContainer.append(TextBoxbubble);

    let TextBoxHeaderContainer = document.createElement("div");
    TextBoxHeaderContainer.className = "TextBoxHeaderContainer";
    TextBoxbubble.append(TextBoxHeaderContainer);

    let TextBoxHeaderText = document.createElement("p");
    TextBoxHeaderText.className = "TextBoxHeaderText InterMediumTextFont";
    TextBoxHeaderText.innerHTML = window["CariKlikBerangkatTxt" + window.CurrentCountryID];
    TextBoxHeaderContainer.append(TextBoxHeaderText);

    let CloseGuidePanel = document.createElement("button");
    CloseGuidePanel.className = "CloseGuidePanel Selectable";
    CloseGuidePanel.onclick = function()
    {
        window.ClosePanelAnimate(null, HintContentContainer, null);
    }
    TextBoxHeaderContainer.append(CloseGuidePanel);

    let TextBoxMessageSection = document.createElement("div");
    TextBoxMessageSection.className = "TextBoxMessageSection";
    TextBoxbubble.append(TextBoxMessageSection);

    let TextBoxMessageText = document.createElement("p");
    TextBoxMessageText.className = "InterRegularTextFont";
    TextBoxMessageText.innerHTML = window["LoginWithGooglePopUpMessageTxt" + window.CurrentCountryID];
    TextBoxMessageSection.append(TextBoxMessageText);

    let BubblePointer = document.createElement("div");
    BubblePointer.className = "BubblePointer";
    TextBoxContainer.append(BubblePointer);

    let WhereToClickButtonGuide = document.createElement("div");
    WhereToClickButtonGuide.className = "WhereToClickGoogleLoginGuide";
    WhereToClickButtonGuide.onclick = function()
    {
        window.ClosePanelAnimate(null, HintContentContainer, null);
        window.InstantiateLoginPanel('');
    }
    HintContentContainer.append(WhereToClickButtonGuide);


    //============================ ANIMATE =====================================

    HintContentContainer.animate([{bottom: "-100%"},{bottom: 0}], {duration: window.AnimateBlockerDuration});
}

// =================================== INSTANTIATE LOGIN ===================================

window.EmailCurrentTemp = null;

window.InstantiateLoginPanel = function(whatemail)
{
    // Reset -------------------------------
    window.MemberPingIDTemp  = "";
    window.EmailCurrentTemp  = "";

    // Instantiate ----------------------------

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    BasicBlackBlocker.id = "BlockerLoginPanelSectionMain";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel";
    BasicBlackBlocker.append(FlexFullDisplayPanel);

    // All Container ----------------------------------------------------------

    let SignInMainStepsWrapper = document.createElement("div");
    SignInMainStepsWrapper.className = "FlexContainerBaseAnimate SignInMainFlexWrapper";
    SignInMainStepsWrapper.id = "SignInMainStepsWrapper";
    FlexFullDisplayPanel.append(SignInMainStepsWrapper);

    let ForgotPasswordStepsWrapper = document.createElement("div");
    ForgotPasswordStepsWrapper.className = "FlexContainerBaseAnimate SignInMainFlexWrapper";
    ForgotPasswordStepsWrapper.id = "ForgotPasswordStepsWrapper";
    ForgotPasswordStepsWrapper.style = "opacity: 0; left: 105%; position: absolute; display: none;";
    FlexFullDisplayPanel.append(ForgotPasswordStepsWrapper);

    let ForgotPassConfirmStepsWrapper = document.createElement("div");
    ForgotPassConfirmStepsWrapper.className = "FlexContainerBaseAnimate EmailConfirmFlexWrapper";
    ForgotPassConfirmStepsWrapper.id = "ForgotPassConfirmStepsWrapper";
    ForgotPassConfirmStepsWrapper.style = "opacity: 0; left: 105%; position: absolute; display: none;";
    FlexFullDisplayPanel.append(ForgotPassConfirmStepsWrapper);

    let EmailConfirmationStepsWrapper = document.createElement("div");
    EmailConfirmationStepsWrapper.className = "FlexContainerBaseAnimate EmailConfirmFlexWrapper";
    EmailConfirmationStepsWrapper.id = "EmailConfirmationStepsWrapper";
    EmailConfirmationStepsWrapper.style = "opacity: 0; left: 105%; position: absolute; display: none;";
    FlexFullDisplayPanel.append(EmailConfirmationStepsWrapper);

    let CreatePasswordStepsWrapper = document.createElement("div");
    CreatePasswordStepsWrapper.className = "FlexContainerBaseAnimate CreatePasswordFlexWrapper";
    CreatePasswordStepsWrapper.id = "CreatePasswordStepsWrapper";
    CreatePasswordStepsWrapper.style = "opacity: 0; left: 105%; position: absolute; display: none;";
    FlexFullDisplayPanel.append(CreatePasswordStepsWrapper);

    let AlmostThereStepsWrapper = document.createElement("div");
    AlmostThereStepsWrapper.className = "FlexContainerBaseAnimate CreatePasswordFlexWrapper";
    AlmostThereStepsWrapper.id = "AlmostThereStepsWrapper";
    AlmostThereStepsWrapper.style = "opacity: 0; left: 105%; position: absolute; display: none;";
    FlexFullDisplayPanel.append(AlmostThereStepsWrapper);

    let YourAccountSuccessWrapper = document.createElement("div");
    YourAccountSuccessWrapper.className = "FlexContainerBaseAnimate FinalConfirmationWrapper";
    YourAccountSuccessWrapper.id = "YourAccountSuccessWrapper";
    YourAccountSuccessWrapper.style = "opacity: 0; left: 105%; position: absolute; display: none;";
    FlexFullDisplayPanel.append(YourAccountSuccessWrapper);


    // -----------------------------  Main Sign In -----------------------------


    let SignInMainStepsWrapperFlex = document.createElement("div");
    SignInMainStepsWrapperFlex.style="width: 100%;height: fit-content; display: flex;";
    SignInMainStepsWrapper.append(SignInMainStepsWrapperFlex);

    let SignInHeadderText = document.createElement("p");
    SignInHeadderText.className = "RoomHotelNameInsidePanel InterBoldTextFont";
    SignInHeadderText.innerHTML = window["SignInOrCreateAccHeaderTxt" + window.CurrentCountryID];
    SignInMainStepsWrapperFlex.append(SignInHeadderText);

    let SignInHeadderCloseButton = document.createElement("img");
    SignInHeadderCloseButton.className = "CloseButtonInsidePanel Selectable2";
    SignInHeadderCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    SignInHeadderCloseButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    SignInMainStepsWrapperFlex.append(SignInHeadderCloseButton);

    let RedWarningMainSignIn = document.createElement("div");
    RedWarningMainSignIn.className = "BasicRadius MarginTextUpDown RedWarningContainer";
    RedWarningMainSignIn.id = "RedWarningMainSignIn";
    RedWarningMainSignIn.style.display = "none";
    RedWarningMainSignIn.style.marginBottom = 0;
    SignInMainStepsWrapper.append(RedWarningMainSignIn);

    let RedWarningMainSignInText = document.createElement("p");
    RedWarningMainSignInText.className = "InterRegularTextFont";
    RedWarningMainSignInText.id = "RedWarningMainSignInText";
    RedWarningMainSignInText.innerHTML = window["InvalidEmailFormatMes" + window.CurrentCountryID];
    RedWarningMainSignIn.append(RedWarningMainSignInText);

    let SignInInputEmailAddressWrapper = document.createElement("div"); // Email ----------
    SignInInputEmailAddressWrapper.className="BasicHeaderAndInputWrapper";
    SignInMainStepsWrapper.append(SignInInputEmailAddressWrapper);

    let SignInInputEmailAddressHeaderText = document.createElement("p");
    SignInInputEmailAddressHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    SignInInputEmailAddressHeaderText.innerHTML = window["EmailAddressTxt" + window.CurrentCountryID];
    SignInInputEmailAddressWrapper.append(SignInInputEmailAddressHeaderText);

    let SignInInputEmailAddressInputContainer = document.createElement("div");
    SignInInputEmailAddressInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    SignInInputEmailAddressInputContainer.style = "width: 100%; min-width: 100%; margin-bottom: 0;";
    SignInInputEmailAddressInputContainer.id = "SignInInputEmailAddressInputContainer";
    SignInInputEmailAddressWrapper.append(SignInInputEmailAddressInputContainer);

    let SignInInputEmailAddressInputIcon = document.createElement("img");
    SignInInputEmailAddressInputIcon.className = "BasicIconInsideInput2";
    SignInInputEmailAddressInputIcon.src = "/Assets/images/ButtonIcon/mail-grey.svg";
    SignInInputEmailAddressInputIcon.style = "margin-right: 0;";
    SignInInputEmailAddressInputContainer.append(SignInInputEmailAddressInputIcon);

    let SignInInputEmailAddressInputField = document.createElement("input");
    SignInInputEmailAddressInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    SignInInputEmailAddressInputField.type = "email";
    SignInInputEmailAddressInputField.placeholder = window["InputEmailPlaceholder" + window.CurrentCountryID];
    SignInInputEmailAddressInputField.id = "SignInInputEmailAddressInputField";
    SignInInputEmailAddressInputField.style.outline = 0;
    SignInInputEmailAddressInputField.value = whatemail;
    SignInInputEmailAddressInputField.onfocus = function(event)
    {
        RedWarningMainSignIn.style.display = "none";
        window.CheckUserSignInInput(event, "SignIn", false);
        SignInInputEmailAddressInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
        document.getElementById("SignInInputPasswordWrapper").style.display = "none";
    }
    SignInInputEmailAddressInputField.oninput = function(event)
    {
        window.CheckUserSignInInput(event, "SignIn", false);
        document.getElementById("SignInInputPasswordWrapper").style.display = "none";
    }
    SignInInputEmailAddressInputField.addEventListener("focusout", (event) =>
    {
        window.CheckUserSignInInput(event, "SignIn", true);
    });
    SignInInputEmailAddressInputContainer.append(SignInInputEmailAddressInputField);


    let SignInInputPasswordWrapper = document.createElement("div"); // Password ----------
    SignInInputPasswordWrapper.className="BasicHeaderAndInputWrapper";
    SignInInputPasswordWrapper.style.marginTop = 0;
    SignInInputPasswordWrapper.style.display = "none";
    SignInInputPasswordWrapper.id = "SignInInputPasswordWrapper";
    SignInMainStepsWrapper.append(SignInInputPasswordWrapper);

    let ForgotAndHeaderWrapper = document.createElement("div");
    ForgotAndHeaderWrapper.style.display = "flex";
    ForgotAndHeaderWrapper.style.flex = 1;
    ForgotAndHeaderWrapper.style.height = "fit-content";
    SignInInputPasswordWrapper.append(ForgotAndHeaderWrapper);

    let SignInInputPasswordHeaderText = document.createElement("p");
    SignInInputPasswordHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    SignInInputPasswordHeaderText.innerHTML = window["PasswordHeaderText" + window.CurrentCountryID];
    ForgotAndHeaderWrapper.append(SignInInputPasswordHeaderText);

    let ForgotPasswordTxt = document.createElement("p");
    ForgotPasswordTxt.className = "InputFieldHeaderText HyperlinkUnderlineText InterMediumTextFont";
    ForgotPasswordTxt.innerHTML = window["ForgotPasswordTxt" + window.CurrentCountryID] + "?";
    ForgotPasswordTxt.style.color = "rgb(58, 159, 221)";
    ForgotPasswordTxt.style.marginLeft = "auto";
    ForgotPasswordTxt.style.marginRight = 0;
    ForgotPasswordTxt.onclick = function()
    {
        let LoadingBlocker = window.InstantiateLoadingBlocker("ForgotPasswordBlocker");
        let EmailForgotPassInputfield = document.getElementById("ForgotPasswordInputEmailAddressInputField");
        window.MovePanelInsideContainerNext(SignInMainStepsWrapper, ForgotPasswordStepsWrapper, FlexFullDisplayPanel, function()
        {
            LoadingBlocker.remove();
            EmailForgotPassInputfield.focus();
        });
        EmailForgotPassInputfield.value = SignInInputEmailAddressInputField.value;
    }
    ForgotAndHeaderWrapper.append(ForgotPasswordTxt);

    let SignInInputPasswordInputContainer = document.createElement("div");
    SignInInputPasswordInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    SignInInputPasswordInputContainer.id = "SignInInputPasswordInputContainer";
    SignInInputPasswordInputContainer.style = "width: 100%; min-width: 100%; margin-bottom: 0;";
    SignInInputPasswordWrapper.append(SignInInputPasswordInputContainer);

    let SignInInputPasswordInputField = document.createElement("input");
    SignInInputPasswordInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InputPasswordWithButton InterMediumTextFont";
    SignInInputPasswordInputField.type = "password";
    SignInInputPasswordInputField.id = "SignInInputPasswordInputField";
    SignInInputPasswordInputField.placeholder = window["InputPassPlaceholder" + window.CurrentCountryID];
    SignInInputPasswordInputField.style.outline = 0;
    SignInInputPasswordInputField.onfocus = function(event)
    {
        RedWarningMainSignIn.style.display = "none";
        window.CheckUserSignInInput(event, "SignIn", false);
        SignInInputPasswordInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    }
    SignInInputPasswordInputField.oninput = function(event)
    {
        window.CheckUserSignInInput(event, "SignIn", false);
    }
    SignInInputPasswordInputField.addEventListener("focusout", (event) =>
    {
        window.CheckUserSignInInput(event, "SignIn", true);
    });
    SignInInputPasswordInputContainer.append(SignInInputPasswordInputField);

    let SignInInputPasswordHidePasswordButton = document.createElement("img");
    SignInInputPasswordHidePasswordButton.className = "BasicIconInsideInput2";
    SignInInputPasswordHidePasswordButton.src = "/Assets/images/ButtonIcon/hidepassword.svg";
    SignInInputPasswordHidePasswordButton.style = "margin-left: 0;";
    SignInInputPasswordHidePasswordButton.onclick = function()
    {
        if(SignInInputPasswordInputField.type == "password")
        {
            SignInInputPasswordInputField.type = "text";
        }
        else
        {
            SignInInputPasswordInputField.type = "password";
        }
    }
    SignInInputPasswordInputContainer.append(SignInInputPasswordHidePasswordButton);

    let ContinueButtonSignIn = document.createElement("button"); // Continue Button ----------
    ContinueButtonSignIn.type = "submit";
    ContinueButtonSignIn.className="BasicTextButton BasicBoxShadow OrangeButton ButtonInvalid SignInButtonTop InterMediumTextFont Selectable";
    ContinueButtonSignIn.style = "margin: 0; width: 100%;";
    ContinueButtonSignIn.innerHTML = window["ContinueWithEmailTxt" + window.CurrentCountryID];
    ContinueButtonSignIn.id = "ContinueButtonSignIn";
    ContinueButtonSignIn.onclick = function(event)
    {
        window.event.preventDefault();
        window.event.stopPropagation();

        if(ContinueButtonSignIn.classList.contains("ButtonInvalid") == false)
        {
            window.ContinueButtonClickedSignInSection(event, SignInInputEmailAddressInputField.value, SignInInputPasswordWrapper, SignInInputPasswordInputField, RedWarningMainSignIn, RedWarningMainSignInText,
            FlexFullDisplayPanel, SignInMainStepsWrapper, EmailConfirmationStepsWrapper, CreatePasswordStepsWrapper)
        }
    }
    SignInMainStepsWrapper.append(ContinueButtonSignIn);

    let OrUseText = document.createElement("p");
    OrUseText.className="DescriptionTextNotDisableable MarginTextUpDown InterItalicTextFont";
    OrUseText.style = "color: #475467; margin-left: auto; margin-right: auto;";
    OrUseText.innerHTML = window["OrUserOtherOpTxt" + window.CurrentCountryID];
    SignInMainStepsWrapper.append(OrUseText);

    let SignInWithGoogleButton = document.createElement("button"); // Sign In With Phone Button ----------
    SignInWithGoogleButton.className="BasicTextButton BasicBoxShadow GreyBorderBlackTextButton SignInButtonTop Selectable";
    SignInWithGoogleButton.style = "margin: 0; width: 100%;";
    SignInWithGoogleButton.onclick = function()
    {
        let SignInBlocker = window.InstantiateLoadingBlocker("SignInBlocker");

        loginauthservice("google", null, (response)=>
        {
            if(!response.ok)
            {
                let ErrorMessage = response.error;
                console.log("LOGIN ERROR:", ErrorMessage);

                if(ErrorMessage.message != "Firebase: Error (auth/popup-closed-by-user).")
                {
                    RedWarningMainSignIn.style.display = "";
                    RedWarningMainSignInText.innerHTML = window["ErrorInConnectServer" + window.CurrentCountryID];
                }
                
                logoutauthservice((response) =>{})
            }
            else
            {
                console.log("LOGIN SUCCESS");
                console.log("MainSession:", response.MainSession);
                console.log("BasicInfo:", response.BasicInfoSession);
                console.log("LoggedIn:", response.loggedin);

                window.location.href = new URL(window.location.href);
            }
            SignInBlocker.remove();
        });
    }
    SignInMainStepsWrapper.append(SignInWithGoogleButton);

    let SignInWithGoogleButtonWrapper = document.createElement("div");
    SignInWithGoogleButtonWrapper.style = "width: fit-content; height: fit-content; display: flex; margin: auto;";
    SignInWithGoogleButton.append(SignInWithGoogleButtonWrapper);

    let SignInWithGoogleButtonIcon = document.createElement("img");
    SignInWithGoogleButtonIcon.className = "BasicIconInsideButton";
    SignInWithGoogleButtonIcon.src = "/Assets/images/ButtonIcon/google-G-icon.svg";
    SignInWithGoogleButtonIcon.style.marginLeft = 0;
    SignInWithGoogleButtonWrapper.append(SignInWithGoogleButtonIcon);

    let SignInWithGoogleButtonText = document.createElement("p");
    SignInWithGoogleButtonText.innerHTML = window["SignInwithGoogleTxt" + window.CurrentCountryID];
    SignInWithGoogleButtonWrapper.append(SignInWithGoogleButtonText);

    if(window.PhoneFeatureIsUnavailable == false)
    {
        let OrUseText = document.createElement("p");
        OrUseText.className="DescriptionTextNotDisableable MarginTextUpDown InterItalicTextFont";
        OrUseText.style = "color: #475467; margin-left: auto; margin-right: auto;";
        OrUseText.innerHTML = window["OrUserOtherOpTxt" + window.CurrentCountryID];
        SignInMainStepsWrapper.append(OrUseText);

        let SignInWithPhoneButton = document.createElement("button"); // Sign In With Phone Button ----------
        SignInWithPhoneButton.className="BasicTextButton BasicBoxShadow GreyBorderBlackTextButton SignInButtonTop Selectable";
        SignInWithPhoneButton.style = "margin: 0; width: 100%;";
        SignInWithPhoneButton.onclick = function()
        {

        }
        SignInMainStepsWrapper.append(SignInWithPhoneButton);

        let SignInWithPhoneButtonWrapper = document.createElement("div");
        SignInWithPhoneButtonWrapper.style = "width: fit-content; height: fit-content; display: flex; margin: auto;";
        SignInWithPhoneButton.append(SignInWithPhoneButtonWrapper);

        let SignInWithPhoneButtonIcon = document.createElement("img");
        SignInWithPhoneButtonIcon.className = "BasicIconInsideButton";
        SignInWithPhoneButtonIcon.src = "/Assets/images/ButtonIcon/sign-in-phone.svg";
        SignInWithPhoneButtonIcon.style.marginLeft = 0;
        SignInWithPhoneButtonWrapper.append(SignInWithPhoneButtonIcon);

        let SignInWithPhoneButtonText = document.createElement("p");
        SignInWithPhoneButtonText.innerHTML = window["SignInwithPhoneTxt" + window.CurrentCountryID];
        SignInWithPhoneButtonWrapper.append(SignInWithPhoneButtonText);
    }

    let TermsAndConditionSignInSection = document.createElement("p");
    TermsAndConditionSignInSection.className = "DescriptionTextNotDisableable MarginTextUpDown InterRegularTextFont";
    TermsAndConditionSignInSection.style = "color: #475467; margin-left: auto; margin-right: auto; margin-bottom: 0; text-align: center;";
    TermsAndConditionSignInSection.innerHTML = window["TermAndConditionMessage" + window.CurrentCountryID];
    SignInMainStepsWrapper.append(TermsAndConditionSignInSection);


    // Add Enter Event ----------------------------------------------

    SignInInputEmailAddressInputField.addEventListener("keydown", function(event)
    {
        if (window.event.key === "Enter")
        {
            window.event.preventDefault();
            ContinueButtonSignIn.click();
        }
    });

    SignInInputPasswordInputField.addEventListener("keydown", function(event)
    {
        if (window.event.key === "Enter")
        {
            window.event.preventDefault();
            ContinueButtonSignIn.click();
        }
    });

    window.CheckUserSignInInput(window.event, "SignIn", false);

    // ----------------------------- Enter Email Forgot Password -----------------------------

    let ForgotPasswordMainStepsWrapperFlex = document.createElement("div");
    ForgotPasswordMainStepsWrapperFlex.style="width: 100%;height: fit-content; display: flex;";
    ForgotPasswordStepsWrapper.append(ForgotPasswordMainStepsWrapperFlex);

    let ForgotPasswordHeadderText = document.createElement("p");
    ForgotPasswordHeadderText.className = "RoomHotelNameInsidePanel InterBoldTextFont";
    ForgotPasswordHeadderText.innerHTML = window["ForgotPasswordTxt" + window.CurrentCountryID];
    ForgotPasswordMainStepsWrapperFlex.append(ForgotPasswordHeadderText);

    let ForgotPasswordHeadderCloseButton = document.createElement("img");
    ForgotPasswordHeadderCloseButton.className = "CloseButtonInsidePanel Selectable2";
    ForgotPasswordHeadderCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    ForgotPasswordHeadderCloseButton.onclick = function()
    {
        window.MovePanelInsideContainerBack(ForgotPasswordStepsWrapper, SignInMainStepsWrapper, FlexFullDisplayPanel);
    }
    ForgotPasswordMainStepsWrapperFlex.append(ForgotPasswordHeadderCloseButton);

    let RedWarningMainForgotPassword = document.createElement("div");
    RedWarningMainForgotPassword.className = "BasicRadius MarginTextUpDown RedWarningContainer";
    RedWarningMainForgotPassword.id = "RedWarningMainForgotPassword";
    RedWarningMainForgotPassword.style.display = "none";
    RedWarningMainForgotPassword.style.marginBottom = 0;
    ForgotPasswordStepsWrapper.append(RedWarningMainForgotPassword);

    let RedWarningMainForgotPasswordText = document.createElement("p");
    RedWarningMainForgotPasswordText.className = "InterMediumTextFont";
    RedWarningMainForgotPasswordText.id = "RedWarningMainForgotPasswordText";
    RedWarningMainForgotPasswordText.innerHTML = window["InvalidEmailFormatMes" + window.CurrentCountryID];
    RedWarningMainForgotPassword.append(RedWarningMainForgotPasswordText);

    let ForgotPasswordMessageText = document.createElement("p");
    ForgotPasswordMessageText.className = "DescriptionTextNotDisableable DescriptionEmailConfirmationText MarginTextUpDown InterRegularTextFont";
    ForgotPasswordMessageText.innerHTML = window["ResetPasswordMessageTxt" + window.CurrentCountryID];
    ForgotPasswordStepsWrapper.append(ForgotPasswordMessageText);

    let ForgotPasswordInputEmailAddressWrapper = document.createElement("div"); // Email ----------
    ForgotPasswordInputEmailAddressWrapper.className="BasicHeaderAndInputWrapper";
    ForgotPasswordStepsWrapper.append(ForgotPasswordInputEmailAddressWrapper);

    let ForgotPasswordInputEmailAddressHeaderText = document.createElement("p");
    ForgotPasswordInputEmailAddressHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    ForgotPasswordInputEmailAddressHeaderText.innerHTML = window["EmailAddressTxt" + window.CurrentCountryID];
    ForgotPasswordInputEmailAddressWrapper.append(ForgotPasswordInputEmailAddressHeaderText);

    let ForgotPasswordInputEmailAddressInputContainer = document.createElement("div");
    ForgotPasswordInputEmailAddressInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    ForgotPasswordInputEmailAddressInputContainer.style = "width: 100%; min-width: 100%; margin-bottom: 0;";
    ForgotPasswordInputEmailAddressInputContainer.id = "ForgotPasswordInputEmailAddressInputContainer";
    ForgotPasswordInputEmailAddressWrapper.append(ForgotPasswordInputEmailAddressInputContainer);

    let ForgotPasswordInputEmailAddressInputIcon = document.createElement("img");
    ForgotPasswordInputEmailAddressInputIcon.className = "BasicIconInsideInput2";
    ForgotPasswordInputEmailAddressInputIcon.src = "/Assets/images/ButtonIcon/mail-grey.svg";
    ForgotPasswordInputEmailAddressInputIcon.style = "margin-right: 0;";
    ForgotPasswordInputEmailAddressInputContainer.append(ForgotPasswordInputEmailAddressInputIcon);

    let ForgotPasswordInputEmailAddressInputField = document.createElement("input");
    ForgotPasswordInputEmailAddressInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    ForgotPasswordInputEmailAddressInputField.type = "email";
    ForgotPasswordInputEmailAddressInputField.placeholder = window["InputEmailPlaceholder" + window.CurrentCountryID];
    ForgotPasswordInputEmailAddressInputField.id = "ForgotPasswordInputEmailAddressInputField";
    ForgotPasswordInputEmailAddressInputField.style.outline = 0;
    ForgotPasswordInputEmailAddressInputField.value = whatemail;
    ForgotPasswordInputEmailAddressInputField.onfocus = function(event)
    {
        RedWarningMainForgotPassword.style.display = "none";
        window.CheckUserForgotPasswordInput(event, ForgotPasswordStepsWrapper, ForgotPassConfirmStepsWrapper, FlexFullDisplayPanel, false);
        ForgotPasswordInputEmailAddressInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    }
    ForgotPasswordInputEmailAddressInputField.oninput = function(event)
    {
        window.CheckUserForgotPasswordInput(event, ForgotPasswordStepsWrapper, ForgotPassConfirmStepsWrapper, FlexFullDisplayPanel, false);
    }
    ForgotPasswordInputEmailAddressInputField.addEventListener("focusout", (event) =>
    {
        window.CheckUserForgotPasswordInput(event, ForgotPasswordStepsWrapper, ForgotPassConfirmStepsWrapper, FlexFullDisplayPanel, true);
    });
    ForgotPasswordInputEmailAddressInputContainer.append(ForgotPasswordInputEmailAddressInputField);

    let ContinueButtonForgotPassword = document.createElement("button"); // Continue Button ----------
    ContinueButtonForgotPassword.type = "submit";
    ContinueButtonForgotPassword.className = "BasicTextButton BasicBoxShadow OrangeButton ButtonInvalid SignInButtonTop";
    ContinueButtonForgotPassword.style = "margin: 0; width: 100%;";
    ContinueButtonForgotPassword.innerHTML = window["ForgotPasswordSendEmailButtonTxt" + window.CurrentCountryID];
    ContinueButtonForgotPassword.id = "ContinueButtonForgotPassword";
    ForgotPasswordStepsWrapper.append(ContinueButtonForgotPassword);

    // Add Enter Event ----------------------------------------------

    ForgotPasswordInputEmailAddressInputField.addEventListener("keydown", function(event)
    {
        if(window.event.key === "Enter")
        {
            window.event.preventDefault();
            ContinueButtonForgotPassword.click();
        }
    });

    // ----------------------------- Forgot Password Confirm Message -----------------------------

    let ForgotPassConfirmStepsWrapperFlex = document.createElement("div");
    ForgotPassConfirmStepsWrapperFlex.style="width: 100%;height: fit-content; display: flex;";
    ForgotPassConfirmStepsWrapper.append(ForgotPassConfirmStepsWrapperFlex);

    let ForgotPassConfirmCloseButton = document.createElement("img");
    ForgotPassConfirmCloseButton.className = "CloseButtonInsidePanel Selectable2";
    ForgotPassConfirmCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    ForgotPassConfirmCloseButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    ForgotPassConfirmStepsWrapperFlex.append(ForgotPassConfirmCloseButton);


    let ForgotPassConfirmIcon = document.createElement("img");
    ForgotPassConfirmIcon.className = "EmailConfirmationIcon";
    ForgotPassConfirmIcon.src = "/Assets/images/Icon/email-confirmation-icon.svg";
    ForgotPassConfirmStepsWrapper.append(ForgotPassConfirmIcon);

    let ForgotPassConfirmHeaderText = document.createElement("p");
    ForgotPassConfirmHeaderText.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
    ForgotPassConfirmHeaderText.style = "width: fit-content; margin: 0 auto;";
    ForgotPassConfirmHeaderText.innerHTML = window["RecoveryLinkHasSentTxt" + window.CurrentCountryID];
    ForgotPassConfirmStepsWrapper.append(ForgotPassConfirmHeaderText);

    let ForgotPassConfirmMessageText = document.createElement("p");
    ForgotPassConfirmMessageText.className = "DescriptionTextNotDisableable DescriptionForgotPassConfirmText MarginTextUpDown InterRegularTextFont";
    ForgotPassConfirmMessageText.style = "color: #1b1b1b; margin-left: auto; margin-right: auto; text-align: center;";
    ForgotPassConfirmMessageText.id = "ForgotPassConfirmMessageText";
    ForgotPassConfirmMessageText.innerHTML = window["WeHaveSendRecoveryEmailToTxt" + window.CurrentCountryID]("test@gmail.com");
    ForgotPassConfirmStepsWrapper.append(ForgotPassConfirmMessageText);

    let ForgotPassConfirmAlreadyVerifyButton = document.createElement("button");
    ForgotPassConfirmAlreadyVerifyButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable";
    ForgotPassConfirmAlreadyVerifyButton.style = "margin: 0 auto;";
    ForgotPassConfirmAlreadyVerifyButton.innerHTML = window["CloseButtonTxt" + window.CurrentCountryID];
    ForgotPassConfirmAlreadyVerifyButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    ForgotPassConfirmStepsWrapper.append(ForgotPassConfirmAlreadyVerifyButton);


    // -----------------------------  Email Confirmation -----------------------------

    let EmailConfirmationStepsWrapperFlex = document.createElement("div");
    EmailConfirmationStepsWrapperFlex.style="width: 100%;height: fit-content; display: flex;";
    EmailConfirmationStepsWrapper.append(EmailConfirmationStepsWrapperFlex);

    let EmailConfirmationCloseButton = document.createElement("img");
    EmailConfirmationCloseButton.className = "CloseButtonInsidePanel Selectable2";
    EmailConfirmationCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    EmailConfirmationCloseButton.onclick = function()
    {
        window.event.preventDefault();
        window.event.stopPropagation();

        window.RemoveTimerAndVisibility(true);
        window.MovePanelInsideContainerBack(EmailConfirmationStepsWrapper, SignInMainStepsWrapper, FlexFullDisplayPanel);
    }
    EmailConfirmationStepsWrapperFlex.append(EmailConfirmationCloseButton);


    let EmailConfirmationIcon = document.createElement("img");
    EmailConfirmationIcon.className = "EmailConfirmationIcon";
    EmailConfirmationIcon.src = "/Assets/images/Icon/email-confirmation-icon.svg";
    EmailConfirmationStepsWrapper.append(EmailConfirmationIcon);

    let EmailConfirmationHeaderText = document.createElement("p");
    EmailConfirmationHeaderText.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
    EmailConfirmationHeaderText.style = "width: fit-content; margin: 0 auto;";
    EmailConfirmationHeaderText.innerHTML = window["EmailConfirmationTxt" + window.CurrentCountryID];
    EmailConfirmationStepsWrapper.append(EmailConfirmationHeaderText);

    let EmailConfirmationMessageText = document.createElement("p");
    EmailConfirmationMessageText.className = "DescriptionTextNotDisableable DescriptionEmailConfirmationText MarginTextUpDown InterRegularTextFont";
    EmailConfirmationMessageText.style = "color: #1b1b1b; margin-left: auto; margin-right: auto; text-align: center;";
    EmailConfirmationMessageText.innerHTML = window.WeHaveSentEmailValidTxt(window.CurrentCountryID, null);
    // EmailConfirmationMessageText.innerHTML = window["WeHaveSentEmailValidTxt" + window.CurrentCountryID];
    EmailConfirmationStepsWrapper.append(EmailConfirmationMessageText);

    // let EmailConfirmationAlreadyVerifyButton = document.createElement("button");
    // EmailConfirmationAlreadyVerifyButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable";
    // EmailConfirmationAlreadyVerifyButton.style = "margin: 0 auto;";
    // EmailConfirmationAlreadyVerifyButton.innerHTML = "Already Verify";
    // EmailConfirmationAlreadyVerifyButton.onclick = function()
    // {

    // }
    // EmailConfirmationStepsWrapper.append(EmailConfirmationAlreadyVerifyButton);

    let EmailConfirmationIfyounotgotanemailText = document.createElement("p");
    EmailConfirmationIfyounotgotanemailText.className = "DescriptionTextNotDisableable MarginTextUpDown InterItalicTextFont";
    EmailConfirmationIfyounotgotanemailText.style="color: #475467; margin-left: auto; margin-right: auto;";
    EmailConfirmationIfyounotgotanemailText.innerHTML = window["IfYouGotNoEmailTxt" + window.CurrentCountryID];
    EmailConfirmationStepsWrapper.append(EmailConfirmationIfyounotgotanemailText);

    let ResendChangeEmailButtonWrapper = document.createElement("div");
    ResendChangeEmailButtonWrapper.className = "MoreThanOneButtonFlexWrapper ResendChangeEmailButtonWrapper";
    ResendChangeEmailButtonWrapper.style = "margin-top: 0;";
    EmailConfirmationStepsWrapper.append(ResendChangeEmailButtonWrapper);

    let EmailConfirmationResendEmailButton = document.createElement("button");
    EmailConfirmationResendEmailButton.className = "BasicTextButton BasicBoxShadow OrangeButton ButtonInvalid SignInButtonTop Selectable";
    EmailConfirmationResendEmailButton.innerHTML = window["ResendEmailBtnTxt" + window.CurrentCountryID];
    EmailConfirmationResendEmailButton.id = "EmailConfirmationResendEmailButton";
    EmailConfirmationResendEmailButton.onclick = function(event)
    {
        window.event.preventDefault();
        window.event.stopPropagation();

        if(EmailConfirmationResendEmailButton.classList.contains("ButtonInvalid") == false)
        {
            window.RemoveTimerAndVisibility(true);
            window.ContinueButtonClickedSignInSection(event, SignInInputEmailAddressInputField.value, SignInInputPasswordWrapper, SignInInputPasswordInputField, RedWarningMainSignIn, RedWarningMainSignInText, FlexFullDisplayPanel, SignInMainStepsWrapper, EmailConfirmationStepsWrapper, CreatePasswordStepsWrapper);
        }
    }
    ResendChangeEmailButtonWrapper.append(EmailConfirmationResendEmailButton);

    let EmailConfirmationChangeEmailButton = document.createElement("button");
    EmailConfirmationChangeEmailButton.className = "BasicTextButton BasicBoxShadow GreyBorderBlackTextButton SignInButtonTop Selectable";
    EmailConfirmationChangeEmailButton.innerHTML = window["ChangeEmailBtnTxt" + window.CurrentCountryID];
    EmailConfirmationChangeEmailButton.onclick = function(event)
    {
        window.event.preventDefault();
        window.event.stopPropagation();

        window.RemoveTimerAndVisibility(true);
        window.MovePanelInsideContainerBack(EmailConfirmationStepsWrapper, SignInMainStepsWrapper, FlexFullDisplayPanel);
    }
    ResendChangeEmailButtonWrapper.append(EmailConfirmationChangeEmailButton);

    let EmailConfirmationOrangeWrapper = document.createElement("div");
    EmailConfirmationOrangeWrapper.className = "OrangeWarningContainer BasicRadius HideOnMobile";
    EmailConfirmationStepsWrapper.append(EmailConfirmationOrangeWrapper);

    let EmailConfirmationMarginWrapper = document.createElement("div");
    EmailConfirmationMarginWrapper.style = "width: fit-content; height: fit-content; margin: auto; display: flex;";
    EmailConfirmationOrangeWrapper.append(EmailConfirmationMarginWrapper);

    let EmailConfirmationCircleIcon = document.createElement("img");
    EmailConfirmationCircleIcon.className = "WarningCircleIcon";
    EmailConfirmationCircleIcon.src = "/Assets/images/ButtonIcon/warning-circle.svg";
    EmailConfirmationMarginWrapper.append(EmailConfirmationCircleIcon);

    let EmailConfirmationOrangeText = document.createElement("p");
    EmailConfirmationOrangeText.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
    EmailConfirmationOrangeText.style.margin = "auto 0";
    EmailConfirmationOrangeText.innerHTML = window["LinkWillExpTxt" + window.CurrentCountryID];
    EmailConfirmationMarginWrapper.append(EmailConfirmationOrangeText);

    let TermsAndConditionEmailConfirmationSection = document.createElement("p");
    TermsAndConditionEmailConfirmationSection.className = "DescriptionTextNotDisableable MarginTextUpDown InterRegularTextFont";
    TermsAndConditionEmailConfirmationSection.style = "color: #475467; margin-left: auto; margin-right: auto; margin-bottom: 0; text-align: center;";
    TermsAndConditionEmailConfirmationSection.innerHTML = window["TermAndConditionMessage" + window.CurrentCountryID];
    EmailConfirmationStepsWrapper.append(TermsAndConditionEmailConfirmationSection);

    // -----------------------------  Create Password -----------------------------

    let CreatePasswordStepsWrapperFlex = document.createElement("div");
    CreatePasswordStepsWrapperFlex.style="width: 100%;height: fit-content; display: flex;";
    CreatePasswordStepsWrapper.append(CreatePasswordStepsWrapperFlex);

    let CreatePasswordCloseButton = document.createElement("img");
    CreatePasswordCloseButton.className = "CloseButtonInsidePanel Selectable2";
    CreatePasswordCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CreatePasswordCloseButton.onclick = function()
    {
        window.MovePanelInsideContainerBack(CreatePasswordStepsWrapper, SignInMainStepsWrapper, FlexFullDisplayPanel);
    }
    CreatePasswordStepsWrapperFlex.append(CreatePasswordCloseButton);

    let CreatePasswordStepsHeader = document.createElement("p");
    CreatePasswordStepsHeader.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
    CreatePasswordStepsHeader.style="width: fit-content; margin: 0 auto;";
    CreatePasswordStepsHeader.innerHTML = window["CreatePasswordTxt" + window.CurrentCountryID];
    CreatePasswordStepsWrapper.append(CreatePasswordStepsHeader);

    let CreatePasswordStepsDescription = document.createElement("p");
    CreatePasswordStepsDescription.className = "DescriptionTextNotDisableable DescriptionEmailConfirmationText MarginTextUpDown InterRegularTextFont";
    CreatePasswordStepsDescription.style="color: #1b1b1b; margin-left: auto; margin-right: auto; text-align: center;";
    CreatePasswordStepsDescription.innerHTML = window["ThankYouForVerifiedMes" + window.CurrentCountryID];
    CreatePasswordStepsWrapper.append(CreatePasswordStepsDescription);

    let CreatePasswordStepsPasswordWrapper = document.createElement("div"); // Password ----
    CreatePasswordStepsPasswordWrapper.className = "BasicHeaderAndInputWrapper";
    CreatePasswordStepsWrapper.append(CreatePasswordStepsPasswordWrapper);

    let CreatePasswordStepsPasswordHeader = document.createElement("p");
    CreatePasswordStepsPasswordHeader.className = "InputFieldHeaderText InterMediumTextFont";
    CreatePasswordStepsPasswordHeader.innerHTML = window["PasswordHeaderText" + window.CurrentCountryID];
    CreatePasswordStepsPasswordWrapper.append(CreatePasswordStepsPasswordHeader);

    let CreatePasswordStepsPasswordInputContainer = document.createElement("div");
    CreatePasswordStepsPasswordInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    CreatePasswordStepsPasswordInputContainer.style="width: 100%; min-width: 100%; margin-bottom: 0;";
    CreatePasswordStepsPasswordInputContainer.id = "AlmostThereNewPasswordInputContainer";
    CreatePasswordStepsPasswordWrapper.append(CreatePasswordStepsPasswordInputContainer);

    let CreatePasswordStepsPasswordInputField = document.createElement("input");
    CreatePasswordStepsPasswordInputField.type = "password";
    CreatePasswordStepsPasswordInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InputPasswordWithButton InterMediumTextFont";
    CreatePasswordStepsPasswordInputField.placeholder = window["NewPasswordPlaceholderTxt" + window.CurrentCountryID];
    CreatePasswordStepsPasswordInputField.style.outline = 0;
    CreatePasswordStepsPasswordInputField.id = "AlmostThereNewPasswordInputField";
    CreatePasswordStepsPasswordInputContainer.append(CreatePasswordStepsPasswordInputField);

    let CreatePasswordStepsPasswordInputIcon = document.createElement("img");
    CreatePasswordStepsPasswordInputIcon.className = "BasicIconInsideInput2";
    CreatePasswordStepsPasswordInputIcon.src = "/Assets/images/ButtonIcon/hidepassword.svg";
    CreatePasswordStepsPasswordInputIcon.style.marginLeft = 0;
    CreatePasswordStepsPasswordInputContainer.append(CreatePasswordStepsPasswordInputIcon);

    let CreatePasswordStepsWarningText = document.createElement("p");
    CreatePasswordStepsWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    CreatePasswordStepsWarningText.id = "AlmostThereNewPasswordWarningText";
    CreatePasswordStepsPasswordWrapper.append(CreatePasswordStepsWarningText);


    let ConfirmPasswordStepsPasswordWrapper = document.createElement("div"); // Confirm Password ----
    ConfirmPasswordStepsPasswordWrapper.className = "BasicHeaderAndInputWrapper";
    CreatePasswordStepsWrapper.append(ConfirmPasswordStepsPasswordWrapper);

    let ConfirmPasswordStepsPasswordHeader = document.createElement("p");
    ConfirmPasswordStepsPasswordHeader.className = "InputFieldHeaderText InterMediumTextFont";
    ConfirmPasswordStepsPasswordHeader.innerHTML = window["ReenterPasswordHeaderText" + window.CurrentCountryID];
    ConfirmPasswordStepsPasswordWrapper.append(ConfirmPasswordStepsPasswordHeader);

    let ConfirmPasswordStepsPasswordInputContainer = document.createElement("div");
    ConfirmPasswordStepsPasswordInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    ConfirmPasswordStepsPasswordInputContainer.style="width: 100%; min-width: 100%; margin-bottom: 0;";
    ConfirmPasswordStepsPasswordInputContainer.id = "AlmostThereConfirmPasswordInputContainer";
    ConfirmPasswordStepsPasswordWrapper.append(ConfirmPasswordStepsPasswordInputContainer);

    let ConfirmPasswordStepsPasswordInputField = document.createElement("input");
    ConfirmPasswordStepsPasswordInputField.type = "password";
    ConfirmPasswordStepsPasswordInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InputPasswordWithButton InterMediumTextFont";
    ConfirmPasswordStepsPasswordInputField.id = "AlmostThereConfirmPasswordInputField";
    ConfirmPasswordStepsPasswordInputField.placeholder = window["ReenterPasswordPlaceholderTxt" + window.CurrentCountryID];
    ConfirmPasswordStepsPasswordInputField.style.outline = 0;
    ConfirmPasswordStepsPasswordInputContainer.append(ConfirmPasswordStepsPasswordInputField);

    let ConfirmPasswordStepsPasswordInputIcon = document.createElement("img");
    ConfirmPasswordStepsPasswordInputIcon.className = "BasicIconInsideInput2";
    ConfirmPasswordStepsPasswordInputIcon.src = "/Assets/images/ButtonIcon/hidepassword.svg";
    ConfirmPasswordStepsPasswordInputIcon.style.marginLeft = 0;
    ConfirmPasswordStepsPasswordInputContainer.append(ConfirmPasswordStepsPasswordInputIcon);

    let ConfirmPasswordStepsWarningText = document.createElement("p");
    ConfirmPasswordStepsWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    ConfirmPasswordStepsWarningText.id = "AlmostThereConfirmPasswordWarningText";
    ConfirmPasswordStepsPasswordWrapper.append(ConfirmPasswordStepsWarningText);

    let ConfirmPasswordNextButton = document.createElement("button"); // Next Button ----
    ConfirmPasswordNextButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable";
    ConfirmPasswordNextButton.style.margin = "0 auto";
    ConfirmPasswordNextButton.innerHTML = window["NextBtnTxt" + window.CurrentCountryID];
    ConfirmPasswordNextButton.id = "AlmostThereConfirmPasswordNextButton";
    CreatePasswordStepsWrapper.append(ConfirmPasswordNextButton);

    let TermsAndConditionCreatePasswordSection = document.createElement("p"); // Terms & Condition ----
    TermsAndConditionCreatePasswordSection.className = "DescriptionTextNotDisableable MarginTextUpDown InterRegularTextFont";
    TermsAndConditionCreatePasswordSection.style = "color: #475467; margin-left: auto; margin-right: auto; margin-bottom: 0; text-align: center;";
    TermsAndConditionCreatePasswordSection.innerHTML = window["TermAndConditionMessage" + window.CurrentCountryID];
    CreatePasswordStepsWrapper.append(TermsAndConditionCreatePasswordSection);

    // ADD FUNCTION =======================================================

    // Create Password ---------------------------------------------------
    CreatePasswordStepsPasswordInputIcon.onclick = function()
    {
        if(CreatePasswordStepsPasswordInputField.type == "password")
        {
            CreatePasswordStepsPasswordInputField.type = "text";
        }
        else
        {
            CreatePasswordStepsPasswordInputField.type = "password";
        }
    }

    CreatePasswordStepsPasswordInputField.onfocus = function(event)
    {
        ConfirmPasswordNextButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
        CreatePasswordStepsWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        CreatePasswordStepsPasswordInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    }
    CreatePasswordStepsPasswordInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedAlmostThere(1, true, window.EmailCurrentTemp);
    });

    // Confirm Password ---------------------------------------------------
    ConfirmPasswordStepsPasswordInputIcon.onclick = function()
    {
        if(ConfirmPasswordStepsPasswordInputField.type == "password")
        {
            ConfirmPasswordStepsPasswordInputField.type = "text";
        }
        else
        {
            ConfirmPasswordStepsPasswordInputField.type = "password";
        }
    }

    ConfirmPasswordStepsPasswordInputField.onfocus = function(event)
    {
        ConfirmPasswordNextButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
        ConfirmPasswordStepsWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        ConfirmPasswordStepsPasswordInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    }
    ConfirmPasswordStepsPasswordInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedAlmostThere(1, true, window.EmailCurrentTemp);
    });

    // Push Pasword Button ---------------------------------------------------
    ConfirmPasswordNextButton.onclick = function()
    {
        let PushPasswordBlocker = window.InstantiateLoadingBlocker("PushPasswordBlocker");
        window.PushNewUserPassword(PushPasswordBlocker, FlexFullDisplayPanel, CreatePasswordStepsWrapper, window.EmailCurrentTemp, CreatePasswordStepsPasswordInputField, ()=> window.MovePanelInsideContainerNext(CreatePasswordStepsWrapper, AlmostThereStepsWrapper, FlexFullDisplayPanel, function(){PushPasswordBlocker.remove()}));
    }
    
    // -----------------------------  Almost There -----------------------------

    let AlmostThereStepsWrapperFlex = document.createElement("div");
    AlmostThereStepsWrapperFlex.style="width: 100%;height: fit-content; display: flex;";
    AlmostThereStepsWrapper.append(AlmostThereStepsWrapperFlex);

    let AlmostThereCloseButton = document.createElement("img");
    AlmostThereCloseButton.className = "CloseButtonInsidePanel Selectable2";
    AlmostThereCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    AlmostThereStepsWrapperFlex.append(AlmostThereCloseButton);

    let AlmostThereStepsHeader = document.createElement("p");
    AlmostThereStepsHeader.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
    AlmostThereStepsHeader.style="width: fit-content; margin: 0 auto;";
    AlmostThereStepsHeader.innerHTML = window["AlmostDoneHeaderText" + window.CurrentCountryID];
    AlmostThereStepsWrapper.append(AlmostThereStepsHeader);

    let AlmostThereStepsDescription = document.createElement("p");
    AlmostThereStepsDescription.className = "DescriptionTextNotDisableable DescriptionEmailConfirmationText MarginTextUpDown InterRegularTextFont";
    AlmostThereStepsDescription.style = "color: #1b1b1b; margin-left: auto; margin-right: auto; text-align: center;";
    AlmostThereStepsDescription.innerHTML = window["ThankYouForVerThenCompleteProf" + window.CurrentCountryID];
    AlmostThereStepsWrapper.append(AlmostThereStepsDescription);

    let AlmostThereFirstLastNameWrapper = document.createElement("div"); // First Name & Last Name
    AlmostThereFirstLastNameWrapper.className = "TwoSeparatorWrapper InputFieldMargin";
    AlmostThereStepsWrapper.append(AlmostThereFirstLastNameWrapper);

    let AlmostThereFirstNameWrapper = document.createElement("div");
    AlmostThereFirstNameWrapper.className = "TwoSeparatorContent";
    AlmostThereFirstLastNameWrapper.append(AlmostThereFirstNameWrapper);

    let AlmostThereFirstNameHeaderText = document.createElement("p");
    AlmostThereFirstNameHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    AlmostThereFirstNameHeaderText.innerHTML = window["FirstNameTxt" + window.CurrentCountryID];
    AlmostThereFirstNameWrapper.append(AlmostThereFirstNameHeaderText);

    let AlmostThereFirstNameInputContainer = document.createElement("div");
    AlmostThereFirstNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    AlmostThereFirstNameInputContainer.id = "AlmostThereFirstNameInputContainer";
    AlmostThereFirstNameInputContainer.style = "width: 100%; min-width: 100%;";
    AlmostThereFirstNameWrapper.append(AlmostThereFirstNameInputContainer);

    let AlmostThereFirstNameInputField = document.createElement("input");
    AlmostThereFirstNameInputField.type = "text";
    AlmostThereFirstNameInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    AlmostThereFirstNameInputField.id = "AlmostThereFirstNameInputField";
    AlmostThereFirstNameInputField.placeholder = window["InputFirstNamePlaceholder" + window.CurrentCountryID];
    AlmostThereFirstNameInputContainer.append(AlmostThereFirstNameInputField);

    let AlmostThereFirstNameWarning = document.createElement("p");
    AlmostThereFirstNameWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    AlmostThereFirstNameWarning.id = "AlmostThereFirstNameWarningText";
    AlmostThereFirstNameWrapper.append(AlmostThereFirstNameWarning);



    let AlmostThereLastNameWrapper = document.createElement("div");
    AlmostThereLastNameWrapper.className = "TwoSeparatorContent";
    AlmostThereFirstLastNameWrapper.append(AlmostThereLastNameWrapper);

    let AlmostThereLastNameHeaderText = document.createElement("p");
    AlmostThereLastNameHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    AlmostThereLastNameHeaderText.innerHTML = window["LastNameTxt" + window.CurrentCountryID];
    AlmostThereLastNameWrapper.append(AlmostThereLastNameHeaderText);

    let AlmostThereLastNameInputContainer = document.createElement("div");
    AlmostThereLastNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    AlmostThereLastNameInputContainer.id = "AlmostThereLastNameInputContainer";
    AlmostThereLastNameInputContainer.style = "width: 100%; min-width: 100%;";
    AlmostThereLastNameWrapper.append(AlmostThereLastNameInputContainer);

    let AlmostThereLastNameInputField = document.createElement("input");
    AlmostThereLastNameInputField.type = "text";
    AlmostThereLastNameInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    AlmostThereLastNameInputField.id = "AlmostThereLastNameInputField";
    AlmostThereLastNameInputField.placeholder = window["InputLastNamePlaceholder" + window.CurrentCountryID];
    AlmostThereLastNameInputContainer.append(AlmostThereLastNameInputField);

    let AlmostThereLastNameWarningText = document.createElement("p");
    AlmostThereLastNameWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    AlmostThereLastNameWarningText.id = "AlmostThereLastNameWarningText";
    AlmostThereLastNameWrapper.append(AlmostThereLastNameWarningText);



    let AlmostThereEmailWrapper = document.createElement("div"); // Email
    AlmostThereEmailWrapper.className = "InputFieldMargin";
    AlmostThereStepsWrapper.append(AlmostThereEmailWrapper);

    let AlmostThereEmailWrapperHeader = document.createElement("p");
    AlmostThereEmailWrapperHeader.className = "InputFieldHeaderText InterMediumTextFont";
    AlmostThereEmailWrapperHeader.innerHTML = window["EmailTxt" + window.CurrentCountryID];
    AlmostThereEmailWrapper.append(AlmostThereEmailWrapperHeader);

    let AlmostThereEmailInputContainer = document.createElement("div");
    AlmostThereEmailInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid";
    AlmostThereEmailInputContainer.id = "AlmostThereEmailInputContainer";
    AlmostThereEmailInputContainer.style = "width: 100%; min-width: 100%;";
    AlmostThereEmailWrapper.append(AlmostThereEmailInputContainer);

    let AlmostThereEmailInputField = document.createElement("input");
    AlmostThereEmailInputField.type = "email";
    AlmostThereEmailInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    AlmostThereEmailInputField.id = "AlmostThereEmailInputField";
    AlmostThereEmailInputField.placeholder = window["SampleEmailPlaceholder" + window.CurrentCountryID];
    AlmostThereEmailInputContainer.append(AlmostThereEmailInputField);

    let AlmostThereEmailWarningText = document.createElement("p");
    AlmostThereEmailWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    AlmostThereEmailWarningText.id = "AlmostThereEmailWarningText";
    AlmostThereEmailWrapper.append(AlmostThereEmailWarningText);



    let AlmostThereGenderWrapper = document.createElement("div"); // Gender
    AlmostThereGenderWrapper.className = "InputFieldMargin BasicHeaderAndInputWrapper";
    AlmostThereGenderWrapper.style.marginTop = 0;
    AlmostThereStepsWrapper.append(AlmostThereGenderWrapper);

    let AlmostThereGenderWrapperHeader = document.createElement("p");
    AlmostThereGenderWrapperHeader.className = "InputFieldHeaderText InterMediumTextFont";
    AlmostThereGenderWrapperHeader.innerHTML = window["GenderHeaderTxt" + window.CurrentCountryID];
    AlmostThereGenderWrapper.append(AlmostThereGenderWrapperHeader);

    let AlmostThereGenderFlexWrapper = document.createElement("div");
    AlmostThereGenderFlexWrapper.style = "display: flex; flex-direction: row;";
    AlmostThereGenderWrapper.append(AlmostThereGenderFlexWrapper);

    let AlmostThereGenderMaleCheckBoxMargin = document.createElement("div");
    AlmostThereGenderMaleCheckBoxMargin.className = "CheckBoxMarginBasic";
    AlmostThereGenderMaleCheckBoxMargin.id = "AlmostThereGenderFlexWrapper";
    AlmostThereGenderFlexWrapper.append(AlmostThereGenderMaleCheckBoxMargin);

    let AlmostThereGenderMaleCheckBoxLabel = document.createElement("label");
    AlmostThereGenderMaleCheckBoxLabel.className = "FilterCheckBoxContainer";
    AlmostThereGenderMaleCheckBoxMargin.append(AlmostThereGenderMaleCheckBoxLabel);

    let AlmostThereGenderMaleCheckBoxInput = document.createElement("input");
    AlmostThereGenderMaleCheckBoxInput.type = "radio";
    AlmostThereGenderMaleCheckBoxInput.className = "FilterCheckBox Selectable";
    AlmostThereGenderMaleCheckBoxInput.name = "GenderAlmostDone";
    AlmostThereGenderMaleCheckBoxLabel.append(AlmostThereGenderMaleCheckBoxInput);

    let AlmostThereGenderMaleCheckBoxSpan = document.createElement("span");
    AlmostThereGenderMaleCheckBoxSpan.className = "CheckBoxSpan";
    AlmostThereGenderMaleCheckBoxLabel.append(AlmostThereGenderMaleCheckBoxSpan);

    let AlmostThereGenderMaleCheckBoxText = document.createElement("p");
    AlmostThereGenderMaleCheckBoxText.className = "CheckBoxText InterMediumTextFont";
    AlmostThereGenderMaleCheckBoxText.innerHTML = window["GenderMaleTxt" + window.CurrentCountryID];
    AlmostThereGenderMaleCheckBoxMargin.append(AlmostThereGenderMaleCheckBoxText);


    let AlmostThereGenderFemaleCheckBoxMargin = document.createElement("div");
    AlmostThereGenderFemaleCheckBoxMargin.className = "CheckBoxMarginBasic";
    AlmostThereGenderFlexWrapper.append(AlmostThereGenderFemaleCheckBoxMargin);

    let AlmostThereGenderFemaleCheckBoxLabel = document.createElement("label");
    AlmostThereGenderFemaleCheckBoxLabel.className = "FilterCheckBoxContainer";
    AlmostThereGenderFemaleCheckBoxMargin.append(AlmostThereGenderFemaleCheckBoxLabel);

    let AlmostThereGenderFemaleCheckBoxInput = document.createElement("input");
    AlmostThereGenderFemaleCheckBoxInput.type = "radio";
    AlmostThereGenderFemaleCheckBoxInput.className = "FilterCheckBox Selectable";
    AlmostThereGenderFemaleCheckBoxInput.name = "GenderAlmostDone";
    AlmostThereGenderFemaleCheckBoxLabel.append(AlmostThereGenderFemaleCheckBoxInput);

    let AlmostThereGenderFemaleCheckBoxSpan = document.createElement("span");
    AlmostThereGenderFemaleCheckBoxSpan.className = "CheckBoxSpan";
    AlmostThereGenderFemaleCheckBoxLabel.append(AlmostThereGenderFemaleCheckBoxSpan);

    let AlmostThereGenderFemaleCheckBoxText = document.createElement("p");
    AlmostThereGenderFemaleCheckBoxText.className = "CheckBoxText InterMediumTextFont";
    AlmostThereGenderFemaleCheckBoxText.innerHTML = window["GenderFemaleTxt" + window.CurrentCountryID];
    AlmostThereGenderFemaleCheckBoxMargin.append(AlmostThereGenderFemaleCheckBoxText);


    let AlmostTherePhoneNumberWrapper = document.createElement("div"); // Phone Number
    AlmostTherePhoneNumberWrapper.className = "InputFieldMargin";
    AlmostThereStepsWrapper.append(AlmostTherePhoneNumberWrapper);

    let AlmostTherePhoneNumberWrapperHeader = document.createElement("p");
    AlmostTherePhoneNumberWrapperHeader.className = "InputFieldHeaderText InterMediumTextFont";
    AlmostTherePhoneNumberWrapperHeader.innerHTML = window["PhoneNumberHeaderTxt" + window.CurrentCountryID];
    AlmostTherePhoneNumberWrapper.append(AlmostTherePhoneNumberWrapperHeader);

    let AlmostTherePhoneNumberInputContainer = document.createElement("div");
    AlmostTherePhoneNumberInputContainer.className = "SmallPanelDropDownContainer";
    AlmostTherePhoneNumberInputContainer.id = "AlmostTherePhoneNumberInputContainer";
    AlmostTherePhoneNumberWrapper.append(AlmostTherePhoneNumberInputContainer);

    let AlmostTherePhoneNumberCodeContainer = document.createElement("div");
    AlmostTherePhoneNumberCodeContainer.className = "FirstNumberPhoneNumberWrapper";
    AlmostTherePhoneNumberCodeContainer.id = "AlmostTherePhoneNumberCodeContainer";
    AlmostTherePhoneNumberCodeContainer.setAttribute("country-code", 62);
    AlmostTherePhoneNumberInputContainer.append(AlmostTherePhoneNumberCodeContainer);

    let PhoneCodeNumberTextWrapper = document.createElement("div");
    PhoneCodeNumberTextWrapper.className = "PhoneCodeNumberTextWrapper Selectable3";
    AlmostTherePhoneNumberCodeContainer.append(PhoneCodeNumberTextWrapper);

    let AlmostTherePhoneNumberCodeText = document.createElement("p");
    AlmostTherePhoneNumberCodeText.className = "InterMediumTextFont";
    AlmostTherePhoneNumberCodeText.innerHTML = "+62";
    PhoneCodeNumberTextWrapper.append(AlmostTherePhoneNumberCodeText);

    let AlmostTherePhoneNumberInputField = document.createElement("input");
    AlmostTherePhoneNumberInputField.type = "number";
    AlmostTherePhoneNumberInputField.className = "InputFieldInsideSmallPanel InputFieldWithButton Selectable3 InterMediumTextFont";
    AlmostTherePhoneNumberInputField.placeholder = "12345678";
    AlmostTherePhoneNumberInputField.id = "AlmostTherePhoneNumberInputField";
    AlmostTherePhoneNumberInputContainer.append(AlmostTherePhoneNumberInputField);

    let AlmostTherePhoneNumberWarningText = document.createElement("p");
    AlmostTherePhoneNumberWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    AlmostTherePhoneNumberWarningText.id = "AlmostTherePhoneNumberWarningText";
    AlmostTherePhoneNumberWrapper.append(AlmostTherePhoneNumberWarningText);


    let AlmostThereCountryWrapper = document.createElement("div"); // Country --------------
    AlmostThereCountryWrapper.className = "InputFieldMargin";
    AlmostThereStepsWrapper.append(AlmostThereCountryWrapper);

    let AlmostThereCountryHeaderText = document.createElement("p");
    AlmostThereCountryHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    AlmostThereCountryHeaderText.innerHTML = window["CountryHeaderTxt" + window.CurrentCountryID];
    AlmostThereCountryWrapper.append(AlmostThereCountryHeaderText);

    let AlmostThereCountryDropDownContainer = document.createElement("div");
    AlmostThereCountryDropDownContainer.className = "SmallPanelDropDownContainer";
    AlmostThereCountryDropDownContainer.id = "AlmostThereCountryDropDownContainer";
    AlmostThereCountryDropDownContainer.setAttribute("country-selected", "Indonesia");
    AlmostThereCountryDropDownContainer.setAttribute("original-country", "");
    AlmostThereCountryWrapper.append(AlmostThereCountryDropDownContainer);

    let AlmostThereCountryDropDownWrapper = document.createElement("div");
    AlmostThereCountryDropDownWrapper.className = "SmallPanelDropDownInputWrapper Selectable3 InterMediumTextFont";
    AlmostThereCountryDropDownContainer.append(AlmostThereCountryDropDownWrapper);

    let AlmostThereCountryIcon = document.createElement("img");
    AlmostThereCountryIcon.className = "CircleInsideInputField";
    AlmostThereCountryIcon.src = "/Assets/images/CountryCode/Indonesia.svg";
    AlmostThereCountryIcon.id = "AlmostThereCountryIcon";
    AlmostThereCountryDropDownWrapper.append(AlmostThereCountryIcon);

    let AlmostThereCountryText = document.createElement("p");
    AlmostThereCountryText.id = "AlmostThereCountryText";
    AlmostThereCountryText.innerHTML = "Indonesia";
    AlmostThereCountryDropDownWrapper.append(AlmostThereCountryText);

    let AlmostThereCountryChevron = document.createElement("img");
    AlmostThereCountryChevron.className = "ChevronInsideInput ToggleArrow";
    AlmostThereCountryChevron.id = "AlmostThereCountryChevron";
    AlmostThereCountryChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
    AlmostThereCountryChevron.style.rotate = "0deg";
    AlmostThereCountryDropDownWrapper.append(AlmostThereCountryChevron);


    let AlmostThereIDCardWrapper = document.createElement("div"); // ID Card (Optional)
    AlmostThereIDCardWrapper.className = "InputFieldMargin";
    AlmostThereStepsWrapper.append(AlmostThereIDCardWrapper);

    let AlmostThereIDCardHeaderWrapper = document.createElement("div");
    AlmostThereIDCardHeaderWrapper.className = "HeaderTextWithRadioButtonWrapper";
    AlmostThereIDCardWrapper.append(AlmostThereIDCardHeaderWrapper);

    let AlmostThereIDCardCheckBoxLabel = document.createElement("label");
    AlmostThereIDCardCheckBoxLabel.className = "FilterCheckBoxContainer";
    AlmostThereIDCardHeaderWrapper.append(AlmostThereIDCardCheckBoxLabel);

    let AlmostThereIDCardCheckBox = document.createElement("input");
    AlmostThereIDCardCheckBox.className = "FilterCheckBox Selectable";
    AlmostThereIDCardCheckBox.type = "checkbox";
    AlmostThereIDCardCheckBox.id = "AlmostThereIDCardCheckBox";
    AlmostThereIDCardCheckBoxLabel.append(AlmostThereIDCardCheckBox);

    let AlmostThereIDCardCheckBoxSpan = document.createElement("span");
    AlmostThereIDCardCheckBoxSpan.className = "CheckBoxSpan";
    AlmostThereIDCardCheckBoxLabel.append(AlmostThereIDCardCheckBoxSpan);

    let AlmostThereIDCardWrapperHeader = document.createElement("p");
    AlmostThereIDCardWrapperHeader.className = "CheckBoxText InterMediumTextFont";
    AlmostThereIDCardWrapperHeader.innerHTML = window["IDCardHeaderTxt" + window.CurrentCountryID];
    AlmostThereIDCardHeaderWrapper.append(AlmostThereIDCardWrapperHeader);

    let AlmostThereIDCardInputFieldContainer = document.createElement("div");
    AlmostThereIDCardInputFieldContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldContainerInvalid";
    AlmostThereIDCardInputFieldContainer.style = "width: 100%; min-width: 100%;";
    AlmostThereIDCardInputFieldContainer.id = "AlmostThereIDCardInputFieldContainer";
    AlmostThereIDCardWrapper.append(AlmostThereIDCardInputFieldContainer);

    let AlmostThereIDCardInputField = document.createElement("input");
    AlmostThereIDCardInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    AlmostThereIDCardInputField.type = "text";
    AlmostThereIDCardInputField.id = "AlmostThereIDCardInputField";
    AlmostThereIDCardInputField.placeholder = window["IDCardInputPlaceholder" + window.CurrentCountryID];
    AlmostThereIDCardInputFieldContainer.append(AlmostThereIDCardInputField);

    let AlmostThereIDCardWarningText = document.createElement("p");
    AlmostThereIDCardWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    AlmostThereIDCardWarningText.id = "AlmostThereIDCardWarningText";
    AlmostThereIDCardWrapper.append(AlmostThereIDCardWarningText);


    let AlmostThereReferralIDWrapper = document.createElement("div"); // Referral ID
    AlmostThereReferralIDWrapper.className = "InputFieldMargin";
    AlmostThereStepsWrapper.append(AlmostThereReferralIDWrapper);

    let AlmostThereReferralIDHeader = document.createElement("p");
    AlmostThereReferralIDHeader.className = "InputFieldHeaderText InterMediumTextFont";
    AlmostThereReferralIDHeader.innerHTML = window["ReferralID" + window.CurrentCountryID] + " <span class='InterItalicTextFont'>(" + window["OptionalTxt" + window.CurrentCountryID] + ")</span>";
    AlmostThereReferralIDWrapper.append(AlmostThereReferralIDHeader);

    let AlmostThereReferralIDContainer = document.createElement("div");
    AlmostThereReferralIDContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    AlmostThereReferralIDContainer.id = "AlmostThereReferralIDContainer";
    AlmostThereReferralIDContainer.style = "width: 100%; min-width: 100%;";
    AlmostThereReferralIDWrapper.append(AlmostThereReferralIDContainer);

    let AlmostThereReferralIDInputField = document.createElement("input");
    AlmostThereReferralIDInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    AlmostThereReferralIDInputField.id = "AlmostThereReferralIDInputField";
    AlmostThereReferralIDInputField.type = "text";
    AlmostThereReferralIDInputField.placeholder = window["ReferralIDInputPlaceholder" + window.CurrentCountryID];
    AlmostThereReferralIDContainer.append(AlmostThereReferralIDInputField);

    let AlmostThereReferralIDWarningText = document.createElement("p");
    AlmostThereReferralIDWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    AlmostThereReferralIDWarningText.id = "AlmostThereReferralIDWarningText";
    AlmostThereReferralIDWrapper.append(AlmostThereReferralIDWarningText);


    let TwoButtonAlmostThereWrapper = document.createElement("div"); // Set Up Later Continue Button
    TwoButtonAlmostThereWrapper.className = "MoreThanOneButtonFlexWrapper InputFieldMarginBoth";
    TwoButtonAlmostThereWrapper.style = "margin-left: auto; margin-right: auto;";
    AlmostThereStepsWrapper.append(TwoButtonAlmostThereWrapper);

    let AlmostThereSetUpLaterButton = document.createElement("button");
    AlmostThereSetUpLaterButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight PaddingExtendedButton Selectable";
    AlmostThereSetUpLaterButton.innerHTML = window["SetuplaterText" + window.CurrentCountryID];
    TwoButtonAlmostThereWrapper.append(AlmostThereSetUpLaterButton);

    let AlmostThereContinueButton = document.createElement("button");
    AlmostThereContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable";
    AlmostThereContinueButton.innerHTML = window["ContinueTxt" + window.CurrentCountryID];
    AlmostThereContinueButton.id = "AlmostThereContinueButton";
    TwoButtonAlmostThereWrapper.append(AlmostThereContinueButton);

    let TermsAndConditionAlmostThere = document.createElement("p"); // Terms & Condition ----
    TermsAndConditionAlmostThere.className = "DescriptionTextNotDisableable MarginTextUpDown InterRegularTextFont";
    TermsAndConditionAlmostThere.style = "color: #475467; margin-left: auto; margin-right: auto; margin-bottom: 0; text-align: center;";
    TermsAndConditionAlmostThere.innerHTML = window["TermAndConditionMessage" + window.CurrentCountryID];
    AlmostThereStepsWrapper.append(TermsAndConditionAlmostThere);


    // Add Function =========================================================================

    // Close --------------------------------------------------------
    AlmostThereCloseButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, function()
        {
            window.location.reload();
        });
    }

    // First Name --------------------------------------------------------
    AlmostThereFirstNameInputField.onfocus = function(event)
    {
        AlmostThereContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
        AlmostThereFirstNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        AlmostThereFirstNameWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    }
    AlmostThereFirstNameInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedAlmostThere(2, true, window.EmailCurrentTemp);
    });

    // Last Name --------------------------------------------------------
    AlmostThereLastNameInputField.onfocus = function(event)
    {
        AlmostThereContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
        AlmostThereLastNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        AlmostThereLastNameWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    }
    AlmostThereLastNameInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedAlmostThere(2, true, window.EmailCurrentTemp);
    });

    // Email --------------------------------------------------------
    AlmostThereEmailInputField.onfocus = function(event)
    {
        AlmostThereContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
        AlmostThereEmailInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        AlmostThereEmailWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    }
    AlmostThereEmailInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedAlmostThere(2, true, window.EmailCurrentTemp);
    });

    // ID Card --------------------------------------------------------
    AlmostThereIDCardInputField.onfocus = function(event)
    {
        AlmostThereContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
        AlmostThereIDCardInputFieldContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        AlmostThereIDCardWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    }
    AlmostThereIDCardInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedAlmostThere(2, true, window.EmailCurrentTemp);
    });

    // Referral ID --------------------------------------------------------
    AlmostThereReferralIDInputField.onfocus = function(event)
    {
        AlmostThereContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
        AlmostThereReferralIDContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        AlmostThereReferralIDWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    }
    AlmostThereReferralIDInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedAlmostThere(2, true, window.EmailCurrentTemp);
    });

    // Gender ---------------------------------------------------
    AlmostThereGenderMaleCheckBoxInput.onclick = function()
    {
        window.CheckInputtedAlmostThere(2, true, window.EmailCurrentTemp);
    }
    
    AlmostThereGenderFemaleCheckBoxInput.onclick = function()
    {
        window.CheckInputtedAlmostThere(2, true, window.EmailCurrentTemp);
    }

    // Phone Number ---------------------------------------------------
    AlmostTherePhoneNumberCodeContainer.onclick = function()
    {
        window.OpenCountryCode(AlmostTherePhoneNumberCodeContainer, AlmostTherePhoneNumberCodeText, 'AlmostThere', window.CheckInputtedAlmostThere(2, true, window.EmailCurrentTemp));
    }

    AlmostTherePhoneNumberInputField.onfocus = function(event)
    {
        AlmostThereContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable ButtonUnselectable";
        AlmostTherePhoneNumberInputContainer.className = "SmallPanelDropDownContainer";
        AlmostTherePhoneNumberWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    }
    AlmostTherePhoneNumberInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedAlmostThere(2, true, window.EmailCurrentTemp);
    });

    // Country ---------------------------------------------------
    AlmostThereCountryDropDownContainer.onclick = function()
    {
        window.OpenCountryChoice(AlmostThereCountryDropDownContainer, AlmostThereCountryIcon, AlmostThereCountryText, "AlmostThereCountryChevron", "AlmostThere", ()=> window.CheckInputtedAlmostThere(2, true, window.EmailCurrentTemp));
    }

    // ID Card --------------------------------------------------------
    AlmostThereIDCardCheckBox.onchange = function()
    {
        if(AlmostThereIDCardCheckBox.checked == true)
        {
            AlmostThereIDCardInputFieldContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        }
        else
        {
            AlmostThereIDCardWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
            AlmostThereIDCardInputFieldContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldContainerInvalid";
        }
        window.CheckInputtedAlmostThere(2, true, window.EmailCurrentTemp);
    }

    // Set Up & Continue Button --------------------------------------------------------
    
    AlmostThereSetUpLaterButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, function()
        {
            window.location.reload();
        });
    }
    
    AlmostThereContinueButton.onclick = function()
    {
        let PushNewUserInfoBlocker = window.InstantiateLoadingBlocker("PushNewUserInfoBlocker");
        window.PushNewUserInfoAlmostThere(window.EmailCurrentTemp, PushNewUserInfoBlocker, ()=> window.MovePanelInsideContainerNext(AlmostThereStepsWrapper, YourAccountSuccessWrapper, FlexFullDisplayPanel, function(){PushNewUserInfoBlocker.remove()}));
    }

    // ----------------------------- SUCCESS -----------------------------

    let YourAccountSuccessStepsWrapperFlex = document.createElement("div");
    YourAccountSuccessStepsWrapperFlex.style="width: 100%;height: fit-content; display: flex;";
    YourAccountSuccessWrapper.append(YourAccountSuccessStepsWrapperFlex);

    let YourAccountSuccessCloseButton = document.createElement("img");
    YourAccountSuccessCloseButton.className = "CloseButtonInsidePanel Selectable2";
    YourAccountSuccessCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    YourAccountSuccessStepsWrapperFlex.append(YourAccountSuccessCloseButton);

    let CheckSuccessGreenCircle = document.createElement("img");
    CheckSuccessGreenCircle.className = "CheckSuccessGreenCircle";
    CheckSuccessGreenCircle.src = "/Assets/images/Icon/check-grey-circle.svg";
    YourAccountSuccessWrapper.append(CheckSuccessGreenCircle);

    let YourAccountSuccessHeader = document.createElement("p");
    YourAccountSuccessHeader.className = "RoomHotelNameInsidePanel MarginTextUpDown InterBoldTextFont";
    YourAccountSuccessHeader.style.marginLeft = "auto";
    YourAccountSuccessHeader.style.marginRight = "auto";
    YourAccountSuccessHeader.style.textAlign = "center";
    YourAccountSuccessHeader.innerHTML = window["AccCreateSuccessWeltoPing" + window.CurrentCountryID];
    YourAccountSuccessWrapper.append(YourAccountSuccessHeader);

    let YourAccountSuccessMessage = document.createElement("p");
    YourAccountSuccessMessage.className = "DescriptionTextNotDisableable DescriptionForgotPassConfirmText MarginTextUpDown InterRegularTextFont";
    YourAccountSuccessMessage.style.color = "rgb(27, 27, 27)";
    YourAccountSuccessMessage.style.marginLeft = "auto";
    YourAccountSuccessMessage.style.marginRight = "auto";
    YourAccountSuccessMessage.style.textAlign = "center";
    YourAccountSuccessMessage.innerHTML = window["AccCreateSuccessMessage" + window.CurrentCountryID];
    YourAccountSuccessWrapper.append(YourAccountSuccessMessage);

    let YourAccountSuccessExploreButton = document.createElement("button");
    YourAccountSuccessExploreButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable InputFieldMarginBoth";
    YourAccountSuccessExploreButton.style = "margin-left: auto; margin-right: auto;";
    YourAccountSuccessExploreButton.innerHTML = window["ExplorePinginGoText" + window.CurrentCountryID];
    YourAccountSuccessWrapper.append(YourAccountSuccessExploreButton);

    // ====================================== FUNCTION 3 (SUCCESS) ====================================== 

    YourAccountSuccessCloseButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, function()
        {
            window.location.reload();
        });
    }

    YourAccountSuccessExploreButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, function()
        {
            window.location.reload();
        });
    }

    // -------------------------- ANIMATE ----------------------------

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}

window.CheckUserSignInInput = function(event, whichstep, isallowchange)
{
    event.preventDefault();
    event.stopPropagation();

    let SomethingWrong = false;

    let WarningRedTopMain = document.getElementById("RedWarningMainSignIn");
    let WarningRedTopMainText = document.getElementById("RedWarningMainSignInText");

    let SignInEmailInputContainer = document.getElementById("SignInInputEmailAddressInputContainer");
    let SignInEmailInput = document.getElementById("SignInInputEmailAddressInputField").value;

    let SignInPasswordMainContainer = document.getElementById("SignInInputPasswordWrapper");
    let SignInPasswordInputContainer = document.getElementById("SignInInputPasswordInputContainer");
    let SignInPasswordInput = document.getElementById("SignInInputPasswordInputField").value;

    let ContinueButtonSignIn = document.getElementById("ContinueButtonSignIn");

    if(whichstep == "SignIn")
    {
        // EMAIL ------------------------------------
        if(SignInEmailInput == ""  || SignInEmailInput.replace(/ /g, "") == "" || window.CheckEmailValidity(SignInEmailInput) == false)
        {
            SomethingWrong = true;

            if(isallowchange == true)
            {
                WarningRedTopMain.style.display = "";
                SignInEmailInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3 InputFieldWarningOutline";
                SignInPasswordMainContainer.style.display = "none";

                if(SignInEmailInput == ""  || SignInEmailInput.replace(/ /g, "") == "")
                {
                    WarningRedTopMainText.innerHTML = window["EmailCannotEmpty" + window.CurrentCountryID];
                }
                else
                {
                    WarningRedTopMainText.innerHTML = window["InvalidEmailFormatMes" + window.CurrentCountryID];
                }
            }
        }
        else
        {
            SignInEmailInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
        }

        // PASSWORD ------------------------------------
        if(SignInPasswordMainContainer.style.display != "none")
        {
            if(SignInPasswordInput == ""  || SignInPasswordInput.replace(/ /g, "") == "" || SignInPasswordInput.length < window.MinimalPasswordCharacter)
            {
                SomethingWrong = true;
                if(isallowchange == true)
                {
                    WarningRedTopMain.style.display = "";
                    if(SignInPasswordInput == ""  || SignInPasswordInput.replace(/ /g, "") == "")
                    {
                        WarningRedTopMainText.innerHTML = window["PasswordCannotBeEmptyTxt" + window.CurrentCountryID];
                    }
                    else
                    {
                        WarningRedTopMainText.innerHTML = window["MinPassWarning" + window.CurrentCountryID];
                    }

                    SignInPasswordInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3 InputFieldWarningOutline";
                }
            }
        }

        if(SomethingWrong == false)
        {
            ContinueButtonSignIn.className ="BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop InterMediumTextFont Selectable";
        }
        else
        {
            ContinueButtonSignIn.className ="BasicTextButton BasicBoxShadow OrangeButton ButtonInvalid SignInButtonTop InterMediumTextFont Selectable";
        }
    }
}

window.ContinueButtonClickedSignInSection = function(event, EmailInputted, PasswordContainer, ThisPasswordInputField, RedWarningContainer, RedWarningText, FlexFullDisplayPanel, SignInSectionWrapper, EmailConfirmationWrapper, CreatePasswordWrapper)
{
    event.preventDefault();
    event.stopPropagation();

    let PasswordInputted = ThisPasswordInputField.value;

    document.getElementById("EmailConfirmationResendEmailButton").className = "BasicTextButton BasicBoxShadow OrangeButton ButtonInvalid SignInButtonTop Selectable";

    let SignInBlocker = window.InstantiateLoadingBlocker("ContinueSignInBlocker");

    (async () =>
    {
        if (await window.CheckEmailValidityBackEnd(EmailInputted))
        {
            let formData = new FormData();
            formData.append('email', EmailInputted);
            formData.append('lang', window.CurrentCountryID);

            let CheckEmailURL = "/v2/email/check";

            window.CallApiAxios({
                method: "POST",
                url: CheckEmailURL,
                data: formData,
            }).then(res =>
            {
                console.log(CheckEmailURL);

                if(res.status == 200)
                {
                    let CheckEmailData = res.data.data;
                    console.log(CheckEmailData);

                    if(CheckEmailData.status_account == "Non-Active") // Disabled Account -------------------
                    {
                        RedWarningContainer.style.display = "";
                        RedWarningText.innerHTML = window["YourAccTempDisabledContactUsError" + window.CurrentCountryID];
                        SignInBlocker.remove();
                    }
                    else // If No Issue -------------------
                    {
                        if(CheckEmailData.new_register == false && CheckEmailData.send_email_verif == false) // If Verified Continue ================================
                        {
                            if(PasswordContainer.style.display == "none") // If Password Container Still Not Visible ----------------------------
                            {
                                if(CheckEmailData.password_null == true) // If Password Havent Been Inputted but Verified
                                {              
                                    window.EmailCurrentTemp = EmailInputted;
                                    document.getElementById("AlmostThereEmailInputField").value = EmailInputted;

                                    window.MovePanelInsideContainerNext(SignInSectionWrapper, CreatePasswordWrapper, FlexFullDisplayPanel, function(){SignInBlocker.remove()});
                                }
                                else
                                {
                                    PasswordContainer.style.display = "";
                                    ThisPasswordInputField.focus();
                                    SignInBlocker.remove();
                                }
                            }
                            else // If Password Visible, Submit Login
                            {
                                formData.append('password', PasswordInputted);
                                window.ImmediateLoginEmailandPassword(formData, RedWarningContainer, RedWarningText, SignInBlocker, ()=>{
                                    window.location.href = new URL(window.location.href)
                                });
                            }
                        }
                        else if(CheckEmailData.send_email_verif == true) // If Unverified Go To Email Confirmation =================================
                        {
                            (async () =>
                            {
                                let RequestEmailVerifURL = "/v2/email/request-verif";
                                await window.getBrowserData(formData);
                                console.log(window.ConvertFormDataToJSON(formData));

                                window.CallApiAxios({
                                    method: "POST",
                                    url: RequestEmailVerifURL,
                                    data: formData
                                }).then(res =>
                                {
                                    console.log(RequestEmailVerifURL);
                                    console.log(res);

                                    if(res.data.success == true)
                                    {
                                        let SendVerifData = res.data;
                                        console.log(SendVerifData);

                                        let EmailText = document.getElementById("EmailTextInConfirmation");
                                        EmailText.innerHTML = EmailInputted;

                                        let DurationText = document.getElementById("DurationTextEmailConfirmation");

                                        // window.EndTimeCountDown = Date.now() + (15 * 60 * 1000); // Set Countdown 15 After This Start
                                        window.EndTimeCountDown = window.ConvertThisToDate(SendVerifData.data.best_before, true);

                                        console.log(window.EndTimeCountDown);

                                        let FunctionAfterCountDownEnd = function() // Function that will Be Called After Countdown Finished
                                        {
                                            document.removeEventListener("visibilitychange", window.VisibilityChangeHandler); // Remove Visibility Change Function
                                            document.getElementById("EmailConfirmationResendEmailButton").className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
                                        }

                                        window.StartCountDown([DurationText], 1, null, ()=> FunctionAfterCountDownEnd());
                                        if(EmailConfirmationWrapper.style.position == "absolute")
                                        {
                                            window.MovePanelInsideContainerNext(SignInSectionWrapper, EmailConfirmationWrapper, FlexFullDisplayPanel, function(){SignInBlocker.remove()});
                                        }
                                        else
                                        {
                                            window.FadeOutInInsideContainer(EmailConfirmationWrapper);
                                            SignInBlocker.remove();
                                        }
                                    }
                                    else
                                    {
                                        RedWarningContainer.style.display = "";
                                        RedWarningText.innerHTML = window["BasicErrorMes" + window.CurrentCountryID];
                                        SignInBlocker.remove();
                                    }
                                })
                                .catch(err =>
                                {
                                    //console.error(err);
                                    RedWarningContainer.style.display = "";
                                    RedWarningText.innerHTML = window["BasicErrorMes" + window.CurrentCountryID];
                                    SignInBlocker.remove();
                                });
                            })();
                        }
                    }
                }
                else
                {
                    RedWarningContainer.style.display = "";
                    RedWarningText.innerHTML = window["BasicErrorMes" + window.CurrentCountryID];
                    SignInBlocker.remove();
                }
            })
            .catch(err =>
            {
                //console.error(err);

                RedWarningContainer.style.display = "";
                RedWarningText.innerHTML = window["BasicErrorMes" + window.CurrentCountryID];
                SignInBlocker.remove();
            });
        }
        else
        {
            RedWarningContainer.style.display = "";
            RedWarningText.innerHTML = window["InvalidEmailFormatMes" + window.CurrentCountryID];
            SignInBlocker.remove();
        }
    })();
}


window.ImmediateLoginEmailandPassword = async function(formData, RedWarningContainer, RedWarningText, SignInBlocker, functiontocall)
{
    await window.getBrowserData(formData);
    console.log(window.ConvertFormDataToJSON(formData));

    loginauthservice("pingingo", formData, (response) =>
    {
        if(!response.ok)
        {
            let ErrorMessage = response.error
            let ErrorMessageToDisplay = window["ErrorInConnectServer" + window.CurrentCountryID];

            console.log("LOGIN ERROR:", ErrorMessage);
            
            if(ErrorMessage.message == "Invalid email or password")
            {
                ErrorMessageToDisplay = window["WrongPasswordTxt" + window.CurrentCountryID];
            }
            else if(ErrorMessage.errors != null && ErrorMessage.errors.password[0] == "The password field must be at least 8 characters.")
            {
                ErrorMessageToDisplay = window["MinPassWarning" + window.CurrentCountryID];
            }

            if(RedWarningText != null)
            {
                RedWarningContainer.style.display = "";
                RedWarningText.innerHTML = ErrorMessageToDisplay;
            }
            else
            {
                window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["PasswordGagalTersimpanTxt" + window.CurrentCountryID]);
            }
        }
        else
        {
            console.log("LOGIN SUCCESS");
            console.log("MainSession:", response.MainSession);
            console.log("BasicInfo:", response.BasicInfoSession);
            console.log("LoggedIn:", response.loggedin);

            if(functiontocall != null)
            {
                window.CurrentUserToken = response.MainSession.usd_PING_tkn;
                window.CurrentUserID = response.MainSession.usd_PING_id;
                functiontocall();
            }
        }

        if(SignInBlocker != null)
        SignInBlocker.remove();
    });
}

// =================================== UPDATE USER INFO =====================================

window.UpdateUserProfile = function(thisuserid, formData, thiswarningtext, functiontocallifsuccess, functiontocallaftererror)
{
    let EditProfileURL = "/v2/profile/" + thisuserid;

    let TextToDisplay = window["WarningUpdateUserDataSuccess" + window.CurrentCountryID];
    let WarningClassName = "WarningPanelSuccess";

    window.CallApiAxios({
        method: "PUT",
        url: EditProfileURL,
        data: formData
    }).then(res =>
    {
        console.log(EditProfileURL);
        console.log(res);

        // If Success ---------------------------------------------

        if(res.status == 200) 
        {
            if(functiontocallifsuccess != null)
                functiontocallifsuccess();
        }
        else // If Failed ---------------------------------------------
        {
            TextToDisplay = window["BasicErrorMes" + window.CurrentCountryID];
            WarningClassName = "WarningPanelFailed WarningFailedAlert";

            if(functiontocallaftererror != null)
                functiontocallaftererror();
        }

        if(thiswarningtext != null) // Display Status --------------------------------
        {
            thiswarningtext.innerHTML = TextToDisplay;
        }
        else
        {
            window.DisplayWarningPopUp(WarningClassName, TextToDisplay);
        }
    })
    .catch(err =>
    {
        //console.error(err);

        if(err.data.message != null) // Determine Status --------------------------------
        {
            if(err.data.message == "User not found")
            {
                TextToDisplay = window["UserNotFoundTxt" + window.CurrentCountryID];
            }
            else
            {
                TextToDisplay = window["WarningUpdateUserDataFailed" + window.CurrentCountryID];
            }
        }
        else
        {
            TextToDisplay = window["BasicErrorMes" + window.CurrentCountryID];
        }

        if(thiswarningtext != null) // Display Status --------------------------------
        {
            thiswarningtext.innerHTML = TextToDisplay;
        }
        else
        {
            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", TextToDisplay);
        }

        if(functiontocallifsuccess != null) // Call Function --------------------------------
            functiontocallaftererror();
    });
}


// ================================== UPDATE USER REFERRAL =================================

window.UpdateReferralOnly = function(formData, userid, thiswarningtext, functiontocallsuccess, functiontocallerror)
{
    let CheckInputtedReferralURL = "/v2/profile/" + userid + "/referral-member";
    console.log(window.ConvertFormDataToJSON(formData));
    
    window.CallApiAxios({
        method: "POST",
        url: CheckInputtedReferralURL,
        data: formData
    }).then(res =>
    {
        console.log(CheckInputtedReferralURL);
        console.log(res);

        let TextToDisplay = window["WarningReferralMyProfileSuccessTxt" + window.CurrentCountryID];
        let WarningClassName = "WarningPanelSuccess";

        // If Success ---------------------------------------------

        if(res.status == 201 || res.data.success == true)
        {
            let PushReferralData = res.data.data;
            console.log(PushReferralData);

            if(functiontocallsuccess != null)
                functiontocallsuccess();
        }
        else // If Failed ---------------------------------------------
        {
            TextToDisplay = window["WarningReferralFailedTxt" + window.CurrentCountryID];
            WarningClassName = "WarningPanelFailed WarningFailedAlert";

            if(functiontocallerror != null)
                functiontocallerror();
        }

        if(thiswarningtext != null) // Display Status --------------------------------
        {
            thiswarningtext.innerHTML = TextToDisplay;
        }
        else
        {
            window.DisplayWarningPopUp(WarningClassName, TextToDisplay);
        }

    })
    .catch(err =>
    {
        //console.error(err);

        if(thiswarningtext != null) // Display Status --------------------------------
        {
            thiswarningtext.innerHTML = window.DetermineErrorReferralTxt(err.data.message);
        }
        else
        {
            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window.DetermineErrorReferralTxt(err.data.message));
        }

        if(functiontocallerror != null) // Call Function --------------------------------
            functiontocallerror();
    });
}


// =================================== FORGOT PASSWORD FUNCTION ===================================

// Send Email Section ----------------
window.CheckUserForgotPasswordInput = function(event, ForgotPasswordStepsWrapper, ForgotPassConfirmStepsWrapper, FlexFullDisplayPanel, isallowchange)
{
    event.preventDefault();
    event.stopPropagation();

    let SomethingWrong = false;

    let RedWarningMainForgotPassword = document.getElementById("RedWarningMainForgotPassword");
    let RedWarningMainForgotPasswordText = document.getElementById("RedWarningMainForgotPasswordText");

    let ForgotPassEmailAddressInputContainer = document.getElementById("ForgotPasswordInputEmailAddressInputContainer");
    let ForgotPassEmailInput = document.getElementById("ForgotPasswordInputEmailAddressInputField").value;

    let ContinueButtonForgotPassword = document.getElementById("ContinueButtonForgotPassword");

    // EMAIL ------------------------------------
    if(ForgotPassEmailInput == ""  || ForgotPassEmailInput.replace(/ /g, "") == "" || window.CheckEmailValidity(ForgotPassEmailInput) == false)
    {
        SomethingWrong = true;

        if(isallowchange == true)
        {
            RedWarningMainForgotPassword.style.display = "";
            ForgotPassEmailAddressInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3 InputFieldWarningOutline";

            if(ForgotPassEmailInput == ""  || ForgotPassEmailInput.replace(/ /g, "") == "")
            {
                RedWarningMainForgotPasswordText.innerHTML = window["EmailCannotEmpty" + window.CurrentCountryID];
            }
            else
            {
                RedWarningMainForgotPasswordText.innerHTML = window["InvalidEmailFormatMes" + window.CurrentCountryID];
            }
        }
    }
    else
    {
        ForgotPassEmailAddressInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    }

    if(SomethingWrong == false)
    {
        ContinueButtonForgotPassword.className ="BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
        ContinueButtonForgotPassword.onclick = function(event)
        {
            event.preventDefault();
            event.stopPropagation();

            if(ContinueButtonForgotPassword.classList.contains("ButtonInvalid") == false)
            {
                let SendResetPasswordBlocker = window.InstantiateLoadingBlocker("SendResetPasswordBlocker");

                let SendResetPasswordURL = "/v2/password/reset/request";

                (async () =>
                {
                    let formData = new FormData();
                    formData.append('email', ForgotPassEmailInput);
                    formData.append('lang', window.CurrentCountryID);
                    await window.getBrowserData(formData);

                    console.log(SendResetPasswordURL);
                    console.log(window.ConvertFormDataToJSON(formData));

                    window.CallApiAxios({
                        method: "POST",
                        url: SendResetPasswordURL,
                        data: formData
                    }).then(res =>
                    {
                        console.log(res);

                        if(res.status == 202)
                        {
                            let SendResetPasswordData = res.data.data;
                            console.log(SendResetPasswordData);

                            document.getElementById("ForgotPassConfirmMessageText").innerHTML = window["WeHaveSendRecoveryEmailToTxt" + window.CurrentCountryID](ForgotPassEmailInput);
                            window.MovePanelInsideContainerNext(ForgotPasswordStepsWrapper, ForgotPassConfirmStepsWrapper, FlexFullDisplayPanel, function(){SendResetPasswordBlocker.remove()});
                        }
                        else
                        {
                            RedWarningMainForgotPassword.style.display = "";
                            RedWarningMainForgotPasswordText.innerHTML = window["FailedRequestResetPasswordTxt" + window.CurrentCountryID];
                            SendResetPasswordBlocker.remove();
                        }
                    })
                    .catch(err =>
                    {
                        //console.error(err);

                        let ErrorMessageData = err.data;

                        RedWarningMainForgotPassword.style.display = "";
                        SendResetPasswordBlocker.remove();

                        if(ErrorMessageData.message == "User not verified" && ErrorMessageData.next_step == "request_email_verification")
                        {
                            RedWarningMainForgotPasswordText.innerHTML = window["YouAccountNotVerifiedTxt" + window.CurrentCountryID];
                        }
                        else if(ErrorMessageData.message == "User not found" && ErrorMessageData.next_step == "register")
                        {
                            RedWarningMainForgotPasswordText.innerHTML = window["UserNotFoundTxt" + window.CurrentCountryID];
                        }
                        else if(ErrorMessageData.message == "Password has never been set"  && ErrorMessageData.next_step == "request_email_verification")
                        {
                            RedWarningMainForgotPasswordText.innerHTML = window["ErrorPasswordNeverBeenSetTxt" + window.CurrentCountryID];
                        }
                        else if(ErrorMessageData.message == "Validation failed")
                        {
                            if(ErrorMessageData.errors.email != null)
                            {
                                RedWarningMainForgotPasswordText.innerHTML = window["EmailUnverifiedTxt" + window.CurrentCountryID];
                            }
                            else
                            {
                                RedWarningMainForgotPasswordText.innerHTML = window["LanguageInvalidTxt" + window.CurrentCountryID];
                            }
                        }
                        else
                        {
                            RedWarningMainForgotPasswordText.innerHTML = window["FailedRequestResetPasswordTxt" + window.CurrentCountryID];
                        }
                    });
                })();
            }
        }
    }
    else
    {
        ContinueButtonForgotPassword.className ="BasicTextButton BasicBoxShadow OrangeButton ButtonInvalid SignInButtonTop";
        ContinueButtonForgotPassword.onclick = function(){};
    }
}

// Resetting Password Section -------------------

window.InstantiateForgotPassword = function(ForgotPasswordArray)
{
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel";
    FlexFullDisplayPanel.id = "FlexFullDisplayPanelForgotPassword";
    BasicBlackBlocker.append(FlexFullDisplayPanel);

    // Containers =======================================================

    let ForgotPasswordFinalStepsWrapper = document.createElement("div");
    ForgotPasswordFinalStepsWrapper.className = "FlexContainerBaseAnimate CreatePasswordFlexWrapper";
    ForgotPasswordFinalStepsWrapper.id = "ForgotPasswordFinalStepsWrapper";
    FlexFullDisplayPanel.append(ForgotPasswordFinalStepsWrapper);

    let ResetPassSuccessWrapper = document.createElement("div");
    ResetPassSuccessWrapper.className = "FlexContainerBaseAnimate FinalConfirmationWrapper";
    ResetPassSuccessWrapper.id = "ResetPassSuccessWrapper";
    ResetPassSuccessWrapper.style = "opacity: 0; left: 105%; position: absolute; display: none;";
    FlexFullDisplayPanel.append(ResetPassSuccessWrapper);

    // Input New Pass =======================================================

    let ForgotPasswordMainStepsWrapperFlex = document.createElement("div");
    ForgotPasswordMainStepsWrapperFlex.style="width: 100%;height: fit-content; display: flex;";
    ForgotPasswordFinalStepsWrapper.append(ForgotPasswordMainStepsWrapperFlex);

    let ForgotPasswordHeadderText = document.createElement("p");
    ForgotPasswordHeadderText.className = "RoomHotelNameInsidePanel InterBoldTextFont";
    ForgotPasswordHeadderText.innerHTML = window["ResetPasswordHeaderTxt" + window.CurrentCountryID];
    ForgotPasswordMainStepsWrapperFlex.append(ForgotPasswordHeadderText);

    let ForgotPasswordHeadderCloseButton = document.createElement("img");
    ForgotPasswordHeadderCloseButton.className = "CloseButtonInsidePanel Selectable2";
    ForgotPasswordHeadderCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    ForgotPasswordHeadderCloseButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    ForgotPasswordMainStepsWrapperFlex.append(ForgotPasswordHeadderCloseButton);

    let RedwarningContainer = document.createElement("div");
    RedwarningContainer.className = "BasicRadius MarginTextUpDown RedWarningContainer InterMediumTextFont";
    RedwarningContainer.style.display = "none";
    ForgotPasswordFinalStepsWrapper.append(RedwarningContainer);

    let RedwarningText = document.createElement("p");
    RedwarningText.className = "InterMediumTextFont";
    RedwarningText.textContent = "Invalid Email Format";
    RedwarningContainer.append(RedwarningText);

    let CreatePasswordWrapper = document.createElement("div"); // New Password ----
    CreatePasswordWrapper.className = "BasicHeaderAndInputWrapper";
    ForgotPasswordFinalStepsWrapper.append(CreatePasswordWrapper);

    let CreatePasswordHeader = document.createElement("p");
    CreatePasswordHeader.className = "InputFieldHeaderText InterMediumTextFont";
    CreatePasswordHeader.innerHTML = window["PasswordHeaderText" + window.CurrentCountryID];
    CreatePasswordWrapper.append(CreatePasswordHeader);

    let CreatePasswordInputContainer = document.createElement("div");
    CreatePasswordInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    CreatePasswordInputContainer.style="width: 100%; min-width: 100%; margin-bottom: 0;";
    CreatePasswordWrapper.append(CreatePasswordInputContainer);

    let CreatePasswordInputField = document.createElement("input");
    CreatePasswordInputField.type = "password";
    CreatePasswordInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InputPasswordWithButton InterMediumTextFont";
    CreatePasswordInputField.placeholder = window["NewPasswordPlaceholderTxt" + window.CurrentCountryID];
    CreatePasswordInputField.style.outline = 0;
    CreatePasswordInputContainer.append(CreatePasswordInputField);

    let CreatePasswordInputIcon = document.createElement("img");
    CreatePasswordInputIcon.className = "BasicIconInsideInput2";
    CreatePasswordInputIcon.src = "/Assets/images/ButtonIcon/hidepassword.svg";
    CreatePasswordInputIcon.style.marginLeft = 0;
    CreatePasswordInputIcon.onclick = function()
    {
        if(CreatePasswordInputField.type == "password")
        {
            CreatePasswordInputField.type = "text";
        }
        else
        {
            CreatePasswordInputField.type = "password";
        }
    }
    CreatePasswordInputContainer.append(CreatePasswordInputIcon);

    let CreatePasswordWarningText = document.createElement("p");
    CreatePasswordWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    CreatePasswordWrapper.append(CreatePasswordWarningText);


    let ConfirmPasswordWrapper = document.createElement("div"); // Confirm Password ----
    ConfirmPasswordWrapper.className = "BasicHeaderAndInputWrapper";
    ForgotPasswordFinalStepsWrapper.append(ConfirmPasswordWrapper);

    let ConfirmPasswordHeader = document.createElement("p");
    ConfirmPasswordHeader.className = "InputFieldHeaderText InterMediumTextFont";
    ConfirmPasswordHeader.innerHTML = window["ReenterPasswordHeaderText" + window.CurrentCountryID];
    ConfirmPasswordWrapper.append(ConfirmPasswordHeader);

    let ConfirmPasswordInputContainer = document.createElement("div");
    ConfirmPasswordInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    ConfirmPasswordInputContainer.style="width: 100%; min-width: 100%; margin-bottom: 0;";
    ConfirmPasswordInputContainer.id = "ConfirmPasswordResetPasswordInputFieldContainer"
    ConfirmPasswordWrapper.append(ConfirmPasswordInputContainer);

    let ConfirmPasswordInputField = document.createElement("input");
    ConfirmPasswordInputField.type = "password";
    ConfirmPasswordInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InputPasswordWithButton InterMediumTextFont";
    ConfirmPasswordInputField.placeholder = window["ReenterPasswordPlaceholderTxt" + window.CurrentCountryID];
    ConfirmPasswordInputField.style.outline = 0;
    ConfirmPasswordInputField.id = "ConfirmPasswordResetPasswordInputField";
    ConfirmPasswordInputContainer.append(ConfirmPasswordInputField);

    let ConfirmPasswordInputIcon = document.createElement("img");
    ConfirmPasswordInputIcon.className = "BasicIconInsideInput2";
    ConfirmPasswordInputIcon.src = "/Assets/images/ButtonIcon/hidepassword.svg";
    ConfirmPasswordInputIcon.style.marginLeft = 0;
    ConfirmPasswordInputIcon.onclick = function()
    {
        if(ConfirmPasswordInputField.type == "password")
        {
            ConfirmPasswordInputField.type = "text";
        }
        else
        {
            ConfirmPasswordInputField.type = "password";
        }
    }
    ConfirmPasswordInputContainer.append(ConfirmPasswordInputIcon);

    let ConfirmPasswordWarningText = document.createElement("p");
    ConfirmPasswordWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    ConfirmPasswordWrapper.append(ConfirmPasswordWarningText);


    let ConfirmPasswordNextButton = document.createElement("button");
    ConfirmPasswordNextButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
    ConfirmPasswordNextButton.style.margin = "0 auto";
    ConfirmPasswordNextButton.id = "ResetPasswordButtonApply";
    ConfirmPasswordNextButton.innerHTML = window["SavePasswordButtonTxt" + window.CurrentCountryID];
    ForgotPasswordFinalStepsWrapper.append(ConfirmPasswordNextButton);


    // Reset Pass =======================================================

    let ResetPassSuccessStepsWrapperFlex = document.createElement("div");
    ResetPassSuccessStepsWrapperFlex.style="width: 100%;height: fit-content; display: flex;";
    ResetPassSuccessWrapper.append(ResetPassSuccessStepsWrapperFlex);

    let ResetPassSuccessCloseButton = document.createElement("img");
    ResetPassSuccessCloseButton.className = "CloseButtonInsidePanel Selectable2";
    ResetPassSuccessCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    ResetPassSuccessStepsWrapperFlex.append(ResetPassSuccessCloseButton);

    let CheckSuccessGreenCircle = document.createElement("img");
    CheckSuccessGreenCircle.className = "CheckSuccessGreenCircle";
    CheckSuccessGreenCircle.src = "/Assets/images/Icon/check-grey-circle.svg";
    ResetPassSuccessWrapper.append(CheckSuccessGreenCircle);

    let ResetPassSuccessHeader = document.createElement("p");
    ResetPassSuccessHeader.className = "RoomHotelNameInsidePanel MarginTextUpDown InterBoldTextFont";
    ResetPassSuccessHeader.style.marginLeft = "auto";
    ResetPassSuccessHeader.style.marginRight = "auto";
    ResetPassSuccessHeader.style.textAlign = "center";
    ResetPassSuccessHeader.innerHTML = window["ResetPasswordSuccessTxt" + window.CurrentCountryID];
    ResetPassSuccessWrapper.append(ResetPassSuccessHeader);

    let ResetPassSuccessMessage = document.createElement("p");
    ResetPassSuccessMessage.className = "DescriptionTextNotDisableable DescriptionForgotPassConfirmText MarginTextUpDown InterRegularTextFont";
    ResetPassSuccessMessage.style.color = "rgb(27, 27, 27)";
    ResetPassSuccessMessage.style.marginLeft = "auto";
    ResetPassSuccessMessage.style.marginRight = "auto";
    ResetPassSuccessMessage.style.textAlign = "center";
    ResetPassSuccessMessage.innerHTML = window["AccCreateSuccessMessage" + window.CurrentCountryID];
    ResetPassSuccessWrapper.append(ResetPassSuccessMessage);


    let ResetPassSuccessExploreButton = document.createElement("button");
    ResetPassSuccessExploreButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable InputFieldMarginBoth";
    ResetPassSuccessExploreButton.style = "margin-left: auto; margin-right: auto;";
    ResetPassSuccessExploreButton.innerHTML = window["ExplorePinginGoText" + window.CurrentCountryID];
    ResetPassSuccessWrapper.append(ResetPassSuccessExploreButton);

    // ADD FUNCTION =======================================================

    CreatePasswordInputField.onfocus = function(event)
    {
        ConfirmPasswordNextButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
        CreatePasswordWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        CreatePasswordInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    }
    CreatePasswordInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedResetPassword(ForgotPasswordArray, CreatePasswordInputContainer, CreatePasswordInputField, CreatePasswordWarningText,
        ConfirmPasswordInputContainer, ConfirmPasswordInputField, ConfirmPasswordWarningText,
        ConfirmPasswordNextButton, RedwarningContainer, RedwarningText, ForgotPasswordFinalStepsWrapper, ResetPassSuccessWrapper, FlexFullDisplayPanel, ResetPassSuccessCloseButton, ResetPassSuccessExploreButton);
    });

    ConfirmPasswordInputField.onfocus = function(event)
    {
        ConfirmPasswordNextButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
        ConfirmPasswordWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        ConfirmPasswordInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    }
    ConfirmPasswordInputField.addEventListener("focusout", (event) =>
    {
        window.CheckInputtedResetPassword(ForgotPasswordArray, CreatePasswordInputContainer, CreatePasswordInputField, CreatePasswordWarningText,
        ConfirmPasswordInputContainer, ConfirmPasswordInputField, ConfirmPasswordWarningText,
        ConfirmPasswordNextButton, RedwarningContainer, RedwarningText, ForgotPasswordFinalStepsWrapper, ResetPassSuccessWrapper, FlexFullDisplayPanel, ResetPassSuccessCloseButton, ResetPassSuccessExploreButton);
    });

    // ANIMATE =======================================================

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}

window.CheckInputtedResetPassword = function(ForgotPasswordArray, CreatePasswordInputContainer, CreatePasswordInputField, CreatePasswordWarningText, ConfirmPasswordInputContainer, ConfirmPasswordInputField, ConfirmPasswordWarningText, ConfirmPasswordNextButton, RedwarningContainer, RedwarningText, ForgotPasswordFinalStepsWrapper, ResetPassSuccessWrapper, FlexFullDisplayPanel, ResetPassSuccessCloseButton, ResetPassSuccessExploreButton)
{
    let IsPasswordCorrect = window.ConfirmTwoPasswordInputCorrect(CreatePasswordInputField.value, ConfirmPasswordInputField.value, CreatePasswordInputContainer, ConfirmPasswordInputContainer, CreatePasswordWarningText, ConfirmPasswordWarningText, true);

    if(IsPasswordCorrect == false)
    {
        ConfirmPasswordNextButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
        ConfirmPasswordNextButton.onclick = function(){};
    }
    else
    {
        ConfirmPasswordNextButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable";
        ConfirmPasswordNextButton.onclick = function()
        {
            let ResetPasswordURL = "/v2/password/reset/new";
            let ResetPasswordBlocker = window.InstantiateLoadingBlocker("ResetPasswordBlocker");

            (async () =>
            {
                let formData = new FormData();
                formData.append('email', ForgotPasswordArray[1]);
                formData.append('member', ForgotPasswordArray[2]);
                formData.append('id_code', ForgotPasswordArray[3]);
                formData.append('code', ForgotPasswordArray[4]);
                formData.append('lang', window.CurrentCountryID);
                formData.append('new_password', CreatePasswordInputField.value);
                formData.append('password', CreatePasswordInputField.value);
                await window.getBrowserData(formData);
                console.log(ResetPasswordURL);
                console.log(window.ConvertFormDataToJSON(formData));

                window.CallApiAxios({
                    method: "POST",
                    url: ResetPasswordURL,
                    data: formData
                }).then(res =>
                {
                    console.log(res);

                    if(res.data.message == "New password has been set successfully")
                    {
                        let ImmediateLoginBlocker = window.InstantiateLoadingBlocker("ImmediateLoginBlocker");
                        window.ImmediateLoginEmailandPassword(formData, null, null, null, ()=>{ImmediateLoginBlocker.remove()});

                        window.MovePanelInsideContainerNext(ForgotPasswordFinalStepsWrapper,  ResetPassSuccessWrapper, FlexFullDisplayPanel, function()
                        {
                            ResetPasswordBlocker.remove();

                            ResetPassSuccessCloseButton.onclick = function()
                            {
                                window.location.reload();
                            }
                            ResetPassSuccessExploreButton.onclick = function()
                            {
                                window.location.reload();
                            }
                        });
                    }
                    else
                    {
                        ResetPasswordBlocker.remove();
                        RedwarningContainer.style.display = "";
                        RedwarningText.innerHTML = window["FailedToResetPasswordTxt" + window.CurrentCountryID];
                    }
                })
                .catch(err =>
                {
                    //console.error(err);
                    let ErrorMessageData = err.data;

                    RedwarningContainer.style.display = "";
                    ResetPasswordBlocker.remove();

                    if(ErrorMessageData.message == "Reset password request has already been used")
                    {
                        RedwarningText.innerHTML = window["ErrorLinkExpiredTxt" + window.CurrentCountryID];
                    }
                    else if(ErrorMessageData.message == "Reset password has expired. Please request a new one.")
                    {
                        RedwarningText.innerHTML = window["ErrorAlreadyResetPasswordTxt" + window.CurrentCountryID];
                    }
                    else if(ErrorMessageData.message == "Validation failed")
                    {
                        if(ErrorMessageData.errors.email[0] == "The email field must be a valid email address.")
                        {
                            RedwarningText.innerHTML = window["EmailMustBeValidEmailAddressTxt" + window.CurrentCountryID];
                        }
                        else if(ErrorMessageData.errors.new_password[0] ==  "The new password field must be at least 8 characters.")
                        {
                            RedwarningText.innerHTML = window["MinPassWarningTxt2" + window.CurrentCountryID];
                        }
                    }
                    else
                    {
                        RedwarningText.innerHTML = window["FailedToResetPasswordTxt" + window.CurrentCountryID];
                    }
                });

            })();
        }
    }
}


// =================================== ANIMATE BACKGROUND =======================================

window.AutoAnimateBackground = function()
{
    setTimeout(function()
    {
        let BackgroundAnimateContainer = document.querySelectorAll('.MainBackgroundAnimateContainer');
        BackgroundAnimateContainer.forEach(ThisContainer =>
        {
            let MainBackgroundAnimate = ThisContainer.querySelectorAll('.MainBackgroundAnimate');
            let CurrentBackground;
            let NextBackground;
            let IsThisLast = false;

            if(MainBackgroundAnimate.length > 1)
            {
                for(let i = 0; i < MainBackgroundAnimate.length; i++)
                {
                    if(MainBackgroundAnimate[i].style.opacity == "1")
                    {
                        CurrentBackground = MainBackgroundAnimate[i];
                        if(i == (MainBackgroundAnimate.length - 1))
                        {
                            NextBackground = MainBackgroundAnimate[0];
                            IsThisLast = true;
                        }
                        else
                        {
                            NextBackground = MainBackgroundAnimate[i+1];
                        }
                    }
                }

                NextBackground.style.opacity = "1";
                if(IsThisLast == false)
                {
                    NextBackground.animate([{opacity: '0'},{opacity: '1'}], {duration: 500});
                    setTimeout(function()
                    {
                        CurrentBackground.style.opacity = "0";
                    }, 1000);
                }
                else
                {
                    CurrentBackground.style.opacity = "0";
                    CurrentBackground.animate([{opacity: '1'},{opacity: '0'}], {duration: 500});
                }
            }
        });
        setTimeout(function()
        {
            window.AutoAnimateBackground();
        }, 1000);
    }, 5000);
}

window.AutoAnimateIMGInsidePanel = function(thiscontainer)
{
    let ThisImageLists = thiscontainer.querySelectorAll('img');
    setTimeout(function()
    {
        let CurrentBackground;
        let NextBackground;
        let IsThisLast = false;

        for(let i = 0; i < ThisImageLists.length; i++)
        {
            if(ThisImageLists[i].style.opacity == "1")
            {
                CurrentBackground = ThisImageLists[i];
                if(i == (ThisImageLists.length - 1))
                {
                    NextBackground = ThisImageLists[0];
                    IsThisLast = true;
                }
                else
                {
                    NextBackground = ThisImageLists[i+1];
                }
            }
        }
        NextBackground.style.opacity = "1";
        if(IsThisLast == false)
        {
            NextBackground.animate([{opacity: '0'},{opacity: '1'}], {duration: 500});
            setTimeout(function()
            {
                CurrentBackground.style.opacity = "0";
            }, 1000);
        }
        else
        {
            CurrentBackground.style.opacity = "0";
            CurrentBackground.animate([{opacity: '1'},{opacity: '0'}], {duration: 500});
        }

        setTimeout(function()
        {
            window.AutoAnimateIMGInsidePanel(thiscontainer);
        }, 1000);

    }, 5000);
}


// ====================================== CONTROL CHEVRON ==========================================

window.RotateToggle = function(togglename, allowchangeall)
{
    let AnimateDuration = 100;

    let ToggleButtons = document.querySelectorAll(".ToggleArrow");

    for(let i = 0; i < ToggleButtons.length; i++)
    {
        if(ToggleButtons[i].getAttribute("id") == togglename)
        {
            if(ToggleButtons[i].style.rotate == "0deg")
            {
                ToggleButtons[i].animate([{rotate: '0deg'},{rotate: '180deg'}], {duration: AnimateDuration});
                setTimeout(function()
                {
                    ToggleButtons[i].style.rotate = "180deg";
                }, AnimateDuration);

            }
            else
            {
                ToggleButtons[i].animate([{rotate: '180deg'},{rotate: '0deg'}], {duration: AnimateDuration});

                setTimeout(function()
                {
                    ToggleButtons[i].style.rotate = "0deg";
                }, AnimateDuration);
            }
        }
        else if(allowchangeall == true)
        {
            if(ToggleButtons[i].style.rotate == "180deg")
            {
                ToggleButtons[i].animate([{rotate: '180deg'},{rotate: '0deg'}], {duration: AnimateDuration});
                setTimeout(function()
                {
                    ToggleButtons[i].style.rotate = "0deg";
                }, AnimateDuration);
            }
        }
    }
}

// ================================== INSTANTIATE PANEL ==================================

window.OpenPanelsList = [];

window.FunctionCheckInstantiateDropDown = function(thisdropdownid, WhereToInstantiate)
{
    let ThisPanelID = thisdropdownid;

    let CheckExistingSamePanel = document.getElementById(ThisPanelID);
    // If Already Exist Remove it ------------------------------------------------
    if(CheckExistingSamePanel)
    {
        window.removePanelsFrom(CheckExistingSamePanel);
        return null;
    }

    // Remove unrelated Panels Except The Parents ----------------------------------------
    while (window.OpenPanelsList.length > 0)
    {
        let topPanel = window.OpenPanelsList[window.OpenPanelsList.length - 1];

        if (topPanel.contains(WhereToInstantiate))
        {
            break; // keep parent -----------------
        }

        topPanel.remove();
        window.OpenPanelsList.pop();
    }

    // Create DropDown Panel Container -----------------------------------
    let ThisDropDownContainerFlex = document.createElement("div");
    ThisDropDownContainerFlex.className = "ContainerFlex";
    ThisDropDownContainerFlex.id = ThisPanelID;
    WhereToInstantiate.append(ThisDropDownContainerFlex);

    // Register Panel to List ---------------------------------------------
    window.OpenPanelsList.push(ThisDropDownContainerFlex);

    return ThisDropDownContainerFlex
}

// ================================= ONCLICK ANY AREA -> REMOVE THE PANEL ====================================

// document.onclick = function (e)
// {
//     if (window.ParentPanelContainer != null)
//     {
//         if (window.ParentPanelContainer.contains(e.target))
//         {
//             window.ParentPanelContainer.remove();
//             window.ParentPanelContainer = null;
//             window.RotateToggle("", true);
//         }
//     }

//     if (window.window.PanelChoiceOpen != null)
//     {
//         if (!window.window.PanelChoiceOpen.contains(e.target))
//         {
//             window.window.PanelChoiceOpen.remove();
//             window.window.PanelChoiceOpen = null;
//             window.RotateToggle("", true);
//         }
//     }
// };

document.onclick = function (e)
{
    if (!window.OpenPanelsList || window.OpenPanelsList.length === 0) return;

    let clickedInsideIndex = -1;

    for (let i = 0; i < window.OpenPanelsList.length; i++)
    {
        if (window.OpenPanelsList[i].contains(e.target))
        {
            clickedInsideIndex = i;
        }
    }

    if (clickedInsideIndex !== -1)
    {
        // Close only child panels above
        for (let i = window.OpenPanelsList.length - 1; i > clickedInsideIndex; i--)
        {
            window.OpenPanelsList[i].remove();
            window.OpenPanelsList.pop();
        }
    }
    else
    {
        // Click outside → close everything
        window.closeAllPanels();
        // window.RotateToggle("", true);
    }
};


// Remove panels starting from a specific panel
window.removePanelsFrom = function(panel)
{
    const index = window.OpenPanelsList.indexOf(panel);

    if (index !== -1)
    {
        for (let i = window.OpenPanelsList.length - 1; i >= index; i--)
        {
            window.OpenPanelsList[i].remove();
            window.OpenPanelsList.pop();
        }
    }
};

// Close all panels
window.closeAllPanels = function()
{
    while (window.OpenPanelsList.length > 0)
    {
        let panel = window.OpenPanelsList.pop();
        panel.remove();
    }
};

// ============================ CONVERT FORMDATA TO JSON ==============================

window.ConvertFormDataToJSON = function(formData)
{
    let formDataJSON = {};
    formData.forEach((value, key) =>
    {
        if (formDataJSON[key])
        {
            if (Array.isArray(formDataJSON[key]))
            {
                formDataJSON[key].push(value);
            }
            else
            {
                formDataJSON[key] = [formDataJSON[key], value];
            }
        }
        else
        {
            formDataJSON[key] = value;
        }
    });
    return formDataJSON;
}

// =========================== CONVERT SPECIAL CHARACTER JSON ==================================

function fixEncoding(str)
{
    try
    {
        return decodeURIComponent(escape(str));
    }
    catch (e)
    {
        return str;
    }
}

window.fixObjectEncoding = function(obj)
{
    if (typeof obj === "string") {
        return fixEncoding(obj);
    }

    if (Array.isArray(obj)) {
        return obj.map(window.fixObjectEncoding);
    }

    if (typeof obj === "object" && obj !== null) {
        for (const key in obj) {
            obj[key] = window.fixObjectEncoding(obj[key]);
        }
    }

    return obj;
}

window.decodeMojibake = function(garbledString, originalEncoding)
{
  const encoder = new TextEncoder();
  const utf8Bytes = encoder.encode(garbledString);

  const decoder = new TextDecoder(originalEncoding);
  const correctedString = decoder.decode(utf8Bytes);

  return correctedString;
}

window.decodeGarbledContent = function(text)
{
  if (typeof text !== 'string') return text;

  // STEP 1: The universal Windows-1252 to UTF-8 Byte Overrides table
  // This handles emojis (ðŸ“Œ -> 📌) and other standard byte errors.
  // Note: Flattened structural codes like 8211/8212 are removed from this loop.
  const cp1252Overrides =
  {
    8364: 0x80, 2010: 0x82, 8218: 0x82, 402: 0x83, 8222: 0x84, 8230: 0x85, 
    8224: 0x86, 8225: 0x87, 710: 0x88, 2030: 0x89, 352: 0x8A, 8249: 0x8B, 
    338: 0x8C,  381: 0x8E, 8216: 0x91, 8217: 0x92, 8220: 0x93, 8221: 0x94, 
    8226: 0x95, 732: 0x98, 8482: 0x99, 353: 0x9A, 8250: 0x9B, 339: 0x9C,  
    382: 0x9E, 376: 0x9F
  };

  let decodedText = text;

  try {
    // Convert emojis and standard broken sequences into correct UTF-8
    const bytes = new Uint8Array(text.split('').map(char =>
    {
        const code = char.charCodeAt(0);

        if (cp1252Overrides[code] !== undefined)
        {
          return cp1252Overrides[code];
        }

        return code & 0xFF;
      })
    );
    decodedText = new TextDecoder('utf-8').decode(bytes);
  }
  catch (error)
  {
    // If byte decoding fails, fall back to the original text input
    decodedText = text;
  }

  // STEP 2: Clean up the structural dash patterns from the decoded string
  // This handles instances where the text encoder flattened the string ahead of time
  return decodedText
    .replace(/â€”/g, '—')  // Fixes broken em dashes perfectly
    .replace(/â€“/g, '–')  // Fixes broken en dashes perfectly
    .replace(/€”/g, '—')  // Catch-all safety for partial corruption
    .replace(/€“/g, '–'); // Catch-all safety for partial corruption
}


window.StringToJSON = function(str)
{
  try
  {
    return JSON.parse(str);
  }
  catch (error)
  {
    return null;
  }
}

// ===================================== NOTIFICATION =======================================

window.DisplayWarningPopUp = function(whatstatus, whatmessage)
{
    if(document.getElementById('WarningPanelContainer')== null)
    {
        let WarningPanelContainer = document.createElement("div");
        WarningPanelContainer.className = "WarningPanelContainer";
        WarningPanelContainer.id = "WarningPanelContainer";
        document.getElementsByTagName("body")[0].append(WarningPanelContainer);
    }

    let WarningPanelSendStatus = document.createElement("div");
    WarningPanelSendStatus.className = "WarningPanelSendStatus "+ whatstatus;
    document.getElementById('WarningPanelContainer').append(WarningPanelSendStatus);

    let WarningPanelIconContainer = document.createElement("div");
    WarningPanelIconContainer.className = "WarningPanelIconContainer";
    WarningPanelSendStatus.append(WarningPanelIconContainer);

    let WarningPanelIcon = document.createElement("img");
    WarningPanelIcon.className = "WarningPanelIcon";
    WarningPanelIconContainer.append(WarningPanelIcon);

    let WarningPanelTextMessage = document.createElement("p");
    WarningPanelTextMessage.className = "WarningPanelTextMessage InterMediumTextFont";
    WarningPanelTextMessage.innerHTML = whatmessage;
    WarningPanelSendStatus.append(WarningPanelTextMessage);

    let NotificationMessageTime = document.createElement("p");
    NotificationMessageTime.className = "NotificationMessageTime InterRegularTextFont";
    NotificationMessageTime.innerHTML = window["NowTxt" + window.CurrentCountryID];
    WarningPanelSendStatus.append(NotificationMessageTime);

    window.AnimateAndRemovingWarningPanel(WarningPanelSendStatus);
}

window.AnimateAndRemovingWarningPanel = function(whichpanel)
{
    whichpanel.animate([{opacity: 0, right: "-15%"},{opacity: 1, right: 0}], {duration: 300});
    whichpanel.style.opacity = 1;
    whichpanel.style.left = 0;

    setTimeout(function()
    {
        whichpanel.animate([{opacity: 1, left: 0}, {opacity: 0, left: "-15%"}], {duration: 300});
        whichpanel.style.opacity = 0;
        whichpanel.style.left ="15%";
        setTimeout(function()
        {
            whichpanel.remove();
            let WarningPanelSendStatus = document.querySelectorAll('.WarningPanelSendStatus');

            if(WarningPanelSendStatus.length == 0)
            {
                document.getElementById('WarningPanelContainer').remove();
            }
        }, 300);
    }, 2000);
}


// =========================== CONVERT TO JSON =================================

// function window.ConvertDataJSON(retreiveddata)
// {
//     let data = retreiveddata;
//     // console.log("Original:", retreiveddata);

//     if (retreiveddata === "Koneksi ke database gagal: Too many connections")
//     {
//         window.alert(retreiveddata);
//         return data;
//     }

//     if (typeof retreiveddata === "string")
//     {
//         const jsonMatch = retreiveddata.match(/(\[.*\]|\{.*\})/s);
//         // console.log("Match:", jsonMatch);

//         if (jsonMatch)
//         {
//             let possibleJson = jsonMatch[0];
//             // Replace single quotes with double quotes
//             possibleJson = possibleJson.replace(/'/g, '"');
//             // console.log("Cleaned:", possibleJson);

//             try
//             {
//                 const parsedJSON = JSON.parse(possibleJson);
//                 // console.log("Parsed JSON:", parsedJSON);
//                 data = parsedJSON;
//             }
//             catch (e)
//             {
//                 // console.warn("JSON parsing failed:", e.message);
//                 data = retreiveddata; // fallback
//             }
//         }
//         else
//         {
//             data = retreiveddata;
//         }
//     }

//     return data;
// }

window.ConvertDataJSON = function(retreiveddata)
{
    if (retreiveddata === "Koneksi ke database gagal: Too many connections")
    {
        return retreiveddata;
    }

    try
    {
        return JSON.parse(retreiveddata);
    }
    catch (e)
    {
        return retreiveddata;
    }
}


window.isJsonParsable = function(value)
{
    if (typeof value !== "string")
    {
        return value;
    }

    try
    {
        let ParsedJSON = JSON.parse(value);
        return ParsedJSON[0];
    }
    catch (e)
    {
        return value;
    }
}

// =============================== OPEN CLOSE PANEL ANIMATE ===========================

window.OpenPanelAnimate = function(PanelContainer, BackBlocker)
{
    if(PanelContainer != null)
    {
        PanelContainer.animate([{bottom: "-100%"},{bottom: 0}], {duration: window.AnimateBlockerDuration});
    }
    BackBlocker.animate([{opacity: 0},{opacity: 1}], {duration: window.AnimateBlockerDuration});
    BackBlocker.style.opacity = 1;
}

window.ClosePanelAnimate = function(PanelContainer, BackBlocker, functiontocall)
{
    if(PanelContainer != null)
    {
        PanelContainer.animate([{bottom: 0},{bottom: "-100%"}], {duration: window.AnimateBlockerDuration});
    }
    BackBlocker.animate([{opacity: 1},{opacity: 0}], {duration: window.AnimateBlockerDuration});
    BackBlocker.style.opacity = 0;

    setTimeout(function()
    {
        BackBlocker.remove();

        if(functiontocall != null)
        {
            functiontocall();
        }

    }, window.AnimateBlockerDuration);
}

// =============================== ANIMATE LEFT RIGHT ===========================

window.MovePanelInsideContainerNext = function(CurrentPanel, NextPanel, whichcontainer, functiontocall)
{
    whichcontainer.style.overflow = "hidden";

    if(CurrentPanel != null)
    {
        CurrentPanel.style.opacity = 0;
        CurrentPanel.style.left = "-15%";
        CurrentPanel.animate([{opacity: 1, left: "0%"},{opacity: 0, left: "-15%"}], {duration: window.AnimateBlockerDuration});
    }
    else
    {
        whichcontainer.style.opacity = 0;
    }

    setTimeout(function()
    {
        if(CurrentPanel != null)
        {
            CurrentPanel.style.position = "absolute";
            CurrentPanel.style.display = "none";
            CurrentPanel.style.left = "-105%";
        }
        else
        {
            whichcontainer.style.opacity = 1;
            whichcontainer.animate([{opacity: 0},{opacity: 1}], {duration: window.AnimateBlockerDuration});
        }

        NextPanel.style.opacity = 1;
        NextPanel.style.left = "0%";
        NextPanel.style.position = "relative";
        NextPanel.style.display = "";
        NextPanel.animate([{opacity: 0, left: "15%"},{opacity: 1, left: "0%"}], {duration: window.AnimateBlockerDuration});

        setTimeout(function()
        {
            whichcontainer.style.overflow = "";
            if(functiontocall != null)
            {
                functiontocall();
            }

        }, window.AnimateBlockerDuration);

    }, window.AnimateBlockerDuration * 2.5);
}

window.MovePanelInsideContainerBack = function(CurrentPanel, PreviousPanel, whichcontainer, functiontocall)
{
    whichcontainer.style.overflow = "hidden";
    CurrentPanel.style.opacity = 0;
    CurrentPanel.style.left = "15%";
    CurrentPanel.animate([{opacity: 1, left: "0%"},{opacity: 0, left: "15%"}], {duration: window.AnimateBlockerDuration});

    setTimeout(function()
    {
        CurrentPanel.style.position = "absolute";
        CurrentPanel.style.display = "none";
        CurrentPanel.style.left = "105%";

        PreviousPanel.style.opacity = 1;
        PreviousPanel.style.left = "0%";
        PreviousPanel.style.position = "relative";
        PreviousPanel.style.display = "";
        PreviousPanel.animate([{opacity: 0, left: "-15%"},{opacity: 1, left: "0%"}], {duration: window.AnimateBlockerDuration});

        setTimeout(function()
        {
            whichcontainer.style.overflow = "";
            if(functiontocall != null)
            {
                functiontocall();
            }

        }, window.AnimateBlockerDuration);
    }, window.AnimateBlockerDuration * 2.5);
}

window.FadeOutInInsideContainer = function(CurrentPanel)
{
    CurrentPanel.style.opacity = 0;
    CurrentPanel.animate([{opacity: 1},{opacity: 0}], {duration: window.AnimateBlockerDuration});

    setTimeout(function()
    {
        CurrentPanel.style.opacity = 1;
        CurrentPanel.animate([{opacity: 0},{opacity: 1}], {duration: window.AnimateBlockerDuration});

    }, window.AnimateBlockerDuration * 2.5);
}

// =============================== SEE ALL PHOTOS ===============================

window.OpenSeeAllPhotosContainer = function()
{
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    BasicBlackBlocker.style.backgroundColor = "rgba(0, 0, 0, 0.9)";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let HotelPhotoChoiceMainContainer = document.createElement("div");
    HotelPhotoChoiceMainContainer.className = "HotelPhotoChoiceMainContainer";
    BasicBlackBlocker.append(HotelPhotoChoiceMainContainer);

    // ------------------------------ Photo Choice ------------------------------

    let HotelPhotoChoiceTopContainer = document.createElement("div");
    HotelPhotoChoiceTopContainer.className = "HotelPhotoChoiceTopContainer";
    HotelPhotoChoiceMainContainer.append(HotelPhotoChoiceTopContainer);

    let BackButton = document.createElement("button"); // Back --------------
    BackButton.className = "NextPrevButtonPhotoChoice Selectable2";
    HotelPhotoChoiceTopContainer.append(BackButton);

    let BackButtonIcon = document.createElement("img");
    BackButtonIcon.src = "/Assets/images/ButtonIcon/chevron-grey.svg";
    BackButtonIcon.style.rotate = "180deg";
    BackButton.append(BackButtonIcon);

    let HotelPhotoChoiceTopPhotoContainer = document.createElement("div"); // Photo Container --------------
    HotelPhotoChoiceTopPhotoContainer.className = "HotelPhotoChoiceTopPhotoContainer";
    HotelPhotoChoiceTopContainer.append(HotelPhotoChoiceTopPhotoContainer);

    // let HotelPhotoChoiceDisplayIMG = document.createElement("img");
    // HotelPhotoChoiceDisplayIMG.className = "Selectable";
    // HotelPhotoChoiceTopPhotoContainer.append(HotelPhotoChoiceDisplayIMG);

    let NextButton = document.createElement("button"); // Next --------------
    NextButton.className = "NextPrevButtonPhotoChoice Selectable2";
    HotelPhotoChoiceTopContainer.append(NextButton);

    let NextButtonIcon = document.createElement("img");
    NextButtonIcon.src = "/Assets/images/ButtonIcon/chevron-grey.svg";
    NextButton.append(NextButtonIcon);

    BackButton.onclick = function()
    {
        if(window.WhichIndexImage == 0)
        {
            window.WhichIndexImage = (parseInt(window.FullPhotoListForIndex.length) -1);
        }
        else
        {
            window.WhichIndexImage--;
        }
        window.ChangeToSelectedImageFullScreen(HotelPhotoChoiceTopPhotoContainer, true);
    }

    NextButton.onclick = function()
    {
        if(window.WhichIndexImage == (parseInt(window.FullPhotoListForIndex.length) -1))
        {
            window.WhichIndexImage = 0;
        }
        else
        {
            window.WhichIndexImage++;
        }
        window.ChangeToSelectedImageFullScreen(HotelPhotoChoiceTopPhotoContainer, true);
    }

    // ------------------------------ Button Bottom ------------------------------

    let HotelPhotoChoiceSortButtonContainer = document.createElement("div");
    HotelPhotoChoiceSortButtonContainer.className = "HotelPhotoChoiceSortButtonContainer";
    HotelPhotoChoiceMainContainer.append(HotelPhotoChoiceSortButtonContainer);

    let AllButton = document.createElement("button");
    AllButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable ImageSortButton";
    AllButton.id = "AllButtonImageSort";
    HotelPhotoChoiceSortButtonContainer.append(AllButton);

    let BuildingButton = document.createElement("button");
    BuildingButton.className = "BasicTextButton BasicBoxShadow ButtonUnselected SignInButtonTop Selectable WhiteOuterHover ImageSortButton";
    BuildingButton.id = "BuildingButtonImageSort";
    HotelPhotoChoiceSortButtonContainer.append(BuildingButton);

    let RoomButton = document.createElement("button");
    RoomButton.className = "BasicTextButton BasicBoxShadow ButtonUnselected SignInButtonTop Selectable WhiteOuterHover ImageSortButton";
    RoomButton.id = "RoomButtonImageSort";
    HotelPhotoChoiceSortButtonContainer.append(RoomButton);

    let ExperienceButton = document.createElement("button");
    ExperienceButton.className = "BasicTextButton BasicBoxShadow ButtonUnselected SignInButtonTop Selectable WhiteOuterHover ImageSortButton";
    ExperienceButton.id = "ExperienceButtonImageSort";
    HotelPhotoChoiceSortButtonContainer.append(ExperienceButton);

    // ------------------------------ Photo Choice ------------------------------

    let ListOfPhotoToClickHotelPhoto = document.createElement("div");
    ListOfPhotoToClickHotelPhoto.className = "ListOfPhotoToClickHotelPhoto HideScrollBar";
    HotelPhotoChoiceMainContainer.append(ListOfPhotoToClickHotelPhoto);

    let ListOfPhotoToClickHotelPhotoWrapper = document.createElement("div");
    ListOfPhotoToClickHotelPhotoWrapper.className = "ListOfPhotoToClickHotelPhotoWrapper BasicGradientTopBottomMask";
    ListOfPhotoToClickHotelPhoto.append(ListOfPhotoToClickHotelPhotoWrapper);


    let BuildingPhotoLength = window.HotelRoomPhotoSortedData.hotel_photo.length;
    let RoomPhotoLength = window.HotelRoomPhotoSortedData.room_photo.length;
    let ExperiencePhotoLength = window.HotelRoomPhotoSortedData.experience_photo.length;

    AllButton.innerHTML = window["AllTxt" + window.CurrentCountryID] + " (" + (BuildingPhotoLength + RoomPhotoLength) + ")";
    BuildingButton.innerHTML = window["ExteriorTxt" + window.CurrentCountryID] + " (" + BuildingPhotoLength + ")";
    RoomButton.innerHTML =  window["RoomTxt" + window.CurrentCountryID] + " (" + RoomPhotoLength + ")";
    ExperienceButton.innerHTML =  window["ExperienceTxt" + window.CurrentCountryID] + " (" + ExperiencePhotoLength + ")";

    window.InstantiateListOfImageChoiceFullScreen("All", ListOfPhotoToClickHotelPhotoWrapper, HotelPhotoChoiceTopPhotoContainer);
    
    AllButton.onclick = function()
    {
        window.InstantiateListOfImageChoiceFullScreen("All", ListOfPhotoToClickHotelPhotoWrapper, HotelPhotoChoiceTopPhotoContainer);
    }
    BuildingButton.onclick = function()
    {
        window.InstantiateListOfImageChoiceFullScreen("Building", ListOfPhotoToClickHotelPhotoWrapper, HotelPhotoChoiceTopPhotoContainer);
    }
    RoomButton.onclick = function()
    {
        window.InstantiateListOfImageChoiceFullScreen("Room", ListOfPhotoToClickHotelPhotoWrapper, HotelPhotoChoiceTopPhotoContainer);
    }
    ExperienceButton.onclick = function()
    {
        window.InstantiateListOfImageChoiceFullScreen("Experience", ListOfPhotoToClickHotelPhotoWrapper, HotelPhotoChoiceTopPhotoContainer);
    }

    if(BuildingPhotoLength == 0)
    {
        BuildingButton.remove();
    }
    if(RoomPhotoLength == 0)
    {
        RoomButton.remove();
    }
    if(ExperiencePhotoLength == 0)
    {
        ExperienceButton.remove();
    }

    // -------------------------------- Close Button -----------------------------------

    let CloseWhiteBlocker = document.createElement("img");
    CloseWhiteBlocker.className = "CloseWhiteBlocker Selectable2";
    CloseWhiteBlocker.src = "/Assets/images/ButtonIcon/close-white.svg";
    CloseWhiteBlocker.onclick = function()
    {
        window.ClosePanelAnimate(HotelPhotoChoiceMainContainer, BasicBlackBlocker, null);
    }
    BasicBlackBlocker.append(CloseWhiteBlocker);

    // ---------------------------- ANIMATE -------------------------------------

    window.OpenPanelAnimate(null, BasicBlackBlocker);
}

window.InstantiateListOfImageChoiceFullScreen = function(whichtype, wheretoinstantiate, hotelimagecontainer)
{
    window.FullPhotoListForIndex = [];

    // Change Button Class ---------------------------------

    let ImageSortButton = document.querySelectorAll('.ImageSortButton');
    ImageSortButton.forEach(Button =>
    {
        Button.className = "BasicTextButton BasicBoxShadow ButtonUnselected SignInButtonTop Selectable WhiteOuterHover ImageSortButton";
        if(Button.id == whichtype + "ButtonImageSort")
        {
            Button.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable ImageSortButton";
        }
    });

    // Append All Image To One Data ---------------------------------

    if(whichtype == "All")
    {
        window.FullPhotoListForIndex = window.AllHotelImagePool;
    }
    else if(whichtype == "Building")
    {
        window.FullPhotoListForIndex = window.AllFacilitiesImagePool;
    }
    else if(whichtype == "Room")
    {
        window.FullPhotoListForIndex = window.AllRoomImagePool;
    }
    else if(whichtype == "Experience")
    {
        window.FullPhotoListForIndex = window.AllExperienceImagePool;
    }

    // Instantiate All Image Choice ---------------------------------

    wheretoinstantiate.innerHTML = "";

    for(let i = 0; i < window.FullPhotoListForIndex.length; i++)
    {
        let ListOfPhotoPanelHotelPhoto = document.createElement("div");
        ListOfPhotoPanelHotelPhoto.className = "ListOfPhotoPanelHotelPhoto Selectable WhiteOuterHover";
        ListOfPhotoPanelHotelPhoto.id = "ListOfPhotoPanelHotelPhoto" + i;
        ListOfPhotoPanelHotelPhoto.onclick = function()
        {
            window.WhichIndexImage = i;
            window.ChangeToSelectedImageFullScreen(hotelimagecontainer, true);
        }
        wheretoinstantiate.append(ListOfPhotoPanelHotelPhoto);

        let ImageFullCover = ListOfPhotoPanelHotelPhoto.appendChild(window.bindImageFromPool(window.FullPhotoListForIndex[i]));
        ImageFullCover.classList.add("ImageFullCover");

        // let ImageFullCover = document.createElement("img");
        // ImageFullCover.className = "ImageFullCover";
        // // ImageFullCover.src = window.FullPhotoListForIndex[i];
        // window.checkImageUrlValid(window.FullPhotoListForIndex[i], "/Assets/images/NoHotelImage.jpg", ImageFullCover, () => {}, { quality: 50});
        // ListOfPhotoPanelHotelPhoto.append(ImageFullCover);
    }

    // Prpare Start Index -----------------------------------------------
    window.WhichIndexImage = 0;
    window.ChangeToSelectedImageFullScreen(hotelimagecontainer, false);
}

window.ChangeToSelectedImageFullScreen = function(hotelimagecontainer, animateout)
{
    // Animate ----------------------------------------------------------------------------------------

    let NextTransitionDuration = 0;
    if(animateout == true)
    {
        hotelimagecontainer.style.opacity = 0;
        hotelimagecontainer.animate([{opacity: 1},{opacity: 0}], {duration: window.AnimateBlockerDuration});
        NextTransitionDuration = window.AnimateBlockerDuration;
    }

    setTimeout(function()
    {
        hotelimagecontainer.innerHTML = "";

        let HotelPhotoChoiceDisplayIMG = hotelimagecontainer.appendChild(window.bindImageFromPool(window.FullPhotoListForIndex[window.WhichIndexImage]));
        HotelPhotoChoiceDisplayIMG.classList.add("Selectable");
        HotelPhotoChoiceDisplayIMG.onclick = function()
        {
            window.OpenImageFullScreen("WhichIndexImage", window.FullPhotoListForIndex, () => window.ChangeToSelectedImageFullScreen(hotelimagecontainer, true));
        }
        hotelimagecontainer.style.opacity = 1;
        hotelimagecontainer.animate([{opacity: 0},{opacity: 1}], {duration: window.AnimateBlockerDuration});
    }, window.AnimateBlockerDuration);

    // Apply Changes To Photo Choice ----------------------------------------------------------------------------------------

    let PhotoChoice = document.querySelectorAll('.ListOfPhotoPanelHotelPhoto');
    PhotoChoice.forEach(Choice =>
    {
        Choice.className = "ListOfPhotoPanelHotelPhoto ListOfPhotoPanelHotelPhotoNotSelected Selectable WhiteOuterHover";

        if(Choice.id == "ListOfPhotoPanelHotelPhoto" + window.WhichIndexImage)
        {
            Choice.className = "ListOfPhotoPanelHotelPhoto Selectable";
        }
    });
}

window.OpenImageFullScreen = function(whichindextochange, listofimage, whatfunctiontocall)
{
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    // All Image -------------------------------------------------------

    let swiperwrapper = document.createElement("div");
    swiperwrapper.className = "swiper-wrapper";
    BasicBlackBlocker.append(swiperwrapper);

    for(let i = 0; i < listofimage.length; i++)
    {
        let FullScreenImageSwiper = document.createElement("div");
        FullScreenImageSwiper.className = "FullScreenImageSwiper swiper-slide";
        swiperwrapper.append(FullScreenImageSwiper);

        let ImageMainLoading = document.createElement("div");
        ImageMainLoading.className = "loading_grey ImageFullCover";
        FullScreenImageSwiper.append(ImageMainLoading);

        let ImageFullScreen = FullScreenImageSwiper.appendChild(window.bindImageFromPool(window.AllHotelImagePool[i]));
        ImageFullScreen.style.opacity = 0;
        ImageFullScreen.classList.add("ImageFullScreen");

        window.HandleLoadingSkeletonAndImage(ImageMainLoading, ImageFullScreen);

        // let ImageFullScreen = document.createElement("img");
        // ImageFullScreen.className = "ImageFullScreen";
        // ImageFullScreen.src = listofimage[i];
        // FullScreenImageSwiper.append(ImageFullScreen);
    }

    // Prev Button -------------------------------------------------------

    let LeftNavButton = document.createElement("button");
    LeftNavButton.className = "NavButtonFullScreen left";
    BasicBlackBlocker.append(LeftNavButton);

    let LeftNavButtonIMG = document.createElement("img");
    LeftNavButtonIMG.src = "/Assets/images/ButtonIcon/NextPrevFSButton.svg";
    LeftNavButton.append(LeftNavButtonIMG);

    // Next Button -------------------------------------------------------

    let RightNavButton = document.createElement("button");
    RightNavButton.className = "NavButtonFullScreen right";
    BasicBlackBlocker.append(RightNavButton);

    let RightNavButtonIMG = document.createElement("img");
    RightNavButtonIMG.src = "/Assets/images/ButtonIcon/NextPrevFSButton.svg";
    RightNavButton.append(RightNavButtonIMG);

    // Close --------------------------------------------------------------

    let CloseWhiteBlocker = document.createElement("img");
    CloseWhiteBlocker.className = "CloseWhiteBlocker Selectable2";
    CloseWhiteBlocker.src = "/Assets/images/ButtonIcon/close-white.svg";
    CloseWhiteBlocker.style.zIndex = 1;
    CloseWhiteBlocker.onclick = function()
    {
        window.ClosePanelAnimate(null, BasicBlackBlocker, null);
    }
    BasicBlackBlocker.append(CloseWhiteBlocker);

    // ------------------------- Set Swiper -------------------------

    let SwipeFullImage = new window.Swiper(BasicBlackBlocker,
    {
        grabCursor: true,
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        navigation:
        {
            prevEl: LeftNavButton,
            nextEl: RightNavButton
        },
        on:{
        slideChange : function()
        {
            window[whichindextochange] = this.activeIndex;
            whatfunctiontocall();
        }}
    });
    SwipeFullImage.slideTo(window[whichindextochange]);

    // --------------------------------- ANIMATE ON INSTANTIATE ---------------------------------------

    BasicBlackBlocker.animate([{opacity: 0},{opacity: 1}], {duration: window.AnimateBlockerDuration});

    setTimeout(function()
    {
        BasicBlackBlocker.style.opacity = 1;

    }, window.AnimateBlockerDuration);
}


// ===================================== BASIC ROOM QUOTA & TYPE CHANGE =================================

window.ParentPanelContainer = null;

window.InstantiateRoomQuotaAndTypePanel = function(event, wheretoinstantiate, instiateatleft, whattypeisthis, functiontocall)
{
    event.preventDefault();
    event.stopPropagation();

    window.RotateToggle("", true);
        

    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown("RoomQuotaInputFieldPanel" + whattypeisthis, wheretoinstantiate);

    if(ThisDropDownContainer == null)
        return

    window.CheckIfAllRoomExperienceDataAlreadyLoaded(()=>
    {
        console.log("window.ThisRoomData", window.ThisRoomData);

        ThisDropDownContainer.className = "ContainerFlex";
        ThisDropDownContainer.style.bottom = 0;
        ThisDropDownContainer.innerHTML = "";

        window.ThisCurrentQuotaInput = parseInt(wheretoinstantiate.getAttribute("room-quota"));

        let WhitePanelContentContainer = document.createElement("div");
        WhitePanelContentContainer.className = "WhitePanelContentContainer BasicRadius";
        WhitePanelContentContainer.style.top = 0;
        if(instiateatleft == true)
        {
            WhitePanelContentContainer.style.left = 0;
        }
        else
        {
            WhitePanelContentContainer.style.right = 0;
        }
        WhitePanelContentContainer.onclick = function(event)
        {
            event.preventDefault();
            event.stopPropagation();
        }
        ThisDropDownContainer.append(WhitePanelContentContainer);

        let WhitePanelContentMainWrapper = document.createElement("div");
        WhitePanelContentMainWrapper.className = "WhitePanelContentMainWrapper";
        WhitePanelContentMainWrapper.style.flexDirection = "column";
        WhitePanelContentContainer.append(WhitePanelContentMainWrapper);
        
        
        // Room Quantity ----------------------------------------------------------------------------------

        let RoomsQuotaContentWrapper = document.createElement("div");
        RoomsQuotaContentWrapper.className = "WhitePanelContentWrapper";
        WhitePanelContentMainWrapper.append(RoomsQuotaContentWrapper);

        let RoomsQuotaHeaderText = document.createElement("p");
        RoomsQuotaHeaderText.className = "BasicInputTextTop InterMediumTextFont";
        RoomsQuotaHeaderText.innerHTML = window["RoomAmountTxt" + window.CurrentCountryID] + ":";
        RoomsQuotaContentWrapper.append(RoomsQuotaHeaderText);

        let RoomButtonAndInputContainer = document.createElement("div");
        RoomButtonAndInputContainer.className = "RoomQuotaAndTypeContainer";
        RoomsQuotaContentWrapper.append(RoomButtonAndInputContainer);

        let ReduceRoomButton = document.createElement("img");
        ReduceRoomButton.className = "IncreaseReduceRoomButton Selectable2";
        ReduceRoomButton.src = "/Assets/images/ButtonIcon/reduceroom.svg";
        RoomButtonAndInputContainer.append(ReduceRoomButton);

        let QuotaInputFieldRoomContainer = document.createElement("div");
        QuotaInputFieldRoomContainer.className = "Selectable3";
        RoomButtonAndInputContainer.append(QuotaInputFieldRoomContainer);

        let RoomQuotaInputField = document.createElement("input");
        RoomQuotaInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont InputFieldOutline";
        RoomQuotaInputField.type = "number";
        RoomQuotaInputField.placeholder = "0";
        QuotaInputFieldRoomContainer.append(RoomQuotaInputField);

        let RoomIncreaseButton = document.createElement("img");
        RoomIncreaseButton.className = "IncreaseReduceRoomButton Selectable2";
        RoomIncreaseButton.id = "IncreaseRoomQuotaButton";
        RoomIncreaseButton.src = "/Assets/images/ButtonIcon/increaseroom.svg";
        RoomButtonAndInputContainer.append(RoomIncreaseButton);


        // Experiences (No Options) ----------------------------------------------------------------------------------

        let ExperiencesQuotaContentWrapper = document.createElement("div");
        ExperiencesQuotaContentWrapper.className = "WhitePanelContentWrapper";
        WhitePanelContentMainWrapper.append(ExperiencesQuotaContentWrapper);

        let ExperiencesQuotaHeaderText = document.createElement("p");
        ExperiencesQuotaHeaderText.className = "BasicInputTextTop InterMediumTextFont";
        ExperiencesQuotaHeaderText.innerHTML = window["RoomAmountTxt" + window.CurrentCountryID] + ":";
        ExperiencesQuotaContentWrapper.append(ExperiencesQuotaHeaderText);

        let ExperiencesButtonAndInputContainer = document.createElement("div");
        ExperiencesButtonAndInputContainer.className = "RoomQuotaAndTypeContainer";
        ExperiencesQuotaContentWrapper.append(ExperiencesButtonAndInputContainer);

        let ExperiencesReduceButton = document.createElement("img");
        ExperiencesReduceButton.className = "IncreaseReduceRoomButton Selectable2";
        ExperiencesReduceButton.src = "/Assets/images/ButtonIcon/reduceroom.svg";
        ExperiencesButtonAndInputContainer.append(ExperiencesReduceButton);

        let ExperiencesQuotaInputFieldContainer = document.createElement("div");
        ExperiencesQuotaInputFieldContainer.className = "Selectable3";
        ExperiencesButtonAndInputContainer.append(ExperiencesQuotaInputFieldContainer);

        let ExperiencesQuotaInputField = document.createElement("input");
        ExperiencesQuotaInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont InputFieldOutline";
        ExperiencesQuotaInputField.type = "number";
        ExperiencesQuotaInputField.placeholder = "0";
        ExperiencesQuotaInputFieldContainer.append(ExperiencesQuotaInputField);

        let ExperiencesIncreaseButton = document.createElement("img");
        ExperiencesIncreaseButton.className = "IncreaseReduceRoomButton Selectable2";
        ExperiencesIncreaseButton.id = "IncreaseExperiencesQuotaButton";
        ExperiencesIncreaseButton.src = "/Assets/images/ButtonIcon/increaseroom.svg";
        ExperiencesButtonAndInputContainer.append(ExperiencesIncreaseButton);


        // Room Type ----------------------------------------------------------------------------------

        let RoomsTypeContentWrapper = document.createElement("div");
        RoomsTypeContentWrapper.className = "WhitePanelContentWrapper";
        WhitePanelContentMainWrapper.append(RoomsTypeContentWrapper);

        let RoomsTypeHeaderText = document.createElement("p");
        RoomsTypeHeaderText.className = "BasicInputTextTop InterMediumTextFont";
        RoomsTypeHeaderText.innerHTML = window["RoomOrItemTypeTxt" + window.CurrentCountryID] + ":";
        RoomsTypeContentWrapper.append(RoomsTypeHeaderText);

        let RoomTypeDropDownContainer = document.createElement("div");
        RoomTypeDropDownContainer.className = "RoomQuotaAndTypeContainer";
        RoomsTypeContentWrapper.append(RoomTypeDropDownContainer);

        let RoomTypeDropDownSelectable = document.createElement("div");
        RoomTypeDropDownSelectable.className = "Selectable3";
        RoomTypeDropDownContainer.append(RoomTypeDropDownSelectable);

        let RoomTypeDropDownText = document.createElement("p");
        RoomTypeDropDownText.className = "MiniDropDownText InputFieldSelectable InterMediumTextFont InputFieldOutline";
        RoomTypeDropDownSelectable.append(RoomTypeDropDownText);

        let ThisRoomOrExperienceData = window.AllChoicesBasedOnCurrentSelectedRoomAccType;

        for (let i = 0; i < ThisRoomOrExperienceData.length; i++)
        {
            let ThisExpRoomID = ThisRoomOrExperienceData[i]?.id_hotel_room || ThisRoomOrExperienceData[i]?.id;
            let RoomExperienceNameText = ThisRoomOrExperienceData[i].room_name || ThisRoomOrExperienceData[i]["name_" + window.CurrentCountryID];
            
            let WhichType = "Rooms";
            if(ThisRoomOrExperienceData[i].id_hotel_room == null)
                WhichType = "Experiences";

            if(window.CurrentSelectedRoomID == ThisExpRoomID && window.CurrentSelectedAccFacilitiesType == WhichType)
            {
                RoomTypeDropDownText.innerHTML = RoomExperienceNameText;
            }
        }


        // SET FUNCTIONS ---------------------------------------------------------------------------

        let OnInfoChange = function(callfunction)
        {
            console.log("window.CurrentSelectedRoomID", window.CurrentSelectedRoomID);
            console.log("window.CurrentSelectedAccFacilitiesType", window.CurrentSelectedAccFacilitiesType);

            if(window.CurrentSelectedAccFacilitiesType == "Rooms")
            {
                RoomsQuotaContentWrapper.style.display = "";
                ExperiencesQuotaContentWrapper.style.display = "none";
                RoomQuotaInputField.value = window.ThisCurrentQuotaInput;

                if(callfunction == false)
                    window.OnChangeCurrentQuotaInput(wheretoinstantiate, RoomQuotaInputField, null, ReduceRoomButton, OnInfoChange(true));
            }
            else
            {
                RoomsQuotaContentWrapper.style.display = "none";

                if(Array.isArray(window.CurrentUserInputExperienceAddOns.data_input) == false)
                {
                    window.ThisCurrentQuotaInput = window.CurrentUserInputExperienceAddOns.data_input;
                    
                    ExperiencesQuotaContentWrapper.style.display = "";
                    ExperiencesQuotaInputField.value = window.ThisCurrentQuotaInput;

                    if(callfunction == false)
                        window.OnChangeCurrentQuotaInput(wheretoinstantiate, ExperiencesQuotaInputField, null, ExperiencesReduceButton, ()=>OnInfoChange(true));
                }
                else
                {
                    // Experience WITH Options -----------------------------
                    ExperiencesQuotaContentWrapper.style.display = "none";
                }
            }
            
            if(functiontocall != null && callfunction == true)
            {
                console.log(functiontocall);
                functiontocall();
            }
        }

        OnInfoChange(false);

        // Room Quantity Related --------------------------------------------------------------------

        ReduceRoomButton.onclick = function(event) 
        {
            event.preventDefault();
            event.stopPropagation();

            window.ThisCurrentQuotaInput = window.ThisCurrentQuotaInput - 1;
            window.OnChangeCurrentQuotaInput(wheretoinstantiate, RoomQuotaInputField, null, ReduceRoomButton, ()=>OnInfoChange(true));
        }

        RoomIncreaseButton.onclick = function(event)
        {
            event.preventDefault();
            event.stopPropagation();

            window.ThisCurrentQuotaInput = window.ThisCurrentQuotaInput + 1;
            window.OnChangeCurrentQuotaInput(wheretoinstantiate, RoomQuotaInputField, null, ReduceRoomButton, ()=>OnInfoChange(true));
        }

        RoomQuotaInputField.addEventListener("focusout", (event) =>
        {
            window.ThisCurrentQuotaInput = RoomQuotaInputField.value;
            window.OnChangeCurrentQuotaInput(wheretoinstantiate, RoomQuotaInputField, null, ReduceRoomButton, ()=>OnInfoChange(true));
        });

        // Experience (No Option) Related --------------------------------------------------------------------

        ExperiencesQuotaInputField.addEventListener("focusout", (event) =>
        {
            window.ThisCurrentQuotaInput = ExperiencesQuotaInputField.value;
            window.CurrentUserInputExperienceAddOns.data_input = ExperiencesQuotaInputField.value;

            window.OnChangeCurrentQuotaInput(null, ExperiencesQuotaInputField, null, ExperiencesReduceButton, ()=>OnInfoChange(true));
        });
            
        ExperiencesReduceButton.onclick = function(event)
        {
            event.preventDefault();
            event.stopPropagation();

            let CurrentInputted = window.CurrentUserInputExperienceAddOns.data_input;
            CurrentInputted = CurrentInputted - 1;
            window.ThisCurrentQuotaInput = CurrentInputted;
            window.CurrentUserInputExperienceAddOns.data_input = CurrentInputted;

            window.OnChangeCurrentQuotaInput(null, ExperiencesQuotaInputField, null, ExperiencesReduceButton, ()=>OnInfoChange(true));
        }
        ExperiencesIncreaseButton.onclick = function(event)
        {
            event.preventDefault();
            event.stopPropagation();

            let CurrentInputted = window.CurrentUserInputExperienceAddOns.data_input;
            CurrentInputted = CurrentInputted + 1;
            window.ThisCurrentQuotaInput = CurrentInputted;
            window.CurrentUserInputExperienceAddOns.data_input = CurrentInputted;

            window.OnChangeCurrentQuotaInput(wheretoinstantiate, ExperiencesQuotaInputField, null, ExperiencesReduceButton, ()=>OnInfoChange(true));
        }

        // Room Type Related --------------------------------------------------------------------

        RoomTypeDropDownContainer.onclick = function(event)
        {
            event.preventDefault();
            event.stopPropagation();

            window.InstantiateRoomTypeDropDown(RoomTypeDropDownContainer, ThisRoomOrExperienceData, 'RoomDetailsPaymentForm', '', ()=>
            {
                console.log("window.CurrentSelectedRoomID", window.CurrentSelectedRoomID);
                console.log("window.CurrentSelectedAccFacilitiesType", window.CurrentSelectedAccFacilitiesType);

                OnInfoChange(true);

            }, true);

        }
    })
}


window.OpenRoomQuotaChangePanel = function(roomquotainputfield, roomquotatextdisplay, instiateatleft, functiontocall) // Room Quota Basic Change Panel
{
    window.event.preventDefault();
    window.event.stopPropagation();

    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown("RoomQuotaInputFieldPanel" + roomquotatextdisplay, roomquotainputfield);

    if(ThisDropDownContainer == null)
        return

    window.IsCalendarAnimating = false;

    window.ThisCurrentQuotaInput = parseInt(roomquotainputfield.getAttribute("room-quota"));
    let QuotaTextDisplayer = document.getElementById(roomquotatextdisplay);

    ThisDropDownContainer.className = "ContainerFlex";
    ThisDropDownContainer.style.bottom = 0;
    ThisDropDownContainer.innerHTML = "";

    let WhitePanelContentContainer = document.createElement("div");
    WhitePanelContentContainer.className = "WhitePanelContentContainer BasicRadius";
    WhitePanelContentContainer.id = "RoomQuotaInputFieldPanel" + roomquotatextdisplay;
    WhitePanelContentContainer.style.top = 0;
    if(instiateatleft == true)
    {
        WhitePanelContentContainer.style.left = 0;
    }
    else
    {
        WhitePanelContentContainer.style.right = 0;
    }
    WhitePanelContentContainer.onclick = function(event)
    {
        event.preventDefault();
        event.stopPropagation();
    }
    ThisDropDownContainer.append(WhitePanelContentContainer);

    let WhitePanelContentMainWrapper = document.createElement("div");
    WhitePanelContentMainWrapper.className = "WhitePanelContentMainWrapper";
    WhitePanelContentContainer.append(WhitePanelContentMainWrapper);

    let RoomsQuotaContentWrapper = document.createElement("div");
    RoomsQuotaContentWrapper.className = "WhitePanelContentWrapper";
    WhitePanelContentMainWrapper.append(RoomsQuotaContentWrapper);

    let RoomsQuotaHeaderText = document.createElement("p");
    RoomsQuotaHeaderText.className = "BasicInputTextTop InterMediumTextFont";
    RoomsQuotaHeaderText.innerHTML = window["RoomTxtex" + window.CurrentCountryID];
    RoomsQuotaContentWrapper.append(RoomsQuotaHeaderText);

    let RoomButtonAndInputContainer = document.createElement("div");
    RoomButtonAndInputContainer.className = "RoomButtonAndInputContainer";
    RoomsQuotaContentWrapper.append(RoomButtonAndInputContainer);

    let ReduceButton = document.createElement("img");
    ReduceButton.className = "IncreaseReduceRoomButton Selectable2";
    ReduceButton.src = "/Assets/images/ButtonIcon/reduceroom.svg";
    RoomButtonAndInputContainer.append(ReduceButton);

    let QuotaInputFieldContainer = document.createElement("div");
    QuotaInputFieldContainer.className = "SmallPanelDropDownContainer Selectable3";
    RoomButtonAndInputContainer.append(QuotaInputFieldContainer);

    let QuotaInputField = document.createElement("input");
    QuotaInputField.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    QuotaInputField.type = "number";
    QuotaInputField.placeholder = "0";
    QuotaInputField.value = window.ThisCurrentQuotaInput;
    QuotaInputField.addEventListener("focusout", (event) =>
    {
        window.ThisCurrentQuotaInput = QuotaInputField.value;
        window.OnChangeCurrentQuotaInput(roomquotainputfield, QuotaInputField, QuotaTextDisplayer, ReduceButton, functiontocall);
    });
    QuotaInputFieldContainer.append(QuotaInputField);

    let IncreaseButton = document.createElement("img");
    IncreaseButton.className = "IncreaseReduceRoomButton Selectable2";
    IncreaseButton.id = "IncreaseRoomQuotaButton";
    IncreaseButton.src = "/Assets/images/ButtonIcon/increaseroom.svg";
    RoomButtonAndInputContainer.append(IncreaseButton);

    // Apply Functions --------------------------------

    ReduceButton.onclick = function(event)
    {
        event.preventDefault();
        event.stopPropagation();

        window.ThisCurrentQuotaInput = window.ThisCurrentQuotaInput - 1;
        window.OnChangeCurrentQuotaInput(roomquotainputfield, QuotaInputField, QuotaTextDisplayer, ReduceButton, functiontocall);
    }

    IncreaseButton.onclick = function(event)
    {
        event.preventDefault();
        event.stopPropagation();

        window.ThisCurrentQuotaInput = window.ThisCurrentQuotaInput + 1;
        window.OnChangeCurrentQuotaInput(roomquotainputfield, QuotaInputField, QuotaTextDisplayer, ReduceButton, functiontocall);
    }

    window.OnChangeCurrentQuotaInput(roomquotainputfield, QuotaInputField, QuotaTextDisplayer, ReduceButton, functiontocall);
}



window.OnChangeCurrentQuotaInput = function(roomquotainputfield, QuotaInputField, quotatextdisplayer, reducebutton, functiontocall) // Function On Change Quota
{
    reducebutton.className = "IncreaseReduceRoomButton Selectable2";

    if(window.ThisCurrentQuotaInput <= 1)
    {
        window.ThisCurrentQuotaInput = 1;
        reducebutton.className = "IncreaseReduceRoomButton Selectable2 ButtonUnselectableOpacity";
    }

    if(roomquotainputfield != null)
        roomquotainputfield.setAttribute("room-quota", window.ThisCurrentQuotaInput);

    QuotaInputField.value = window.ThisCurrentQuotaInput;

    if(quotatextdisplayer != null)
    {
        quotatextdisplayer.innerHTML = window.ThisCurrentQuotaInput + " " + window["RoomTxt" + window.CurrentCountryID];
        if(window.ThisCurrentQuotaInput > 1)
        {
            quotatextdisplayer.innerHTML = window.ThisCurrentQuotaInput + " " + window["RoomTxtex" + window.CurrentCountryID];
        }
    }

    if(functiontocall != null) // Call Function After It ----------------------
    {
        if(typeof functiontocall === 'string')
        {
            eval(functiontocall);
        }
        else
        {
            functiontocall();
        }
    }
}

window.InstantiateRoomTypeDropDown = function(wheretoinstantiate, roomlistdata, whichtype, roomquotatogglearrow, functiontocall, isabreviated) // Room Type Basic Change Panel
{
    window.event.preventDefault();
    window.event.stopPropagation();

    window.RotateToggle(roomquotatogglearrow, true);
    
    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown("RoomTypeDropDown" + whichtype, wheretoinstantiate);

    if(ThisDropDownContainer == null)
        return

    ThisDropDownContainer.style.bottom = 0;
    ThisDropDownContainer.className = "ContainerFlex";
    ThisDropDownContainer.innerHTML = "";

    let DropDownContainer = document.createElement("div");
    DropDownContainer.className = "DropDownContainer HideScrollBar";
    ThisDropDownContainer.append(DropDownContainer);

    let ScrollToDropDown;

    console.log("roomlistdata", roomlistdata);


    for(let i = 0; i < roomlistdata.length; i++)
    {
        let ThisRoomOrExpData = roomlistdata[i];

        let ThisDataID = ThisRoomOrExpData?.id_hotel_room ?? ThisRoomOrExpData?.id;
        let ThisDataName = ThisRoomOrExpData?.room_name ?? ThisRoomOrExpData["name_" + window.CurrentCountryID];
        let ThisBookType = ThisRoomOrExpData?.book_type;
        let ThisRoomPingData = window.ThisRoomData?.room_pings?.[0]?.dates ?? window.ThisRoomData?.dates;
        let ExperienceOrRoom = "Rooms";
        if(ThisRoomOrExpData.id_experience_type != null)
            ExperienceOrRoom = "Experiences";

        let FunctionToCallOnClickButton = function()
        {
            // Store Before Change Temporarily if Close Apply This One -------------------------
            let PrevData = window.CreateHotelDetailsSnapshot();

            // Apply Update Based On Selecteed Room or Experience ------------------------------
            window.CurrentSelectedRoomID = ThisDataID;
            window.CurrentSelectedRoomExpBookType = ThisBookType;
            window.CurrentSelectedAccFacilitiesType = ExperienceOrRoom;
            window.ThisRoomData = ThisRoomOrExpData;

            let FunctionOnSelectRoomExperience = function()
            {
                if(typeof functiontocall === 'string')
                {
                    eval(functiontocall);
                }
                else
                {
                    functiontocall();
                }
            }

            if(ExperienceOrRoom == "Experiences")
            {
                window.InstantiateJenisExperienceOptionResponsive(
                    ()=>
                    {
                        let UpdatedCheckInArray = window.CheckInDateNonTop.split("-");
                        window.CheckInNonTopInput.setAttribute("year", UpdatedCheckInArray[0]);
                        window.CheckInNonTopInput.setAttribute("month", parseInt(UpdatedCheckInArray[1]));
                        window.CheckInNonTopInput.setAttribute("date", parseInt(UpdatedCheckInArray[2]));

                        let UpdatedCheckOutArray = window.CheckOutDateNonTop.split("-");
                        window.CheckOutNonTopInput.setAttribute("year", UpdatedCheckOutArray[0]);
                        window.CheckOutNonTopInput.setAttribute("month", parseInt(UpdatedCheckOutArray[1]));
                        window.CheckOutNonTopInput.setAttribute("date", parseInt(UpdatedCheckOutArray[2]));

                        FunctionOnSelectRoomExperience();
                    },
                    ()=>
                    {
                        window.RestoreHotelDetailsSnapshot(PrevData);
                    }, true, true
                );
            }
            else
            {
                
                FunctionOnSelectRoomExperience();
            }
        }

        let DropDownSelectionContainer = document.createElement("button");
        DropDownSelectionContainer.className = "DropDownSelectionContainer DropDownWithStatus";
        DropDownSelectionContainer.onclick = function(event)
        {
            event.preventDefault();
            event.stopPropagation();

            ThisDropDownContainer.remove();

            FunctionToCallOnClickButton();

            // window.CurrentSelectedRoomID = roomlistdata[i].id_hotel_room;


        }
        DropDownContainer.append(DropDownSelectionContainer);

        let DropDownSelectionText = document.createElement("p");
        DropDownSelectionText.className = "DropDownSelectionText";
        DropDownSelectionText.innerHTML = ThisDataName;
        DropDownSelectionContainer.append(DropDownSelectionText);

        // (async () =>
        // {
        //     let RoomPingDataCheck = await window.CheckRoomExpDataAvaliablePrice(ExperienceOrRoom, ThisRoomPingData, ThisRoomOrExpData, true);

        //     if(RoomPingDataCheck.room_status == false)
        //     {
        //         // DropDownSelectionContainer.onclick = function()
        //         // {
        //         //     window.event.preventDefault();
        //         //     window.event.stopPropagation();
        //         // }

        //         let DropDownStatusText = document.createElement("p");
        //         DropDownStatusText.className = "DropDownStatusText InterItalicTextFont";
        //         DropDownStatusText.innerHTML = window[ExperienceOrRoom + "UnavailableTxt" + window.CurrentCountryID];
        //         DropDownSelectionContainer.append(DropDownStatusText);

        //         console.log("RoomPingDataCheck", RoomPingDataCheck);

        //         if(RoomPingDataCheck.max_room != null)
        //         {
        //             DropDownStatusText.innerHTML = RoomPingDataCheck.unavailable_text;
        //         }
        //     }

        //     // Get Information For Basic Scroll Start ----------------------------------------------------------------------
        //     if(window.CurrentSelectedRoomID == ThisDataID && ExperienceOrRoom == window.CurrentSelectedAccFacilitiesType)
        //     {
        //         ScrollToDropDown = DropDownSelectionContainer;
        //         DropDownSelectionContainer.classList.add("DropDownSelectionContainerSelected");
        //     }
        // })();
    }

    window.ScrollToSelectedDropDown(DropDownContainer, ScrollToDropDown);
}


// ================================ CHECK ROOM IS EXIST ==========================

window.CheckRoomExpDataAvaliablePrice = async function(whichtype, roompingdata, thisroomdata, isabreviated)
{
    console.log("Calculating Data From Here =====================");
    console.log("roompingdata", roompingdata);

    let DataToReturn =
    {
        "room_status":true,
        
        "price_basic":0,
        "temp_final_price_basic_only_quota":0,
        "temp_final_price_basic_only_night":0,
        "temp_final_price_basic":0,
        "final_price_basic":0,

        "price_after_disc":0,
        "temp_final_price_after_disc_only_quota":0,
        "temp_final_price_after_disc_only_night":0,
        "temp_final_price_after_disc":0,
        "final_price_after_disc":0,

        "disc_price_cut":0,
        "temp_final_disc_price_cut_only_quota":0,
        "temp_final_disc_price_cut_disc_only_night":0,
        "temp_final_disc_price_cut":0,
        "final_disc_price_cut":0,

        "max_room":null,
        "unavailable_text":"Room Unavailable"
    }

    let ExperienceBasicPrice = 0; // Original Price ---------------------------------------------------------
    let TempFinalBasicPriceOnlyQuota = 0; // (Only Multiply By Quota)
    let TempFinalBasicPriceOnlyNight = 0; // (Only Multiply By Night)
    let TempFinalBasicPrice = 0; // (Final By Multiplication)
    let FinalBasicPrice = 0;

    let ExperienceAfterDiscPrice = 0; // After Disc Price -----------------------------------------------------
    let TempFinalBasicAfterDiscPriceOnlyQuota = 0; // (Only Multiply By Quota)
    let TempFinalBasicAfterDiscPriceOnlyNight = 0; // (Only Multiply By Night)
    let TempFinalBasicAfterDiscPrice = 0; // (Final By Multiplication)
    let FinalBasicAfterDiscPrice = 0;

    let ExperienceDisc = 0; // Disc -------------------------------------------------------------------
    let TempFinalBasicDiscOnlyQuota = 0; // (Only Multiply By Quota)
    let TempFinalBasicDiscOnlyNight = 0; // (Only Multiply By Night)
    let TempFinalBasicDisc = 0; // (Final By Multiplication)
    let FinalBasicDisc = 0;

    let MaxRoomOrQuotaThisExperience = null; // Max Quota --------------------------------------------------------------------
    
    let CurrentUserInput = null; // Current Quota -----------------------

    let ExperienceAvailable = true; // Unavailable -----------------------
    let UnavailableText = "Room Unavailable";

    let FirstDate = null;
    let DifDateRange = null;

    if(whichtype == "Experiences") // If Experience ---------------------------------------------------------------
    {
        let CheckInFullDate = window.ConvertDateStringToDateFormat(window.CheckInDateNonTop);
        let CheckOutFullDate = window.ConvertDateStringToDateFormat(window.CheckOutDateNonTop);
        FirstDate = CheckInFullDate;
        DifDateRange = parseInt(window.ThisRoomData.min_booking_notice_days);

        let AllDates = await window.JustLoadRoomExperienceMonthly(CheckInFullDate, CheckOutFullDate, window.CurrentSelectedRoomID, whichtype);

        console.log("All Experience Dates:", AllDates);

        let CurrentInputted = window.CurrentUserInputExperienceAddOns.data_input;
        let DatesData = [];

        for(let i = 0; i < AllDates.length; i++) // Crop Dates Between the Start and End Date ---------------------
        {
            let ThisDate = window.ConvertDateStringToDateFormat(AllDates[i].date);

            if(ThisDate.getTime() == CheckInFullDate.getTime() || (ThisDate.getTime() > CheckInFullDate.getTime() && ThisDate.getTime() <= CheckOutFullDate.getTime()))
            {
                DatesData.push(AllDates[i]);

                if(window.CurrentSelectedRoomExpBookType == "per day")
                    break;
            }
        }

        console.log("Cropped Dates:", DatesData);


        if(Array.isArray(CurrentInputted) == true) // If There's Option ----------------------------
        {
            for(let i = 0; i < DatesData.length; i++) // Filtered Dates
            {
                let ThisDateOptions = DatesData[i].options;

                for(let j = 0; j < ThisDateOptions.length; j++)
                {
                    for(let x = 0; x < CurrentInputted.length; x++)
                    {
                        if(CurrentInputted[x].id == ThisDateOptions[j].id && CurrentInputted[x].id_hotel_experience == ThisDateOptions[j].id_hotel_experience)
                        {
                            let ThisOptionQuotaInput = parseInt(CurrentInputted[x].quantity);

                            let ThisOptionPrice = parseInt(ThisDateOptions[j].price);
                            let ThisOptionAfterDiscPrice = parseInt(ThisDateOptions[j].price_after_disc_per_person);
                            let ThisOptionDisc = parseInt(ThisDateOptions[j].disc_now.total_discount);

                            if(ThisOptionQuotaInput != 0) // If At Least Input 1 To This Option --------
                            {
                                FinalBasicPrice = FinalBasicPrice + (ThisOptionQuotaInput * ThisOptionPrice);
                                FinalBasicAfterDiscPrice = FinalBasicAfterDiscPrice + (ThisOptionQuotaInput * ThisOptionAfterDiscPrice);
                                FinalBasicDisc = FinalBasicDisc + (ThisOptionQuotaInput * ThisOptionDisc);

                                if(i == 0) // Just for a Temp Data ----------------------
                                {
                                    ExperienceBasicPrice = ExperienceBasicPrice + (ThisOptionPrice); // Without Multiply
                                    ExperienceAfterDiscPrice = ExperienceAfterDiscPrice + (ThisOptionAfterDiscPrice);
                                    ExperienceDisc = ExperienceDisc + (ThisOptionDisc);

                                    TempFinalBasicPriceOnlyQuota = TempFinalBasicPriceOnlyQuota + (ThisOptionPrice * ThisOptionQuotaInput); // Only Quota
                                    TempFinalBasicAfterDiscPriceOnlyQuota = TempFinalBasicAfterDiscPriceOnlyQuota + (ThisOptionAfterDiscPrice * ThisOptionQuotaInput);
                                    TempFinalBasicDiscOnlyQuota = TempFinalBasicDiscOnlyQuota + (ThisOptionDisc * ThisOptionQuotaInput);

                                    TempFinalBasicPriceOnlyNight = TempFinalBasicPriceOnlyNight + (ThisOptionPrice * DatesData.length); // Only Total Nights
                                    TempFinalBasicAfterDiscPriceOnlyNight = TempFinalBasicAfterDiscPriceOnlyNight + (ThisOptionAfterDiscPrice * DatesData.length);
                                    TempFinalBasicDiscOnlyNight = TempFinalBasicDiscOnlyNight + (ThisOptionDisc * DatesData.length);

                                    TempFinalBasicPrice = TempFinalBasicPrice + (ThisOptionPrice * DatesData.length * ThisOptionQuotaInput); // Calculate By Multiply All
                                    TempFinalBasicAfterDiscPrice = TempFinalBasicAfterDiscPrice + (ThisOptionAfterDiscPrice * DatesData.length * ThisOptionQuotaInput);
                                    TempFinalBasicDisc =  ThisOptionDisc * DatesData.length * ThisOptionQuotaInput;
                                }

                                if(ThisDateOptions[j].status_available == "No") // If At Least One of Them Status Unavailable ---------------
                                {
                                    ExperienceAvailable = false;
                                    console.log("Got Here!");
                                }
                            }
                        }
                    }
                }
            }
        }
        else // No Options ----------------------------------------------
        {
            for(let i = 0; i < DatesData.length; i++) // Filtered Dates
            {
                let ThisOptionPrice = DatesData[i].price;
                let ThisOptionAfterDiscPrice = DatesData[i].price_after_disc_per_person;
                let ThisOptionDisc = DatesData[i].disc_now.total_discount;
                let MaxQuotaThisDate = DatesData[i].available_quota;
                CurrentUserInput = CurrentInputted;

                if(CurrentInputted != 0) // If At Least 1 Inputted Then Available ------------------
                {
                    FinalBasicPrice = FinalBasicPrice + (CurrentInputted * ThisOptionPrice);
                    FinalBasicAfterDiscPrice = FinalBasicAfterDiscPrice + (CurrentInputted * ThisOptionAfterDiscPrice);
                    FinalBasicDisc = FinalBasicDisc + (CurrentInputted * ThisOptionDisc);

                    if(i == 0) // Just for a Temp Data ----------------------
                    {
                        ExperienceBasicPrice = ThisOptionPrice; // Without Multiply
                        ExperienceAfterDiscPrice = ThisOptionAfterDiscPrice;
                        ExperienceDisc = ThisOptionDisc;

                        TempFinalBasicPriceOnlyQuota = ThisOptionPrice * CurrentInputted; // Only Quota
                        TempFinalBasicAfterDiscPriceOnlyQuota = ThisOptionAfterDiscPrice * CurrentInputted;
                        TempFinalBasicDiscOnlyQuota = ThisOptionDisc * CurrentInputted;

                        TempFinalBasicPriceOnlyNight = ThisOptionPrice * DatesData.length; // Only Total Nights
                        TempFinalBasicAfterDiscPriceOnlyNight = ThisOptionAfterDiscPrice * DatesData.length;
                        TempFinalBasicDiscOnlyNight = ThisOptionDisc * DatesData.length;

                        TempFinalBasicPrice = ThisOptionPrice * DatesData.length * CurrentInputted; // Calculate By Multiply All
                        TempFinalBasicAfterDiscPrice = ThisOptionAfterDiscPrice * DatesData.length * CurrentInputted;
                        TempFinalBasicDisc = ThisOptionDisc * DatesData.length * CurrentInputted;
                    }

                    if(DatesData[i].status_available == "No") // If At Least One of Them Status Unavailable ---------------
                    {
                        ExperienceAvailable = false;
                        console.log("Got Here!");
                    }
                }
                else // If No Then Automatically Unavailable -------------------------
                {
                    ExperienceAvailable = false;
                    console.log("Got Here!");
                }


                if(MaxRoomOrQuotaThisExperience == null || (MaxRoomOrQuotaThisExperience != null && MaxRoomOrQuotaThisExperience > MaxQuotaThisDate)) // Set Max Quota -----------
                {
                    MaxRoomOrQuotaThisExperience = MaxQuotaThisDate;
                }
            }
        }

        if(CurrentInputted != 0 && CurrentInputted > MaxRoomOrQuotaThisExperience)
        {
            UnavailableText = window.MaximumRoomTxtFunc(MaxRoomOrQuotaThisExperience, isabreviated);
            ExperienceAvailable = false;
            console.log("Got Here!");
        }
    }
    else
    {
        if(roompingdata != null && roompingdata.length > 0)
        {
            let whichbookingtype = thisroomdata.book_type;

            FirstDate = window.ConvertDateStringToDateFormat(roompingdata[0].date);
            DifDateRange = thisroomdata.min_booking_notice_days;

            let MaximalCheck = roompingdata.length;
            if(whichbookingtype == "per day")
                MaximalCheck = 1;
            
            CurrentUserInput = window.RoomQuotaNonTop;

            for(let i = 0; i < MaximalCheck; i++)
            {
                let ThisRoomPrice = parseInt(roompingdata[i].price);
                let ThisRoomAfterDiscPrice = parseInt(roompingdata[i].price_after_disc_per_room ?? roompingdata[i].price_after_disc_per_person);
                let ThisRoomDisc = roompingdata[i].disc_now.total_discount;
                let MaxQuotaThisDate = parseInt(roompingdata[i].room_available ?? roompingdata[i].quota);

                if(window.RoomQuotaNonTop != 0) // If At Least 1 Inputted Then Available ------------------
                {
                    FinalBasicPrice = FinalBasicPrice + ThisRoomPrice;
                    FinalBasicAfterDiscPrice = FinalBasicAfterDiscPrice + ThisRoomAfterDiscPrice;
                    FinalBasicDisc = FinalBasicDisc + ThisRoomDisc;

                    if(i === 0) // Just for a Temp Data ----------------------
                    {
                        ExperienceBasicPrice = ThisRoomPrice; // Without Multiply
                        ExperienceAfterDiscPrice = ThisRoomAfterDiscPrice;
                        ExperienceDisc = ThisRoomDisc;

                        TempFinalBasicPriceOnlyQuota = ThisRoomPrice * window.RoomQuotaNonTop; // Only Quota
                        TempFinalBasicAfterDiscPriceOnlyQuota = ThisRoomAfterDiscPrice * window.RoomQuotaNonTop;
                        TempFinalBasicDiscOnlyQuota = ThisRoomDisc * window.RoomQuotaNonTop;

                        TempFinalBasicPriceOnlyNight = ThisRoomPrice * MaximalCheck; // Only Total Nights
                        TempFinalBasicAfterDiscPriceOnlyNight = ThisRoomAfterDiscPrice * MaximalCheck;
                        TempFinalBasicDiscOnlyNight = ThisRoomDisc * MaximalCheck;

                        TempFinalBasicPrice = ThisRoomPrice * MaximalCheck * window.RoomQuotaNonTop; // Calculate By Multiply All
                        TempFinalBasicAfterDiscPrice = ThisRoomAfterDiscPrice * MaximalCheck * window.RoomQuotaNonTop;
                        TempFinalBasicDisc = ThisRoomDisc * MaximalCheck * window.RoomQuotaNonTop;
                    }

                    if(roompingdata[i].status_available == "No" || roompingdata[i].price == 0)
                    {
                        ExperienceAvailable = false;
                        console.log("Got Here!");
                    }
                }
                else
                {
                    ExperienceAvailable = false;
                    console.log("Got Here!");
                }

                if(MaxRoomOrQuotaThisExperience == null || (MaxRoomOrQuotaThisExperience != null && MaxRoomOrQuotaThisExperience > MaxQuotaThisDate)) // Set Max Quota -----------
                {
                    MaxRoomOrQuotaThisExperience = MaxQuotaThisDate;
                }
            }
        }
    }


    // In Case of Min Booking Range --------------------------------------------------------------------------
    
    if(CurrentUserInput != null)
    {
        if(CurrentUserInput != 0 && CurrentUserInput > MaxRoomOrQuotaThisExperience)
        {
            UnavailableText = window.MaximumRoomTxtFunc(MaxRoomOrQuotaThisExperience, isabreviated);
            ExperienceAvailable = false;
        }
        else if(CurrentUserInput == 0)
        {
            ExperienceAvailable = false;
            UnavailableText = window["QuotaTidakBoleh0Txt" + window.CurrentCountryID];
        }
    }

    // Check If Min Date Booking Range Availaible ------------------------------------

    const DateNow = window.GetAndConvertCurrentDate(false);

    const diffInMs = Math.abs(DateNow - FirstDate);
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    if (diffInDays < DifDateRange)
    {
        ExperienceAvailable = false;
        console.log("Got Here!");
        UnavailableText = window.MaximuDatemRangeTxtFunc(DifDateRange, isabreviated);
    }

    // Update The Data To Return ---------------------------------------------------------------------

    DataToReturn.room_status = ExperienceAvailable;
                
    DataToReturn.price_basic = ExperienceBasicPrice;
    DataToReturn.temp_final_price_basic_only_quota = TempFinalBasicPriceOnlyQuota;
    DataToReturn.temp_final_price_basic_only_night = TempFinalBasicPriceOnlyNight;
    DataToReturn.temp_final_price_basic = TempFinalBasicPrice;
    DataToReturn.final_price_basic = FinalBasicPrice;

    DataToReturn.price_after_disc = ExperienceAfterDiscPrice;
    DataToReturn.temp_final_price_after_disc_only_quota = TempFinalBasicAfterDiscPriceOnlyQuota;
    DataToReturn.temp_final_price_after_disc_only_night = TempFinalBasicAfterDiscPriceOnlyNight;
    DataToReturn.temp_final_price_after_disc = TempFinalBasicAfterDiscPrice;
    DataToReturn.final_price_after_disc = FinalBasicAfterDiscPrice;

    DataToReturn.disc_price_cut = ExperienceDisc;
    DataToReturn.temp_final_disc_price_cut_only_quota = TempFinalBasicDiscOnlyQuota;
    DataToReturn.temp_final_disc_price_cut_disc_only_night = TempFinalBasicDiscOnlyNight;
    DataToReturn.temp_final_disc_price_cut = TempFinalBasicDisc;
    DataToReturn.final_disc_price_cut = FinalBasicDisc;

    DataToReturn.max_room = MaxRoomOrQuotaThisExperience;

    DataToReturn.unavailable_text = UnavailableText;

    if(document.getElementById("IncreaseRoomQuotaButton") != null)
    {
        if(CurrentUserInput != null && CurrentUserInput >= MaxRoomOrQuotaThisExperience)
        {
            document.getElementById("IncreaseRoomQuotaButton").className = "IncreaseReduceRoomButton Selectable2 ButtonUnselectableOpacity";
        }
        else
        {
            document.getElementById("IncreaseRoomQuotaButton").className = "IncreaseReduceRoomButton Selectable2";
        }
    }
            
    console.log("DataToReturn", DataToReturn);
    return DataToReturn;
}

// ============================== LOADING CONTENT INSTANTIATE ====================================

window.LoadingContentPanel = function(wheretoinstantiate, whichtype, howmanyinstantiated)
{
    let WhichContainer;

    if(whichtype == 1) // Popular Areas -------------
    {
        WhichContainer = document.createElement("div");
        WhichContainer.className = "SectionSeparatorContainer";
        wheretoinstantiate.append(WhichContainer);

        let SectionContentWrapper = document.createElement("div");
        SectionContentWrapper.className = "SectionContentWrapper";
        WhichContainer.append(SectionContentWrapper);

        let SectionHeaderLoading = document.createElement("div");
        SectionHeaderLoading.className = "SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey BasicRoomHeaderTextLoad";
        SectionContentWrapper.append(SectionHeaderLoading);

        let BasicPanelSwiperMainContainer = document.createElement("div");
        BasicPanelSwiperMainContainer.className = "BasicPanelSwiperMainContainer";
        SectionContentWrapper.append(BasicPanelSwiperMainContainer);

        let ContainerWithMaskEdge = document.createElement("div");
        ContainerWithMaskEdge.className = "ContainerWithMaskEdge PopularAreasMask";
        BasicPanelSwiperMainContainer.append(ContainerWithMaskEdge);

        let PopularAreasPanelContainer = document.createElement("div");
        PopularAreasPanelContainer.className = "PopularAreasPanelContainer";
        ContainerWithMaskEdge.append(PopularAreasPanelContainer);

        for(let i = 0; i < howmanyinstantiated; i++)
        {
            window.InstantiateLoadingPopularPanel(PopularAreasPanelContainer);
        }
    }
    else if (whichtype == 2) // Basic Hotel Container ------------------
    {
        WhichContainer = document.createElement("div");
        WhichContainer.className = "SectionSeparatorContainer SectionSeparatorContainerShortenBottom";
        wheretoinstantiate.append(WhichContainer);

        let SectionContentWrapper = document.createElement("div");
        SectionContentWrapper.className = "SectionContentWrapper";
        WhichContainer.append(SectionContentWrapper);

        let SectionHeaderLoading = document.createElement("div");
        SectionHeaderLoading.className = "SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey BasicRoomHeaderTextLoad";
        SectionContentWrapper.append(SectionHeaderLoading);

        let BasicPanelSwiperMainContainer = document.createElement("div");
        BasicPanelSwiperMainContainer.className = "BasicPanelSwiperMainContainer";
        SectionContentWrapper.append(BasicPanelSwiperMainContainer);

        let ContainerWithMaskEdge = document.createElement("div");
        ContainerWithMaskEdge.className = "ContainerWithMaskEdge";
        BasicPanelSwiperMainContainer.append(ContainerWithMaskEdge);

        let TrendingHotelsSwiperContainer = document.createElement("div");
        TrendingHotelsSwiperContainer.className = "HotelRoomPanelSwiperContainer TrendingHotelsSwiperContainer";
        ContainerWithMaskEdge.append(TrendingHotelsSwiperContainer);

        let BasicHotelListPanelSwiperWrapper = document.createElement("div");
        BasicHotelListPanelSwiperWrapper.className = "BasicHotelListPanelSwiperWrapper";
        BasicHotelListPanelSwiperWrapper.style.display = "flex";
        TrendingHotelsSwiperContainer.append(BasicHotelListPanelSwiperWrapper);

        for(let i = 0; i < howmanyinstantiated; i++)
        {
            window.InstantiateLoadingBasicPanel(BasicHotelListPanelSwiperWrapper);
        }
    }
    else if (whichtype == 3) // Featured Container ------------------
    {
        WhichContainer = [];

        let MainContainer = document.createElement("div");
        MainContainer.className = "SectionSeparatorContainer SectionSeparatorContainerShortenBottom";
        // MainContainer.style.backgroundColor = "#e1eff9";
        wheretoinstantiate.append(MainContainer);

        let SectionContentWrapper = document.createElement("div");
        SectionContentWrapper.className = "SectionContentWrapper";
        MainContainer.append(SectionContentWrapper);

        // 1. Loading Top Button -----------------------

        let ThisTopHeaderButtonContainerLoading = document.createElement("div");
        SectionContentWrapper.append(ThisTopHeaderButtonContainerLoading);

        let SectionHeaderLoading = document.createElement("div");
        SectionHeaderLoading.className = "SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey BasicRoomHeaderTextLoad";
        ThisTopHeaderButtonContainerLoading.append(SectionHeaderLoading);

        let FeaturedButtonLoad = document.createElement("div");
        FeaturedButtonLoad.className = "SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey FeaturedButtonLoad";
        ThisTopHeaderButtonContainerLoading.append(FeaturedButtonLoad);


        WhichContainer.push(ThisTopHeaderButtonContainerLoading);

        // 2. Top Button -----------------------

        let ThisTopHeaderButtonContainerDone = document.createElement("div");
        ThisTopHeaderButtonContainerDone.style.display = "none";
        SectionContentWrapper.append(ThisTopHeaderButtonContainerDone);

        WhichContainer.push(ThisTopHeaderButtonContainerDone);


        // 3. Loading For Featured List Panel -----------------------

        let BasicPanelSwiperMainContainerOnload = document.createElement("div");
        BasicPanelSwiperMainContainerOnload.className = "BasicPanelSwiperMainContainer";
        SectionContentWrapper.append(BasicPanelSwiperMainContainerOnload);

        let ContainerWithMaskEdgeForOnload = document.createElement("div");
        ContainerWithMaskEdgeForOnload.className = "ContainerWithMaskEdge";
        BasicPanelSwiperMainContainerOnload.append(ContainerWithMaskEdgeForOnload);

        let TrendingHotelsSwiperContainer = document.createElement("div");
        TrendingHotelsSwiperContainer.className = "HotelRoomPanelSwiperContainer TrendingHotelsSwiperContainer";
        ContainerWithMaskEdgeForOnload.append(TrendingHotelsSwiperContainer);

        let BasicHotelListPanelSwiperWrapper = document.createElement("div");
        BasicHotelListPanelSwiperWrapper.className = "BasicHotelListPanelSwiperWrapper";
        BasicHotelListPanelSwiperWrapper.style.display = "flex";
        TrendingHotelsSwiperContainer.append(BasicHotelListPanelSwiperWrapper);

        for(let i = 0; i < howmanyinstantiated; i++)
        {
            window.InstantiateLoadingBasicPanel(BasicHotelListPanelSwiperWrapper);
        }

        WhichContainer.push(BasicPanelSwiperMainContainerOnload);

        // 4. Not Found -------------------------------

        let NoFeaturedPropertyFoundContainer = document.createElement("div");
        NoFeaturedPropertyFoundContainer.className = "NoFeaturedPropertyFoundContainer";
        SectionContentWrapper.append(NoFeaturedPropertyFoundContainer);

        let NoFoundIcon = document.createElement("img");
        NoFoundIcon.className = "NoFoundIcon";
        NoFoundIcon.src = "/Assets/images/ButtonIcon/no-featured.svg";
        NoFeaturedPropertyFoundContainer.append(NoFoundIcon);

        let NoFoundHeaderText = document.createElement("p");
        NoFoundHeaderText.className = "NoFoundHeaderText InterBoldTextFont";
        NoFoundHeaderText.innerHTML = window["NoFeaturedPropertyTxt" + window.CurrentCountryID];
        NoFeaturedPropertyFoundContainer.append(NoFoundHeaderText);

        let NoFoundMessageText = document.createElement("p");
        NoFoundMessageText.className = "NoFoundMessageText InterRegularTextFont";
        NoFoundMessageText.innerHTML = window["FeaturedComesToThisProvTxt" + window.CurrentCountryID];
        NoFeaturedPropertyFoundContainer.append(NoFoundMessageText);

        WhichContainer.push(NoFeaturedPropertyFoundContainer);

        // 5. For Instantiate Featured List Panel -----------------------

        let BasicPanelSwiperMainContainerInstantiate = document.createElement("div");
        BasicPanelSwiperMainContainerInstantiate.className = "BasicPanelSwiperMainContainer";
        BasicPanelSwiperMainContainerInstantiate.style.display = "none";
        SectionContentWrapper.append(BasicPanelSwiperMainContainerInstantiate);

        let ContainerWithMaskEdgeForInstantiate = document.createElement("div");
        ContainerWithMaskEdgeForInstantiate.className = "ContainerWithMaskEdge";
        BasicPanelSwiperMainContainerInstantiate.append(ContainerWithMaskEdgeForInstantiate);

        let HotelRoomPanelSwiperContainer = document.createElement("div");
        HotelRoomPanelSwiperContainer.className = "HotelRoomPanelSwiperContainer TrendingHotelsSwiperContainer";
        ContainerWithMaskEdgeForInstantiate.append(HotelRoomPanelSwiperContainer);

        let BasicHotelListPanelSwiperWrapperForInstantiate = document.createElement("div");
        BasicHotelListPanelSwiperWrapperForInstantiate.className = "swiper-wrapper BasicHotelListPanelSwiperWrapper";
        HotelRoomPanelSwiperContainer.append(BasicHotelListPanelSwiperWrapperForInstantiate);

        let PrevButtonDiv = document.createElement("div");
        PrevButtonDiv.className = "PopularAreasLeftRightButtonContainer PaddingButtonLeft";
        BasicPanelSwiperMainContainerInstantiate.append(PrevButtonDiv);

        let PrevButtonButton = document.createElement("button");
        PrevButtonButton.className = "NextPreviousSwiperButton Selectable2 TrendingHotelLeft";
        PrevButtonDiv.append(PrevButtonButton);

        let PrevButtonButtonIMG = document.createElement("img");
        PrevButtonButtonIMG.src = "/Assets/images/ButtonIcon/chevron.svg";
        PrevButtonButton.append(PrevButtonButtonIMG);


        let NextButtonDiv = document.createElement("div");
        NextButtonDiv.className = "PopularAreasLeftRightButtonContainer PaddingButtonRight";
        BasicPanelSwiperMainContainerInstantiate.append(NextButtonDiv);

        let NextButtonButton = document.createElement("button");
        NextButtonButton.className = "NextPreviousSwiperButton Selectable2 TrendingHotelRight";
        NextButtonDiv.append(NextButtonButton);

        let NextButtonButtonIMG = document.createElement("img");
        NextButtonButtonIMG.src = "/Assets/images/ButtonIcon/chevron.svg";
        NextButtonButton.append(NextButtonButtonIMG);

        window.FeaturedHotelSwiper = new window.Swiper(HotelRoomPanelSwiperContainer,
        {
            slidesPerView: 'auto',
            spaceBetween: 0,
            freeMode: true,
            observer: true,
            observeParents: true,
            navigation: {
                prevEl: PrevButtonButton,
                nextEl: NextButtonButton,
            }
        });

        WhichContainer.push(BasicPanelSwiperMainContainerInstantiate);
    }
    else if (whichtype == 4) // Room List Hotel Details ------------------
    {
        let RoomHotelPanel = document.createElement("div");
        RoomHotelPanel.className = "RoomHotelPanel";
        RoomHotelPanel.style.flexDirection = "column";
        RoomHotelPanel.style.pointerEvents = "none";
        wheretoinstantiate.append(RoomHotelPanel);

        let RoomHotelWrapper = document.createElement("div"); // Top Info ----------------
        RoomHotelWrapper.className = "RoomHotelWrapper";
        RoomHotelPanel.append(RoomHotelWrapper);

        let RoomHotelImageInsidePanel = document.createElement("div"); // Room Hotel
        RoomHotelImageInsidePanel.className = "RoomHotelImageInsidePanel";
        RoomHotelWrapper.append(RoomHotelImageInsidePanel);

        let ImageFullCover = document.createElement("div");
        ImageFullCover.className = "loading_grey ImageFullCover";
        RoomHotelImageInsidePanel.append(ImageFullCover);

        let RoomHotelImageRightSectionInSeparatorsidePanel = document.createElement("div");
        RoomHotelImageRightSectionInSeparatorsidePanel.className = "RoomHotelImageRightSectionInSeparatorsidePanel";
        RoomHotelWrapper.append(RoomHotelImageRightSectionInSeparatorsidePanel);

        let RoomHotelPanelInfoOneWrapper = document.createElement("div");
        RoomHotelPanelInfoOneWrapper.className = "RoomHotelPanelInfoOneWrapper";
        RoomHotelImageRightSectionInSeparatorsidePanel.append(RoomHotelPanelInfoOneWrapper);

        let RoomHotelNameDescWrapper = document.createElement("div"); // Top Information ----------------
        RoomHotelNameDescWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
        RoomHotelNameDescWrapper.style.flexDirection = "column";
        RoomHotelPanelInfoOneWrapper.append(RoomHotelNameDescWrapper);

        let RoomNameLoading = document.createElement("div");
        RoomNameLoading.className = "RoomHotelNameInsidePanel loading_grey";
        RoomHotelNameDescWrapper.append(RoomNameLoading);

        let RoomDescriptionLoading = document.createElement("div");
        RoomDescriptionLoading.className = "RoomHotelDescriptionInsidePanel loading_grey";
        RoomHotelNameDescWrapper.append(RoomDescriptionLoading);

        let RoomHotelRightInfo2 = document.createElement("div");
        RoomHotelRightInfo2.className = "RoomHotelRightInfo2 loading_grey";
        RoomHotelRightInfo2.style.marginLeft = 0;
        RoomHotelNameDescWrapper.append(RoomHotelRightInfo2);

        let RoomSmallInfo = document.createElement("div");
        RoomSmallInfo.className = "RoomSmallInfo loading_grey";
        RoomHotelNameDescWrapper.append(RoomSmallInfo);


        let RoomHotelPanelBlueBottomPanel = document.createElement("div"); // Bottom Info ----------------
        RoomHotelPanelBlueBottomPanel.className = "RoomHotelPanelBlueBottomPanel";
        RoomHotelPanel.append(RoomHotelPanelBlueBottomPanel);

        let OriginalandStartPriceWrapper = document.createElement("div"); // Ping to Go and Last Ping
        OriginalandStartPriceWrapper.className = "RoomHotelPanelBlueBottomRightWrapper";
        RoomHotelPanelBlueBottomPanel.append(OriginalandStartPriceWrapper);

        let OriginalPriceText = document.createElement("p");
        OriginalPriceText.className = "CuttedPriceText InterRegularTextFont loading_grey";
        OriginalPriceText.style.color = "transparent";
        OriginalPriceText.style.width = "fit-content";
        OriginalPriceText.innerHTML = "Rp ----- --";
        OriginalandStartPriceWrapper.append(OriginalPriceText);

        let StartPriceText = document.createElement("p");
        StartPriceText.className = "OriginalPriceHotelDetailsText InterRegularTextFont loading_grey";
        StartPriceText.style.color = "transparent";
        StartPriceText.style.width = "fit-content";
        StartPriceText.innerHTML = "--------- ----------- ---";
        OriginalandStartPriceWrapper.append(StartPriceText);

        let SelectRoomButton = document.createElement("button"); // Select Button
        SelectRoomButton.className = "BasicTextButton BasicBoxShadow OrangeButton SelectRoomButton loading_grey";
        SelectRoomButton.style.color = "transparent";
        SelectRoomButton.innerHTML = "-------";
        RoomHotelPanelBlueBottomPanel.append(SelectRoomButton);
    }
    else if (whichtype == 5) // Exprezy Data ------------------
    {
        WhichContainer = document.createElement("div");
        WhichContainer.className = "PingExprezyPanel InterMediumTextFont Selectable swiper-slide PingExprezyPanelLoading";
        WhichContainer.style.pointerEvents = "none";
        wheretoinstantiate.append(WhichContainer);

        let PingExprezyImageContainer = document.createElement("div"); // Ping Exprezy -----------------------
        PingExprezyImageContainer.className = "PingExprezyImageContainer";
        WhichContainer.append(PingExprezyImageContainer);

        let ImageFullCover = document.createElement("div");
        ImageFullCover.className = "loading_grey ImageFullCover";
        PingExprezyImageContainer.append(ImageFullCover);


        let PingExprezyDescriptionContainer = document.createElement("div"); // Bottom Description -----------------------
        PingExprezyDescriptionContainer.className = "PingExprezyDescriptionContainer";
        WhichContainer.append(PingExprezyDescriptionContainer);

        let RoomUserDescription = document.createElement("div");
        RoomUserDescription.className = "RoomSmallInfo loading_grey";
        PingExprezyDescriptionContainer.append(RoomUserDescription);

        let RoomUserLoading = document.createElement("div");
        RoomUserLoading.className = "RoomHotelRightInfo2 loading_grey";
        RoomUserLoading.style.marginLeft = 0;
        PingExprezyDescriptionContainer.append(RoomUserLoading);
    }
    return WhichContainer;
}

window.InstantiateLoadingPopularPanel = function(wheretoInstantiate)
{
    let PopularAreasPanel = document.createElement("div");
    PopularAreasPanel.className = "PopularAreasPanel Unselectable";
    PopularAreasPanel.style.pointerEvents = "none";
    wheretoInstantiate.append(PopularAreasPanel);

    let PopularAreasInformationPanel = document.createElement("div");
    PopularAreasInformationPanel.className = "PopularAreasInformationPanel";
    PopularAreasPanel.append(PopularAreasInformationPanel);

    let PopularAreasImageContainer = document.createElement("div");
    PopularAreasImageContainer.className = "PopularAreasImageContainer";
    PopularAreasInformationPanel.append(PopularAreasImageContainer);

    let ImageFullCover = document.createElement("div");
    ImageFullCover.className = "loading_grey ImageFullCover";
    PopularAreasImageContainer.append(ImageFullCover);

    let NameofHotelPopularAreaLoadGrey = document.createElement("div");
    NameofHotelPopularAreaLoadGrey.className = "loading_grey NameofHotelPopularAreaLoadGrey";
    PopularAreasInformationPanel.append(NameofHotelPopularAreaLoadGrey);

    let HowManyHotelLeftPopularAreaLoadGrey = document.createElement("div");
    HowManyHotelLeftPopularAreaLoadGrey.className = "loading_grey HowManyHotelLeftPopularAreaLoadGrey";
    PopularAreasInformationPanel.append(HowManyHotelLeftPopularAreaLoadGrey);

    return PopularAreasPanel;
}

window.InstantiateLoadingBasicPanel = function(wheretoInstantiate)
{
    let RoomPanelContainer = document.createElement("div");
    RoomPanelContainer.className = "RoomPanelContainer InterMediumTextFont";
    wheretoInstantiate.append(RoomPanelContainer);

    let RoomPanelContentWrapper = document.createElement("div");
    RoomPanelContentWrapper.className = "RoomPanelContentWrapper";
    RoomPanelContainer.append(RoomPanelContentWrapper);

    let RoomPanelImageContainer = document.createElement("div");
    RoomPanelImageContainer.className = "RoomPanelImageContainer";
    RoomPanelContentWrapper.append(RoomPanelImageContainer);

    let ImageFullCover = document.createElement("div");
    ImageFullCover.className = "loading_grey ImageFullCover";
    RoomPanelImageContainer.append(ImageFullCover);

    let RoomPanelBottomInfoWrapper = document.createElement("div");
    RoomPanelBottomInfoWrapper.className = "RoomPanelBottomInfoWrapper";
    RoomPanelContentWrapper.append(RoomPanelBottomInfoWrapper);

    let RoomSmallInfo = document.createElement("div");
    RoomSmallInfo.className = "RoomSmallInfo loading_grey";
    RoomPanelBottomInfoWrapper.append(RoomSmallInfo);

    let RoomHotelNameInsidePanel = document.createElement("div");
    RoomHotelNameInsidePanel.className = "RoomHotelNameInsidePanel loading_grey";
    RoomHotelNameInsidePanel.style.width = "100%";
    RoomPanelBottomInfoWrapper.append(RoomHotelNameInsidePanel);

    let RoomHotelRightInfo1 = document.createElement("div");
    RoomHotelRightInfo1.className = "RoomHotelRightInfo1 loading_grey";
    RoomHotelRightInfo1.style.marginLeft = "auto";
    RoomPanelBottomInfoWrapper.append(RoomHotelRightInfo1);

    let RoomHotelRightInfo2 = document.createElement("div");
    RoomHotelRightInfo2.className = "RoomHotelRightInfo2 loading_grey";
    RoomHotelRightInfo2.style.marginLeft = "auto";
    RoomPanelBottomInfoWrapper.append(RoomHotelRightInfo2);

    return RoomPanelContainer;
}

window.InstantiateLoadingHotelPanel = function(wheretoinstantiate)
{
    let RoomHotelPanel = document.createElement("div");
    RoomHotelPanel.className = "RoomHotelPanel";
    wheretoinstantiate.append(RoomHotelPanel);

    let RoomHotelWrapper = document.createElement("div");
    RoomHotelWrapper.className = "RoomHotelWrapper";
    RoomHotelPanel.append(RoomHotelWrapper);

    let RoomHotelImageInsidePanel = document.createElement("div");
    RoomHotelImageInsidePanel.className = "RoomHotelImageInsidePanel";
    RoomHotelWrapper.append(RoomHotelImageInsidePanel);

    let LoadingImage = document.createElement("div");
    LoadingImage.className = "loading_grey ImageFullCover";
    RoomHotelImageInsidePanel.append(LoadingImage);

    let RoomHotelImageRightSectionInSeparatorsidePanel = document.createElement("div");
    RoomHotelImageRightSectionInSeparatorsidePanel.className = "RoomHotelImageRightSectionInSeparatorsidePanel";
    RoomHotelWrapper.append(RoomHotelImageRightSectionInSeparatorsidePanel);

    let RoomHotelPanelInfoLeftWrapper = document.createElement("div");
    RoomHotelPanelInfoLeftWrapper.className = "RoomHotelPanelInfoLeftWrapper";
    RoomHotelImageRightSectionInSeparatorsidePanel.append(RoomHotelPanelInfoLeftWrapper);

    let RoomHotelNameInsidePanel = document.createElement("div");
    RoomHotelNameInsidePanel.className = "RoomHotelNameInsidePanel loading_grey";
    RoomHotelPanelInfoLeftWrapper.append(RoomHotelNameInsidePanel);

    let RoomSmallInfo = document.createElement("div");
    RoomSmallInfo.className = "RoomSmallInfo loading_grey";
    RoomHotelPanelInfoLeftWrapper.append(RoomSmallInfo);

    let RoomHotelDescriptionInsidePanel = document.createElement("div");
    RoomHotelDescriptionInsidePanel.className = "RoomHotelDescriptionInsidePanel loading_grey";
    RoomHotelPanelInfoLeftWrapper.append(RoomHotelDescriptionInsidePanel);

    let RoomHotelDisplayedNameInsidePanel = document.createElement("div");
    RoomHotelDisplayedNameInsidePanel.className = "RoomHotelDisplayedNameInsidePanel loading_grey";
    RoomHotelPanelInfoLeftWrapper.append(RoomHotelDisplayedNameInsidePanel);

    let TextForExpand = document.createElement("p");
    TextForExpand.className = "InterBoldTextFont";
    TextForExpand.style.opacity = 0;
    TextForExpand.innerHTML = "--";
    RoomHotelDisplayedNameInsidePanel.append(TextForExpand);


    let RoomHotelPanelInfoRightWrapper = document.createElement("div");
    RoomHotelPanelInfoRightWrapper.className = "RoomHotelPanelInfoRightWrapper";
    RoomHotelImageRightSectionInSeparatorsidePanel.append(RoomHotelPanelInfoRightWrapper);

    let RoomBottomInfoLeft = document.createElement("div");
    RoomBottomInfoLeft.className = "RoomBottomInfoLeft";
    RoomHotelPanelInfoRightWrapper.append(RoomBottomInfoLeft);

    let RoomHotelRightInfo3A = document.createElement("div");
    RoomHotelRightInfo3A.className = "RoomHotelRightInfo3 loading_grey";
    RoomBottomInfoLeft.append(RoomHotelRightInfo3A);

    let RoomHotelRightInfo21A = document.createElement("div");
    RoomHotelRightInfo21A.className = "RoomHotelRightInfo2 loading_grey";
    RoomBottomInfoLeft.append(RoomHotelRightInfo21A);

    let RoomHotelRightInfo22A = document.createElement("div");
    RoomHotelRightInfo22A.className = "RoomHotelRightInfo2 loading_grey";
    RoomBottomInfoLeft.append(RoomHotelRightInfo22A);


    let RoomBottomInfoRight = document.createElement("div");
    RoomBottomInfoRight.classNanpme = "RoomBottomInfoRight";
    RoomHotelPanelInfoRightWrapper.append(RoomBottomInfoRight);

    let RoomBottomInfoRightInfo3A = document.createElement("div");
    RoomBottomInfoRightInfo3A.className = "RoomHotelRightInfo3 loading_grey";
    RoomBottomInfoRight.append(RoomBottomInfoRightInfo3A);

    let RoomBottomInfoRightInfo21A = document.createElement("div");
    RoomBottomInfoRightInfo21A.className = "RoomHotelRightInfo2 loading_grey";
    RoomBottomInfoRight.append(RoomBottomInfoRightInfo21A);

    let RoomBottomInfoRightInfo22A = document.createElement("div");
    RoomBottomInfoRightInfo22A.className = "RoomHotelRightInfo2 loading_grey";
    RoomBottomInfoRight.append(RoomBottomInfoRightInfo22A);

    return RoomHotelPanel;
}


// =================================== INSTANTIATE BASIC PANEL ==================================

window.InstantiateBasicHotelPanel = function(ThisHotelToInstantiateData, WhereToInstantiatePanel, LoadingContainer, MainContainerToDisplay)
{
    if(LoadingContainer != null)
    LoadingContainer.remove();

    MainContainerToDisplay.style.display = "";

    for(let i = 0; i < ThisHotelToInstantiateData.length; i++)
    {
        let ThisLoadingPanel = window.InstantiateLoadingBasicPanel(WhereToInstantiatePanel);

        let RoomPanelContainer = document.createElement("div");
        RoomPanelContainer.className = "RoomPanelContainer InterMediumTextFont Selectable swiper-slide";
        RoomPanelContainer.style.display = "none";
        WhereToInstantiatePanel.append(RoomPanelContainer);

        if(ThisHotelToInstantiateData[i].max_discount != null && parseInt(ThisHotelToInstantiateData[i].max_discount) > 0)
        {
            let RoomPanelDiscountBackNew = document.createElement("div"); // Discount Top Max
            RoomPanelDiscountBackNew.className = "RoomPanelDiscountBackNew";
            RoomPanelContainer.append(RoomPanelDiscountBackNew);

            let RoomPanelDiscountTopNew = document.createElement("div");
            RoomPanelDiscountTopNew.className = "RoomPanelDiscountTopNew";
            RoomPanelDiscountBackNew.append(RoomPanelDiscountTopNew);

            let RedBannerNew = document.createElement("img");
            RedBannerNew.className = "RedBannerNew";
            RedBannerNew.src = "/Assets/images/Icon/red-barner-new.png";
            RoomPanelDiscountTopNew.append(RedBannerNew);

            let RoomPanelDiscountTopValueNew = document.createElement("p");
            RoomPanelDiscountTopValueNew.className = "RoomPanelDiscountTopValue InterBoldTextFont";
            RoomPanelDiscountTopValueNew.innerHTML = parseInt(ThisHotelToInstantiateData[i].max_discount) + "%";
            RoomPanelDiscountTopNew.append(RoomPanelDiscountTopValueNew);
        }

        let RoomPanelContentWrapper = document.createElement("div"); // Room Image
        RoomPanelContentWrapper.className = "RoomPanelContentWrapper";
        RoomPanelContainer.append(RoomPanelContentWrapper);

        let RoomPanelImageContainer = document.createElement("div");
        RoomPanelImageContainer.className = "RoomPanelImageContainer";
        RoomPanelContentWrapper.append(RoomPanelImageContainer);

        let imagesProcessed = 0;
        let HowManyImagesToBeCalculated = ThisHotelToInstantiateData[i].photos.length;

        if (window.innerWidth < 768 && HowManyImagesToBeCalculated > 0) // If mobile only 1 Image Instantiated
            HowManyImagesToBeCalculated = 1;

        for(let j = 0; j < HowManyImagesToBeCalculated; j++)
        {
            let RoomImageFullCover = document.createElement("img");
            RoomImageFullCover.className = "ImageFullCover";
            RoomImageFullCover.style.opacity = "0";
            RoomImageFullCover.setAttribute("is-valid", 'false');
            if(j == 0)
            {
                RoomImageFullCover.style.opacity = "1";
            }
            RoomPanelImageContainer.append(RoomImageFullCover);

            window.checkImageUrlValid(ThisHotelToInstantiateData[i].photos[j].hotel_photo, "/Assets/images/NoHotelImage.jpg", RoomImageFullCover, () =>
            {
                imagesProcessed++;

                if(imagesProcessed === HowManyImagesToBeCalculated)
                {
                    window.CheckIfImageLoadedAndCallAFunction(MainContainerToDisplay, ()=>
                    {
                        let functiontocallfinal = function()
                        {
                            ThisLoadingPanel.remove();
                            RoomPanelContainer.style.display = "";
                        }
                        window.CheckAndDeletePhotoInsideContainerIfAtLeastOneExist(RoomPanelImageContainer, ()=> functiontocallfinal())
                    });
                }
            }, { quality: 70});
        }

        // Room Bottom Information --------------------------

        let RoomPanelBottomInfoWrapper = document.createElement("div");
        RoomPanelBottomInfoWrapper.className = "RoomPanelBottomInfoWrapper";
        RoomPanelContentWrapper.append(RoomPanelBottomInfoWrapper);

        if(ThisHotelToInstantiateData[i].benefits != null)
        {
            let BenefitsMaskContainer = document.createElement("div"); // Benefits -------
            BenefitsMaskContainer.className = "ContainerWithMaskEdge";
            RoomPanelBottomInfoWrapper.append(BenefitsMaskContainer);

            let RoomBenefitsContainer = document.createElement("div");
            RoomBenefitsContainer.className = "RoomBenefitsContainer";
            BenefitsMaskContainer.append(RoomBenefitsContainer);

            let RoomBenefitsWrapper = document.createElement("div");
            RoomBenefitsWrapper.className = "swiper-wrapper";
            RoomBenefitsContainer.append(RoomBenefitsWrapper);

            for(let j = 0; j < ThisHotelToInstantiateData[i].benefits.length; j++)
            {
                let RoomBenefitsPanel = document.createElement("div");
                RoomBenefitsPanel.className = "RoomBenefitsPanel swiper-slide";
                RoomBenefitsPanel.innerHTML = ThisHotelToInstantiateData[i].benefits[j]["benefit_name_" + window.CurrentCountryID];
                RoomBenefitsWrapper.append(RoomBenefitsPanel);
            }

            let RoomBenefitsSwiper = new window.Swiper(RoomBenefitsContainer,
            {
                slidesPerView: 'auto',
                spaceBetween: 0,
                freeMode: true,
                observer: true,
                observeParents: true,
                autoplay:
                {
                    delay: 5000,
                },
            });
        }

        let RoomNamePanelText = document.createElement("p"); // Hotel Name -------
        RoomNamePanelText.className = "RoomNameTextInsidePanel";
        RoomNamePanelText.innerHTML = ThisHotelToInstantiateData[i].hotel_name;
        RoomPanelBottomInfoWrapper.append(RoomNamePanelText);

        let LocationPanelWrapper = document.createElement("div"); // Location -------
        LocationPanelWrapper.className = "RoomLocationContainerInsidePanel";
        RoomPanelBottomInfoWrapper.append(LocationPanelWrapper);

        let LocationPanelIMG = document.createElement("img");
        LocationPanelIMG.className = "LocationIconInsidePanel";
        LocationPanelIMG.src = "/Assets/images/ButtonIcon/location-icon.svg";
        LocationPanelWrapper.append(LocationPanelIMG);

        let RoomLocationTextInsidePanel = document.createElement("p");
        RoomLocationTextInsidePanel.className = "RoomLocationTextInsidePanel";
        RoomLocationTextInsidePanel.innerHTML = ThisHotelToInstantiateData[i].city_region + ", " + ThisHotelToInstantiateData[i].province;
        LocationPanelWrapper.append(RoomLocationTextInsidePanel);

        if(ThisHotelToInstantiateData[i].link_gmaps != null)
        {
            RoomLocationTextInsidePanel.innerHTML = RoomLocationTextInsidePanel.innerHTML + " - ";

            let SeeMapTextInsidePanel = document.createElement("a");
            SeeMapTextInsidePanel.className = "SeeMapTextInsidePanel HyperlinkUnderlineText";
            SeeMapTextInsidePanel.innerHTML = window["SeeMapTxt" + window.CurrentCountryID];
            SeeMapTextInsidePanel.target = "_blank";
            SeeMapTextInsidePanel.rel = "noopener noreferrer";
            SeeMapTextInsidePanel.style.zIndex = 1;
            SeeMapTextInsidePanel.href = ThisHotelToInstantiateData[i].link_gmaps;
            LocationPanelWrapper.append(SeeMapTextInsidePanel);
        }


        // if(ThisHotelToInstantiateData[i].last_ping != null && ThisHotelToInstantiateData[i].max_ping != null)
        // {
        //     let LastPingValue = parseInt(ThisHotelToInstantiateData[i].last_ping);
        //     let MaxPingValue = parseInt(ThisHotelToInstantiateData[i].max_ping);
        //     let RemainingPingValue = MaxPingValue - LastPingValue;

        //     let PingToGoInsidePanel = document.createElement("p"); // Ping To Go -------
        //     PingToGoInsidePanel.className = "PingToGoInsidePanel InterMediumTextFont";
        //     PingToGoInsidePanel.innerHTML = RemainingPingValue + " Ping! to go <span class='InterBoldTextFont' style='color: #2494D9;'>" + MaxPingValue + " Ping to max discount</span>";
        //     RoomPanelBottomInfoWrapper.append(PingToGoInsidePanel);
        // }

        let PingFromTextInsidePanel = document.createElement("p"); // From Price -------
        PingFromTextInsidePanel.className = "PingFromTextInsidePanel InterRegularTextFont";
        PingFromTextInsidePanel.style.marginTop = "auto";
        PingFromTextInsidePanel.innerHTML = window["FromTxt" + window.CurrentCountryID] + " <span class='PingFromPriceTextInsidePanel InterBoldTextFont'>IDR " +  parseInt(ThisHotelToInstantiateData[i].pick_room.price_after_disc).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00</span>";
        RoomPanelBottomInfoWrapper.append(PingFromTextInsidePanel);

        let PingNightTextInsidePanel = document.createElement("p"); // 1 Night -------
        PingNightTextInsidePanel.className = "PingNightTextInsidePanel InterRegularTextFont";
        PingNightTextInsidePanel.innerHTML = "1 " + window["NightTxt" + window.CurrentCountryID];
        RoomPanelBottomInfoWrapper.append(PingNightTextInsidePanel);

        // ------------------------------- HREF BUTTON ---------------------------------

        let CheckInDateInput = document.getElementById("CheckInDateInput");
        let CheckInDate = CheckInDateInput.getAttribute("date");
        let CheckInMonth = CheckInDateInput.getAttribute("month");
        let CheckInYear = CheckInDateInput.getAttribute("year");
        let CheckInFullDate = CheckInYear + "-" + CheckInMonth.padStart(2, '0') + "-" + CheckInDate;
        let CheckOutDateInput = document.getElementById("CheckOutDateInput");
        let CheckOutDate = CheckOutDateInput.getAttribute("date");
        let CheckOutMonth = CheckOutDateInput.getAttribute("month");
        let CheckOutYear = CheckOutDateInput.getAttribute("year");
        let CheckOutFullDate = CheckOutYear + "-" + CheckOutMonth.padStart(2, '0') + "-" + CheckOutDate;
        let RoomQuota = document.getElementById("RoomQuotaInput").getAttribute("room-quota");
        // let HREFUrl = "hoteldetails.php?search=" + ThisHotelToInstantiateData[i].province + "&checkin=" + CheckInFullDate + "&checkout=" + CheckOutFullDate + "&room=" + RoomQuota + "&slug="+ ThisHotelToInstantiateData[i].slug;
        let HREFUrl = "/" + ThisHotelToInstantiateData[i].category.category_name.toLowerCase() + "/" + window.CurrentCountryID + "/" + ThisHotelToInstantiateData[i].id_hotel + ".html?type=" + window.SearchFilterType;

        let MyPingButtonHREF = document.createElement("a")
        MyPingButtonHREF.className = "HREFInsideContainer";
        MyPingButtonHREF.href = HREFUrl;
        RoomPanelContainer.append(MyPingButtonHREF);

        // ------------------------------------------------------------------------------
    }
}

window.InstantiateBasicHotelPanel2 = function(ThisHotelToInstantiateData, WhereToInstantiatePanel, MainContainerToDisplay)
{
    for(let i = 0; i < ThisHotelToInstantiateData.length; i++)
    {
        let ThisLoadingPanel = window.InstantiateLoadingBasicPanel(WhereToInstantiatePanel);

        // Set Several Info -----------------------------------------------------------

        let RoomPriceFrom = null;
        let RoomPriceAfterDisc = null;
        let MaxDiscount = null;
        let StatusAvailable = true;
        let WhichType = "Rooms";

        if(ThisHotelToInstantiateData[i].experiences != null)
            WhichType = "Experiences";

        if(WhichType == "Rooms")
        {
            if(ThisHotelToInstantiateData[i].pick_room != null && ThisHotelToInstantiateData[i].range_price_room.from != ThisHotelToInstantiateData[i].pick_room.price_after_disc && ThisHotelToInstantiateData[i].range_price_room.from != null)
                RoomPriceFrom = parseInt(ThisHotelToInstantiateData[i].range_price_room.from); // Price From

            if(ThisHotelToInstantiateData[i].pick_room != null && ThisHotelToInstantiateData[i].pick_room.price_after_disc != null) // Discount
                RoomPriceAfterDisc = parseInt(ThisHotelToInstantiateData[i].pick_room.price_after_disc);

            if(ThisHotelToInstantiateData[i].max_disc != null && ThisHotelToInstantiateData[i].max_disc != 0)
                MaxDiscount = parseInt(ThisHotelToInstantiateData[i].max_disc); // Max Discount

            if(ThisHotelToInstantiateData[i].pick_room == null && ThisHotelToInstantiateData[i].status_available == "No")
                StatusAvailable = false; // Status Available
        }
        else
        {
            let ThisExperienceData = ThisHotelToInstantiateData[i].experiences;

            if(ThisExperienceData != null && ThisExperienceData.length > 0)
            {
                for(let a = 0; a < ThisExperienceData.length; a++)
                {
                    if(ThisExperienceData[a].price != null && (RoomPriceFrom == null || (RoomPriceFrom != null && RoomPriceFrom > ThisExperienceData[a].price)))
                    {
                        RoomPriceFrom = ThisExperienceData[a].price;
                        RoomPriceAfterDisc = ThisExperienceData[a].price_after_disc;
                        MaxDiscount = null;

                        if(ThisExperienceData[a].dates != null) // Without Options -------------------
                        {
                            for(let b = 0; b < ThisExperienceData[a].dates.length; b++)
                            {
                                let ThisDiscountValue = ThisExperienceData[a].dates[b].disc_now.total_discount;

                                if(ThisDiscountValue != null && ThisDiscountValue != 0 && (MaxDiscount == null || (MaxDiscount != null && MaxDiscount < ThisDiscountValue)))
                                {
                                    MaxDiscount = ThisDiscountValue;
                                }
                            }
                        }

                        if(ThisExperienceData[a].options != null) // With Options -------------------
                        {
                            let ThisExpOptions = ThisExperienceData[a].options;

                            for(let b = 0; b < ThisExpOptions.length; b++)
                            {
                                let ThisOptionsDate = ThisExpOptions[b].dates;

                                for(let c = 0; c < ThisOptionsDate.length; c++)
                                {
                                    let ThisDiscountValue = ThisOptionsDate[c].disc_now.total_discount;

                                    if(ThisDiscountValue != null && ThisDiscountValue != 0 && (MaxDiscount == null || (MaxDiscount != null && MaxDiscount < ThisDiscountValue)))
                                    {
                                        MaxDiscount = ThisDiscountValue;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            else
            {
                StatusAvailable = false;
            }

            if(ThisHotelToInstantiateData[i].status_available == "No")
                StatusAvailable = false; // Status Available
        }

        console.log("ThisHotelToInstantiateData[i]", ThisHotelToInstantiateData[i]);

        if(StatusAvailable == false)
            return

        // ---------------------------------------------------------------------------

        let RoomPanelContainer = document.createElement("div");
        RoomPanelContainer.className = "RoomPanelContainer InterMediumTextFont Selectable swiper-slide";
        RoomPanelContainer.style.display = "none";
        WhereToInstantiatePanel.append(RoomPanelContainer);

        if(MaxDiscount != null && parseInt(MaxDiscount) > 0)
        {
            let RoomPanelDiscountBackNew = document.createElement("div"); // Discount Top Max
            RoomPanelDiscountBackNew.className = "RoomPanelDiscountBackNew";
            RoomPanelContainer.append(RoomPanelDiscountBackNew);

            let RoomPanelDiscountTopNew = document.createElement("div");
            RoomPanelDiscountTopNew.className = "RoomPanelDiscountTopNew";
            RoomPanelDiscountBackNew.append(RoomPanelDiscountTopNew);

            let RedBannerNew = document.createElement("img");
            RedBannerNew.className = "RedBannerNew";
            RedBannerNew.src = "/Assets/images/Icon/red-barner-new.png";
            RoomPanelDiscountTopNew.append(RedBannerNew);

            let RoomPanelDiscountTopValueNew = document.createElement("p");
            RoomPanelDiscountTopValueNew.className = "RoomPanelDiscountTopValue InterBoldTextFont";
            RoomPanelDiscountTopValueNew.innerHTML = parseInt(MaxDiscount) + "%";
            RoomPanelDiscountTopNew.append(RoomPanelDiscountTopValueNew);
        }

        let RoomPanelContentWrapper = document.createElement("div"); // Room Image
        RoomPanelContentWrapper.className = "RoomPanelContentWrapper";
        RoomPanelContainer.append(RoomPanelContentWrapper);

        let RoomPanelImageContainer = document.createElement("div");
        RoomPanelImageContainer.className = "RoomPanelImageContainer";
        RoomPanelContentWrapper.append(RoomPanelImageContainer);

        let imagesProcessed = 0;
        let HowManyImagesToBeCalculated = ThisHotelToInstantiateData[i].photos.length;

        if (window.innerWidth < 768 && HowManyImagesToBeCalculated > 0) // If mobile only 1 Image Instantiated
            HowManyImagesToBeCalculated = 1;

        for(let j = 0; j < HowManyImagesToBeCalculated; j++)
        {
            let RoomImageFullCover = document.createElement("img");
            RoomImageFullCover.className = "ImageFullCover";
            RoomImageFullCover.style.opacity = "0";
            RoomImageFullCover.setAttribute("is-valid", 'false');
            if(j == 0)
            {
                RoomImageFullCover.style.opacity = "1";
            }
            RoomPanelImageContainer.append(RoomImageFullCover);

            window.checkImageUrlValid(ThisHotelToInstantiateData[i].photos[j].hotel_photo, "/Assets/images/NoHotelImage.jpg", RoomImageFullCover, () =>
            {
                imagesProcessed++;

                if(imagesProcessed === HowManyImagesToBeCalculated)
                {
                    window.CheckIfImageLoadedAndCallAFunction(MainContainerToDisplay, ()=>
                    {
                        let functiontocallfinal = function()
                        {
                            ThisLoadingPanel.remove();
                            RoomPanelContainer.style.display = "";
                        }
                        window.CheckAndDeletePhotoInsideContainerIfAtLeastOneExist(RoomPanelImageContainer, ()=> functiontocallfinal())
                    });
                }
            }, { quality: 70});
        }

        // Room Bottom Information --------------------------

        let RoomPanelBottomInfoWrapper = document.createElement("div");
        RoomPanelBottomInfoWrapper.className = "RoomPanelBottomInfoWrapper";
        RoomPanelContentWrapper.append(RoomPanelBottomInfoWrapper);

        if(ThisHotelToInstantiateData[i].benefit_per_hotel != null)
        {
            let BenefitsMaskContainer = document.createElement("div"); // Benefits -------
            BenefitsMaskContainer.className = "ContainerWithMaskEdge";
            RoomPanelBottomInfoWrapper.append(BenefitsMaskContainer);

            let RoomBenefitsContainer = document.createElement("div");
            RoomBenefitsContainer.className = "RoomBenefitsContainer";
            BenefitsMaskContainer.append(RoomBenefitsContainer);

            let RoomBenefitsWrapper = document.createElement("div");
            RoomBenefitsWrapper.className = "swiper-wrapper";
            RoomBenefitsContainer.append(RoomBenefitsWrapper);

            for(let j = 0; j < ThisHotelToInstantiateData[i].benefit_per_hotel.length; j++)
            {
                let RoomBenefitsPanel = document.createElement("div");
                RoomBenefitsPanel.className = "RoomBenefitsPanel swiper-slide";
                RoomBenefitsPanel.innerHTML = ThisHotelToInstantiateData[i].benefit_per_hotel[j]["benefit_name_" + window.CurrentCountryID];
                RoomBenefitsWrapper.append(RoomBenefitsPanel);
            }

            let RoomBenefitsSwiper = new window.Swiper(RoomBenefitsContainer,
            {
                slidesPerView: 'auto',
                spaceBetween: 0,
                freeMode: true,
                observer: true,
                observeParents: true,
                autoplay:
                {
                    delay: 5000,
                },
            });
        }

        let RoomNamePanelText = document.createElement("p"); // Hotel Name -------
        RoomNamePanelText.className = "RoomNameTextInsidePanel";
        RoomNamePanelText.innerHTML = ThisHotelToInstantiateData[i].hotel_name;
        RoomPanelBottomInfoWrapper.append(RoomNamePanelText);

        let LocationPanelWrapper = document.createElement("div"); // Location -------
        LocationPanelWrapper.className = "RoomLocationContainerInsidePanel";
        RoomPanelBottomInfoWrapper.append(LocationPanelWrapper);

        let LocationPanelIMG = document.createElement("img");
        LocationPanelIMG.className = "LocationIconInsidePanel";
        LocationPanelIMG.src = "/Assets/images/ButtonIcon/location-icon.svg";
        LocationPanelWrapper.append(LocationPanelIMG);

        let RoomLocationTextInsidePanel = document.createElement("p");
        RoomLocationTextInsidePanel.className = "RoomLocationTextInsidePanel";
        RoomLocationTextInsidePanel.innerHTML = ThisHotelToInstantiateData[i].city_region + ", " + ThisHotelToInstantiateData[i].province;
        LocationPanelWrapper.append(RoomLocationTextInsidePanel);

        if(ThisHotelToInstantiateData[i].link_gmaps != null)
        {
            RoomLocationTextInsidePanel.innerHTML = RoomLocationTextInsidePanel.innerHTML + " - ";

            let SeeMapTextInsidePanel = document.createElement("a");
            SeeMapTextInsidePanel.className = "SeeMapTextInsidePanel HyperlinkUnderlineText";
            SeeMapTextInsidePanel.innerHTML = window["SeeMapTxt" + window.CurrentCountryID];
            SeeMapTextInsidePanel.target = "_blank";
            SeeMapTextInsidePanel.rel = "noopener noreferrer";
            SeeMapTextInsidePanel.style.zIndex = 1;
            SeeMapTextInsidePanel.href = ThisHotelToInstantiateData[i].link_gmaps;
            LocationPanelWrapper.append(SeeMapTextInsidePanel);
        }

        let PingFromTextInsidePanel = document.createElement("p"); // From Price -------
        PingFromTextInsidePanel.className = "PingFromTextInsidePanel InterRegularTextFont";
        PingFromTextInsidePanel.style.marginTop = "auto";
        PingFromTextInsidePanel.innerHTML = window["FromTxt" + window.CurrentCountryID] + " <span class='PingFromPriceTextInsidePanel InterBoldTextFont'>IDR " +  parseInt(RoomPriceAfterDisc).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00</span>";
        RoomPanelBottomInfoWrapper.append(PingFromTextInsidePanel);

        let PingNightTextInsidePanel = document.createElement("p"); // 1 Night -------
        PingNightTextInsidePanel.className = "PingNightTextInsidePanel InterRegularTextFont";
        PingNightTextInsidePanel.innerHTML = "1 " + window["NightTxt" + window.CurrentCountryID];
        if(WhichType == "Experiences")
            PingNightTextInsidePanel.innerHTML = "1 " + window["OrangTxt" + window.CurrentCountryID] + " 1 " + window["SessionTxt" + window.CurrentCountryID];
        RoomPanelBottomInfoWrapper.append(PingNightTextInsidePanel);

        // ------------------------------- HREF BUTTON ---------------------------------

        let CheckInDateInput = document.getElementById("CheckInDateInput");
        let CheckInDate = CheckInDateInput.getAttribute("date");
        let CheckInMonth = CheckInDateInput.getAttribute("month");
        let CheckInYear = CheckInDateInput.getAttribute("year");
        let CheckInFullDate = CheckInYear + "-" + CheckInMonth.padStart(2, '0') + "-" + CheckInDate;
        let CheckOutDateInput = document.getElementById("CheckOutDateInput");
        let CheckOutDate = CheckOutDateInput.getAttribute("date");
        let CheckOutMonth = CheckOutDateInput.getAttribute("month");
        let CheckOutYear = CheckOutDateInput.getAttribute("year");
        let CheckOutFullDate = CheckOutYear + "-" + CheckOutMonth.padStart(2, '0') + "-" + CheckOutDate;
        let RoomQuota = document.getElementById("RoomQuotaInput").getAttribute("room-quota");
        // let HREFUrl = "hoteldetails.php?search=" + ThisHotelToInstantiateData[i].province + "&checkin=" + CheckInFullDate + "&checkout=" + CheckOutFullDate + "&room=" + RoomQuota + "&slug="+ ThisHotelToInstantiateData[i].slug;
        let HREFUrl = "/" + ThisHotelToInstantiateData[i].category.category_name.toLowerCase() + "/" + window.CurrentCountryID + "/" + ThisHotelToInstantiateData[i].id_hotel + ".html?type=" + WhichType;

        let MyPingButtonHREF = document.createElement("a")
        MyPingButtonHREF.className = "HREFInsideContainer";
        MyPingButtonHREF.href = HREFUrl;
        RoomPanelContainer.append(MyPingButtonHREF);

        // ------------------------------------------------------------------------------
    }
}


// =================================== INSTANTIATE IMAGE ON A SINGLE CONTAINER AND APPLY CHECKING LOADING ==============================

window.RemoveImagesUntilItHasMaximum = function(whicharraydata, nameofphotovar, howmanycut)
{
    if(Array.isArray(whicharraydata))
    {
        whicharraydata.forEach(ThisData => {
            ThisData[nameofphotovar] = ThisData[nameofphotovar].slice(0, howmanycut); // Creates a new array with only the first 4
        });

    }
    return whicharraydata;
}


window.CheckAllImageRemoveEmptyAndWaitLoadCallFunc = function(whichphotolist, whichphotovariable, imagenotexist, whichphotocontainer, imagesettings, whichparentcontainer, finalfunctiontocall)
{
    let imagesProcessed = 0;

    if(whichphotolist.length > 0)
    {
        for(let i = 0; i < whichphotolist.length; i++)
        {
            let ImageInstantiate = document.createElement("img");
            ImageInstantiate.className = "ImageFullCover";
            ImageInstantiate.setAttribute("is-valid", 'false');
            ImageInstantiate.style.opacity = "0";
            if(i == 0)
            {
                ImageInstantiate.style.opacity = "1";
            }
            whichphotocontainer.append(ImageInstantiate);

            let WhichPhotoToLoad = whichphotolist[i];
            if(whichphotovariable != null)
                WhichPhotoToLoad = whichphotolist[i][whichphotovariable];

            window.checkImageUrlValid(WhichPhotoToLoad, imagenotexist, ImageInstantiate, () =>
            {
                imagesProcessed++;

                if(imagesProcessed === whichphotolist.length)
                {
                    window.CheckIfImageLoadedAndCallAFunction(whichparentcontainer, ()=>
                    {
                        window.CheckAndDeletePhotoInsideContainerIfAtLeastOneExist(whichphotocontainer, ()=>
                        {
                            if(finalfunctiontocall != null)
                                finalfunctiontocall();
                        })
                    });
                }
            }, imagesettings);
        }
    }
    else
    {
        let ImageInstantiate = document.createElement("img");
        ImageInstantiate.className = "ImageFullCover";
        ImageInstantiate.setAttribute("is-valid", 'false');
        ImageInstantiate.style.opacity = 1;
        whichphotocontainer.append(ImageInstantiate);

        window.checkImageUrlValid(imagenotexist, imagenotexist, ImageInstantiate, () =>
        {
            window.CheckIfImageLoadedAndCallAFunction(whichparentcontainer, ()=>
            {
                window.CheckAndDeletePhotoInsideContainerIfAtLeastOneExist(whichphotocontainer, ()=>
                {
                    if(finalfunctiontocall != null)
                        finalfunctiontocall();
                })
            });
        }, imagesettings);
    }

}

// =================================== CHECK IF IMAGE VALID =====================================

// window.checkImageUrlValid = function(url, ifinvalid, thisimagetoinstantiate, callback, options)
// {
//     if (!url)
//     {
//         thisimagetoinstantiate.src = ifinvalid;
//         callback?.();
//         return;
//     }

//     const img = new Image();
//     img.crossOrigin = "anonymous";

//     img.onload = function()
//     {
//         if (this.width <= 0 || this.height <= 0)
//         {
//             thisimagetoinstantiate.src = ifinvalid;
//             callback?.();
//             return;
//         }

//         // If no Changes Immediately Assign -----------------------------------------------

//         if (!options || (!options.maxWidth && !options.quality && !options.format))
//         {
//             thisimagetoinstantiate.src = url;
//             callback?.();
//             return;
//         }

//         // If at least one Option Exist Apply -----------------------------------------------

//         const
//         {
//             maxWidth = this.width,
//             quality = 0.7,
//             format = "image/jpeg"
//         } = options;

//         const scale = Math.min(1, maxWidth / this.width);
//         const canvas = document.createElement("canvas");

//         canvas.width = this.width * scale;
//         canvas.height = this.height * scale;

//         const ctx = canvas.getContext("2d");
//         ctx.imageSmoothingEnabled = true;
//         ctx.imageSmoothingQuality = "high";

//         ctx.drawImage(this, 0, 0, canvas.width, canvas.height);

//         thisimagetoinstantiate.src = canvas.toDataURL(format, quality);
//         callback?.();
//     };

//     img.onerror = function ()
//     {
//         thisimagetoinstantiate.src = ifinvalid;
//         callback?.();
//     };

//     img.src = url;
// }

// =================================== IMAGE POOL ====================================

// Fully Load All Image Url Before Continue ------------------------------
window.buildImagePoolCompleteLoad = async function (urls, urlifimageinvalid, options = {})
{
  const pool = []

    for (const url of urls)
    {
        let URLToLoad = url.hotel_photo;
        let ImageType = "Hotel";

        if (url.room_photo != null)
        {
            URLToLoad = url.room_photo;
            ImageType = "Room";
        }

        const resolvedUrl = await window.resolveImageUrlForPool(URLToLoad, urlifimageinvalid, options);

        const img = document.createElement("img");
        img.setAttribute("type", ImageType);

        let FinalURLDecide;

        if (!resolvedUrl || resolvedUrl === urlifimageinvalid)
        {
            FinalURLDecide = urlifimageinvalid;
            img.dataset.isexist = "false";
        }
        else
        {
            FinalURLDecide = resolvedUrl;
            img.dataset.isexist = "true";
        }

        const cached = await window.getCachedAsset(FinalURLDecide);
        if (cached)
        {
            img.src = cached;
        }


        pool.push(img);
    }

    return pool;
};

// Build Image Pool While Not Waiting Until All of them Completely Loaded ------------------------------

window.createImagePoolImmediate = async function (urls)
{
    console.log(urls);

    const pool = [];

    for (const url of urls)
    {
        const img = document.createElement("img");
        const realUrl = url.room_photo ?? url.hotel_photo ?? url.photo_url;

        img.dataset.src = realUrl;

        if(url.type == "room")
        {
            img.setAttribute("type", "Room");
        }
        else if(url.type == "experience")
        {
            img.setAttribute("type", "Experience");
        }
        else
        {
            img.setAttribute("type", "Hotel");
        }

        const cached = await window.getCachedAsset(realUrl);

        if (cached)
        {
            img.src = cached;
        }

        pool.push(img);
    }

    return pool;
};


// If Image URL Error Or Wrong, Apply Invalid. As well as Apply Options ---------------------------
window.resolveImageUrlForPool = function(url, urlifimageinvalid, options = {})
{
  return new Promise(resolve => {
    if (!url) {
      resolve(null);
      return;
    }

    const {
      quality = 75,
      format = "webp"
    } = options;

    const compressedUrl =
      `https://wsrv.nl/?url=${encodeURIComponent(url)}&q=${quality}&output=${format}`;

    const img = new Image();

    img.onload = function ()
    {
        if (this.width > 0 && this.height > 0)
        {
            resolve(compressedUrl);
        }
        else
        {
            resolve(urlifimageinvalid);
        }
    };

    img.onerror = function ()
    {
        const fallback = new Image();

        fallback.onload = function ()
        {
            resolve(url);
        };

        fallback.onerror = function ()
        {
            resolve(urlifimageinvalid);
        };

        fallback.src = url;
    };

    img.src = compressedUrl;
  });
}

// (For Immediate Pool Build Only) to Resolve The Image if Not Exist Apply Invalid --------------------------
window.resolvePoolInBackground = async function(pool, fallback)
{
    for (const img of pool)
    {
        const resolved = await window.resolveImageUrlForPool(img.dataset.src, fallback, {quality:100});
        img.src = resolved || fallback;

        img.onload = () =>
        {
            img._clones?.forEach(clone => clone.src = img.src);
        };
    }
};

// Immediately Bind Image From Pool ---------------------------------------
window.bindImageFromPool = function(baseImg)
{
    const img = document.createElement("img");
    img.className = "ImageFullCover";

    baseImg._clones ??= [];
    baseImg._clones.push(img);

    if(baseImg.src)
    {
        img.src = baseImg.src;
    }
    return img;
};

// On Image Loaded Remove Loading Skeleton and Display The Image ------------------------------------
window.HandleLoadingSkeletonAndImage = function (LoadingSkeleton, ThisClonedImage)
{
    function revealimagefrompool()
    {
        LoadingSkeleton.remove();
        ThisClonedImage.style.opacity = 1;
    }

    if(ThisClonedImage.complete && ThisClonedImage.naturalWidth > 0)
    {
        revealimagefrompool();
    }
    else
    {
        ThisClonedImage.onload = revealimagefrompool;
        ThisClonedImage.onerror = revealimagefrompool;
    }
}

// ======================================== CONVERT IMAGE INTO BASE 64 ====================================

window.getBase64StringFromDataURL = function(dataURL)
{
    dataURL = dataURL.replace('data:', '').replace(/^.+,/, '');
    return dataURL;
}

// ======================================== BASIC CHECK IMAGE VALIDITY =====================================

window.checkImageUrlValid = async function(url, ifinvalid, targetImg, callback, options = {})
{
    if(!url || url == null)
    {
        url = ifinvalid;
    }

    const {
        quality = 75,
        format = "webp"
    } = options;

    const cdnUrl = `https://wsrv.nl/?url=${encodeURIComponent(url)}&q=${quality}&output=${format}`;

    // 1️⃣ Try persistent cache first
    const cached = await window.getCachedAsset(cdnUrl);
    if (cached)
    {
        targetImg.src = cached;
        targetImg.setAttribute("is-valid", 'true');
        callback?.();
        return;
    }

    // 2️⃣ Try CDN
    const cdnTest = new Image();
    cdnTest.onload = function()
    {
        targetImg.src = cdnUrl;
        targetImg.setAttribute("is-valid", 'true');
        window.cacheAsset(cdnUrl, cdnUrl);
        callback?.();
    };

    cdnTest.onerror = function()
    {
        // 3️⃣ Try original URL
        const origTest = new Image();
        origTest.onload = function()
        {
            targetImg.src = url;
            window.cacheAsset(url, url);
            callback?.();
        };
        origTest.onerror = function()
        {
            // 4️⃣ Guaranteed fallback
            targetImg.src = ifinvalid;
            callback?.();
        };
        origTest.src = url;
    };

    cdnTest.src = cdnUrl;
};



window.CheckAndDeletePhotoInsideContainerIfAtLeastOneExist = function(thiscontainer, functiontocall)
{
    let images = thiscontainer.querySelectorAll(':scope > img');
    let AtLeastOneExist = false;

    // Check First ------------------------------------

    images.forEach(image =>
    {
        if(AtLeastOneExist == false)
        {
            if(image.getAttribute("is-valid") == 'true')
            {
                AtLeastOneExist = true;
            }
        }
    });

    if(AtLeastOneExist == true) // If at Least one Image Exist Delete The Invalid
    {
        images.forEach(image =>
        {
            if(image.getAttribute("is-valid") == 'false')
            {
                image.remove();
            }
        });
    }
    else if(AtLeastOneExist == false && images.length > 1) // If all of them Not Exist Then
    {
        images.forEach((img, index) =>
        {
            if(index > 0)
            {
                img.remove();
            }
        });
    }

    // If total Image More Thann One Then Animate ------------------------------------

    let CheckImageOneMoreTime = thiscontainer.querySelectorAll(':scope > img');
    if(CheckImageOneMoreTime.length > 1)
    {
        window.AutoAnimateIMGInsidePanel(thiscontainer);
    }

    functiontocall();
}


window.CheckIfImageLoadedAndCallAFunction = function(wholecontainertoload, functiontocall) // Check If All Panel Inside Container Loaded, Then Remove the Container that consist of Loading Panels
{
    const images = wholecontainertoload.querySelectorAll('img');
    let loadedCount = 0;

    const handleImageLoad = () =>
    {
        loadedCount++;

        if (loadedCount === images.length)
        {
            functiontocall();
        }
    };

    images.forEach(image =>
    {
        if (image.complete)
        {
            handleImageLoad();
        }
        else
        {
            image.addEventListener('load', handleImageLoad);
            image.addEventListener('error', handleImageLoad);
        }
    });
}

window.CheckImageContainerImageLoaded = function(wholecontainertoload, thisloadingcontainer, removeloading) // Check If All Panel Inside Container Loaded, Then Remove the Container that consist of Loading Panels
{
    const images = wholecontainertoload.querySelectorAll('img');
    let loadedCount = 0;

    const handleImageLoad = () =>
    {
        loadedCount++;

        if (loadedCount === images.length)
        {
            if(removeloading == true)
            {
                thisloadingcontainer.remove();
            }
            else
            {
                thisloadingcontainer.style.display = "none";
            }
            wholecontainertoload.style.display = "";
        }
    };

    images.forEach(image =>
    {
        if (image.complete)
        {
            handleImageLoad();
        }
        else
        {
            image.addEventListener('load', handleImageLoad);
            image.addEventListener('error', handleImageLoad);
        }
    });
}

window.CheckImageContainerImageLoaded2 = function(wholecontainertoload, removeloading) // Check Only Image and Loading Inside Same Container
{
    let AllImagesInsideThisContainer = wholecontainertoload.querySelectorAll('img');
    let AllLoadingInsideThisContainer = wholecontainertoload.querySelectorAll('.loading_grey');

    let loadedCount = 0;

    const handleImageLoad = () =>
    {
        loadedCount++;

        if (loadedCount === AllImagesInsideThisContainer.length)
        {
            if(removeloading == true)
            {
                AllLoadingInsideThisContainer.forEach(ThisLoading =>
                {
                    ThisLoading.remove();
                });
            }
            else
            {
                AllLoadingInsideThisContainer.forEach(ThisLoading =>
                {
                    ThisLoading.style.display = "none";
                });
            }

            AllImagesInsideThisContainer.forEach(ThisImage =>
            {
                ThisImage.style.display = "";
                ThisImage.style.opacity = 1;
            });
        }
    };

    AllImagesInsideThisContainer.forEach(image =>
    {
        if (image.complete)
        {
            handleImageLoad();
        }
        else
        {
            image.addEventListener('load', handleImageLoad);
            image.addEventListener('error', handleImageLoad);
        }
    });
}


window.HandleAllImageLoadWithFunction = function(allimagestocheck, whattodo)
{
    let loadedCount = 0;

    const handleImageLoad = () =>
    {
        loadedCount++;

        if (loadedCount === allimagestocheck.length)
        {
            whattodo();
        }
    };

    allimagestocheck.forEach(image =>
    {
        if (image.complete)
        {
            handleImageLoad();
        }
        else
        {
            image.addEventListener('load', handleImageLoad);
            image.addEventListener('error', handleImageLoad);
        }
    });
}

// Basic Hotel Panel Data ======================================================


window.ReadyToLoadBasicHotelPanelData = function(WhereToInstantiateAll, URLToLoad, ispaginationclass, HeaderOfContainer)
{
    let ThisBasicHotelContainer = document.createElement("div");
    ThisBasicHotelContainer.className = "SectionSeparatorContainer SectionSeparatorContainerShortenBottom";
    ThisBasicHotelContainer.style.display = "none";
    WhereToInstantiateAll.append(ThisBasicHotelContainer);

    // ============================= CONTAINER ========================================

    let SectionContentWrapper = document.createElement("div");
    SectionContentWrapper.className = "SectionContentWrapper";
    ThisBasicHotelContainer.append(SectionContentWrapper);

    let BasicAreaLoading = document.createElement("p");
    BasicAreaLoading.className = "SectionHeaderTextIndex InterRegularTextFont";
    BasicAreaLoading.innerHTML = HeaderOfContainer;
    SectionContentWrapper.append(BasicAreaLoading);

    let BasicPanelSwiperMainContainer = document.createElement("div");
    BasicPanelSwiperMainContainer.className = "BasicPanelSwiperMainContainer";
    SectionContentWrapper.append(BasicPanelSwiperMainContainer);

    let ContainerWithMaskEdge = document.createElement("div");
    ContainerWithMaskEdge.className = "ContainerWithMaskEdge";
    BasicPanelSwiperMainContainer.append(ContainerWithMaskEdge);

    let BasicAreasPanelContainer = document.createElement("div");
    BasicAreasPanelContainer.className = "HotelRoomPanelSwiperContainer TrendingHotelsSwiperContainer";
    ContainerWithMaskEdge.append(BasicAreasPanelContainer);

    let BasicAreasPanelWrapper = document.createElement("div");
    BasicAreasPanelWrapper.className = "swiper-wrapper BasicHotelListPanelSwiperWrapper";
    BasicAreasPanelContainer.append(BasicAreasPanelWrapper);


    let PrevButtonDiv = document.createElement("div");
    PrevButtonDiv.className = "PopularAreasLeftRightButtonContainer PaddingButtonLeft";
    BasicPanelSwiperMainContainer.append(PrevButtonDiv);

    let PrevButtonButton = document.createElement("button");
    PrevButtonButton.className = "NextPreviousSwiperButton Selectable2 TrendingHotelLeft";
    PrevButtonDiv.append(PrevButtonButton);

    let PrevButtonButtonIMG = document.createElement("img");
    PrevButtonButtonIMG.src = "/Assets/images/ButtonIcon/chevron.svg";
    PrevButtonButton.append(PrevButtonButtonIMG);


    let NextButtonDiv = document.createElement("div");
    NextButtonDiv.className = "PopularAreasLeftRightButtonContainer PaddingButtonRight";
    BasicPanelSwiperMainContainer.append(NextButtonDiv);

    let NextButtonButton = document.createElement("button");
    NextButtonButton.className = "NextPreviousSwiperButton Selectable2 TrendingHotelRight";
    NextButtonDiv.append(NextButtonButton);

    let NextButtonButtonIMG = document.createElement("img");
    NextButtonButtonIMG.src = "/Assets/images/ButtonIcon/chevron.svg";
    NextButtonButton.append(NextButtonButtonIMG);

    let ThisBasicHotelPanelSwiper = new window.Swiper(BasicAreasPanelContainer,
    {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true,
        observer: true,
        observeParents: true,
        navigation: {
            prevEl: PrevButtonButton,
            nextEl: NextButtonButton,
        }
    });

    ThisBasicHotelContainer.style.display = "";

    LoadBasicHotelPanelData(URLToLoad, ispaginationclass, ThisBasicHotelContainer, BasicAreasPanelWrapper, BasicAreasPanelContainer, ThisBasicHotelPanelSwiper);
}

function LoadBasicHotelPanelData(URLToLoad, ispaginationclass, ThisBasicHotelContainer, BasicAreasPanelWrapper, BasicAreasPanelContainer, ThisBasicHotelPanelSwiper)
{
    let LoadingTempInstantiated = [];
    for(let i = 0; i < window.limitPanelPerPage; i++)
    {
        LoadingTempInstantiated.push(window.InstantiateLoadingBasicPanel(BasicAreasPanelWrapper));
    }

    let FullUrlToLoad = "/v2" + URLToLoad;
    let arr = window.location.href.split('?');
    let WhichIndexNow = 1;

    if(window["Current" + ispaginationclass + "Index"] != null)
    {
        WhichIndexNow = window["Current" + ispaginationclass + "Index"];
        let URLExtend = "page=" + WhichIndexNow + "&limit=" + window.limitPanelPerPage;
        if(arr.length > 1 && arr[1] !== '')
        {
            FullUrlToLoad =  FullUrlToLoad + "&" + URLExtend;
        }
        else
        {
            FullUrlToLoad =  FullUrlToLoad + "?" + URLExtend;
        }
    }

    window.CallApiAxios({
        method: "GET",
        url: FullUrlToLoad,
    }).then(res =>
    {
        let BasicHotelPanelData = res.data.data;
        BasicHotelPanelData = window.sortByPriority(BasicHotelPanelData, window.SortAccommodationPriority, "hotel_name");
        // console.log("Load " + HeaderOfContainer + "________________");
        console.log(FullUrlToLoad);
        // console.log(res);
        console.log("BasicHotelPanelData", BasicHotelPanelData);

        // BasicHotelPanelData = window.RemoveImagesUntilItHasMaximum(BasicHotelPanelData, "photos", window.MaximumPhotoEachRoom);

        LoadingTempInstantiated.forEach(loadingtemp =>
        {
            loadingtemp.remove();
        });

        if(WhichIndexNow == 1 && BasicHotelPanelData.length == 0)
        {
            ThisBasicHotelContainer.remove();
            return
        }

        if(res.status == 200 && Array.isArray(BasicHotelPanelData) && BasicHotelPanelData.length > 0)
        {
            window.InstantiateBasicHotelPanel2(BasicHotelPanelData, BasicAreasPanelWrapper, BasicAreasPanelContainer);

            if(res.data.pagination != null && res.data.pagination.has_more == true)
            {
                ThisBasicHotelPanelSwiper.on('reachEnd', function ()
                {
                    window["Current" + ispaginationclass + "Index"]++;
                    LoadBasicHotelPanelData(URLToLoad, ispaginationclass, ThisBasicHotelContainer, BasicAreasPanelWrapper, BasicAreasPanelContainer, ThisBasicHotelPanelSwiper);
                });
            }
            else
            {
                if(ThisBasicHotelPanelSwiper != null)
                ThisBasicHotelPanelSwiper.off('reachEnd');
            }
        }
    })
    .catch(err =>
    {
        console.error(err);
        LoadingTempInstantiated.forEach(loadingtemp =>
        {
            loadingtemp.remove();
        });
        ThisBasicHotelContainer.remove();
        // LoadBasicHotelPanelData(URLToLoad, ispaginationclass, ThisBasicHotelContainer, BasicAreasPanelWrapper, BasicAreasPanelContainer, ThisBasicHotelPanelSwiper);
    });
}

// ==================================== LOADING BLOCKER ================================

window.InstantiateLoadingBlocker = function(blockerid)
{
    let WaitingBlockerChecHotelDetails = document.createElement("div");
    WaitingBlockerChecHotelDetails.className = "BasicBlackBlocker";
    WaitingBlockerChecHotelDetails.id = blockerid;
    document.getElementsByTagName("body")[0].append(WaitingBlockerChecHotelDetails);

    let WaitingClockAnimated = document.createElement("img");
    WaitingClockAnimated.className = "WaitingClockAnimated";
    WaitingClockAnimated.src = "/Assets/images/Icon/waiting-clock-icon.svg";
    WaitingBlockerChecHotelDetails.append(WaitingClockAnimated);

    return WaitingBlockerChecHotelDetails;
}

// ============================ SEARCH TOP CLICKED ================================

window.OnSearchTopButtonClicked = function()
{
    let InputtedSearched = window.MainSearchInputField.value;

    if(InputtedSearched != ""  && InputtedSearched.replace(/ /g, "") != "")
    {
        let SlugSearched = window.MainSearchInputField.getAttribute("province-slug");
        if(SlugSearched == "")
        {
            SlugSearched = window.MainSearchInputField.value.toLowerCase().replace(/\s+/g, '-');
        }

        let CheckInDateInput = document.getElementById("CheckInDateInput");
        let CheckInInfoYear = CheckInDateInput.getAttribute("year");
        let CheckInInfoMonth = CheckInDateInput.getAttribute("month");
        let CheckInInfoDate = CheckInDateInput.getAttribute("date");
        let CheckInInfoCombined = CheckInInfoYear + "-" + CheckInInfoMonth.toString().padStart(2, '0') + "-" + CheckInInfoDate.toString().padStart(2, '0');

        let CheckOutDateInput = document.getElementById("CheckOutDateInput");
        let CheckOutInfoYear = CheckOutDateInput.getAttribute("year");
        let CheckOutInfoMonth = CheckOutDateInput.getAttribute("month");
        let CheckOutInfoDate = CheckOutDateInput.getAttribute("date");
        let CheckOutInfoCombined = CheckOutInfoYear + "-" + CheckOutInfoMonth.toString().padStart(2, '0') + "-" + CheckOutInfoDate.toString().padStart(2, '0');

        let RoomQuotaInput = document.getElementById("RoomQuotaInput").getAttribute("room-quota");

        let FinalURLToLoad = "/search/" + window.CurrentCountryID + "/" +  SlugSearched  + ".html?search=" + InputtedSearched + "&checkin=" + CheckInInfoCombined + "&checkout=" + CheckOutInfoCombined + "&room=" + RoomQuotaInput + "&type=" + window.SearchFilterType;
        window.location.href = FinalURLToLoad;
        // window.location.href = "searchresult.php?search=" + InputtedSearched + "&checkin=" + CheckInInfoCombined + "&checkout=" + CheckOutInfoCombined + "&room=" + RoomQuotaInput + "&slug=" + SlugSearched;
    }
    else
    {
        window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["PleaseInputYourDestinationTxt" + window.CurrentCountryID]);
        // window.MainSearchInputField.style.color = "#C00000";
    }
}

window.InstantiateLoadingCircle = function(wheretoInstantiate, iswhite)
{
    let LoadingBlocker = document.createElement("div");
    LoadingBlocker.className = "loadingcircleblocker";
    wheretoInstantiate.append(LoadingBlocker);

    let LoadingCircle = document.createElement("span");
    LoadingCircle.className = "loadingcircle";
    LoadingBlocker.append(LoadingCircle);

    if(iswhite == true)
    {
        LoadingBlocker.className = "loadingcircleblocker loadingcircleblockerWhite";
    }

    return LoadingBlocker
}

// ==================================== SET TOP DATE AND QUOTA INFO =====================================


window.SetUpTopDateQuotaSearch = function(isthissearchmenu, functionontypechange)
{
    let CurrentUrl = new URL(window.location.href);
    let param = new URLSearchParams(CurrentUrl.search.slice(1));

    let CurrentDayCheck = new Date();
    CurrentDayCheck.setHours(0, 0, 0, 0);

    // ==================== SET DATA BASED ON URL ==========================

    if(window.SearchInfo == null)
    {
        if(CurrentUrl.searchParams.get("search") != null) // Search -------------
        {
            window.SearchInfo = CurrentUrl.searchParams.get("search");
        }
        else if(sessionStorage.getItem("tempsearch") != null)
        {
            window.SearchInfo = sessionStorage.getItem("tempsearch");
        }
        else
        {
            // window.SearchInfo = window.DefaultSearchLocation;
        }
    }
    sessionStorage.removeItem("tempsearch");

    if(window.SlugInfo == null)
    {
        if(CurrentUrl.searchParams.get("slug") != null) // Slug -------------
        {
            window.SlugInfo = CurrentUrl.searchParams.get("slug");
        }
        else if(window.SearchInfo != null)
        {
            window.SlugInfo = window.SearchInfo.toLowerCase().replace(/\s+/g, '-');
        }
    }

    window.FixedSlugInfo = window.SlugInfo;

    if(window.MainSearchInputField != null)
    {
        window.MainSearchInputField.value = window.SearchInfo;
        window.MainSearchInputField.setAttribute("current-inputed", window.SearchInfo);
        window.MainSearchInputField.setAttribute("province-slug", window.SlugInfo);
    }

    if(param.has('checkin') == true) // Check In -------
    {
        window.CheckInInfo = CurrentUrl.searchParams.get("checkin");
    }

    if(param.has('checkout') == true) // Check Out -------
    {
        window.CheckOutInfo = CurrentUrl.searchParams.get("checkout");
    }

    if(param.has('room') == false) // Room -------
    {
        window.RoomNumberInfo = 1;
    }
    else
    {
        window.RoomNumberInfo = parseInt(CurrentUrl.searchParams.get("room"));
    }

    //----------------- CHECK IN ------------------------

    if(window.CheckInInfo == null || window.CheckInInfo == "")
    {
        let yearisnull = CurrentDayCheck.getFullYear();
        let dayisnull = CurrentDayCheck.getDate();
        let monthisnull = CurrentDayCheck.getMonth() + 1;
        window.CheckInInfo = yearisnull + "-" + monthisnull + "-" + dayisnull;
    }

    let CheckInInfoArray = window.CheckInInfo.split("-");
    let CheckInInfoYear = parseInt(CheckInInfoArray[0]);
    let CheckInInfoMonth = parseInt(CheckInInfoArray[1]);
    let CheckInInfoDate = parseInt(CheckInInfoArray[2]);
    let CheckInFullDate = new Date(CheckInInfoYear, CheckInInfoMonth-1, CheckInInfoDate);

    if(CheckInFullDate.getTime() < CurrentDayCheck.getTime()) // Ensure Check In Date is not less than current date
    {
        CheckInInfoYear = CurrentDayCheck.getFullYear();
        CheckInInfoDate = CurrentDayCheck.getDate();
        CheckInInfoMonth = CurrentDayCheck.getMonth() + 1;

        window.CheckInInfo = CheckInInfoYear + "-" + CheckInInfoMonth + "-" + CheckInInfoDate;
        CheckInFullDate = new Date(CheckInInfoYear, CheckInInfoMonth-1, CheckInInfoDate);
    }

    let ThisCheckInDateToDisplay = CheckInInfoDate.toString().padStart(2, '0') + " " + window["monthNames" + window.CurrentCountryID][CheckInInfoMonth-1] + " " + CheckInInfoYear;

    let ThisCheckInInputField = document.getElementById("CheckInDateInput");
    let ThisCheckInInputFieldText = document.getElementById("CheckInDateInputDateText");

    if(ThisCheckInInputField != null && ThisCheckInInputFieldText != null)
    {
        ThisCheckInInputField.setAttribute("Date", CheckInInfoDate);
        ThisCheckInInputField.setAttribute("Month", CheckInInfoMonth);
        ThisCheckInInputField.setAttribute("Year", CheckInInfoYear);

        ThisCheckInInputFieldText.innerHTML = ThisCheckInDateToDisplay;
    }

    let ThisCheckInDayNameText = document.getElementById("CheckInDateInputDayNameText");
    if(ThisCheckInDayNameText != null)
    {
        ThisCheckInDayNameText.innerHTML = window["weekdayFull" + window.CurrentCountryID][(new Date(CheckInInfoYear, CheckInInfoMonth-1, CheckInInfoDate).getDay())];
    }


    window.CheckInNonTopInput = document.getElementById("CheckInDateHotelDetailsInput"); // Non Top Check In
    window.CheckInNonTopInputText = document.getElementById("CheckInDateHotelDetailsInputDateText");

    if(window.CheckInNonTopInput != null && window.CheckInNonTopInputText != null)
    {
        window.CheckInNonTopInput.setAttribute("Date", CheckInInfoDate);
        window.CheckInNonTopInput.setAttribute("Month", CheckInInfoMonth);
        window.CheckInNonTopInput.setAttribute("Year", CheckInInfoYear);

        window.CheckInNonTopInputText.innerHTML = ThisCheckInDateToDisplay;
    }

    window.FixedCheckInInfo = window.CheckInInfo;

    //------------------- CHECK OUT -----------------------

    if(window.CheckOutInfo == null || window.CheckOutInfo == "")
    {
        let dateisnull = new Date(CheckInInfoYear, CheckInInfoMonth-1, CheckInInfoDate);
        dateisnull.setDate(dateisnull.getDate() + 1);
        let yearisnull = dateisnull.getFullYear();
        let dayisnull = dateisnull.getDate();
        let monthisnull = dateisnull.getMonth() + 1;
        window.CheckOutInfo = yearisnull + "-" + monthisnull + "-" + dayisnull;
    }

    let CheckOutInfoArray = window.CheckOutInfo.split("-");
    let CheckOutInfoYear = parseInt(CheckOutInfoArray[0]);
    let CheckOutInfoMonth = parseInt(CheckOutInfoArray[1]);
    let CheckOutInfoDate = parseInt(CheckOutInfoArray[2]);
    let CheckOutFullDate = new Date(CheckOutInfoYear, CheckOutInfoMonth-1, CheckOutInfoDate)

    if(CheckOutFullDate.getTime() <= CheckInFullDate.getTime()) // Ensure Check In Date is not less than current date
    {
        let CheckOutDateTomorrow = CheckInFullDate;
        CheckOutDateTomorrow.setDate(CheckOutDateTomorrow.getDate() + 1);
        CheckOutInfoYear = CheckOutDateTomorrow.getFullYear();
        CheckOutInfoDate = CheckOutDateTomorrow.getDate();
        CheckOutInfoMonth = CheckOutDateTomorrow.getMonth() + 1;

        window.CheckOutInfo = CheckOutInfoYear + "-" + CheckOutInfoMonth + "-" + CheckOutInfoDate;
        CheckOutFullDate = CheckOutDateTomorrow;
    }

    let ThisCheckOutDateToDisplay = CheckOutInfoDate.toString().padStart(2, '0') + " " + window["monthNames" + window.CurrentCountryID][CheckOutInfoMonth-1] + " " + CheckOutInfoYear;

    let ThisCheckOutputInputField = document.getElementById("CheckOutDateInput");
    let ThisCheckOutputInputFieldText = document.getElementById("CheckOutDateInputDateText");

    if(ThisCheckOutputInputField != null && ThisCheckOutputInputFieldText != null)
    {
        ThisCheckOutputInputField.setAttribute("Date", CheckOutInfoDate);
        ThisCheckOutputInputField.setAttribute("Month", CheckOutInfoMonth);
        ThisCheckOutputInputField.setAttribute("Year", CheckOutInfoYear);

        ThisCheckOutputInputFieldText.innerHTML = ThisCheckOutDateToDisplay;
    }

    let ThisCheckOutDayNameText = document.getElementById("CheckOutDateInputDayNameText");
    if(ThisCheckOutDayNameText != null)
    {
        ThisCheckOutDayNameText.innerHTML = window["weekdayFull" + window.CurrentCountryID][(new Date(CheckOutInfoYear, CheckOutInfoMonth-1, CheckOutInfoDate).getDay())];
    }

    window.CheckOutNonTopInput = document.getElementById("CheckOutDateHotelDetailsInput"); // Non Top Check Out
    window.CheckOutNonTopInputText = document.getElementById("CheckOutDateHotelDetailsInputDateText");

    if(window.CheckOutNonTopInput != null && window.CheckOutNonTopInputText != null)
    {
        window.CheckOutNonTopInput.setAttribute("Date", CheckOutInfoDate);
        window.CheckOutNonTopInput.setAttribute("Month", CheckOutInfoMonth);
        window.CheckOutNonTopInput.setAttribute("Year", CheckOutInfoYear);

        window.CheckOutNonTopInputText.innerHTML = ThisCheckOutDateToDisplay;
    }

    window.FixedCheckOutInfo = window.CheckOutInfo;

    // Set Early Hotel Details Mobile Check In - Out ----------------------------------------------------

    let ExtraMobileCheckInOutDateContainer = document.querySelectorAll(".ExtraMobileCheckInOutDateContainer");
    if(ExtraMobileCheckInOutDateContainer != null && ExtraMobileCheckInOutDateContainer.length > 0)
    {
        ExtraMobileCheckInOutDateContainer.forEach(thiscontainer =>
        {
            let ThisCheckInOutMobileText = thiscontainer.querySelector(".ExtraMobileCheckInOutDateText");
            ThisCheckInOutMobileText.innerHTML = ThisCheckInDateToDisplay + " - " + ThisCheckOutDateToDisplay;
        });
    }

    // Set Early Mobile UI Based on Selected Type -------------------------------------------------------

    let MobileQuotaChangeDropDownContainer = document.querySelectorAll(".MobileQuotaChangeDropDownContainer");
    if(window.SelectedHotelDetailsFilter == "Experiences")
    {
        MobileQuotaChangeDropDownContainer.forEach(thismobilequota =>
        {
            thismobilequota.style.display = "none";
        });
    }

    // Set Early Check In Out Share ---------------------------------------------------------------------

    window.CheckInDateNonTop = window.CheckInInfo;
    window.CheckOutDateNonTop = window.CheckOutInfo;

    //------------------------------ DAY DIFFERENCES -----------------------------------------------------

    let DifferenceBetweenDays = window.GetDateDifferences(CheckOutFullDate, CheckInFullDate);
    let DiffDaysText = window.NightTextDisplayer(DifferenceBetweenDays);

    let HowManyNightText = document.getElementById("HowManyNightText");
    if(HowManyNightText != null)
    {
        HowManyNightText.innerHTML = DiffDaysText;
    }

    let HowManyNightTextNonTop = document.getElementById("HowManyNightHotelDetailsInput");
    if(HowManyNightTextNonTop != null)
    {
        HowManyNightTextNonTop.innerHTML = DiffDaysText;

    }

    //------------------------------ NUMBER OF ROOM ------------------------------

    if(CurrentUrl.searchParams.get("room") == "null" || CurrentUrl.searchParams.get("room") == null || CurrentUrl.searchParams.get("room") == "")
    {
        window.RoomNumberInfo = 1;
    }
    if(window.RoomNumberInfo == null || window.RoomNumberInfo == "")
    {
        window.RoomNumberInfo = 1;
    }

    let RoomQuotaTextToDisplay = window.RoomNumberInfo + " " + window["RoomTxt" + window.CurrentCountryID];
    if(window.RoomNumberInfo > 1)
    {
        RoomQuotaTextToDisplay = window.RoomNumberInfo + " " + window["RoomTxtex" + window.CurrentCountryID];
    }

    let RoomQuotaInput = document.getElementById("RoomQuotaInput");
    let RoomQuotaTextDisplay = document.getElementById("RoomQuotaTextDisplay");
    if(RoomQuotaInput != null && RoomQuotaTextDisplay != null)
    {
        RoomQuotaInput.setAttribute("room-quota", window.RoomNumberInfo);
        RoomQuotaTextDisplay.innerHTML = RoomQuotaTextToDisplay;
    }

    let RoomQuotaInputNonTop = document.getElementById("RoomQuotaHotelDetailsInput");
    let RoomQuotaTextDisplayNonTop = document.getElementById("RoomQuotaHotelDetailsDisplayText");
    if(RoomQuotaTextDisplayNonTop != null)
    {
        RoomQuotaInputNonTop.setAttribute("room-quota", window.RoomNumberInfo);
        RoomQuotaTextDisplayNonTop.innerHTML = RoomQuotaTextToDisplay;
    }

    let ThisGuestRoomMobileButton = document.querySelectorAll(".ExtraMobileGuestAndRoomChangeButton");
    ThisGuestRoomMobileButton.forEach(ThisButton =>
    {
        ThisButton.onclick = function()
        {
            let PrevData = window.CreateHotelDetailsSnapshot();

            window.InstantiateEditGuestandRoomQuotaMobilePanel(()=>
            {
                window.RoomQuotaNonTop = window.ThisCurrentQuotaInput;

                document.getElementById("RoomQuotaHotelDetailsInput").setAttribute("room-quota", window.ThisCurrentQuotaInput);
                        
                window.CalculateTotalHotelDetails(true);
            }, ()=>
            {
                window.RestoreHotelDetailsSnapshot(PrevData);

            }, false, true, window.CurrentSelectedAccFacilitiesType);
        }
    });

    let HowManyGuestRoomTextMobileText = document.querySelectorAll(".HowManyGuestRoomTextMobile");
    HowManyGuestRoomTextMobileText.forEach(thistext =>
    {
        thistext.innerHTML = RoomQuotaTextToDisplay;
    });

    window.FixedRoomQuota = window.RoomNumberInfo;

    // ------------------------------ SET UBAH KAMAR MOBILE ---------------------------

    let UbahKamarMobileButton = document.querySelectorAll(".UbahKamarMobileButton");
    UbahKamarMobileButton.forEach(thisbutton =>
    {
        let UbahButtonText = thisbutton.querySelector(".UbahKamarMobileButtonText");
        UbahButtonText.innerHTML = window["EditButtonTxt" + window.CurrentCountryID];
    });

    // ------------------------------ TOTAL ACCOMMODATION ------------------------------

    window.LoadSomeSearchInfo(isthissearchmenu, functionontypechange);
}


window.LoadSomeSearchInfo = function(isthissearchmenu, functionontypechange) // Load Basic Info Such as Total Acc and Search Filter
{
    let TotalAccommodationText = document.getElementById("TotalAccommodationText");
    if(TotalAccommodationText == null || window.SlugInfo == null)
        return

    TotalAccommodationText.innerHTML = "-- " + window["AccommodationTxt" + window.CurrentCountryID];

    if(isthissearchmenu == true)
    {
        (async () =>
        {
            // City Region --------------------------------------------

            await window.LoadCityRegionListBasedOnProvince(window.SlugInfo, functionontypechange);

            // Benefits --------------------------------------------

            await window.LoadBenefitListBasedOnProvince(window.SlugInfo, functionontypechange);

            // Categories --------------------------------------------

            await window.LoadCategoriesBasedOnProvince(window.SlugInfo, functionontypechange);

            if(functionontypechange != null)
                functionontypechange();
        })();
    }

    // Load Total Accommodation ----------------------------------

    if(window.SlugInfo != null || window.SearchInfo != null)
        window.LoadTotalAccommodation(window.SlugInfo, window.SearchInfo);
}

// ---------------------------- LOAD CITY REGION ----------------------------

window.LoadCityRegionListBasedOnProvince = async function(provinceslug, functionontypechange)
{
    let AreaFilterMainContainer = document.getElementById("AreaFilterMainContainer");
    let CityRegionFilterURL = "/v2/hotels/province/" + provinceslug + "/city-region";

    try
    {
        const res = await window.CallApiAxios({
            method: "GET",
            url: CityRegionFilterURL,
        });

        console.log(CityRegionFilterURL);

        if (res.status == 200)
        {
            let CityRegionData = res.data.data;
            console.log(CityRegionData);

            window.PrepareCityRegionCheckBox(CityRegionData, functionontypechange);
        }
        else
        {
            AreaFilterMainContainer.style.display = "none";
            window.SetSearchResultToNotFound();
        }
    }
    catch (err)
    {
        console.log(err);
        AreaFilterMainContainer.style.display = "none";
        window.SetSearchResultToNotFound();
    }
}
// ---------------------------- LOAD BENEFITS ----------------------------

window.LoadBenefitListBasedOnProvince = async function(provinceslug, functionontypechange)
{
    let PopularFilterMainContainer = document.getElementById("PopularFilterMainContainer");
    let BenefitsURL = "/v2/hotels/province/" + provinceslug + "/benefits";

    try
    {
        const res = await window.CallApiAxios({
            method: "GET",
            url: BenefitsURL,
        });

        console.log(BenefitsURL);

        if (res.status == 200)
        {
            let BenefitsData = res.data.data;
            console.log(BenefitsData);

            window.PrepareBenefitFilter(BenefitsData, functionontypechange);
        }
        else
        {
            PopularFilterMainContainer.style.display = "none";
        }
    }
    catch (err)
    {
        console.log(err);
        PopularFilterMainContainer.style.display = "none";
    }
}

// ---------------------------- LOAD CATEGORIES ----------------------------

window.LoadCategoriesBasedOnProvince = async function(provinceslug, functionontypechange)
{
    let CategoriesURL = "/v2/hotels/province/" + provinceslug + "/categories";
    let CategoryFilterMainContainer = document.getElementById("CategoryFilterMainContainer");

    try
    {
        const res = await window.CallApiAxios({
            method: "GET",
            url: CategoriesURL,
        });

        console.log(CategoriesURL);

        if (res.status == 200)
        {
            let CategoriesData = res.data.data;
            console.log(CategoriesData);

            window.GetTheCategorySortCheck(CategoriesData, functionontypechange);
        }
        else
        {
            CategoryFilterMainContainer.style.display = "none";
        }
    }
    catch (err)
    {
        console.log(err);
        CategoryFilterMainContainer.style.display = "none";
    }
}

// ---------------------------- LOAD TOTAL ACCOMMODATION ----------------------------

window.LoadTotalAccommodation = function(provinceslug, searchinput)
{
    let ProvinceURL = "/v2/hotels/province/";
    let TotalAccommodationText = document.getElementById("TotalAccommodationText");
    
    window.CallApiAxios({
        method: "GET",
        url: ProvinceURL,
    }).then(res =>
    {
        TotalAccommodationText.innerHTML = "0 " + window["AccommodationTxt" + window.CurrentCountryID];

        if(res.status == 200)
        {
            let ProvinceData = res.data.data;
            console.log(ProvinceData);

            for(let i = 0; i < ProvinceData.length; i++)
            {
                if(ProvinceData[i].province == provinceslug || ProvinceData[i].province_slug == provinceslug
                    || (ProvinceData[i].province == searchinput || ProvinceData[i].province_slug == searchinput))
                {
                    if(ProvinceData[i].jumlah_hotel > 1)
                    {
                        TotalAccommodationText.innerHTML = ProvinceData[i].jumlah_hotel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " " + window["AccommodationTxtex" + window.CurrentCountryID];
                    }
                    else
                    {
                        TotalAccommodationText.innerHTML = ProvinceData[i].jumlah_hotel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " " + window["AccommodationTxt" + window.CurrentCountryID];
                    }
                }
            }
        }
    }) 
    .catch(err =>
    {
        //console.error(err);
    });
}

// ---------------------- ADD FUNCTION WHEN VISIBILITY CHANGE ---------------------------------

window.AddOnVisibilityChangeFunction = function(functioncallafterreload)
{
    window.VisibilityChangeHandler = () =>
    {
        if (!document.hidden && window.wasHidden)
        {
            window.wasHidden = false;
            if (typeof functioncallafterreload === 'function')
            {
                functioncallafterreload();
            }
        }
        else if (document.hidden)
        {
            window.wasHidden = true;
        }
    };

    document.addEventListener("visibilitychange", window.VisibilityChangeHandler);
}


// =================================== FUNCTION THAT SCROLL THE DROP DOWN TO SELECTED =================================

window.ScrollToSelectedDropDown = function(DropDown, Selected)
{
    if (DropDown && Selected)
    {
        const dropdownTop = DropDown.scrollTop;
        const dropdownBottom = dropdownTop + DropDown.clientHeight;

        const selectedTop = Selected.offsetTop;
        const selectedBottom = selectedTop + Selected.offsetHeight;

        DropDown.scrollTop = selectedTop;
        return

        if (selectedTop < dropdownTop)
        {
            DropDown.scrollTop = selectedTop;
        }
        else if (selectedBottom > dropdownBottom)
        {
            DropDown.scrollTop = selectedBottom - DropDown.clientHeight;
        }
    }
}

window.ScrollToWindow = function(whichsectiontogo)
{
    window.scrollTo
    ({
        top: whichsectiontogo.offsetTop,
        behavior: "smooth"
    });
}


// =================================== ANIATE PANEL ======================================

window.CurrentFinalAnimatedPanel = null;

window.AnimatePanelNextTransition = function(currentpanel, nextpanel, isallowchange, functiontocall)
{
    window.CurrentFinalAnimatedPanel = nextpanel;
    if(isallowchange == true)
    {
        window.IsPanelAnimating = true;
    }

    if(currentpanel != null)
    {
        currentpanel.style.opacity = 0;
        currentpanel.style.left = "-15%";
        currentpanel.animate([{opacity: 1, left: "0%"},{opacity: 0, left: "-15%"}], {duration: window.AnimateLeftPanelDuration});
    }

    setTimeout(function()
    {
        if(currentpanel != null)
        {
            currentpanel.style.position = "absolute";
            currentpanel.style.left = "-105%";
            currentpanel.style.display = "hidden";
        }

        nextpanel.style.opacity = 1;
        nextpanel.style.left = "0%";
        nextpanel.style.position = "relative";
        nextpanel.style.display = "";
        nextpanel.animate([{opacity: 0, left: "15%"},{opacity: 1, left: "0%"}], {duration: window.AnimateLeftPanelDuration});

        setTimeout(function()
        {
            if(isallowchange == true)
            {
                window.IsPanelAnimating = false;
            }

            if(functiontocall != null)
            {
                functiontocall();
            }

        }, window.AnimateLeftPanelDuration);
    }, window.AnimateLeftPanelDuration);
}

window.AnimatePanelPreviousTransition = function(currentpanel, previouspanel, isallowchange, functiontocall)
{
    window.CurrentFinalAnimatedPanel = previouspanel;
    if(isallowchange == true)
    {
        window.IsPanelAnimating = true;
    }

    previouspanel.style.display = "";

    if(currentpanel != null)
    {
        currentpanel.style.opacity = 0;
        currentpanel.style.left = "15%";
        currentpanel.animate([{opacity: 1, left: "0%"},{opacity: 0, left: "15%"}], {duration: window.AnimateLeftPanelDuration});
    }

    setTimeout(function()
    {
        if(currentpanel != null)
        {
            currentpanel.style.position = "absolute";
            currentpanel.style.left = "105%";
        }

        previouspanel.style.opacity = 1;
        previouspanel.style.left = "0%";
        previouspanel.style.position = "relative";
        previouspanel.animate([{opacity: 0, left: "-15%"},{opacity: 1, left: "0%"}], {duration: window.AnimateLeftPanelDuration});

        setTimeout(function()
        {
            if(currentpanel != null)
            {
                currentpanel.style.display = "none";
            }

            if(isallowchange == true)
            {
                window.IsPanelAnimating = false;
            }
            
            if(functiontocall != null)
            {
                functiontocall();
            }

        }, window.AnimateLeftPanelDuration);

    }, window.AnimateLeftPanelDuration);
}

window.AnimateOnlyOpacityDisplay = function(thispanel, isdissapear, functiontocall)
{
    if(isdissapear == true)
    {
        thispanel.style.opacity = 0;
        thispanel.animate([{opacity: 1},{opacity: 0}], {duration: window.AnimateLeftPanelDuration});
    }
    else
    {
        thispanel.style.opacity = 1;
        thispanel.animate([{opacity: 0},{opacity: 1}], {duration: window.AnimateLeftPanelDuration});
    }

    setTimeout(function()
    {
        if(functiontocall != null)
        {
            functiontocall();
        }
    }, window.AnimateLeftPanelDuration);
}


// ==================================== PREPARE SHARE HOTEL BOOKING OR REFFERRAL ====================================

window.MessageWAToDisplay = null;
window.ShareURL = null;
window.CheckShareImageData = null;

window.CheckBookingImageExist = function(bookref, loggedin)
{
    let CheckBookingImgURL = "/v2/share/booking/" + bookref + "/check-share-img";
    let FunctionToCall = ()=>
    {
        window.InstantiateSharePanel(window["ShareThisPingTxt" + window.CurrentCountryID], window["ShareThisPingTxt2" + window.CurrentCountryID], window["ShareBookingSuccessTxt" + window.CurrentCountryID], "Booking", bookref, window.CheckInDateNonTop, window.CheckOutDateNonTop, loggedin);
    }

    window.CallApiAxios({
        method: "GET",
        url: CheckBookingImgURL,
    }).then(res =>
    {
        let CheckBookingImgData = res.data.data;

        console.log(CheckBookingImgURL + " =============");
        console.log(CheckBookingImgData);

        FunctionToCall();
    })
    .catch(err =>
    {
        //console.error(err);

        if(err.data.message == "Share image link not found")
        {
            let formData = new FormData();
            formData.append('ref', bookref);

            window.CreateImageShareTemp("BookingDetails", window.HotelPhotoList[0].hotel_photo, "/v2/share/booking/" + bookref + "/upload-share-img", formData, FunctionToCall);
        }
        else if(err.data.message == "Share image link not found")
        {
            window.CheckBookingImageExist(bookref, loggedin);
        }
        else if(err.data.message == "Hotel not found")
        {
            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["HotelNotActiveTxt" + window.CurrentCountryID]);
        }
        else
        {
            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["ErrorWhenPrepareShareInfo" + window.CurrentCountryID]);
        }
    });
}

window.CheckHotelImageExist = function(hotelphoto, hotelid, loggedin)
{
    let CheckShareHotelImgURL = "/v2/share/hotel/" + hotelid + "/check-share-img";
    let FunctionToCall = ()=>
    {
        window.InstantiateSharePanel(window["ShareAccommodationTxt" + window.CurrentCountryID], window["ShareThisAccommodationTxt2" + window.CurrentCountryID], window["ShareAccommodationSuccessTxt" + window.CurrentCountryID], "Accommodation", hotelid, window.CheckInDateNonTop, window.CheckOutDateNonTop, loggedin);
    }

    window.CallApiAxios({
        method: "GET",
        url: CheckShareHotelImgURL,
    }).then(res =>
    {
        let CheckHotelImgData = res.data.data;

        console.log(CheckShareHotelImgURL + " =============");
        console.log(CheckHotelImgData);

        FunctionToCall();
    })
    .catch(err =>
    {
        //console.error(err);

        if(err.data.message == "Share image link not found")
        {
            let formData = new FormData();
            formData.append('id_hotel', hotelid);

            window.CreateImageShareTemp("Hotel", hotelphoto, "/v2/share/hotel/" + hotelid + "/upload-share-img", formData, FunctionToCall);
        }
        else if(err.data.message == "Share image link not found")
        {
            window.CheckHotelImageExist(hotelphoto, hotelid, loggedin);
        }
        else if(err.data.message == "Hotel not found")
        {
            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["HotelNotActiveTxt" + window.CurrentCountryID]);
        }
        else
        {
            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["ErrorWhenPrepareShareInfo" + window.CurrentCountryID]);
        }
    });
}

window.CheckNCreateShareBooking = function(bookingid, roomphoto, hotelprovince, loggedin)
{
    let LoadingBlocker = window.InstantiateLoadingBlocker("CheckNShareBookingBlocker");

    LoadingBlocker.remove();
    alert("Not Yet Developed, Please Come Again Soon");
    return

    let InfoArray = localStorage.getItem("DTN").split(" - ");

    // -------------------------------- BOOKING DETAILS ----------------------------------

    let URLBookingDetails = "/function/booking_details.php?id_user=" + atob(InfoArray[6]) + "&id_booking=" + bookingid;
    console.log(URLBookingDetails);
    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    window.$.ajax({
        type     : "GET",
        cache    : false,
        url      : URLBookingDetails,

        success  : function(data)
        {
            let BookingDetailsData = window.ConvertDataJSON(data)[0];
            console.log(BookingDetailsData);

            LoadingBlocker.remove();

            if(BookingDetailsData.data_hotel_booking == null && BookingDetailsData.hotel_name == null)
            {
                return;
            }

            // Check In and Out ------------------

            let ThisCheckInArray = BookingDetailsData.date_checkin.split("-");
            let ThisCheckOutArray = BookingDetailsData.date_checkout.split("-");

            let CheckInInputDate = ThisCheckInArray[2] + "-" + ThisCheckInArray[1] + "-" + ThisCheckInArray[0];
            let CheckOutInputDate = ThisCheckOutArray[2] + "-" + ThisCheckOutArray[1] + "-" + ThisCheckOutArray[0];

            // Prepare For Panel Instantiate Info ------------------

            let FunctionToCall = ()=>
            {
                window.InstantiateSharePanel("Share Accommodation", "Share this Accommodation", "Share Accommodation Success", "Booking", BookingDetailsData.id_hotel, CheckInInputDate, CheckOutInputDate, loggedin);
            }

            let CheckURLGET = "/function/check_share_img_booking.php?id_booking=" + bookingid;
            let PushCreatedShareURL = "/function/upload_booking_share_img.php";

            window.ShareURL = bookingid + "=" + hotelprovince;

            let formData = new FormData();
            formData.append('id_booking', bookingid);

            window.CheckShareImageExist(CheckURLGET, roomphoto, PushCreatedShareURL, "Booking", formData, FunctionToCall);
        },
        error: function (error)
        {
            LoadingBlocker.remove();
            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["ErrorWhenPrepareShareInfo" + window.CurrentCountryID]);
        }
    });
}


window.CheckShareImageExist = function(CheckURLGET, roomphoto, PushCreatedShareURL, whichtype, formData, functiontocall)
{
    let LoadingBlocker = window.InstantiateLoadingBlocker("CheckShareImageBlocker");
    console.log(CheckURLGET);

    // Early Setup ----------------------------------------------

    let LastShareCode = "L=" + window.ShareURL;
    if(window.location.hostname == "beta.pingingo.com" || window.location.pathname === "/new_beta" || window.location.hostname === "test.pingingo.com")
    {
        LastShareCode = "B=" + window.ShareURL;
    }

    // Call Checking --------------------------------------------

    LoadingBlocker.remove();
    alert("Not Yet Developed, Please Come Again Soon");

    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    // window.CallApiAxios({
    //     method: "GET",
    //     url: ProfileUserURL,
    // })
    // .then(res =>
    // {
    //     console.log(ProfileUserURL);
    //     console.log(res);

    //     if(res.status == 200)
    //     {
    //         window.CheckShareImageData = window.ConvertDataJSON(data);
    //         if(window.CheckShareImageData[0] != null)
    //             window.CheckShareImageData = window.CheckShareImageData[0];

    //         console.log(window.CheckShareImageData);

    //         LoadingBlocker.remove();

    //         let ThisShareLinkCheck = window.CheckShareImageData.share_img_link;

    //         // ------------------------------------------------------

    //         if(whichtype == "Booking" || whichtype == "Accommodation")
    //         {
    //             window.ShareURL = "https://link.pingingo.com?info=" + btoa("BS=" + LastShareCode);

    //             if(whichtype == "Booking")
    //             {
    //                 window.MessageWAToDisplay = 'Halo Ping Friends!%0aCoba cek salah satu hidden gem di ' + window.HotelDetails.city_region + ".%0a%0a *" +  window.HotelDetails.hotel_name  + '*%0a%0aTempat menginap terbaik untuk kamu yang suka keindahan alam dan hidden gem.%0a%0aMasukan Kode Referral *' + window.CheckShareImageData.booking[0].referral_code + "* saat inging melakukan booking.%0a%0a"+ encodeURIComponent(window.ShareURL);
    //             }
    //             else
    //             {
    //                 window.MessageWAToDisplay = 'Halo!%0aCoba cek salah satu hidden gem di ' + window.HotelDetails.city_region + ".%0a%0a *" +  window.HotelDetails.hotel_name  + '*%0a%0aTempat menginap terbaik untuk kamu yang suka keindahan alam dan hidden gem.%0a%0a'+ encodeURIComponent(window.ShareURL);
    //             }
    //         }
    //         else
    //         {
    //             ThisShareLinkCheck = window.CheckShareImageData.referral_img_link;
    //             window.ShareURL = "https://link.pingingo.com?info=" + btoa("REF=" + LastShareCode);
    //             window.MessageWAToDisplay = 'Halo!%0aLiburan dengan PinginGo yuk.%0aDaftar dan temukan glamping, cottage, resort, dan villa hidden gem di Indonesia dengan mudah dan menyenangkan di PinginGo.%0a%0aMasukan Kode Referral *'+ window.CheckShareImageData.referral_code + '* saat ingin melakukan booking%0a%0a' +encodeURIComponent('#Ping&Share')+'%0a'+ encodeURIComponent(window.ShareURL);
    //         }

    //         // ------------------------------------------------------

    //         let ThisTest = false;

    //         if(ThisShareLinkCheck == null || ThisTest == true)
    //         {
    //             window.CreateImageShareTemp(whichtype, roomphoto, PushCreatedShareURL, formData, ()=>functiontocall())
    //         }
    //         else
    //         {
    //             functiontocall();
    //         }
    //     }
    // })
    // .catch(err =>
    // {
    //     //console.error(err);
    //     LoadUserTopBlocker.remove();
    //     window.LogOutUserFunction(thisuserdata.usd_PING_tkn, false);
    // });
}


window.CreateImageShareTemp = function(whattype, photofortemp, PushCreatedShareURL, formupload, functiontocall)
{
    let LoadingBlocker = window.InstantiateLoadingBlocker("CreateShareImageBlocker");

    // Generate The Temp Image -------------------------------------------------------------------

    let ReferallImageContent = window.GenerateTheImageTemplate(whattype, photofortemp, formupload);
    
    // Convert The Temp Image  ----------------------------------------------------------------------------

    html2canvas(ReferallImageContent).then(canvas =>
    {
        let imageData = canvas.toDataURL("image/jpg");
        let newData = imageData.replace(/^data:image\/jpg/, "data:application/octet-stream");

        fetch(newData)
        .then(res => res.blob())
        .then(function(data)
        {
            console.log(data);

            let fileName = 'referallimage.jpg'
            let file = new File([data], fileName,{type:"image/jpg", lastModified:new Date().getTime()}, 'utf-8');

            let container = new DataTransfer();
            container.items.add(file);

            let InputFile = document.createElement('input');
            InputFile.type="file";
            InputFile.files = container.files;

            ReferallImageContent.remove(); // Remove Created Image -------------------

            // Upload Share Image Form ------------------------------------------------

            formupload.append('image', InputFile.files[0]);

            window.CallApiAxios({
                method: "POST",
                url: PushCreatedShareURL,
                data: formupload,
                convertFormData: false
            }).then(res =>
            {
                console.log(res);
                LoadingBlocker.remove();

                if(res.data.data.status_save_img == "Berhasil mengunggah gambar")
                {
                    functiontocall();
                }
                else
                {
                    window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["ErrorWhenPrepareShareInfo" + window.CurrentCountryID]);
                }
            })
            .catch(err =>
            {
                //console.error(err);
                LoadingBlocker.remove();
                window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["ErrorWhenPrepareShareInfo" + window.CurrentCountryID]);
            });
        }
    )});
}

window.GenerateTheImageTemplate = function(whattype, photofortemp, formupload)
{
    let ReferallImageContent = document.createElement("div");
    ReferallImageContent.id = "ReferallImageContent";
    document.getElementsByTagName("body")[0].append(ReferallImageContent);

    let PinginGoReferImg = document.createElement("img");
    PinginGoReferImg.className = "ImageFullCover";
    PinginGoReferImg.src = photofortemp;
    PinginGoReferImg.onerror = function()
    {
        PinginGoReferImg.src = "/Assets/AnimateBG/2.jpg";
    }
    ReferallImageContent.append(PinginGoReferImg);

    if(whattype == "UserReferral")
    {
        let PinginGoReferTextContainer = document.createElement("div");
        PinginGoReferTextContainer.className = "PinginGoReferTextContainer";
        ReferallImageContent.append(PinginGoReferTextContainer);

        let PinginGoReferText = document.createElement("p");
        PinginGoReferText.className = "PinginGoReferText";
        PinginGoReferText.innerHTML = formupload.get("id_referral");
        PinginGoReferTextContainer.append(PinginGoReferText);
    }
    else
    {
        let PingShareImageBlackGradient = document.createElement("img");
        PingShareImageBlackGradient.className = "PingShareImageBlackGradient";
        PingShareImageBlackGradient.src = "/Assets/images/BlackPingShare.png";
        ReferallImageContent.append(PingShareImageBlackGradient);

        let PingShareTagImg = document.createElement("img");
        PingShareTagImg.className = "PingShareTagImg";
        PingShareTagImg.src = "/Assets/images/Icon/pingShareTag.svg";
        ReferallImageContent.append(PingShareTagImg);

        let PingSharePinginGoLogo = document.createElement("img");
        PingSharePinginGoLogo.className = "PingSharePinginGoLogo";
        PingSharePinginGoLogo.src = "/Assets/images/Icon/pingingo-icon.svg";
        ReferallImageContent.append(PingSharePinginGoLogo);

        if(whattype == "BookingDetails")
        {
            // let LowestMoney = parseInt(window.CheckShareImageData.booking[0].min_price);

            let PingSharePriceContainer = document.createElement("div");
            PingSharePriceContainer.className = "PingSharePriceContainer";
            ReferallImageContent.append(PingSharePriceContainer);

            let PingSharePriceText = document.createElement("p");
            PingSharePriceText.className = "InterBoldTextFont";
            PingSharePriceText.innerHTML = window.BookingDetailsData.order_code;
            // PingSharePriceText.innerHTML = window.ConvertTextToRP(LowestMoney, 1, true, false);
            PingSharePriceContainer.append(PingSharePriceText);
        }
    }

    return ReferallImageContent;
}

// ==================================== INSTANTIATE SHARE PANEL ====================================

window.InstantiateSharePanel = function(headertext, buttonmaintext, successmessage, whattype, hotelid, CheckInInputDate, CheckOutInputDate, loggedin)
{
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.body.append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel";
    BasicBlackBlocker.append(FlexFullDisplayPanel);

    // --------------------------------- SHARE BOOKING ------------------------------------

    let ShareBookingWrapper = document.createElement("div");
    ShareBookingWrapper.className = "FlexContainerBaseAnimate SignInMainFlexWrapper";
    ShareBookingWrapper.id = "ShareBookingWrapper";
    FlexFullDisplayPanel.append(ShareBookingWrapper);

    let headerSection = document.createElement("div");
    headerSection.style.width = "100%";
    headerSection.style.height = "fit-content";
    headerSection.style.display = "flex";
    ShareBookingWrapper.append(headerSection);

    let headerText = document.createElement("p");
    headerText.className = "RoomHotelNameInsidePanel InterBoldTextFont";
    headerText.textContent = headertext;
    headerSection.append(headerText);

    let closeIcon = document.createElement("img");
    closeIcon.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    closeIcon.className = "CloseButtonInsidePanel Selectable2";
    closeIcon.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    headerSection.append(closeIcon);

    let warningContainer = document.createElement("div");
    warningContainer.className = "BasicRadius MarginTextUpDown RedWarningContainer InterMediumTextFont";
    warningContainer.style.display = "none";
    ShareBookingWrapper.append(warningContainer);

    let warningText = document.createElement("p");
    warningText.className = "InterMediumTextFont";
    warningText.textContent = "Invalid Email Format";
    warningContainer.append(warningText);

    let inputWrapper = document.createElement("div");
    inputWrapper.className = "BasicHeaderAndInputWrapper";
    ShareBookingWrapper.append(inputWrapper);

    let inputLabel = document.createElement("p");
    inputLabel.className = "InputFieldHeaderText InterMediumTextFont";
    inputLabel.textContent = "Email Address";
    inputWrapper.append(inputLabel);

    let inputContainer = document.createElement("div");
    inputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
    inputContainer.style.width = "100%";
    inputContainer.style.minWidth = "100%";
    inputContainer.style.marginBottom = "0";
    inputWrapper.append(inputContainer);

    let inputIcon = document.createElement("img");
    inputIcon.src = "/Assets/images/ButtonIcon/mail-grey.svg";
    inputIcon.className = "BasicIconInsideInput";
    inputIcon.style.marginRight = "0";
    inputContainer.append(inputIcon);

    let emailInput = document.createElement("input");
    emailInput.type = "email";
    emailInput.placeholder = window["InputEmailPlaceholder" + window.CurrentCountryID];
    emailInput.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    emailInput.style.outline = "0";
    inputContainer.append(emailInput);


    let shareButton = document.createElement("button"); // Share Button --------------------
    shareButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    shareButton.style.margin = "0";
    shareButton.style.width = "100%";
    shareButton.textContent = buttonmaintext;
    ShareBookingWrapper.append(shareButton);


    let orText = document.createElement("p");
    orText.className = "DescriptionTextNotDisableable MarginTextUpDown InterItalicTextFont";
    orText.style.color = "#475467";
    orText.style.marginLeft = "auto";
    orText.style.marginRight = "auto";
    orText.textContent = "Or";
    ShareBookingWrapper.append(orText);


    let whatsappButton = document.createElement("button"); // Share WhatsApp ------------------
    whatsappButton.className = "BasicTextButton BasicBoxShadow GreenBorderGreenTextButton SignInButtonTop Selectable";
    whatsappButton.style.margin = "0";
    whatsappButton.style.width = "100%";
    whatsappButton.onclick = function()
    {
        window.open('https://api.whatsapp.com/send?text=' + window.MessageWAToDisplay, "_blank",);
    }
    ShareBookingWrapper.append(whatsappButton);

    let whatsappButtonInner = document.createElement("div");
    whatsappButtonInner.style.width = "fit-content";
    whatsappButtonInner.style.height = "fit-content";
    whatsappButtonInner.style.display = "flex";
    whatsappButtonInner.style.margin = "auto";
    whatsappButton.append(whatsappButtonInner);

    let whatsappIcon = document.createElement("img");
    whatsappIcon.src = "/Assets/images/ButtonIcon/announcement-green-loudspeaker.svg";
    whatsappIcon.className = "BasicIconInsideButton";
    whatsappIcon.style.marginLeft = "0";
    whatsappButtonInner.append(whatsappIcon);

    let whatsappText = document.createElement("p");
    whatsappText.textContent = "Share to WhatsApp";
    whatsappButtonInner.append(whatsappText);


    // --------------------------------- SUCCESS ------------------------------------

    let FinalConfirmationWrapper = document.createElement("div");
    FinalConfirmationWrapper.className = "FlexContainerBaseAnimate FinalConfirmationWrapper";
    FinalConfirmationWrapper.id = "YourAccountSuccessWrapper";
    FinalConfirmationWrapper.style.display = "none";
    FlexFullDisplayPanel.append(FinalConfirmationWrapper);

    let topBar = document.createElement("div");
    topBar.style.width = "100%";
    topBar.style.height = "fit-content";
    topBar.style.display = "flex";
    FinalConfirmationWrapper.append(topBar);

    let closeBtn = document.createElement("img");
    closeBtn.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    closeBtn.className = "CloseButtonInsidePanel Selectable2";
    closeBtn.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    topBar.append(closeBtn);

    let checkIcon = document.createElement("img");
    checkIcon.src = "/Assets/images/Icon/check-grey-circle.svg";
    checkIcon.className = "CheckSuccessGreenCircle";
    FinalConfirmationWrapper.append(checkIcon);

    let successText = document.createElement("p");
    successText.className = "RoomHotelNameInsidePanel MarginTextUpDown InterBoldTextFont";
    successText.textContent = successmessage;
    successText.style.width = "fit-content";
    successText.style.margin = "0 auto";
    successText.style.textAlign = "center";
    FinalConfirmationWrapper.append(successText);

    let doneButton = document.createElement("button");
    doneButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable InputFieldMarginBoth";
    doneButton.textContent = "Done";
    doneButton.style.marginLeft = "auto";
    doneButton.style.marginRight = "auto";
    doneButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    FinalConfirmationWrapper.append(doneButton);

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);

    // Onclick On Share By Email -------------------------------------------------------

    shareButton.onclick = function()
    {
        let ValueInputted = emailInput.value;

        if(window.CheckEmailValidity(ValueInputted) == false) // Check Email Validity -----------------
        {
            warningContainer.style.display = "";
            warningText.innerHTML = window["InvalidEmailFormatMes" + window.CurrentCountryID];
        }
        else if(loggedin == false)
        {
            warningContainer.style.display = "";
            warningText.innerHTML = window["YouNeedToLogiTxt" + window.CurrentCountryID];
        }
        else // Start Sharing -----------------
        {
            let LoadingBlocker = window.InstantiateLoadingBlocker("ShareHotelEmailBlocker");
            LoadingBlocker.remove();
            alert("Not Yet Developed, Please Come Again Soon");

            return

            let InfoArray = localStorage.getItem("DTN").split(" - ");
            let GETURLShare = "/function/share_join_email.php?id_user=" + atob(InfoArray[6]) + "&to_email=" + ValueInputted;

            if(whattype == "Accommodation" || whattype == "Booking")
            {
                GETURLShare = "/function/share_hotel_email.php?id_user=" + atob(InfoArray[6]) + "&to_email=" + ValueInputted + "&id_hotel=" + hotelid + "&date_checkin=" + CheckInInputDate+ "&date_checkout=" + CheckOutInputDate;
            }
            console.log(GETURLShare);
            //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            window.$.ajax({
                type     : "GET",
                cache    : false,
                url      : GETURLShare,

                success  : function(data)
                {
                    let ShareDataResult = window.ConvertDataJSON(data);
                    console.log(ShareDataResult);
                    LoadingBlocker.remove();

                    if(ShareDataResult.status_send == "Email berhasil terkirim")
                    {
                        window.AnimatePanelNextTransition(ShareBookingWrapper, FinalConfirmationWrapper, true, null);
                    }
                    else if(ShareDataResult.status_send == "Email ini sudah mendaftar!")
                    {
                        warningContainer.style.display = "";
                        warningText.innerHTML = window["EmailAlreadyRegisteredTxt" + window.CurrentCountryID];
                    }
                    else
                    {
                        warningContainer.style.display = "";
                        warningText.innerHTML = window["ErrorWhenSendEmailTxt" + window.CurrentCountryID];
                    }
                },
                error: function (error)
                {
                    console.log(error);
                    LoadingBlocker.remove();
                }
            });
        }
    }
}


// ============================ TO HIDE AND DISPLAY FULL DETAIL PAYMENT AND BOOKING DETAILS ============================

window.HideandDisplayPaymentDetails = function(ishide)
{
    let PriceContainers = document.querySelectorAll('.ThisPriceContainerToHideShow');
    PriceContainers.forEach(ThisContainer =>
    {
        if(ishide == true)
        {
            ThisContainer.classList.remove("ShowDetailsPriceON");
            ThisContainer.classList.add("ShowDetailsPriceOFF");
        }
        else
        {
            ThisContainer.classList.remove("ShowDetailsPriceOFF");
            ThisContainer.classList.add("ShowDetailsPriceON");
        }
    });
}


//========================================= GET IMAGE URL =====================================

window.getImgURL = function(url, callback)
{
    let xhr = new XMLHttpRequest();
    xhr.onload = function() {
        callback(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}

// ========================================= COPY TO CLIP BOARD =====================================

window.CopyToClipboardItem = function(whattocopy)
{
    window.DisplayWarningPopUp("WarningCopySuccess", window["CopyClipboardSuccessTxt" + window.CurrentCountryID]);
    navigator.clipboard.writeText(whattocopy);
}

// ========================================= ALLOW ONLY INPUT/ ONLY NUMBER  ======================================

window.CheckInputAllowed = function(input, pattern)
{
    let allowedRegex = new RegExp("^[" + pattern + "]*$");
    if (!allowedRegex.test(input.value))
    {
        let cleanRegex = new RegExp("[^" + pattern + "]", "g");
        input.value = input.value.replace(cleanRegex, '');
    }
}

window.UnallowInputNonNumber = function(ThisInputField) // Set Only Number Inputted
{
    ThisInputField.addEventListener('beforeinput', e =>
    {
        if (!(Number(e.data) >= 0 && Number(e.data) <= 9) && ThisInputField.type == "number")
        {
          e.preventDefault();
        }
    });
}

// ====================================== MAINTENANCE ====================================

window.IsMaintenanceNow = false;

window.AllowedIDLive = [16, 542, 17, 1];
window.AllowedIDBeta = [27, 1, 92, 63, 29];

window.CheckAvailableToAccessMaintenance = function(BasicInfoSession, loggedin)
{
    let Allowed = true;

    if(window.IsMaintenanceNow == true)
    {
        Allowed = false;

        if(loggedin == true)
        {
            let WhichIDToCheck = window.AllowedIDLive;

            if(window.location.hostname == "beta.pingingo.com" || window.location.pathname.includes("/new_beta") == true || window.location.hostname == "test.pingingo.com")
                WhichIDToCheck = window.AllowedIDBeta;

            WhichIDToCheck.forEach(thisid =>
            {
                if(BasicInfoSession.no == thisid)
                {
                    Allowed = true;
                }
            });
        }
    }

    return Allowed;
}

window.DisplayMaintenance = function()
{
    document.getElementsByTagName("body")[0].style.pointerEvents = "none";

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let MaintenanceMainParent = document.createElement("div");
    MaintenanceMainParent.className = "MaintenanceMainParent";
    BasicBlackBlocker.append(MaintenanceMainParent);

    let MainTopButtonWrapper = document.createElement("div");
    MainTopButtonWrapper.className = "MainTopButtonWrapper TopCornerButtonContainerScrolled";
    // MainTopButtonWrapper.style.boxShadow = "0 0 0";
    MainTopButtonWrapper.style.backgroundColor = "#FFFFFFB2";
    MaintenanceMainParent.append(MainTopButtonWrapper);

    let TopMenuPanel = document.createElement("div");
    TopMenuPanel.className = "TopMenuPanel";
    MainTopButtonWrapper.append(TopMenuPanel);

    let TopBackgroundThatWillChange = document.createElement("div");
    TopBackgroundThatWillChange.className = "TopBackgroundThatWillChange";
    TopMenuPanel.append(TopBackgroundThatWillChange);

    // Top Bar
    let TopMenuSectionWrapper = document.createElement("div");
    TopMenuSectionWrapper.className = "TopMenuSectionWrapper";
    TopMenuSectionWrapper.style.display = "flex";
    TopMenuPanel.append(TopMenuSectionWrapper);

    let PinginGoLogo = document.createElement("img");
    PinginGoLogo.src = "/Assets/images/Icon/pingingo-icon.svg";
    PinginGoLogo.className = "PinginGoLogo";
    TopMenuSectionWrapper.append(PinginGoLogo);

    // Main Content
    let MaintenanceContentWrapper = document.createElement("div");
    MaintenanceContentWrapper.className = "MaintenanceContentWrapper";
    MaintenanceMainParent.append(MaintenanceContentWrapper);

    let MaintenanceTextWrapper = document.createElement("div"); // Text Content
    MaintenanceTextWrapper.className = "MaintenanceTextWrapper";
    MaintenanceContentWrapper.append(MaintenanceTextWrapper);

    let SorryWeAreP = document.createElement("p");
    SorryWeAreP.className = "SectionHeaderTextIndex2 InterMediumTextFont";
    SorryWeAreP.style.color = "#344054";
    SorryWeAreP.textContent = "Sorry, We're";
    MaintenanceTextWrapper.append(SorryWeAreP);

    let UnderMaintenanceP = document.createElement("p");
    UnderMaintenanceP.className = "PaymentSectionHeaderText2 InterBoldTextFont";
    UnderMaintenanceP.style.color = "#ED7C42";
    UnderMaintenanceP.textContent = "Under Maintenances";
    MaintenanceTextWrapper.append(UnderMaintenanceP);

    let TakingAShortBreakToRef = document.createElement("p");
    TakingAShortBreakToRef.className = "LabelGreyHeaderText InterRegularTextFont";
    TakingAShortBreakToRef.style.color = "#667085";
    TakingAShortBreakToRef.innerHTML = `Taking a short break to refresh 🌱We're fine-tuning everything to make your travel experience even smoother and more exciting!<br><br>Stay tuned — we'll be back soon so you can #Ping again 🌍`;
    MaintenanceTextWrapper.append(TakingAShortBreakToRef);

    // Maintenance image
    let MaintenanceIMG = document.createElement("img");
    MaintenanceIMG.src = "/Assets/images/Icon/maintenance-icon.png";
    MaintenanceIMG.className = "MaintenanceIMG";
    MaintenanceContentWrapper.append(MaintenanceIMG);
}


// ================================= PROVINCE AND CITY REGION ===============================

window.InstantiateProvinceDropDown = function(provincedata, WhereToInstantiate, provincetextdisplay, provincechevronid, cityregioncontainer, cityregiontextdisplay, cityregionchevronid, functiontocall)
{
    window.RotateToggle(provincechevronid, true);
    

    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown("ProvinceDropDownContainer" + provincechevronid, WhereToInstantiate);

    if(ThisDropDownContainer == null)
        return

    ThisDropDownContainer.style.bottom = 0;
    ThisDropDownContainer.className = "ContainerFlex";
    ThisDropDownContainer.innerHTML = "";

    // Prepare Which Scroll Start ------------------------------------------------------------------

    let WhichProvinceSelected = WhereToInstantiate.getAttribute("which-province");
    let ScrollToDropDown;

    // Drop Down ------------------------------------------------------------------

    let DropDownContainer = document.createElement("div");
    DropDownContainer.className = "DropDownContainer HideScrollBar";
    ThisDropDownContainer.append(DropDownContainer);

    for(let i = 0; i < provincedata.length; i++)
    {
        let ProvinceDropDownButton = document.createElement("div");
        ProvinceDropDownButton.className = "DropDownSelectionContainer DropDownWithStatus";
        ProvinceDropDownButton.onclick = function(event)
        {
            event.preventDefault();
            event.stopPropagation();

            window.RotateToggle("", true);

            ThisDropDownContainer.remove();

            WhereToInstantiate.setAttribute("which-province", provincedata[i].id);
            WhereToInstantiate.setAttribute("which-name", provincedata[i].name);
            provincetextdisplay.innerHTML = provincedata[i].text_display[window.CurrentCountryID];

            if(provincedata[i].id == "")
            {
                cityregioncontainer.className = "SmallPanelDropDownContainer InputFieldContainerInvalid";
            }
            else
            {
                cityregioncontainer.className = "SmallPanelDropDownContainer";
            }

            cityregioncontainer.setAttribute("which-city-region", "");
            cityregioncontainer.setAttribute("which-name", "");
            cityregiontextdisplay.innerHTML = "-------";

            if(functiontocall != null)
            {
                functiontocall();
            }
        }
        DropDownContainer.append(ProvinceDropDownButton);

        let ProvinceDropDownButtonText = document.createElement("p");
        ProvinceDropDownButtonText.className = "DropDownSelectionText";
        ProvinceDropDownButtonText.innerHTML = provincedata[i].text_display[window.CurrentCountryID];
        ProvinceDropDownButton.append(ProvinceDropDownButtonText);


        // Get Information For Basic Scroll Start
        if(WhichProvinceSelected == provincedata[i].id)
        {
            ScrollToDropDown = ProvinceDropDownButton;
            ProvinceDropDownButton.classList.add("DropDownSelectionContainerSelected");
        }
    }

    window.ScrollToSelectedDropDown(DropDownContainer, ScrollToDropDown);
}

window.InstantiateCityRegionDropDown = function(provincedropdown, cityregioncontainer, cityregiontextdisplay, cityregionchevronid, functiontocall)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    window.RotateToggle(cityregionchevronid, true);

    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown("CityRegionDropDownContainer" + cityregionchevronid, cityregioncontainer);

    if(ThisDropDownContainer == null)
        return

    ThisDropDownContainer.style.bottom = 0;
    ThisDropDownContainer.className = "ContainerFlex";
    ThisDropDownContainer.innerHTML = "";

    
    // Prepare Which Scroll Start ------------------------------------------------------------------

    let WhichProvinceSelected = provincedropdown.getAttribute("which-province");
    let WhichCityRegionSelected = cityregioncontainer.getAttribute("which-city-region");
    let ScrollToDropDown;

    // Drop Down ------------------------------------------------------------------

    let DropDownContainer = document.createElement("div");
    DropDownContainer.className = "DropDownContainer HideScrollBar";
    ThisDropDownContainer.append(DropDownContainer);


    // Loading Temp -----------------------------------------------

    let WidthList = ["55%", "50%", "40%"];

    for(let i = 0; i < WidthList.length; i++)
    {
        let ThisDataButton = document.createElement("div");
        ThisDataButton.className = "DropDownSelectionContainer DropDownWithStatus";
        ThisDataButton.style.pointerEvents = "none";
        DropDownContainer.append(ThisDataButton);

        let ThisDataButtonLoading = document.createElement("div");
        ThisDataButtonLoading.className = "loading_grey NameofHotelPopularAreaLoadGrey";
        ThisDataButtonLoading.style.margin = "auto 0";
        ThisDataButtonLoading.style.width = WidthList[i];
        ThisDataButton.append(ThisDataButtonLoading);
    }

    // Load City Region and Instantiate Drop Down -----------------------------------------------

    fetch('wilayah-indonesia/city-region/' + WhichProvinceSelected + '.json')
    .then((response) => response.json())
    .then(function(data)
    {
        let CityRegionData = data;
        console.log(CityRegionData);

        DropDownContainer.innerHTML = "";

        for(let i = 0; i < CityRegionData.length; i++)
        {
            let ProvinceDropDownButton = document.createElement("div");
            ProvinceDropDownButton.className = "DropDownSelectionContainer DropDownWithStatus";
            ProvinceDropDownButton.onclick = function(event)
            {
                event.preventDefault();
                event.stopPropagation();

                window.RotateToggle("", true);

                ThisDropDownContainer.remove();

                cityregioncontainer.setAttribute("which-city-region", CityRegionData[i].id);
                cityregioncontainer.setAttribute("which-name", CityRegionData[i].name);
                cityregiontextdisplay.innerHTML = CityRegionData[i].text_display[window.CurrentCountryID];

                if(functiontocall != null)
                {
                    functiontocall();
                }
            }
            DropDownContainer.append(ProvinceDropDownButton);

            let ProvinceDropDownButtonText = document.createElement("p");
            ProvinceDropDownButtonText.className = "DropDownSelectionText";
            ProvinceDropDownButtonText.innerHTML = CityRegionData[i].text_display[window.CurrentCountryID];
            ProvinceDropDownButton.append(ProvinceDropDownButtonText);

            // Get Information For Basic Scroll Start
            if(WhichCityRegionSelected == CityRegionData[i].id)
            {
                ScrollToDropDown = ProvinceDropDownButton;
                ProvinceDropDownButton.classList.add("DropDownSelectionContainerSelected");
            }
        }

        window.ScrollToSelectedDropDown(DropDownContainer, ScrollToDropDown);
    });
}

// ======================================== GENDER ==================================

window.InstatiateGenderDropDown = function(WhereToInstantiate, textdisplayer, dropdownchevronid, functiontocall)
{
    window.RotateToggle(dropdownchevronid, true);


    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown("GenderDropDown" + dropdownchevronid, WhereToInstantiate);

    if(ThisDropDownContainer == null)
        return

    ThisDropDownContainer.style.bottom = 0;
    ThisDropDownContainer.className = "ContainerFlex";
    ThisDropDownContainer.innerHTML = "";

    // Prepare Which Scroll Start ------------------------------------------------------------------

    let WhichGenderSelected = WhereToInstantiate.getAttribute("which-gender");
    let ScrollToDropDown;
        
    // Drop Down ------------------------------------------------------------------

    let DropDownContainer = document.createElement("div");
    DropDownContainer.className = "DropDownContainer HideScrollBar";
    ThisDropDownContainer.append(DropDownContainer);

    for(let i = 0; i < window.GenderChoicesJSON.length; i++)
    {
        let GenderDropDownButton = document.createElement("div");
        GenderDropDownButton.className = "DropDownSelectionContainer DropDownWithStatus";
        GenderDropDownButton.onclick = function(event)
        {
            event.preventDefault();
            event.stopPropagation();

            window.RotateToggle("", true);

            ThisDropDownContainer.remove();

            WhereToInstantiate.setAttribute("which-gender", window.GenderChoicesJSON[i].which_type);
            textdisplayer.innerHTML = window[window.GenderChoicesJSON[i].translation + window.CurrentCountryID];

            if(functiontocall != null)
            {
                functiontocall();
            }
        }
        DropDownContainer.append(GenderDropDownButton);

        let GenderDropDownButtonText = document.createElement("p");
        GenderDropDownButtonText.className = "DropDownSelectionText";
        GenderDropDownButtonText.innerHTML = window[window.GenderChoicesJSON[i].translation + window.CurrentCountryID];
        GenderDropDownButton.append(GenderDropDownButtonText);


        // Get Information For Basic Scroll Start
        if(WhichGenderSelected == window.GenderChoicesJSON[i].which_type)
        {
            ScrollToDropDown = GenderDropDownButton;
            GenderDropDownButton.classList.add("DropDownSelectionContainerSelected");
        }
    }

    window.ScrollToSelectedDropDown(DropDownContainer, ScrollToDropDown);
}

// ========================================= CHECK IF IT IS MOBILE =========================================

window.IsThisMobile = function()
{
    const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
}


// ============================== DETERMINE SIZE ==================================

window.DetermineSizeFile = function(thisfile)
{
    let _size = thisfile;

    let fSExt = new Array('Bytes', 'KB', 'MB', 'GB'), i=0;
    while(_size>900)
    {
        _size/=1024;
        i++;
    }
    let exactSize = (Math.round(_size*100)/100)+' '+fSExt[i];
    return exactSize;
}


// =========================== CHANGE ARRAY BASED ON PRIORITY ==================================

window.SortAreaHomePriority = ["Bali"];
window.SortAccommodationPriority = ["Tamblingan Village Luxury Villas in Munduk", "Bukit Bena Campgrounds - Camping Experience dengan View Gunung Gede Pangrango", "D'Limasan Cottage"];

// window.sortByPriority = function(data, priorityList, key)
// {
//     const priorityIndex = new Map();
//     priorityList.forEach((val, i) => priorityIndex.set(val, i));

//     console.log("This Hotel Data", data);

//     if (!Array.isArray(data))
//     {
//         console.warn("sortByPriority: data is not an array:", data);
//         return data;
//     }

//     return data.sort((a, b) =>
//     {
//         const valA = a[key];
//         const valB = b[key];

//         const idxA = priorityIndex.has(valA) ? priorityIndex.get(valA) : Infinity;
//         const idxB = priorityIndex.has(valB) ? priorityIndex.get(valB) : Infinity;

//         return idxA - idxB;
//     });
// }

window.sortByPriority = function(data, priorityList, key)
{
    if(!Array.isArray(data))
    {
        console.warn("sortByPriority: data is not an array:", data);
        return data;
    }

    // Normalized Text -------------------------------------------------
    const normalizeText = (text) =>
    {
        return String(text || "")
            .toLowerCase()
            .trim()
            .replace(/[’']/g, "'")      // Convert ’ to '
            .replace(/\s+/g, " ");
    };

    // Store The Normalized Priority Map -------------------------------
    const priorityMap = new Map();

    priorityList.forEach((item, index) =>
    {
        priorityMap.set(normalizeText(item), index);
    });

    // Sort Based On Priority ----------------------------------------
    return [...data].sort((a, b) =>
    {
        const aValue = normalizeText(a[key]);
        const bValue = normalizeText(b[key]);

        const aPriority = priorityMap.has(aValue)
            ? priorityMap.get(aValue)
            : Number.MAX_SAFE_INTEGER;

        const bPriority = priorityMap.has(bValue)
            ? priorityMap.get(bValue)
            : Number.MAX_SAFE_INTEGER;

        return aPriority - bPriority;
    });
};


// ================================= CACHE HANDLER ===============================

window.getAssetDB = function()
{
    if (window._assetDB) return Promise.resolve(window._assetDB);

    return new Promise(resolve =>
    {
        const req = indexedDB.open("AssetCache", 1);
        req.onupgradeneeded = e =>
        {
            e.target.result.createObjectStore("assets");
        };
        req.onsuccess = e =>
        {
            window._assetDB = e.target.result;
            resolve(window._assetDB);
        };
    });
};


window.GetOneImageCache = async function(url, image)
{
    const cached = await window.getCachedAsset(url);
    if (cached)
    {
        image.src = cached;
        return cached;
    }

    try
    {
        const res = await fetch(url);
        const blob = await res.blob();
        const objUrl = URL.createObjectURL(blob);

        const db = await window.getAssetDB();
        const tx = db.transaction("assets","readwrite");
        tx.objectStore("assets").put(blob, url);

        image.src = objUrl;
        return objUrl;
    }
    catch (e)
    {
        image.remove();
        return null;
    }
};



window.cacheAsset = async function(key, url)
{
    const res = await fetch(url);
    const blob = await res.blob();

    const db = await window.getAssetDB();
    const tx = db.transaction("assets","readwrite");
    tx.objectStore("assets").put(blob, key);
};

window.getCachedAsset = async function(key)
{
    const db = await window.getAssetDB();

    return new Promise(resolve =>
    {
        const tx = db.transaction("assets","readonly");
        const req = tx.objectStore("assets").get(key);
        req.onsuccess = () =>
        {
            if (req.result)
            {
                resolve(URL.createObjectURL(req.result)); // recreate fresh blobURL
            }
            else resolve(null);
        };
    });
};


// =========================== LOAD HOTEL DETAILS ===========================

window.LoadAccommodationDetails = function(loadingblocker, functiontocall, fallback)
{
    let UrlHotelDetails = "/v2/hotels/" + window.HotelID + "?checkin=" + window.CheckInDateNonTop + "&checkout=" + window.CheckOutDateNonTop + "&rooms=" + window.RoomQuotaNonTop;
    window.CallApiAxios({
        method: "GET",
        url: UrlHotelDetails,
    })
    .then(res =>
    {
        console.log(UrlHotelDetails);

        if(res.status == 200)
        {
            window.HotelDetails = res.data.data;
            console.log("window.HotelDetails", window.HotelDetails);
            
            let ExploreHotelDetailsButton = document.getElementById("ExploreHotelDetailsButton");
            if(ExploreHotelDetailsButton != null && window.HotelDetails.province != null)
            {
                ExploreHotelDetailsButton.href = "/search/en/bali.html?search=" + window.HotelDetails.province + "&type=" + window.SearchFilterType;
            }
            
            functiontocall();
        }
        else
        {
            if(loadingblocker != null)
                loadingblocker.remove();

            console.log("Error!");

            if(fallback != null)
                fallback();
        }
    })
    .catch(err =>
    {
        console.log(err);
        if(loadingblocker != null)
            loadingblocker.remove();

        if(fallback != null)
            fallback();
    });
}


// ============================== CALL API FUNCTION =============================

window.CallApiAxios = async function ({
    method = "GET",
    url,
    data = null,
    params = null,
    convertFormData = true
}) {
    try {
        let payload = data;
        let headers = {};

        // CASE 1: FormData
        if (data instanceof FormData) {
            if (convertFormData) {
                payload = formDataToJson(data);
                headers["Content-Type"] = "application/json";
            } else {
                payload = data;
                // ❗ Let Axios set multipart automatically
                headers["Content-Type"] = "multipart/form-data";
            }
        }

        // CASE 2: Plain Object (JSON)
        else if (data && typeof data === "object") {
            headers["Content-Type"] = "application/json";
        }

        const res = await api.request({
            method,
            url,
            data: payload,
            params,
            headers
        });

        return res;
    }
    catch (err) {
        if (err.response) {
            throw {
                status: err.response.status,
                data: err.response.data,
                headers: err.response.headers
            };
        }

        throw err;
    }
};

// =============================== FORM DATA TO JSON ===================================

function formDataToJson(formData)
{
    const obj = {};

    for (const [key, value] of formData.entries())
    {
        if (value instanceof File || value instanceof Blob)
        {
            throw new Error(
                `Cannot convert file field "${key}" to JSON`
            );
        }

        if (obj[key] !== undefined)
        {
            if (!Array.isArray(obj[key]))
            {
                obj[key] = [obj[key]];
            }
            obj[key].push(value);
        }
        else
        {
            obj[key] = value;
        }
    }

    return obj;
}


// ============================ GET BROWSER LOCATION =================================

window.getBrowserData = function (formData)
{
    return new Promise((resolve) => {

        // const browserInfo = {
        //     userAgent: navigator.userAgent,
        //     platform: navigator.platform,
        //     language: navigator.language,
        //     timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        // };

        let PlatformUsed = "web"
        if(navigator.platform == "iPhone" || navigator.platform == "iPod" || navigator.platform == "iPad" || navigator.platform == "Mac68K" || navigator.platform == "MacPPC" || navigator.platform == "MacIntel")
        {
            PlatformUsed = "ios";
        }
        else if(navigator.platform == "Android")
        {
            PlatformUsed = "android";
        }

        formData.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
        formData.append('platform', PlatformUsed);
        formData.append('user_agent', navigator.userAgent);
        formData.append('ip_address', "");

        if (!("geolocation" in navigator))
        {
            formData.append('status_tracking_location', 'Geolocation NOT supported');
            formData.append('latitude', '');
            formData.append('longitude', '');

            return resolve(formData);
        }

        navigator.geolocation.getCurrentPosition(
            (position) =>
            {
                formData.append('status_tracking_location', 'Geolocation success');
                formData.append('latitude', position.coords.latitude);
                formData.append('longitude', position.coords.longitude);
                resolve(formData);
            },
            (error) =>
            {
                let reason = 'Unknown error';

                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        reason = 'Permission denied';
                        break;
                    case error.POSITION_UNAVAILABLE:
                        reason = 'Position unavailable';
                        break;
                    case error.TIMEOUT:
                        reason = 'Geolocation timeout';
                        break;
                }

                formData.append('status_tracking_location', reason);
                formData.append('latitude', '');
                formData.append('longitude', '');
                resolve(formData);
            },
            {
                enableHighAccuracy: false,
                timeout: 5000,
                maximumAge: 0
            }
        );
    });
};

// ==================================== FUNCTION MAKE NEW OBSERVER ====================================

window.makeObserver = function(option)
{
    let loading = false;

    const observer = new IntersectionObserver((entries) =>
    {
        if (!entries[0].isIntersecting) return;
        if (loading) return;

        const page = window[option.pageKey];
        const lastPage = window[option.lastPageKey];

        if (lastPage == null || page < lastPage)
        {
            loading = true;
            window[option.pageKey]++;

            Promise.resolve(option.functiontocall())
                .finally(() => {
                    loading = false;
                });

        } else {
            observer.disconnect();
        }
    }, {
        threshold: 0.1,
    });

    observer.observe(option.sentinelEl);
    return observer;
}

// ============================= GENERATE QR AND DISPLAY ON CANVAS ========================================

window.generateQR = function(value, whichcanvas, functiontocall, iferror)
{
    QRCode.toCanvas(whichcanvas, value, function (error)
    {
        if(error)
        {
            //console.error(error);
            
            if(iferror != null)
                iferror();
        }
        else
        {
            console.log('QR generated!');

            if(functiontocall != null)
                functiontocall();
        }

    });
}


// =============================== DOWNLOAD IMAGE FROM CANVAS ====================================

window.DownloadCanvasasImage = function(thiscanvas, filename, whattype)
{
    const image = thiscanvas.toDataURL(whattype, 1.0);

    // Create temporary link
    const link = document.createElement('a');
    link.href = image;
    link.download = filename;

    // Trigger download
    link.click();
}




// =============================== QUANTITY DROPDOWN ====================================

window.InstantiateQuantityDropDown = function(event, WhereToInstantiate, dropdownchevronid, whatstart, howmanytoinstantiate, whichinput, functiontocall)
{
    event.preventDefault();
    event.stopPropagation();

    window.RotateToggle(dropdownchevronid, true);
    
    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown("QuantityDropDown" + dropdownchevronid, WhereToInstantiate);

    if(ThisDropDownContainer == null)
        return

    ThisDropDownContainer.style.bottom = 0;
    ThisDropDownContainer.style.zIndex = 99;
    ThisDropDownContainer.className = "ContainerFlex";
    ThisDropDownContainer.innerHTML = "";

    // Prepare Which Scroll Start ------------------------------------------------------------------

    let WhatInputQuantityNow = whichinput.value;
    let ScrollToDropDown;
        
    // Drop Down ------------------------------------------------------------------

    let DropDownContainer = document.createElement("div");
    DropDownContainer.className = "DropDownContainer HideScrollBar";
    ThisDropDownContainer.append(DropDownContainer);

    for(let i = whatstart; i <= howmanytoinstantiate; i++)
    {
        let ThisDropDownButton = document.createElement("div");
        ThisDropDownButton.className = "DropDownSelectionContainer DropDownWithStatus";
        ThisDropDownButton.onclick = function(event)
        {
            event.preventDefault();
            event.stopPropagation();
                
            window.RotateToggle("", true);
            
            ThisDropDownContainer.remove();

            whichinput.value = i;
                
            if(functiontocall != null)
                functiontocall();
        }
        DropDownContainer.append(ThisDropDownButton);

        let ThisDropDownButtonText = document.createElement("p");
        ThisDropDownButtonText.className = "DropDownSelectionText";
        ThisDropDownButtonText.innerHTML = i;
        ThisDropDownButton.append(ThisDropDownButtonText);

        // Get Information For Basic Scroll Start
        if(WhatInputQuantityNow == i)
        {
            ScrollToDropDown = ThisDropDownButton;
            ThisDropDownButton.classList.add("DropDownSelectionContainerSelected");
        }
    }

    window.ScrollToSelectedDropDown(DropDownContainer, ScrollToDropDown);
}










// ==================================== NOT FOUND PAGE =====================================

window.SetNotFoundUI = function()
{
    document.getElementById("NotFoundPageHeader").innerHTML = window["PageNotFoundHeaderTxt" + window.CurrentCountryID];
    document.getElementById("NotFoundPageMessageText").innerHTML = window["PageNotFoundMessageTxt" + window.CurrentCountryID];
    document.getElementById("ExplorePinginGoNotFoundText").innerHTML = window["ExplorePinginGoText" + window.CurrentCountryID];
}





// ================================== LOTTIE ===========================================

window.createLottie = function(thiscontainer, jsonUrl, options = {})
{
    return lottie.loadAnimation(
    {
        container: thiscontainer,
        renderer: 'svg',
        loop: options.loop ?? true,
        autoplay: options.autoplay ?? true,
        path: jsonUrl
    });
};

window.destroyLottie = function(anim)
{
  anim.destroy();
};


// ================================ DYNAMIC COLLAPSIBLE =================================

window.SetDynamicCollapsible = function(content, button, textElement)
{
    const collapsedHeight = getComputedStyle(content).maxHeight;

    button.onclick = () =>
    {
        if(content.classList.contains("expanded"))
        {
            // Convert "none" back to px
            content.style.maxHeight = content.scrollHeight + "px";

            // Force browser reflow
            void content.offsetHeight;

            content.style.maxHeight = collapsedHeight;
            content.classList.remove("expanded");

            if(textElement)
                textElement.innerHTML = window["ViewAllTxt" + window.CurrentCountryID]
        }
        else
        {
            content.style.maxHeight = content.scrollHeight + "px";

            content.addEventListener("transitionend", function handler()
            {
                content.style.maxHeight = "none";
                content.classList.add("expanded");
                content.removeEventListener("transitionend", handler);
            });

            if(textElement)
                textElement.innerHTML = window["HideButtonTxt2" + window.CurrentCountryID]
        }
    };
}

// window.SetDynamicCollapsible = function(content, button)
// {
//     button.onclick = () =>
//     {
//         if(content.classList.contains("expanded"))
//         {
//             content.style.maxHeight = getComputedStyle(content).maxHeight;
//             content.classList.remove("expanded");
//         }
//         else
//         {
//             content.style.maxHeight = content.scrollHeight + "px";

//             content.addEventListener("transitionend", function handler()
//             {
//                 content.style.maxHeight = "none";
//                 content.classList.add("expanded");
//                 content.removeEventListener("transitionend", handler);
//                 // button.style.display = "none";
//             });
//         }
//     };

//     // LihatSemuaTextDescription.innerHTML = window["ViewAllTxt" + window.CurrentCountryID];
// };


// ================================ RESPONSIVE BASED ON SCREEN SIZE ======================================

const MaxMobileSize = "560px";
const MaxMobileSize2 = "650px";
window.ResponsivePanelMediaQuery = window.matchMedia("(max-width: " + MaxMobileSize + ")");
window.ResponsivePanelMediaQuery2 = window.matchMedia("(max-width: " + MaxMobileSize2 + ")");

window.ResponsivePanelMediaQuery.addEventListener("change", function(event)
{
    if(event.matches) // Remove Desktop If Mobile Size
    {
        document.querySelectorAll(".ResponsiveDesktopPanel").forEach(panel =>
        {
            if(typeof panel.OnResponsiveRemove === "function")
            {
                panel.OnResponsiveRemove();
                panel.remove();
            }
        });
    }
    else // Remove Mobile If Desktop Size ------------------
    {
        document.querySelectorAll(".ResponsiveMobilePanel").forEach(panel =>
        {
            if(typeof panel.OnResponsiveRemove === "function")
            {
                panel.OnResponsiveRemove();
                panel.remove();
            }
        });
    }
});

